import './assets/@software-distribution-hub.css';
import { j as e, i as re, d as kt, p as us } from "./@vendor-BxhYAQFM.js";
import { createContext as vt, useMemo as q, useContext as Ct, useState as T, useEffect as ee, createElement as fs, useRef as Ye, Fragment as _r } from "react";
import { Link as ke, useParams as Te, useHistory as fe, useRouteMatch as gs, useLocation as fn, generatePath as W, Route as Re, Switch as Bs, Redirect as gn } from "react-router-dom";
import { CDMaterialResourceQuery as Ns, ResourceKindType as G, preventDefault as za, DTSwitch as Pn, ConditionalWrap as $e, GenericEmptyState as J, ComponentSizeType as oe, getResourceApiUrl as ge, ResourceVersionType as ne, get as xe, showError as U, useAsync as K, SelectPicker as st, ConfirmationModal as Hs, ConfirmationModalVariantType as Gs, ButtonWithLoader as Ws, ToastManager as ae, ToastVariantType as le, VisibleModal as Ut, stopPropagation as lt, APIResponseHandler as Ee, InfoBlock as cs, ZERO_TIME_STRING as Dt, DATE_TIME_FORMATS as hr, RegistryType as xn, EnvironmentTypeEnum as Ot, DependencyType as oi, DeploymentStageType as be, getCommonSelectStyle as fr, Button as ie, ButtonComponentType as Rt, Icon as Me, ButtonVariantType as _e, URLS as bn, getUrlWithSearchParams as Qn, stringComparatorBySortOrder as te, getOrdinal as ii, handleRelativeDateSorting as Ka, SortingOrder as Fn, numberComparatorBySortOrder as Us, extractImage as gr, SourceTypeMap as Oa, PatchOperationType as he, processCDMaterialServiceResponse as ci, DeploymentWithConfigType as di, patch as Ls, SortableTableHeaderCell as Z, post as Ue, put as $t, ServerErrors as pi, API_STATUS_CODES as Bt, getIsRequestAborted as hs, trash as Ht, getWebhookEventsForEventId as mi, BASE_CONFIGURATION_ENV_ID as ui, getSelectPickerOptionByValue as ln, Tooltip as xt, TIMELINE_STATUS as es, findRight as _i, WFR_STATUS_DTO_TO_DEPLOYMENT_STATUS_MAP as hi, DEPLOYMENT_STATUS as Ln, InfoIconTippy as xr, useDownload as Ja, RegistryIcon as Mt, RadioGroup as En, RadioGroupItem as $s, CustomInput as Fe, REGISTRY_TYPE_MAP as Pl, Checkbox as js, RepositoryAction as wn, CHECKBOX_VALUE as Oe, useMainContext as br, SERVER_MODE as fi, useForm as gi, VirtualClusterSidebar as xi, ButtonStyleType as qe, DeleteConfirmationModal as Gt, DC_DELETE_SUBTITLES as bi, ERROR_STATUS_CODE as Er, Progressing as vs, logExceptionToSentry as Ei, DEPLOYMENT_WINDOW_TYPE as Ni, useScrollable as ji, TRIGGER_STATUS_PROGRESSING as vi, getModuleConfigured as Ci, ModuleNameMap as Nr, getTriggerHistory as Fl, FetchIdDataStatus as Rs, STAGE_TYPE as kn, PromiseAllStatusType as Na, useInterval as yi, ErrorScreenManager as bt, Sidebar as Ti, HistoryComponentType as Si, asyncWrap as wi, mapByKey as Ul, TriggerOutput as Ri, LogResizeButton as Ii, getKeyToBooleanMapFromArray as Qs, VisibleModal2 as Nn, handleUTCTime as Qa, noop as We, useSearchString as jr, useUrlFilters as Xn, DraggableWrapper as Ai, DraggablePositionVariant as Li, DraggableButton as ki, ButtonWithSelector as Di, ImageWithFallback as Oi, Drawer as rt, useStateFilters as ds, getDeploymentStageTitle as Zn, SegmentedControl as ea, TippyCustomized as vr, TippyTheme as Cr, FilterChips as sa, getTimeDifference as Mi, AnimatedTimer as Pi, MODAL_TYPE as rn, capitalizeFirstLetter as yr, ActivityIndicator as Fi, StatusType as Js, StatusComponent as Ui, useBulkSelection as Tr, BulkSelectionEvents as on, BulkSelection as $i, GenericSectionErrorState as As, BulkSelectionProvider as Bi, SelectAllDialogStatus as Hi, abortPreviousRequests as Vs, DEPLOYMENT_STAGE_TO_NODE_MAP as Gi, SearchBar as qs, useTriggerAutoClickTimestamp as Wi, prefixZeroIfSingleDigit as Vi, GenericFilterEmptyState as yt, AppStatusModal as qi, Textarea as jn, LoadingIndicator as Sr, ContextSwitcher as wr, handleAnalyticsEvent as Rr, useBreadcrumb as ta, BreadcrumbText as Et, PageHeader as na, DOCUMENTATION as aa, BreadCrumb as Xa, TabGroup as Ir, ClipboardButton as Un, CodeEditor as $l, MODES as Bl, Reload as Yi, RJSFForm as zi, GenericDescription as Za, ImageChipCell as Ki, CommitChipCell as Ji, ArtifactInfoModal as Ar, EditableTextArea as el, getRandomColor as la, useGetUserRoles as Qi, getIsMaterialInfoAvailable as Xi, ImageCard as Zi, ImageCardAccordion as ec, useImageSelectionUtilityContext as sc, ModuleStatus as tc, getWebhookEventIcon as nc, ImageType as ac, getHandleOpenURL as lc, TreeView as rc, useDebounce as oc, DetectBottom as ic, DevtronProgressing as ra, FilterSelectPicker as sl, FeatureTitleWithInfo as cc, ModalSidebarPanel as vn, validateName as mn, validateDescription as oa, MESSAGES as dc, SEMANTIC_VERSION_DOCUMENTATION_LINK as pc, validateSemanticVersioning as mc, PopupMenu as It, highlightSearchText as _s, ActionMenu as Lr, renderValidInputButtonTippy as tl, validateDisplayName as cn, validateURL as Hl, validateIfImageExist as uc, isNullOrUndefined as $n, UserStatusDto as _c, requiredField as Gl, DOCUMENTATION_HOME_PAGE as hc, FeatureDescriptionModal as fc, getIsApprovalPolicyConfigured as ja } from "@devtron-labs/devtron-fe-common-lib";
import { R as $, F as Ce, D as Bn, g as gc, G as gt, I as pt, a as nl, A as Wl, b as xc, c as bc, d as Ec, e as Rn, f as Nc, h as D, i as Vl, C as jc, E as vc, j as kr, k as Dr, l as ot, m as Or, n as In, o as va, p as Cc, q as yc, r as Tc, J as Sc, s as wc, t as Rc, u as Ic, S as Ac, v as Lc, w as kc, U as Nt, x as Dc, y as Oc, z as Mc } from "./@global-configuration-DvZkjZJA.js";
import { ReactComponent as Pc } from "./assets/ic-download.5d648842.svg";
import { ReactComponent as Fc } from "./assets/ic-helm-package-blue.18f4ff6e.svg";
import { ReactComponent as Uc } from "./assets/ic-download-file.95926f80.svg";
import { ReactComponent as $c } from "./assets/ic-environment-temp.3209250b.svg";
import { ReactComponent as Cn } from "./assets/ic-help-outline.bd39bc26.svg";
import Bc from "./assets/ic-empty-virtual-deployment.cff37cf2.png";
import { ReactComponent as Mr } from "./assets/ic-boxes.1bc23026.svg";
import { ReactComponent as al } from "./assets/ic-check.73991ac2.svg";
import { ReactComponent as ys } from "./assets/ic-cross.54cad648.svg";
import { ReactComponent as ll } from "./assets/ic-error.b0bbe394.svg";
import { ReactComponent as Pr } from "./assets/ic-flag-green.5e519661.svg";
import { ReactComponent as Hc } from "./assets/ic-flag-grey.65e92fdb.svg";
import { ReactComponent as Gc } from "./assets/ic-flag-last-wave.bfa2d816.svg";
import { ReactComponent as rl } from "./assets/ic-locked.974e3a7d.svg";
import { ReactComponent as un } from "./assets/ic-success.d61bac19.svg";
import { ReactComponent as Fr } from "./assets/ic-deploy-color.db04cea8.svg";
import { ReactComponent as Ur } from "./assets/ic-in-progress.0598554b.svg";
import { ReactComponent as Wc } from "./assets/ic-yet-to-trigger.8957244f.svg";
import { ReactComponent as Vc } from "./assets/ic-diff-file-added.0deb6763.svg";
import { ReactComponent as ql } from "./assets/ic-diff-file-removed.2ed80281.svg";
import { ReactComponent as qc } from "./assets/software-distribution-hub.a8fb47d7.svg";
import { ReactComponent as Wt } from "./assets/ic-delete-interactive.63fabf04.svg";
import { ReactComponent as ol } from "./assets/ic-menu-dots.398f5cfa.svg";
import { ReactComponent as Ys } from "./assets/ic-pencil.4b680b92.svg";
import { ReactComponent as Yc } from "./assets/ic-building.6771dfe5.svg";
import { ReactComponent as jt } from "./assets/ic-arrow-right.f942ee03.svg";
import { ReactComponent as zc } from "./assets/ic-exit-fullscreen.d20ef1b5.svg";
import { ReactComponent as Kc } from "./assets/ic-fullscreen.5e3d1964.svg";
import { ReactComponent as Jc } from "./assets/catalog-schema-null-state.69b433d4.svg";
import { ReactComponent as Je } from "./assets/ic-add.b1e7fd27.svg";
import Hn from "./assets/group-similar.d1527089.png";
import { ReactComponent as Qc } from "./assets/ic-link.87517174.svg";
import { ReactComponent as il } from "./assets/ic-env.9381cd8d.svg";
import { ReactComponent as tt } from "./assets/ic-caret-down.c459567f.svg";
import { ReactComponent as Xc } from "./assets/ic-folder-color.6d1e5314.svg";
import { ReactComponent as Zc } from "./assets/isolated-installation-deployment.aa3b7c4e.svg";
import { ReactComponent as ed } from "./assets/ic-medium-clean-brush.263acd35.svg";
import { ReactComponent as Ts } from "./assets/ic-close.40c46877.svg";
import Ma from "./assets/cloud-empty-state.9bb9b0ae.png";
import { ReactComponent as sd } from "./assets/ic-cluster.2b1908bd.svg";
import { ReactComponent as Pa } from "./assets/ic-release-channel.98287e08.svg";
import { ReactComponent as td } from "./assets/ic-release-channel-medium.31c135ca.svg";
import { ReactComponent as nd } from "./assets/ic-installation-color.9fbaabc4.svg";
import { ReactComponent as ad } from "./assets/ic-client.faf8b8be.svg";
import ld from "./assets/teenage-package-delivery.e1185625.png";
import rd from "./assets/empty-folder.4570c4ae.webp";
import { ReactComponent as $r } from "./assets/ic-help.a75a7835.svg";
import { ReactComponent as cl } from "./assets/ic-devtron-app.fda22992.svg";
import { ReactComponent as od } from "./assets/ic-info-outlined.8e2a6c07.svg";
import id from "./assets/release-add-application.9090fe90.png";
import { ReactComponent as cd } from "./assets/ic-arrow-counter-clockwise.e020e189.svg";
import { ReactComponent as dd } from "./assets/ic-flag-add.fad4a8f9.svg";
import { ReactComponent as ia } from "./assets/ic-info-outline.a2baf25b.svg";
import { ReactComponent as pd } from "./assets/drag.fae5ee6b.svg";
import { ReactComponent as Br } from "./assets/ic-search.d31b1c9d.svg";
import { ReactComponent as Hr } from "./assets/ic-medium-warning.410e7036.svg";
import dn from "./assets/person-working-on-pc.5efff7ef.png";
import { ReactComponent as md } from "./assets/ic-arrows-clockwise.424f0538.svg";
import { ReactComponent as Gr } from "./assets/ic-chevron-down.c06b8238.svg";
import { ReactComponent as zs } from "./assets/ic-release-color.bfdfec1c.svg";
import Wr, { components as Vr } from "react-select";
import { ReactComponent as qr } from "./assets/ic-checks.9005997e.svg";
import { ReactComponent as ud } from "./assets/ic-like.e042e09e.svg";
import { ReactComponent as _d } from "./assets/ic-pause.3b22cdeb.svg";
import hd from "./assets/release-note-null-state.f92348ce.webp";
import { ReactComponent as dl } from "./assets/ic-arrow-line-down.f554943b.svg";
import { ReactComponent as fd } from "./assets/ic-blackout-window.721874f5.svg";
import { ReactComponent as gd } from "./assets/ic-maintenance-window.5c0e183d.svg";
import { ReactComponent as xd } from "./assets/ic-zip-folder.78e09767.svg";
import ca, { ReactComponent as bd } from "./assets/ic-mechanical-operation.201add3a.svg";
import Ed from "./assets/release-order-null-state.56740f29.png";
import { ReactComponent as Nd } from "./assets/ic-arrows-left-right.67c9617c.svg";
import { ReactComponent as jd } from "./assets/ic-medium-locked.aff2f6e4.svg";
import { ReactComponent as vd } from "./assets/ic-unlocked.b5d0c5c2.svg";
import { ReactComponent as Cd } from "./assets/ic-image-sparkles.bd601d6e.svg";
import { ReactComponent as yd } from "./assets/ic-release-color-previous.93d8dbc6.svg";
import Td from "./assets/clip-delete-confirmation.77ab0429.png";
import { ReactComponent as Sd } from "./assets/ic-arrow-square-out.5ad40e74.svg";
import { ReactComponent as Yr } from "./assets/git.69b080c3.svg";
import { ReactComponent as wd } from "./assets/ic-gitcommit.b4ba7fdb.svg";
import { ReactComponent as Rd } from "./assets/ic-build-color.ac847ffd.svg";
import { ReactComponent as Id } from "./assets/ic-select-workflow-empty-state.7f1e5740.svg";
import { ReactComponent as Ad } from "./assets/ic-restore.e1ff823a.svg";
import Fa from "./assets/no-artifact.fd2d84d9.webp";
import { ReactComponent as Ld } from "./assets/ic-tag.34388acc.svg";
import { ReactComponent as da } from "./assets/ic-warning.ddd476e3.svg";
import { ReactComponent as Yl } from "./assets/ic-workflow.42719859.svg";
import { ReactComponent as kd } from "./assets/ic-git-branch.9a4e14d0.svg";
import { ReactComponent as Dd } from "./assets/ic-job-color.979f31cd.svg";
import { ReactComponent as Od } from "./assets/ic-linked-cd.af93dda0.svg";
import { ReactComponent as Md } from "./assets/ic-node-build-linked.d388ec9f.svg";
import { ReactComponent as Pd } from "./assets/ic-webhook.f843d42b.svg";
import Fd from "./assets/no-target-tenants.0891629d.png";
import Ud from "./assets/release-not-ready.8d094f89.png";
import $d from "./assets/requirements-not-locked.c0eb5da1.webp";
import { ReactComponent as _n } from "./assets/ic-rocket.7be5910f.svg";
import Bd from "./assets/no-offending-pipeline.9861878e.svg";
import Hd from "./assets/person-on-rocket.f16cb83a.png";
import { ReactComponent as Gd } from "./assets/ic-caret-left-small.eec57a21.svg";
import { ReactComponent as Wd } from "./assets/ic-nav-rocket.5b7562ba.svg";
import { ReactComponent as zr } from "./assets/ic-arrow-clockwise.80fd562b.svg";
import { ReactComponent as Vd } from "./assets/ic-file.3126c24e.svg";
import { ReactComponent as qd } from "./assets/ic-paper-plane.208d4a13.svg";
import { ReactComponent as Yd } from "./assets/ic-grid-view.2f6e770c.svg";
import zd from "./assets/create-release.c6e3fd36.svg";
import { ReactComponent as Kd } from "./assets/boxes-box.ef1ae465.svg";
import { ReactComponent as Jd } from "./assets/ic-copy.0c429146.svg";
const Kr = vt(null), dE = ({
  children: s,
  renderers: t
}) => {
  const n = q(() => t, []);
  return /* @__PURE__ */ e.jsx(Kr.Provider, { value: n, children: s });
}, Qd = () => {
  const s = Ct(Kr);
  if (!s)
    throw new Error("SoftwareDistributionHubRenderContext cannot be used outside SoftwareDistributionHub scope");
  return s;
}, Be = {
  SELECT_LABEL: {
    LABEL: "Select image by label",
    PLACEHOLDER: "Select label"
  },
  UNSAVED_CHANGES_INDICATOR: "Unsaved changes",
  IMAGE_CTA: "Save",
  SEARCH_PLACEHOLDER: "Search by image tag",
  RIGHT_PANEL_ENVIRONMENTS_HEADING: "Environments in this workflow",
  NO_WORKFLOW_EMPTY_STATE: {
    title: "No workflow available",
    subTitle: "Application is not fully configured. Complete the configuration"
  },
  NO_ARTIFACT_FROM_SEARCH: {
    title: "No artifacts found",
    subTitle: "We could not find any image matching the criteria"
  },
  NO_ARTIFACT_FOUND: {
    title: "No artifacts found",
    subTitle: "We could not find any matching image"
  },
  UNABLE_TO_FETCH_EVENT_NAME: "Unable to fetch event name",
  SUCCESS_SAVE_MESSAGE: "Deployment source updated successfully",
  CLEAR_ARTIFACT_FILTERS: "Clear filters",
  SEARCH_SOURCE: {
    SEARCH_IMAGE_TAG: "Search image tag"
  },
  SELECT_ARTIFACT_CTA: "Select"
}, Xd = (s, t) => `No previous deployment of '${s}' found in '${t}'`, Zd = (s, t) => `Images of '${s}' deployed from releases in '${t}' will be available here`, ep = (s) => `Show only images deployed from '${s}'`, sp = (s) => `Select image for release '${s}'`, tp = (s) => s ? `Select a workflow for '${s}' to view available images` : "Select an application to view its workflows", np = (s) => `${s} Applications`, ap = (s) => {
  switch (s) {
    case Ns.CI_JOB:
      return "Job Pipeline";
    case Ns.WEBHOOK:
      return "External Service";
    case Ns.LINKED_CI:
      return "Linked Build Pipeline";
    case Ns.LINKED_CD:
      return "Sync with environment";
    default:
      return "-";
  }
}, lp = (s, t) => {
  switch (s) {
    case Ns.WEBHOOK:
      return "Webhook";
    default:
      return t;
  }
}, rp = (s, t) => s ? "Request in progress" : t ? null : "No changes to save", op = (s) => `No deployment pipelines exist for '${s}'`, ip = (s) => `Tag '${s}' not found`, zl = "deployment-source-select", Ua = "*", pl = 0, cp = {
  DEFAULT_PLACEHOLDER: "Search by project or application name",
  GROUP_HEADING_SUFFIX: "project"
}, Ve = {
  getTitle: (s, t) => t === G.releaseTrack ? `${s} / Manage Applications` : `Manage Applications in '${s}'`,
  SELECT_PLACEHOLDER: "Search and add applications",
  NO_RELEASE_ORDER_EMPTY_STATE: {
    TITLE: "Add Applications",
    SUB_TITLE: "Add applications now to kickstart your deployment."
  },
  NO_APPLICATIONS_IN_RELEASE_ORDER: {
    TITLE_FOR_RELEASE: "No applications in this stage",
    TITLE_FOR_TRACK: "Drag and drop the applications",
    SUB_TITLE_FOR_TRACK: "you wish to release after the ones listed above."
  },
  ADD_RELEASE_STAGE_BUTTON: "Add Release Stage",
  RESET_BUTTON: "Reset",
  SUBMIT_CTA_TEXT: "Save changes",
  UNSAVED_CHANGES: "Unsaved changes",
  DELETE_DIALOG: {
    DESCRIPTION: "Removing the application from the release will remove all requirements added against the application.",
    CONFIRMATION_TEXT: "Are you sure?",
    PRIMARY_TEXT: "Remove"
  },
  REQUEST_IN_PROGRESS: "Request in progress",
  NO_CHANGES: "No changes to save"
}, dp = (s, t, n) => t === G.release ? n ? "Manage application release order" : "Applications in release" : `Manage release order for ${s} application(s)`, pp = (s, t) => `Remove '${s}' from '${t}'`, mp = (s, t) => s ? Ve.REQUEST_IN_PROGRESS : t ? null : Ve.NO_CHANGES, Jr = vt(
  {}
), up = ({
  children: s,
  parentResourceKind: t,
  resourceId: n,
  resourceName: a,
  trackId: l,
  releaseOrderingFromApi: o,
  releaseOrdering: r,
  setReleaseOrdering: i,
  releaseOrderingForTrack: c,
  isReleaseOrderActive: d
}) => {
  const [m, p] = T(null), [u, _] = T(d), h = t === G.releaseTrack, { selectedApplicationsMap: f, selectedApplicationsCount: g, trackApplicationsRequiredMap: b } = q(() => {
    const R = gm(r), B = Object.keys(R).length;
    return {
      selectedApplicationsMap: R,
      selectedApplicationsCount: B,
      // This is done since the required check is not enforced for release
      trackApplicationsRequiredMap: xm(c)
    };
  }, [r]);
  ee(() => {
    _(d);
  }, [d]);
  const j = (R) => {
    if (R && f[R].selectedImage) {
      p(f[R]);
      return;
    }
    const { releaseOrderIndex: B, applicationIndex: P } = f[R] || m, L = Ql({
      releaseOrdering: r,
      targetReleaseOrderIndex: B,
      targetApplicationIndex: P,
      clearReleaseOrdersIfEmpty: !0
    });
    i(L), p(null);
  }, E = ({
    applicationName: R,
    applicationId: B,
    isRequired: P
  }) => {
    if (!R || !B)
      return;
    const L = Em({
      releaseOrdering: r,
      applicationName: R,
      applicationId: B,
      // By default new application would be required if the resource is track
      isRequired: h || P
    });
    i(L);
  }, v = (R) => {
    const B = R.reduce(
      (M, Y) => (M[Y.label] = !0, M),
      {}
    ), P = Object.keys(f).find(
      (M) => !B[M] && // if the app doesn't exist in the options list in case of manage release order
      // for release, it should exist in the release track; otherwise the operation is not add
      (h || M in b)
    );
    if (P) {
      j(P);
      return;
    }
    if (t === G.releaseTrack) {
      const M = R.find((je) => !f[je.label]), Y = M?.label, O = M?.value ? Number(M?.value) : 0, { isRequired: Q } = M;
      E({ applicationName: Y, applicationId: O, isRequired: Q });
      return;
    }
    const L = c.map(({ applications: M, ...Y }) => ({
      ...Y,
      applications: M.filter((O) => B[O.name])
    })), F = u ? L : [
      {
        ...L[0],
        applications: L.flatMap(({ applications: M }) => M).filter((M) => !!B[M.name])
      }
    ];
    i(F);
  }, x = () => {
    const R = Nm(r);
    i(R);
  }, N = (R, B, P) => {
    const {
      releaseOrderIndex: L,
      applicationIndex: F,
      selectedImage: M,
      registryType: Y,
      applicationId: O,
      artifactId: Q,
      artifactSourceAppWorkflowId: je,
      sourceReleaseConfiguration: ps,
      isRequired: ts,
      isDeleted: X
    } = f[R], ce = Ql({
      releaseOrdering: r,
      targetReleaseOrderIndex: L,
      targetApplicationIndex: F
    }), we = Cm(
      ce,
      B,
      P,
      {
        name: R,
        selectedImage: M,
        registryType: Y,
        appId: O,
        artifactId: Q,
        artifactSourceAppWorkflowId: je,
        sourceReleaseConfiguration: ps,
        isRequired: ts,
        isDeleted: X
      }
    );
    i(we);
  }, y = (R) => {
    const B = vm(r, R);
    i(B);
  }, C = () => {
    p(null);
  }, S = (R) => {
    const {
      releaseOrderIndex: B,
      applicationIndex: P,
      selectedImage: L,
      registryType: F,
      applicationId: M,
      artifactId: Y,
      artifactSourceAppWorkflowId: O,
      sourceReleaseConfiguration: Q,
      isRequired: je,
      isDeleted: ps
    } = f[R], ts = ym(
      r,
      B,
      P,
      {
        name: R,
        selectedImage: L,
        registryType: F,
        appId: M,
        artifactId: Y,
        artifactSourceAppWorkflowId: O,
        sourceReleaseConfiguration: Q,
        isRequired: !je,
        isDeleted: ps
      }
    );
    i(ts);
  }, I = () => {
    i(c);
  }, w = () => {
    _((R) => {
      if (R) {
        const P = [
          {
            ...r[0],
            applications: r.flatMap(({ applications: L }) => L).filter((L) => !!f[L.name])
          }
        ];
        return i(P), !1;
      }
      const B = c.map(({ applications: P, ...L }) => ({
        ...L,
        applications: P.filter((F) => !!f[F.name])
      }));
      return i(B), !0;
    });
  }, k = q(
    () => ({
      // Primitive
      parentResourceKind: t,
      resourceId: n,
      resourceName: a,
      trackId: l,
      releaseOrderingFromApi: o,
      releaseOrdering: r,
      releaseOrderingForTrack: c,
      selectedApplicationsMap: f,
      trackApplicationsRequiredMap: b,
      selectedApplicationsCount: g,
      isReleaseOrderActive: u,
      deleteApplicationData: m,
      // Transitive
      isParentResourceReleaseTrack: h,
      isReleaseOrderingDifferentFromTrack: !h && Eo(r, c, {
        shouldCheckForSelectedImage: !1
      }),
      // Handlers
      setReleaseOrdering: i,
      toggleIsReleaseOrderActive: w,
      handleDeleteApplication: j,
      handleApplicationSelection: v,
      handleAddNewReleaseOrder: x,
      handleMoveApplicationOrder: N,
      handleDeleteReleaseOrder: y,
      handleCloseDeleteModal: C,
      toggleApplicationRequired: S,
      resetReleaseOrderingToTrackOrdering: I
    }),
    [
      t,
      n,
      a,
      l,
      o,
      r,
      c,
      f,
      b,
      g,
      u,
      m
    ]
  );
  return /* @__PURE__ */ e.jsx(Jr.Provider, { value: k, children: s });
}, Vt = () => {
  const s = Ct(Jr);
  if (!s)
    throw new Error("Wrap with ManageReleaseOrderProvider");
  return s;
}, _p = ({
  application: { name: s, isRequired: t, isDeleted: n },
  releaseOrderIndex: a,
  applicationIndex: l,
  draggingApplicationName: o,
  handleClearDraggingApplicationName: r,
  handleSetDraggingApplicationName: i
}) => {
  const {
    handleMoveApplicationOrder: c,
    handleDeleteApplication: d,
    toggleApplicationRequired: m,
    parentResourceKind: p,
    trackApplicationsRequiredMap: u
  } = Vt(), _ = p === G.releaseTrack, h = _ ? t : u[s] ?? !1, f = !_ && h, g = () => {
    i(s);
  }, b = () => {
    c(o, a, l);
  }, j = () => {
    d(s);
  }, E = () => {
    m(s);
  }, v = (x) => /* @__PURE__ */ e.jsx(re, { className: "default-tt", arrow: !1, content: `'${s}' must be part of the release`, children: x });
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `p-8 flexbox dc__gap-8 dc__align-items-center dc__content-space br-4 ${o === s ? "bcb-1 eb-2" : "bg__primary dc__hover-n50 dc__no-border"}`,
      ..._ && {
        draggable: o === s,
        onDragOver: za,
        onDragEnter: b,
        onDragEnd: r,
        onDrop: r
      },
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex left center dc__gap-8", children: [
          _ ? /* @__PURE__ */ e.jsx(
            "button",
            {
              type: "button",
              className: "p-0 dc__no-background dc__no-border dc__outline-none-imp flex dc__grabbable dc__no-shrink",
              "data-testid": `drag-${s}`,
              "aria-label": `drag ${s}`,
              onMouseDown: g,
              onMouseUp: r,
              children: /* @__PURE__ */ e.jsx(pd, { className: "icon-dim-16 dc__no-shrink" })
            }
          ) : /* @__PURE__ */ e.jsx(cl, { className: "dc__no-shrink icon-dim-24" }),
          /* @__PURE__ */ e.jsxs("span", { className: `flex left dc__gap-8 flex-grow-1 fs-13 fw-4 lh-20 ${n ? "cr-5" : "cn-9"}`, children: [
            /* @__PURE__ */ e.jsxs("span", { className: "dc__truncate", children: [
              s,
              " ",
              h && /* @__PURE__ */ e.jsx(hn, {})
            ] }),
            n && /* @__PURE__ */ e.jsx("span", { className: "dc__no-shrink", children: "Application not found" })
          ] })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex left center dc__gap-8 dc__no-shrink", children: [
          _ && /* @__PURE__ */ e.jsx(
            Pn,
            {
              name: `app-${s}-required`,
              ariaLabel: `Toggle ${s} required in release order`,
              isChecked: h,
              onChange: E,
              shape: "square",
              variant: "theme",
              iconName: "ic-asterisk",
              iconColor: "R500"
            }
          ),
          /* @__PURE__ */ e.jsx($e, { condition: f, wrap: v, children: /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
            "button",
            {
              className: `p-0 dc__no-background dc__no-border dc__outline-none-imp flex icon-dim-16 ${f ? "dc__disabled" : "icon-delete__hover"}`,
              type: "button",
              onClick: j,
              "aria-label": `remove-${s}-from-release-order`,
              disabled: f,
              children: /* @__PURE__ */ e.jsx(Wt, { className: "icon-dim-16 dc__no-shrink" })
            }
          ) }) })
        ] })
      ]
    }
  );
}, hp = ({
  releaseOrder: s,
  isLastReleaseOrder: t,
  draggingApplicationName: n,
  handleClearDraggingApplicationName: a,
  handleSetDraggingApplicationName: l
}) => {
  const { handleDeleteReleaseOrder: o, handleMoveApplicationOrder: r, isParentResourceReleaseTrack: i } = Vt(), { id: c, title: d, icon: m, applications: p } = s, u = () => {
    o(c);
  }, _ = () => {
    r(n, c, 0);
  }, h = () => p.length === 0 ? /* @__PURE__ */ e.jsx(
    "div",
    {
      className: "dc__border-dashed pt-20 pb-20 pl-20 pr-20 flex bg__secondary br-4",
      ...i && {
        onDragOver: za,
        onDrop: a,
        onDragEnter: _
      },
      children: /* @__PURE__ */ e.jsx("div", { className: "w-236 cn-7 fs-12 dc__align-center", children: i ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsxs("span", { className: "fw-6 lh-18", children: [
          Ve.NO_APPLICATIONS_IN_RELEASE_ORDER.TITLE_FOR_TRACK,
          " "
        ] }),
        /* @__PURE__ */ e.jsx("span", { className: "fw-4 lh-18", children: Ve.NO_APPLICATIONS_IN_RELEASE_ORDER.SUB_TITLE_FOR_TRACK })
      ] }) : /* @__PURE__ */ e.jsx("span", { className: "fw-6 lh-18", children: Ve.NO_APPLICATIONS_IN_RELEASE_ORDER.TITLE_FOR_RELEASE }) })
    }
  ) : /* @__PURE__ */ e.jsx("div", { className: "flexbox-col p-4 br-8 bg__primary dc__info-card dc__info-card--no-hover", children: p.map((g, b) => /* @__PURE__ */ e.jsx(
    _p,
    {
      application: g,
      handleClearDraggingApplicationName: a,
      handleSetDraggingApplicationName: l,
      applicationIndex: b,
      releaseOrderIndex: s.id,
      draggingApplicationName: n
    },
    g.name
  )) }), f = c === 0;
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
      /* @__PURE__ */ e.jsxs(
        "div",
        {
          className: `pl-12 pr-12 pt-4 pb-4 flexbox dc__content-space ${f ? "" : "dc__hover-n50 dc__visible-hover dc__visible-hover--parent"}`,
          children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-8", children: [
              m,
              /* @__PURE__ */ e.jsx("h3", { className: "m-0 dc__ellipsis-right cn-7 fs-12 fw-6 lh-20 dc__uppercase", children: d })
            ] }),
            !f && i && /* @__PURE__ */ e.jsx(
              "button",
              {
                type: "button",
                className: "p-0 dc__no-background dc__no-border dc__outline-none-imp dc__visible-hover--child dc__no-shrink",
                "data-testid": `remove-release-stage-${c}-button`,
                "aria-label": "remove-release-stage-button",
                onClick: u,
                children: "—"
              }
            )
          ]
        }
      ),
      h()
    ] }),
    (i || !t) && /* @__PURE__ */ e.jsx("div", { className: "w-24 h-16 dc__border-dashed--n3-right" })
  ] });
}, fp = () => {
  const {
    releaseOrdering: s,
    selectedApplicationsCount: t,
    handleAddNewReleaseOrder: n,
    parentResourceKind: a,
    resetReleaseOrderingToTrackOrdering: l,
    isReleaseOrderActive: o,
    toggleIsReleaseOrderActive: r,
    isReleaseOrderingDifferentFromTrack: i,
    isParentResourceReleaseTrack: c,
    releaseOrderingForTrack: d
  } = Vt(), m = d.length > 1, [p, u] = T(null), _ = () => {
    u(null);
  }, h = (g) => {
    u(g);
  };
  if (!s.length)
    return /* @__PURE__ */ e.jsx("div", { className: "pt-16 flexbox-col h-100", children: /* @__PURE__ */ e.jsx(
      J,
      {
        title: Ve.NO_RELEASE_ORDER_EMPTY_STATE.TITLE,
        subTitle: Ve.NO_RELEASE_ORDER_EMPTY_STATE.SUB_TITLE,
        image: id,
        classname: "dc__border-dashed--n3 br-4",
        imageClassName: "dc__blend-luminosity dc__opacity-0_2"
      }
    ) });
  const f = () => c && /* @__PURE__ */ e.jsxs(
    "button",
    {
      className: "dc__tab-focus flex dc__gap-4 px-8 py-4 dc__no-background dc__no-border dc__outline-none-imp dc__w-fit-content dc__hover-n50",
      type: "button",
      onClick: n,
      "data-testid": "add-release-stage-button",
      children: [
        /* @__PURE__ */ e.jsx(dd, { className: "icon-dim-16 dc__no-shrink" }),
        /* @__PURE__ */ e.jsx("span", { className: "cb-5 fs-13 fw-6 lh-20 dc__ellipsis-right", children: Ve.ADD_RELEASE_STAGE_BUTTON })
      ]
    }
  );
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space py-16 dc__gap-4", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-4", children: [
        /* @__PURE__ */ e.jsx("h2", { className: "m-0 cn-9 fs-13 fw-6 lh-20 dc__truncate", children: dp(
          t,
          a,
          o
        ) }),
        /* @__PURE__ */ e.jsx(ia, { className: "icon-dim-16 dc__no-shrink" })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "flex center dc__gap-8 dc__no-shrink", children: [
        f(),
        !c && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          m && /* @__PURE__ */ e.jsxs("div", { className: "flex center dc__gap-4", children: [
            /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-20 cn-9", children: "Release order" }),
            /* @__PURE__ */ e.jsx(
              Pn,
              {
                name: "toggle-enable-release-ordering",
                ariaLabel: "Enable release ordering toggle",
                isChecked: o,
                onChange: r,
                size: oe.small
              }
            )
          ] }),
          o && i && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            m && /* @__PURE__ */ e.jsx("div", { className: "dc__divider h-20 bcn-1" }),
            /* @__PURE__ */ e.jsx(
              re,
              {
                content: "Reset to ordering from release track",
                className: "default-tt",
                arrow: !1,
                children: /* @__PURE__ */ e.jsxs(
                  "button",
                  {
                    className: "dc__tab-focus flex dc__gap-4 py-2 dc__no-background dc__no-border dc__outline-none-imp dc__w-fit-content dc__hover-n50",
                    type: "button",
                    onClick: l,
                    "data-testid": "reset-order-to-track",
                    children: [
                      /* @__PURE__ */ e.jsx(cd, { className: "icon-dim-16 dc__no-shrink scb-5" }),
                      /* @__PURE__ */ e.jsx("span", { className: "cb-5 fs-13 fw-6 lh-20 dc__ellipsis-right", children: Ve.RESET_BUTTON })
                    ]
                  }
                )
              }
            )
          ] })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "pt-8 flexbox-col", children: s.map((g, b) => /* @__PURE__ */ e.jsx(
      hp,
      {
        releaseOrder: g,
        isLastReleaseOrder: b === s.length - 1,
        draggingApplicationName: p,
        handleSetDraggingApplicationName: h,
        handleClearDraggingApplicationName: _
      }
    )) }),
    f()
  ] });
}, gp = async ({
  resourceKind: s,
  resourceId: t
}) => {
  try {
    const n = ge({
      baseUrl: $.RESOURCE_DEPENDENCIES_OPTIONS,
      kind: s,
      version: ne.alpha1,
      ...t && {
        queryParams: {
          id: t
        }
      }
    }), { result: a } = await xe(n);
    return Sm(a?.[0]?.projectWiseAppList);
  } catch (n) {
    return U(n), [];
  }
}, xp = () => {
  const {
    selectedApplicationsMap: s,
    handleApplicationSelection: t,
    resourceId: n,
    isParentResourceReleaseTrack: a,
    parentResourceKind: l
  } = Vt(), [o, r] = K(
    () => gp(
      l === G.releaseTrack ? {
        resourceKind: l
      } : {
        resourceKind: l,
        resourceId: n
      }
    )
  ), i = wm(s, r), c = (d) => s[d.label] && d.isRequired;
  return /* @__PURE__ */ e.jsx(
    st,
    {
      inputId: "release-order-app-selector",
      isMulti: !0,
      options: r,
      value: i,
      onChange: t,
      isSearchable: !0,
      isClearable: !1,
      isLoading: o,
      placeholder: Ve.SELECT_PLACEHOLDER,
      formatOptionLabel: Rm,
      isOptionDisabled: a ? void 0 : c,
      menuListFooterConfig: a ? null : {
        type: "text",
        value: /* @__PURE__ */ e.jsxs("div", { children: [
          /* @__PURE__ */ e.jsx("p", { className: "m-0", children: "Only applications added to the release track can be included in the release." }),
          /* @__PURE__ */ e.jsxs("p", { className: "m-0", children: [
            "Applications marked with ",
            /* @__PURE__ */ e.jsx(hn, {}),
            " must be part of the release."
          ] })
        ] })
      },
      icon: /* @__PURE__ */ e.jsx(Br, {}),
      controlShouldRenderValue: !1,
      showSelectedOptionsCount: !0,
      size: oe.large
    }
  );
}, bp = () => {
  const { deleteApplicationData: s, handleCloseDeleteModal: t, handleDeleteApplication: n } = Vt(), a = () => n();
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col h-100 dc__overflow-auto pt-16 pb-16 pl-20 pr-20", children: [
    /* @__PURE__ */ e.jsx(xp, {}),
    /* @__PURE__ */ e.jsx(fp, {}),
    !!s?.applicationId && /* @__PURE__ */ e.jsx(
      Hs,
      {
        variant: Gs.delete,
        title: pp(
          s?.applicationName,
          s?.releaseOrderName
        ),
        subtitle: Ve.DELETE_DIALOG.DESCRIPTION,
        buttonConfig: {
          secondaryButtonConfig: {
            onClick: t,
            text: "Cancel"
          },
          primaryButtonConfig: {
            onClick: a,
            text: Ve.DELETE_DIALOG.PRIMARY_TEXT
          }
        },
        handleClose: t,
        children: /* @__PURE__ */ e.jsx("p", { className: "fs-13 cn-7 lh-20 m-0", children: Ve.DELETE_DIALOG.CONFIRMATION_TEXT })
      }
    )
  ] });
}, Ep = ({
  handleSuccess: s,
  handleCloseManageReleaseModal: t
}) => {
  const [n, a] = T(!1), { releaseOrdering: l, releaseOrderingFromApi: o, resourceId: r, parentResourceKind: i, isReleaseOrderActive: c } = Vt(), d = q(
    () => Eo(l, o),
    [JSON.stringify(l), JSON.stringify(o)]
  ), m = async (_) => {
    za(_);
    try {
      a(!0), await Pm(r, i, l, c), await s(), ae.showToast({
        variant: le.success,
        description: "Saved successfully"
      }), t();
    } catch (h) {
      U(h), a(!1);
    }
  }, p = mp(n, d), u = (_) => /* @__PURE__ */ e.jsx(re, { content: p, placement: "top", className: "default-tt", arrow: !1, children: /* @__PURE__ */ e.jsx("span", { children: _ }) });
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `flexbox pt-16 pb-16 pl-20 pr-20 dc__align-items-center dc__no-shrink dc__border-top ${d ? "dc__content-space" : "dc__content-end"}`,
      children: [
        d && /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-item-center dc__gap-6", children: [
          /* @__PURE__ */ e.jsx(Hr, { className: "icon-dim-20 dc__no-shrink" }),
          /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: Ve.UNSAVED_CHANGES })
        ] }),
        /* @__PURE__ */ e.jsx($e, { condition: !!p, wrap: u, children: /* @__PURE__ */ e.jsx(
          Ws,
          {
            rootClassName: "cta flex h-36",
            isLoading: n,
            onClick: m,
            disabled: !!p,
            children: Ve.SUBMIT_CTA_TEXT
          }
        ) })
      ]
    }
  );
}, Qr = ({
  handleCloseManageReleaseModal: s,
  handleSuccess: t,
  parentResourceKind: n,
  resourceName: a,
  resourceId: l,
  trackId: o
}) => {
  const r = n === G.releaseTrack, [i, c] = T([]), [d, m, p, u] = K(
    () => Promise.all([
      Wn(l, n),
      r ? null : Wn(o, G.releaseTrack)
    ])
  ), _ = m?.[0]?.releaseOrdering ?? [], h = m?.[0]?.isReleaseOrderActive ?? !0, f = m?.[1]?.releaseOrdering ?? [];
  return ee(() => {
    m?.[0] && c(_);
  }, [m]), /* @__PURE__ */ e.jsx(Ut, { className: "", onEscape: s, close: s, children: /* @__PURE__ */ e.jsx(
    up,
    {
      parentResourceKind: n,
      resourceId: l,
      resourceName: a,
      trackId: o,
      releaseOrderingFromApi: _,
      releaseOrdering: i,
      setReleaseOrdering: c,
      releaseOrderingForTrack: f,
      isReleaseOrderActive: h,
      children: /* @__PURE__ */ e.jsxs(
        "div",
        {
          className: "bg__primary dc__position-fixed dc__right-0 dc__top-0 h-100 flexbox-col dc__content-space w-600",
          onClick: lt,
          children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col h-100 dc__content-space bg__primary dc__overflow-auto", children: [
              /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__align-items-center dc__border-bottom pb-12 pt-12 pl-20 pr-20", children: [
                /* @__PURE__ */ e.jsx("h2", { className: "m-0 cn-9 fs-16 fw-6 lh-24 dc__truncate", children: Ve.getTitle(a, n) }),
                /* @__PURE__ */ e.jsx(
                  "button",
                  {
                    className: "flex dc__transparent dc__outline-none-imp dc__no-border p-0 dc__tab-focus",
                    type: "button",
                    onClick: s,
                    "aria-label": "close-release-order-modal",
                    children: /* @__PURE__ */ e.jsx(Ts, { className: "icon-dim-24 dc__no-shrink fcn-6" })
                  }
                )
              ] }),
              /* @__PURE__ */ e.jsxs(
                Ee,
                {
                  isLoading: d,
                  progressingProps: {
                    pageLoader: !0
                  },
                  error: p,
                  errorScreenManagerProps: {
                    code: p?.code,
                    reload: u
                  },
                  children: [
                    r && /* @__PURE__ */ e.jsx(
                      cs,
                      {
                        description: `Only applications defined here can be used in releases of '${a}'.`,
                        borderConfig: { top: !1, left: !1, right: !1 },
                        borderRadiusConfig: { top: !1, left: !1, right: !1, bottom: !1 }
                      }
                    ),
                    /* @__PURE__ */ e.jsx(bp, {})
                  ]
                }
              )
            ] }),
            !d && !p && /* @__PURE__ */ e.jsx(
              Ep,
              {
                handleSuccess: t,
                handleCloseManageReleaseModal: s
              }
            )
          ]
        }
      )
    }
  ) });
}, Xr = vt(null), Np = ({ value: s, children: t }) => /* @__PURE__ */ e.jsx(Xr.Provider, { value: s, children: t }), it = () => {
  const s = Ct(Xr);
  if (!s)
    throw new Error("Wrap with ReleaseTrackDetailProvider");
  return s;
}, pa = (s = 0) => `${s} ${s === 1 ? "Installation" : "Installations"}`, Zr = (s) => {
  const {
    name: t = "",
    overview: { installationId: n = "" },
    upstreamDepCount: a = 0,
    subscriptionConfig: l
  } = s || {};
  return {
    name: t,
    installationId: n,
    environmentCount: a,
    releaseChannelId: l?.identifier ?? null
  };
}, jp = (s) => {
  const { metadata: t, id: n = 0 } = s || {}, {
    envName: a,
    namespace: l,
    default: o,
    clusterName: r,
    isVirtualEnvironment: i = !1
  } = t || {};
  return {
    id: n,
    name: a,
    namespace: l,
    environmentType: o ? Ot.production : Ot.nonProduction,
    cluster: r,
    isVirtual: i
  };
}, vp = (s, t) => {
  const {
    name: n = "",
    installationId: a = "",
    dependencies: l = [],
    releaseChannelId: o = null,
    releaseChannelName: r = null
  } = s || {}, { deploymentConfig: i } = t ?? {};
  return {
    name: n,
    installationId: a,
    releaseChannelId: o,
    releaseChannelName: r,
    environments: l.map(jp),
    deploymentConfig: i ? {
      dockerRegistryId: i.dockerRegistryId ?? null,
      pushToRemote: i.pushToRemote ?? !1,
      repository: i.repository ?? "",
      tokenId: i.tokenId ?? null,
      token: i.token ?? null,
      tokenName: i.tokenName ?? "",
      hostName: i.hostName ?? "",
      dockerRegistryType: i.dockerRegistryType ?? xn.DOCKER
    } : null
  };
}, ml = (s) => {
  const { name: t = "", overview: n, childObjects: a = [], childDepCount: l = 0, catalogSchemaResourceId: o } = s || {}, { tenantId: r = "", icon: i = "", createdBy: c, createdOn: d = "", description: m = "", readme: p } = n || {}, { name: u = "" } = c || {}, { value: _ = "" } = p || {};
  return {
    name: t,
    tenantId: r,
    image: i,
    createdBy: u,
    createdOn: d && d !== Dt ? kt(d).format(hr.TWELVE_HOURS_FORMAT) : "",
    description: m,
    note: _,
    installations: a.map(Zr),
    installationsCount: l ?? 0,
    catalogSchemaResourceId: o
  };
}, Cp = ({
  releaseChannelId: s
}) => s.length ? s.map(
  (n) => `${G.releaseChannel}|identifier|${n}`
) : [], yp = (s) => s?.name && s?.installationConfig?.name ? `${s.name} (${s.installationConfig.name})` : "-", Tp = (s) => s.tenantId && s.installationConfig.installationId ? `${s.tenantId}/${s.installationConfig.installationId}` : "", ks = (s) => {
  const t = {
    isReleaseTriggered: s?.isReleaseTriggered ?? !1,
    tenantId: s?.tenantId ?? "",
    name: s?.tenantName ?? "",
    image: s?.tenantIcon ?? "",
    installationConfig: {
      installationId: s?.installationId ?? "",
      name: s?.installationName ?? "",
      releaseChannelId: s?.releaseChannelId ?? null,
      releaseChannelName: s?.releaseChannelName ?? null,
      installationIdentifier: s?.installationIdentifier ?? ""
    }
  };
  return {
    ...t,
    displayText: yp(t),
    identifier: Tp(t)
  };
}, qt = (s) => ks({
  installationId: `installation-id-${s}`,
  installationName: `installation-${s}`,
  tenantIcon: "",
  tenantId: `tenant-id-${s}`,
  tenantName: `tenant-${s}`,
  releaseChannelId: null,
  releaseChannelName: null
}), Sp = (s) => {
  const { id: t, identifier: n, data: a, mappingConfig: l } = s || {}, {
    clusterName: o = "",
    namespace: r = "",
    default: i = !1,
    isVirtualEnvironment: c = !1
  } = a || {}, d = ks(l);
  return {
    id: t,
    name: n,
    namespace: r,
    environmentType: i ? Ot.production : Ot.nonProduction,
    cluster: o,
    tenantConfig: d,
    isVirtual: c
  };
}, wp = (s) => {
  let t = 0;
  return Object.values(s).reduce(
    (n, a) => n.concat(
      Object.keys(a).map((l) => ({
        identifier: l,
        // eslint-disable-next-line no-plusplus
        index: t++,
        typeOfDependency: oi.UPSTREAM,
        resourceKind: G.environment,
        resourceVersion: ne.v1
      }))
    ),
    []
  );
}, Yt = ({
  tenantId: s,
  installationId: t
}) => `${s}-${t}`;
var Is = /* @__PURE__ */ ((s) => (s.isolated = "isolated", s.nonIsolated = "nonIsolated", s.empty = "empty", s))(Is || {}), as = /* @__PURE__ */ ((s) => (s.environment = "environment", s.namespace = "namespace", s.environmentType = "environmentType", s.tenantInstallation = "tenantInstallation", s))(as || {});
const Rp = Array.from(Array(3).keys()).map((s) => ({
  id: s,
  name: `env-${s}`,
  namespace: `namespace-${s}`,
  environmentType: Ot.nonProduction,
  cluster: `cluster-${s}`,
  tenantConfig: qt(s),
  isVirtual: !1
})), eo = ({ tenantConfig: s }, t) => s?.name === t.tenantName && s?.installationConfig?.name === t.installationName || !(s?.name && s?.installationConfig?.name), so = (s) => Object.keys(s ?? {}).filter(Boolean).length, ul = (s) => s?.some(({ isVirtual: t }) => t) || !1, to = (s) => Object.values(s).reduce((t, n) => {
  const a = Object.values(n);
  return a.length ? ul(a) ? Is.isolated : Is.nonIsolated : t;
}, Is.empty), Ip = (s, t) => {
  const n = to(s), a = Object.values(
    t
  ).reduce((l, { isVirtual: o }) => o ? Is.isolated : Is.nonIsolated, Is.empty);
  return !(n === a || n === Is.empty || a === Is.empty);
};
var A = /* @__PURE__ */ ((s) => (s.PRE_POST_INITIATED = "Starting", s.PRE_POST_RUNNING = "Running", s.DEPLOY_INITIATED = "Initiating", s.PROGRESSING = "Progressing", s.QUEUED = "Queued", s.ABORTED = "Aborted", s.TIMED_OUT = "TimedOut", s.DEGRADED = "Degraded", s.ERROR = "Error", s.CANCELLED = "CANCELLED", s.FAILED = "Failed", s.SUCCEEDED = "Succeeded", s.HEALTHY = "Healthy", s.NOT_TRIGGERED = "Not Triggered", s.UNABLE_TO_FETCH = "UnableToFetch", s.MISSING = "Missing", s.WAITING_TO_START = "WaitingToStart", s.UNKNOWN = "Unknown", s))(A || {}), z = /* @__PURE__ */ ((s) => (s.yetToTrigger = "yetToTrigger", s.onGoing = "onGoing", s.failed = "failed", s.completed = "completed", s))(z || {}), ma = /* @__PURE__ */ ((s) => (s.IMAGE_TAG = "artifactTag", s.IMAGE_LABEL = "imageTag", s.RELEASE = "release", s))(ma || {}), pe = /* @__PURE__ */ ((s) => (s.RELEASE_TRACK = "release-track", s.RELEASE = "release", s.CD_PIPELINE = "cd-pipeline", s))(pe || {}), _l = /* @__PURE__ */ ((s) => (s.ALPHA_1 = "alpha1", s.V1 = "v1", s))(_l || {}), ue = /* @__PURE__ */ ((s) => (s.PARTIALLY_RELEASED = "partiallyReleased", s.COMPLETELY_RELEASED = "completelyReleased", s.CORRUPTED = "corrupted", s))(ue || {}), H = /* @__PURE__ */ ((s) => (s.DRAFT = "draft", s.READY_FOR_RELEASE = "readyForRelease", s.HOLD = "hold", s.RESCINDED = "rescind", s))(H || {}), At = /* @__PURE__ */ ((s) => (s.RELEASE_STAGE = "level", s.APPLICATION = "upstream", s))(At || {}), no = /* @__PURE__ */ ((s) => (s.ENVIRONMENTS = "environments", s))(no || {}), ao = /* @__PURE__ */ ((s) => (s.ARTIFACT = "artifact", s))(ao || {}), yn = /* @__PURE__ */ ((s) => (s.bundled = "bundled", s.nonBundled = "non-bundled", s))(yn || {}), ve = /* @__PURE__ */ ((s) => (s.processed = "200", s.processedAndPushed = "201", s.notProcessed = "11001", s.notExecuted = "11002", s))(ve || {});
const Ca = {
  DEPLOY: "Deployment stage",
  PRE_DEPLOY: "Pre deployment stage",
  POST_DEPLOY: "Post deployment stage "
}, Pe = {
  IN_PROGRESS: "In progress",
  QUEUED: "Queued",
  FAILED: "Failed",
  ABORTED: "Aborted",
  TIMED_OUT: "Timeout",
  DEGRADED: "Degraded",
  ERROR: "Error",
  SUCCEEDED: "Success",
  HEALTHY: "Healthy",
  UNABLE_TO_FETCH: "Unable to fetch",
  NOT_TRIGGERED: "Not triggered",
  MISSING: "Missing",
  UNKNOWN: "Unknown",
  WAITING_TO_START: "Waiting to start"
}, Zs = {
  [A.DEPLOY_INITIATED]: Pe.IN_PROGRESS,
  [A.PRE_POST_INITIATED]: Pe.IN_PROGRESS,
  [A.PRE_POST_RUNNING]: Pe.IN_PROGRESS,
  [A.PROGRESSING]: Pe.IN_PROGRESS,
  [A.QUEUED]: Pe.QUEUED,
  [A.FAILED]: Pe.FAILED,
  [A.TIMED_OUT]: Pe.TIMED_OUT,
  [A.DEGRADED]: Pe.DEGRADED,
  [A.ERROR]: Pe.ERROR,
  [A.CANCELLED]: Pe.ABORTED,
  [A.ABORTED]: Pe.ABORTED,
  [A.SUCCEEDED]: Pe.SUCCEEDED,
  [A.HEALTHY]: Pe.HEALTHY,
  [A.NOT_TRIGGERED]: Pe.NOT_TRIGGERED,
  [A.UNABLE_TO_FETCH]: Pe.UNABLE_TO_FETCH,
  [A.MISSING]: Pe.MISSING,
  [A.UNKNOWN]: Pe.UNKNOWN,
  [A.WAITING_TO_START]: Pe.WAITING_TO_START
}, Qe = "allInstallation", hl = {
  [Qe]: 0,
  [z.yetToTrigger]: 0,
  [z.onGoing]: 0,
  [z.failed]: 0,
  [z.completed]: 0
}, Ap = Array.from(Array(3).keys()).map((s) => ({
  tenantConfig: qt(s),
  tenantInstallationRolloutStatus: z.onGoing,
  apps: [],
  rolloutStatusSummary: { ...hl },
  isTenantInstallationIsolated: !1
}));
var Gn = /* @__PURE__ */ ((s) => (s.tenantInstallation = "tenantInstallation", s))(Gn || {});
const ua = {
  [Qe]: "All Tenants",
  [z.yetToTrigger]: "Yet to trigger",
  [z.onGoing]: "Ongoing",
  [z.failed]: "Failed (Any stage)",
  [z.completed]: "Completed"
}, Lp = [
  {
    value: Qe,
    tippyContent: "Rollout status for all tenant (installations)",
    icon: /* @__PURE__ */ e.jsx(Fr, { className: "w-100 h-100" })
  },
  {
    value: z.yetToTrigger,
    tippyContent: "Tenant (Installations) for which no rollouts are triggered",
    icon: /* @__PURE__ */ e.jsx(Wc, { className: "w-100 h-100" })
  },
  {
    value: z.onGoing,
    tippyContent: "Tenant (Installations) for which rollouts are ongoing and no deployment stage has failed",
    icon: /* @__PURE__ */ e.jsx(Ur, { className: "w-100 h-100 ic-in-progress-orange" })
  },
  {
    value: z.failed,
    tippyContent: "Tenant (Installations) for which any deployment stage is failed",
    icon: /* @__PURE__ */ e.jsx(ll, { className: "w-100 h-100" })
  },
  {
    value: z.completed,
    tippyContent: "Tenant (Installations) for which all rollouts have completed successfully",
    icon: /* @__PURE__ */ e.jsx(un, { className: "w-100 h-100" })
  }
], kp = {
  [Qe]: {
    countBackgroundClass: "bg__primary dc__border-n1 h-20",
    iconClass: "dc__hide-section"
  },
  [z.yetToTrigger]: {
    countBackgroundClass: "bg__secondary",
    iconClass: "bcn-3"
  },
  [z.onGoing]: {
    countBackgroundClass: "bco-50",
    iconClass: "bco-5"
  },
  [z.failed]: {
    countBackgroundClass: "bcr-50",
    iconClass: "bcr-5"
  },
  [z.completed]: {
    countBackgroundClass: "bcg-50",
    iconClass: "bcg-5"
  }
}, Dp = [
  z.yetToTrigger,
  z.onGoing,
  z.failed,
  z.completed
], Op = [
  Qe,
  z.yetToTrigger,
  z.onGoing,
  z.failed,
  z.completed
];
var me = /* @__PURE__ */ ((s) => (s.notTriggered = "Not Triggered", s.failed = "Failed", s.inProgress = "Progressing", s.succeeded = "Succeeded", s.queued = "Queued", s.others = "Others", s))(me || {});
const _t = {
  "Not Triggered": Zs[A.NOT_TRIGGERED],
  Failed: Zs[A.FAILED],
  Progressing: Zs[A.PROGRESSING],
  Succeeded: Zs[A.SUCCEEDED],
  Queued: Zs[A.QUEUED],
  Others: "Others"
}, ya = [
  {
    label: _t[
      "Not Triggered"
      /* notTriggered */
    ],
    value: "Not Triggered"
    /* notTriggered */
  },
  {
    label: _t.Failed,
    value: "Failed"
    /* failed */
  },
  {
    label: _t.Progressing,
    value: "Progressing"
    /* inProgress */
  },
  {
    label: _t.Succeeded,
    value: "Succeeded"
    /* succeeded */
  }
], Mp = [
  {
    stageType: be.PRE,
    options: [...ya]
  },
  {
    stageType: be.DEPLOY,
    options: [
      ...ya,
      {
        label: _t.Queued,
        value: "Queued",
        hideIfCountZero: !0
      },
      {
        label: _t.Others,
        value: "Others",
        hideIfCountZero: !0
      }
    ]
  },
  {
    stageType: be.POST,
    options: [...ya]
  }
], Pt = (s) => `${s.appId}-${s.envId}`, lo = (s, t) => ({
  appId: s.appId,
  pipelineId: s.pipelineId,
  envId: s.envId,
  existingStages: s.existingStages,
  levelIndex: t
}), fl = (s) => {
  if (!s?.length)
    return {};
  const t = {};
  return s.forEach((n) => {
    n.applications.forEach((a) => {
      t[a.name] = JSON.parse(JSON.stringify(a));
    });
  }), t;
};
var pn = /* @__PURE__ */ ((s) => (s.deleted = "deleted", s.added = "added", s.removed = "removed", s))(pn || {});
const Pp = {
  added: /* @__PURE__ */ e.jsx(Vc, { className: "w-100 h-100" }),
  removed: /* @__PURE__ */ e.jsx(ql, { className: "w-100 h-100" }),
  deleted: /* @__PURE__ */ e.jsx(ql, { className: "w-100 h-100" })
}, Fp = {
  value: "",
  updatedOn: "",
  updatedBy: {
    id: 0,
    icon: !1,
    name: ""
  }
}, Kl = fr(), Up = {
  ...Kl,
  control: (s, t) => ({
    ...Kl.control(s, t),
    width: "100%",
    height: 36,
    minHeight: 36
  })
}, $p = "Please select a release track", Bp = "Please select a release track from the available options", Jl = "Release created successfully", Hp = "Release updated successfully", gl = "add", wt = { value: "", error: "" }, xl = "Saved Changes", ro = [
  Ce.CanTrigger,
  Ce.CanTriggerInDeploymentWindow,
  Ce.ExceptionUser
], oo = {
  SDH_SWITCH_RELEASE_ITEM_CLICKED: "SDH_SWITCH_RELEASE_ITEM_CLICKED",
  SDH_SWITCH_TENANTS_ITEM_CLICKED: "SDH_SWITCH_TENANTS_ITEM_CLICKED"
}, Ne = ({
  baseUrl: s,
  kind: t,
  version: n = _l.ALPHA_1,
  payload: a
}) => Qn(`${s}/${t}/${n}`, a), Gp = (s) => !s || s.areAllTargeted ? {
  areAllInstallationsTargeted: !0
} : {
  installations: (s.installations || []).map(({ identifier: t }) => ({
    identifier: t || ""
  }))
}, io = (s) => {
  if (!s)
    return null;
  const { id: t, name: n, overview: a, configStatus: l, parentConfig: o, depStatus: r, catalogSchemaResourceId: i } = s, {
    description: c = "",
    createdBy: d = {
      name: ""
    },
    createdOn: m = "",
    note: p,
    releaseVersion: u = "",
    tags: _ = {},
    firstReleasedOn: h = ""
  } = a || {}, f = Object.keys(_).map((g) => ({
    label: g,
    value: _[g].value
  })).sort((g, b) => te(g.label, b.label));
  return {
    id: t,
    name: n,
    status: l?.status || H.DRAFT,
    isLocked: l?.isLocked || !1,
    description: c,
    note: {
      value: p?.value ?? "",
      updatedBy: {
        icon: p?.updatedBy?.icon ?? !1,
        id: p?.updatedBy?.id ?? 0,
        name: p?.updatedBy?.name ?? ""
      },
      updatedOn: p?.updatedOn ?? ""
    },
    trackId: o?.id,
    track: o?.identifier ?? "",
    version: u,
    createdBy: d.name,
    createdOn: m && m !== Dt ? kt(m).format(Bn.TWELVE_HOURS_FORMAT) : "",
    tags: f,
    firstReleasedOn: h && h !== Dt ? kt(h).format(Bn.DATE_FORMAT) : "",
    areAllImagesSelected: r?.areAllImagesSelected || !1,
    areDepPresent: r?.areDepPresent || !1,
    installationsMappedToRelease: Gp(s.target),
    catalogSchemaResourceId: i
  };
}, co = (s) => s?.map(io) ?? [], bl = (s) => {
  if (!s)
    return null;
  const { id: t, name: n, overview: a, childObjects: l } = s, {
    description: o = "",
    createdBy: r = {
      name: ""
    },
    createdOn: i = ""
  } = a || {};
  return {
    id: t,
    name: n,
    description: o,
    releases: co(l),
    createdBy: r.name,
    createdOn: i && i !== Dt ? kt(i).format(Bn.TWELVE_HOURS_FORMAT) : ""
  };
}, Wp = (s) => s?.map(bl) ?? [], nt = (s, t) => {
  const n = s === 0;
  return t && !n ? {
    title: "Release Last",
    icon: /* @__PURE__ */ e.jsx(Gc, { className: "icon-dim-16 dc__no-shrink" })
  } : {
    title: `Release ${ii(s + 1)}`,
    icon: n ? /* @__PURE__ */ e.jsx(Pr, { className: "icon-dim-16 dc__no-shrink" }) : /* @__PURE__ */ e.jsx(Hc, { className: "icon-dim-16 dc__no-shrink" })
  };
}, zt = (s) => ({
  resourceKind: G.devtronApplication,
  resourceVersion: ne.v1,
  identifier: s
}), po = (s) => s ? s.sort((t, n) => te(t.name, n.name)).map(({ mappingConfig: t, ...n }) => ({
  ...n,
  tenantConfig: ks(t)
})) : [], mo = (s) => {
  const t = s?.commitSource?.map((l) => ({
    hash: l.revision ?? "",
    shortHash: l.revision?.substring(0, 7),
    message: l.message ?? ""
  })) ?? [], n = s?.image ?? "", a = {
    artifactId: s?.artifactId,
    image: n,
    imagePath: gr(n),
    registryType: s?.registryType || xn.OTHER,
    sourceMessage: t[0]?.message ?? ""
  };
  return {
    commitDetails: t,
    imageDetails: a
  };
}, Vp = ({
  identifier: s,
  config: t,
  deleted: n
}) => {
  const { commitDetails: a, imageDetails: l } = mo(t?.artifactConfig);
  return {
    isDeleted: n ?? !1,
    name: s ?? "-",
    commitDetails: a,
    imageDetails: l,
    releaseInstructions: t?.releaseInstruction ?? ""
  };
}, qp = (s) => {
  const t = s.flatMap(
    ({ childObjects: r }) => po(
      r?.find(
        (i) => i.type === no.ENVIRONMENTS
      )?.data
    )
  ), n = t.filter(({ tenantConfig: r }) => !r.identifier).map(({ name: r }) => r).sort(te), {
    releaseChannelToTenantInstallationMap: a,
    tenantInstallationsNotSubscribedToReleaseChannel: l,
    tenantInstallationDetailsMap: o
  } = t.reduce(
    (r, { tenantConfig: i, name: c }) => {
      const { releaseChannelId: d, installationIdentifier: m, releaseChannelName: p } = i.installationConfig || {};
      return m && (d ? r.releaseChannelToTenantInstallationMap[d] ? r.releaseChannelToTenantInstallationMap[d].tenantDetails.add(m) : r.releaseChannelToTenantInstallationMap[d] = {
        releaseChannelName: p,
        tenantDetails: /* @__PURE__ */ new Set([m])
      } : r.tenantInstallationsNotSubscribedToReleaseChannel.add(m), r.tenantInstallationDetailsMap[m] ? r.tenantInstallationDetailsMap[m].environments.add(c) : r.tenantInstallationDetailsMap[m] = {
        environments: /* @__PURE__ */ new Set([c]),
        tenantInstallationConfig: i
      }), r;
    },
    {
      releaseChannelToTenantInstallationMap: {},
      tenantInstallationsNotSubscribedToReleaseChannel: /* @__PURE__ */ new Set(),
      tenantInstallationDetailsMap: {}
    }
  );
  return {
    unmappedEnvironments: [...new Set(n)],
    releaseChannelToTenantInstallationMap: a,
    tenantInstallationsNotSubscribedToReleaseChannel: l,
    tenantInstallationDetailsMap: o
  };
}, uo = (s) => {
  if (!s)
    return {
      applicationsByStages: [],
      environments: [],
      tenantsWithInstallations: [],
      unmappedEnvironments: [],
      releaseChannels: []
    };
  const t = s.sort((i, c) => Us(i.level, c.level)), n = t.length, a = t.flatMap((i) => i.dependencies ?? []).sort((i, c) => te(i.envName, c.envName)).map(({ mappingConfig: i, ...c }) => ({
    ...c,
    tenantConfig: ks(i)
  })), l = a.map(({ tenantConfig: i }) => structuredClone(i)).filter(({ identifier: i }) => !!i), o = {}, r = {};
  return {
    applicationsByStages: t.map((i, c) => ({
      ...nt(c, c === n - 1),
      id: i.level,
      applications: [...new Set(i?.dependencies?.map(({ appName: d }) => d) ?? [])]
    })).filter((i) => i.applications.length > 0),
    environments: [...new Set(a.map(({ envName: i }) => i))],
    tenantsWithInstallations: l.filter(({ identifier: i }) => o[i] ? !1 : (o[i] = !0, !0)),
    unmappedEnvironments: [
      ...new Set(
        a.filter(({ tenantConfig: { identifier: i } }) => !i).map(({ envName: i }) => i)
      )
    ],
    releaseChannels: a.map(({ tenantConfig: i }) => ({
      name: i.installationConfig.releaseChannelName,
      channelId: i.installationConfig.releaseChannelId
    })).filter(({ channelId: i }) => i && !r[i] ? (r[i] = !0, !0) : !1)
  };
}, El = (s) => {
  if (!s)
    return {
      deploymentsCount: {
        totalCount: 0,
        filteredCount: 0
      },
      tenantsCount: {
        totalCount: 0,
        filteredCount: 0
      },
      rolloutStatus: {
        ...hl,
        [Qe]: 0
      },
      filterDeploymentStatus: {
        [be.PRE]: {
          [me.notTriggered]: 0,
          [me.failed]: 0,
          [me.inProgress]: 0,
          [me.succeeded]: 0,
          [me.queued]: 0,
          [me.others]: 0
        },
        [be.DEPLOY]: {
          [me.notTriggered]: 0,
          [me.failed]: 0,
          [me.inProgress]: 0,
          [me.succeeded]: 0,
          [me.queued]: 0,
          [me.others]: 0
        },
        [be.POST]: {
          [me.notTriggered]: 0,
          [me.failed]: 0,
          [me.inProgress]: 0,
          [me.succeeded]: 0,
          [me.queued]: 0,
          [me.others]: 0
        }
      }
    };
  const {
    installationDeploymentRolloutStatus: t = {},
    stageWiseDeploymentStatus: n = {},
    mappingConfigCount: a = {},
    deploymentsCount: l = {}
  } = s ?? {
    mappingConfigCount: {},
    deploymentsCount: {},
    installationDeploymentRolloutStatus: {},
    stageWiseDeploymentStatus: {}
  }, o = Object.keys(be).reduce(
    (r, i) => {
      const c = n[i.toLowerCase()];
      return r[i] = {
        [me.notTriggered]: c[me.notTriggered] ?? 0,
        [me.failed]: c[me.failed] ?? 0,
        [me.inProgress]: c[me.inProgress] ?? 0,
        [me.succeeded]: c[me.succeeded] ?? 0,
        [me.queued]: c[me.queued] ?? 0,
        [me.others]: c[me.others] ?? 0
      }, r;
    },
    {}
  );
  return {
    tenantsCount: {
      totalCount: a.totalCount ?? 0,
      filteredCount: a.filteredCount ?? 0
    },
    deploymentsCount: {
      totalCount: l.totalCount ?? 0,
      filteredCount: l.filteredCount ?? 0
    },
    rolloutStatus: {
      [Qe]: t[Qe] ?? 0,
      [z.yetToTrigger]: t[z.yetToTrigger] ?? 0,
      [z.failed]: t[z.failed] ?? 0,
      [z.onGoing]: t[z.onGoing] ?? 0,
      [z.completed]: t[z.completed] ?? 0
    },
    filterDeploymentStatus: o
  };
}, Nl = (s) => ({
  appId: s.appId,
  appName: s.appName,
  envId: s.envId,
  envName: s.envName,
  pipelineId: s.pipelineId,
  deployStatus: s.deployStatus || A.NOT_TRIGGERED,
  preStatus: s.preStatus || A.NOT_TRIGGERED,
  postStatus: s.postStatus || A.NOT_TRIGGERED,
  existingStages: {
    pre: s.existingStages?.pre || !1,
    deploy: s.existingStages?.deploy || !0,
    post: s.existingStages?.post || !1
  },
  isDeployable: s.taskRunAllowed || !1,
  tenantConfig: ks(s.mappingConfig),
  preCdWorkflowRunnerId: s.preCdWorkflowRunnerId || 0,
  cdWorkflowRunnerId: s.cdWorkflowRunnerId || 0,
  postCdWorkflowRunnerId: s.postCdWorkflowRunnerId || 0,
  isVirtualEnvironment: s.isVirtualEnvironment || !1
}), Yp = (s, t) => {
  const n = s?.sort((o, r) => Us(o.level, r.level)) ?? [], a = n.length;
  return {
    countSummary: El(t),
    releaseStageList: n.map((o, r) => ({
      ...nt(r, r === a - 1),
      id: o.level,
      applications: (o.dependencies ?? []).map((i) => Nl(i))
    }))
  };
}, zp = (s) => s?.map(Nl) ?? [], _o = (s) => {
  switch (s) {
    case Ce.CanTriggerInDeploymentWindow:
    case Ce.CanTrigger:
    case Ce.ExceptionUser:
      return {
        code: s,
        icon: /* @__PURE__ */ e.jsx(al, { className: "w-100 h-100 scg-7" }),
        text: /* @__PURE__ */ e.jsx("span", { className: "cg-7 fw-6", children: "Can trigger" }),
        statusCode: Ce.CanTrigger,
        sortPriority: 3
      };
    case Ce.NotAuthorized:
      return {
        code: s,
        icon: /* @__PURE__ */ e.jsx(rl, { className: "w-100 h-100 scy-7" }),
        text: /* @__PURE__ */ e.jsx("span", { className: "cy-7 fw-6", children: "Not authorized" }),
        statusCode: Ce.NotAuthorized,
        sortPriority: 2
      };
    default:
      return {
        code: s ?? Ce.CannotTrigger,
        icon: /* @__PURE__ */ e.jsx(ys, { className: "w-100 h-100 fcr-7" }),
        text: /* @__PURE__ */ e.jsx("span", { className: "cr-7 fw-6", children: "Cannot trigger" }),
        statusCode: Ce.CannotTrigger,
        sortPriority: 1
      };
  }
}, ho = (s = []) => s?.map((t) => ({
  appId: t.appId,
  appName: t.appName,
  envId: t.envId,
  envName: t.envName,
  feasibility: _o(t.feasibility?.code),
  message: t.feasibility?.userMessage ?? "",
  tenantConfig: ks(t.mappingConfig)
})) ?? [], Kp = (s) => {
  const t = s.reduce(
    (a, { feasibility: l }) => (a[l.statusCode] += 1, a),
    {
      [Ce.NotAuthorized]: 0,
      [Ce.CannotTrigger]: 0,
      [Ce.CanTrigger]: 0
    }
  ), n = t[Ce.NotAuthorized] + t[Ce.CannotTrigger];
  return n > 0 ? {
    statusCode: Ce.CannotTrigger,
    sortPriority: 1,
    icon: /* @__PURE__ */ e.jsx(ys, { className: "w-100 h-100 fcr-7" }),
    text: /* @__PURE__ */ e.jsx("span", { className: "cr-7 fw-6", children: "Cannot trigger" }),
    message: `${n} out ${s.length} pipelines cannot be triggered`
  } : {
    statusCode: Ce.CanTrigger,
    sortPriority: 2,
    icon: /* @__PURE__ */ e.jsx(al, { className: "w-100 h-100 scg-7" }),
    text: /* @__PURE__ */ e.jsx("span", { className: "cg-7 fw-6", children: "Can trigger" })
  };
}, Jp = (s) => {
  const n = ho(s).reduce((a, { tenantConfig: l, ...o }) => (a[l.identifier] || (a[l.identifier] = {
    tenantConfig: l,
    feasibilityList: []
  }), a[l.identifier].feasibilityList.push(o), a), {});
  return Object.values(n).map((a) => ({
    ...a,
    tenantFeasibility: Kp(a.feasibilityList),
    // Filter the non-feasible pipelines
    feasibilityList: a.feasibilityList.filter(
      (l) => !ro.includes(l.feasibility.code)
    )
  }));
}, $a = (s, t) => {
  const n = s?.code, a = s?.userMessage;
  switch (n) {
    case ve.processed:
      return {
        code: n,
        icon: /* @__PURE__ */ e.jsx(un, { className: "w-100 h-100" }),
        text: /* @__PURE__ */ e.jsx("span", { className: "cg-7 fw-6", children: t ? "Succeeded" : "Initiated" }),
        sortPriority: t ? 5 : 6,
        message: a
      };
    case ve.processedAndPushed:
      return {
        code: n,
        icon: /* @__PURE__ */ e.jsx(un, { className: "w-100 h-100" }),
        text: /* @__PURE__ */ e.jsx("span", { className: "cg-7 fw-6", children: "Generated & pushed to OCI" }),
        sortPriority: t ? 7 : 8,
        message: a
      };
    case ve.notExecuted:
      return {
        code: n,
        icon: /* @__PURE__ */ e.jsx(ys, { className: "w-100 h-100 fcn-6" }),
        text: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fw-6", children: "Not executed" }),
        sortPriority: t ? 4 : 3,
        message: a
      };
    default:
      return {
        code: n ?? ve.notProcessed,
        icon: /* @__PURE__ */ e.jsx(ll, { className: "w-100 h-100" }),
        text: /* @__PURE__ */ e.jsx("span", { className: "cr-7 fw-6", children: t ? "Failed" : "Not triggered" }),
        sortPriority: t ? 2 : 1,
        message: a
      };
  }
}, Qp = (s, t) => {
  const n = s.reduce(
    (l, { triggerStatus: o }) => (l[o.code] += 1, l),
    {
      [ve.processed]: 0,
      [ve.processedAndPushed]: 0,
      [ve.notProcessed]: 0,
      [ve.notExecuted]: 0
    }
  ), a = n[ve.notProcessed] + n[ve.notExecuted] + // Include the release orchestration manifest to the not process item count
  ([ve.notExecuted, ve.notProcessed].includes(
    t.code
  ) ? 1 : 0);
  return a > 0 ? {
    code: ve.notProcessed,
    icon: /* @__PURE__ */ e.jsx(ll, { className: "w-100 h-100" }),
    text: /* @__PURE__ */ e.jsx("span", { className: "cr-7 fw-6", children: "Failed" }),
    sortPriority: 1,
    // +1 denotes release orchestration manifest
    message: `${a} out of ${s.length + 1} failed`
  } : {
    code: ve.processed,
    sortPriority: 2,
    icon: /* @__PURE__ */ e.jsx(un, { className: "w-100 h-100" }),
    text: /* @__PURE__ */ e.jsx("span", { className: "cg-7 fw-6", children: n[ve.processedAndPushed] > 0 ? "Generated & pushed to OCI" : "Generated" }),
    message: ""
  };
}, fo = (s = []) => s?.map((t) => {
  const n = t.isVirtualEnv || !1, a = n ? {
    isVirtualEnv: n,
    helmPackageName: t.helmPackageName
  } : {};
  return {
    appId: t.appId,
    appName: t.appName,
    envId: t.envId,
    envName: t.envName,
    triggerStatus: $a(t.triggerStatus, n),
    tenantConfig: ks(t.mappingConfig),
    romStatus: $a(t.romStatus, n),
    stage: t.cdWorkflowType ?? be.DEPLOY,
    ...a
  };
}) ?? [], Xp = (s) => {
  const n = fo(s).reduce((a, { tenantConfig: l, romStatus: o, ...r }) => (a[l.identifier] || (a[l.identifier] = {
    tenantConfig: l,
    deploymentList: [],
    romStatus: o ?? {
      code: ve.notExecuted,
      icon: /* @__PURE__ */ e.jsx(ys, { className: "w-100 h-100 fcn-6" }),
      text: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fw-6", children: "Not executed" }),
      message: ""
    }
  }), a[l.identifier].deploymentList.push(r), a), {});
  return Object.values(n).map((a) => ({
    ...a,
    tenantTriggerStatus: Qp(a.deploymentList, a.romStatus)
  }));
}, go = (s, t) => Object.values(s ?? {}).flatMap(
  (n) => Object.values(n).map(({ appId: a, pipelineId: l, levelIndex: o }) => ({
    appId: a,
    pipelineId: l,
    deploymentWithConfig: di.LAST_SAVED_CONFIG,
    cdWorkflowType: t,
    levelIndex: o
  }))
), Zp = (s) => s?.length ? s.map((t) => {
  const { ciPipeline: n, cdPipelines: a } = t;
  return {
    id: t.id,
    workflowName: t.workflowName || "",
    pipelineType: n?.pipelineType || Ns.CI,
    pipelineName: n?.name || "",
    sourceInfo: n?.ciMaterial?.map((l) => ({
      ciMaterialId: l?.id || 0,
      repositoryName: l?.gitMaterialName || "",
      sourceValue: l?.source?.value || "",
      sourceType: l?.source?.type || Oa.BranchFixed
    })) ?? [],
    environments: a?.map((l) => ({
      environmentName: l?.environmentName ?? "",
      environmentId: l?.environmentId
    }))?.sort((l, o) => te(l.environmentName, o.environmentName)) ?? []
  };
}) : [], xo = (s, t, n) => {
  const a = !!s?.sourceReleaseConfiguration?.releaseVersion;
  return n === s?.artifactId ? a ? s.sourceReleaseConfiguration.releaseVersion !== t?.releaseVersion : !!t?.releaseVersion : !0;
}, bo = ({
  artifactId: s,
  registryName: t,
  registryType: n,
  artifactSourceAppWorkflowId: a,
  sourceReleaseConfiguration: l,
  appName: o
}) => ({
  dependencyInfo: zt(o),
  query: [
    {
      op: he.replace,
      path: "image",
      value: {
        artifactId: s,
        registryName: t,
        registryType: n,
        artifactSourceAppWorkflowId: a,
        ...l ? { sourceReleaseConfiguration: l } : {}
      }
    }
  ]
}), em = (s, t, n) => {
  const a = fl(t), l = Object.keys(n);
  return {
    id: s,
    dependencyPatch: l.reduce(
      (o, r) => {
        const {
          selectedImage: i,
          artifactId: c,
          registryName: d,
          registryType: m,
          sourceReleaseConfiguration: p,
          artifactSourceAppWorkflowId: u
        } = n[r];
        return xo(a[r], p, c) ? i ? (o.push(
          bo({
            artifactId: c,
            registryName: d,
            registryType: m,
            sourceReleaseConfiguration: p,
            artifactSourceAppWorkflowId: u,
            appName: r
          })
        ), o) : (o.push({
          dependencyInfo: zt(r),
          query: [
            {
              op: he.remove,
              path: "image"
            }
          ]
        }), o) : o;
      },
      []
    )
  };
}, sm = (s, t) => s.reduce(
  (n, a) => {
    const { applicationsToArtifactsMap: l, appNameToIdMap: o } = n;
    return l[a.identifier] = ci(
      a.data,
      null,
      t,
      null,
      !0
    ), o[a.identifier] = a.id, {
      applicationsToArtifactsMap: l,
      appNameToIdMap: o
    };
  },
  { applicationsToArtifactsMap: {}, appNameToIdMap: {} }
), tm = (s) => {
  const t = [...new Set(s.map((n) => n.rolloutStatus))];
  return t.includes(z.failed) ? z.failed : t.length === 1 ? t[0] : z.onGoing;
}, nm = (s, t) => {
  const n = s?.map(
    ({ installationDeploymentRolloutStatus: r, ...i }) => ({
      ...Nl(i),
      installationDeploymentRolloutStatus: r ?? z.yetToTrigger
    })
  ) ?? [], l = Object.values(
    n.reduce(
      (r, {
        tenantConfig: i,
        envId: c,
        envName: d,
        appId: m,
        appName: p,
        preStatus: u,
        deployStatus: _,
        postStatus: h,
        existingStages: f,
        installationDeploymentRolloutStatus: g,
        cdWorkflowRunnerId: b,
        preCdWorkflowRunnerId: j,
        postCdWorkflowRunnerId: E,
        pipelineId: v,
        isVirtualEnvironment: x
      }) => (r[i.identifier] || (r[i.identifier] = {
        tenantConfig: i,
        apps: []
      }), r[i.identifier].apps.push({
        envId: c,
        envName: d,
        appId: m,
        appName: p,
        deployStatus: _,
        preStatus: u,
        postStatus: h,
        existingStages: f,
        rolloutStatus: g,
        cdWorkflowRunnerId: b,
        preCdWorkflowRunnerId: j,
        postCdWorkflowRunnerId: E,
        pipelineId: v,
        isVirtualEnvironment: x
      }), r),
      {}
    )
  ).map(({ apps: r, ...i }) => {
    const c = r.sort((d, m) => te(d.appName, m.appName));
    return {
      ...i,
      tenantInstallationRolloutStatus: tm(c),
      apps: c,
      isTenantInstallationIsolated: ul(
        r.map(({ isVirtualEnvironment: d }) => ({
          isVirtual: d
        }))
      ),
      rolloutStatusSummary: r.reduce(
        (d, m) => (d[m.rolloutStatus] += 1, d),
        { ...hl }
      )
    };
  });
  return {
    countSummary: El(t),
    rolloutStatusList: l
  };
}, jl = ({
  rolloutStatus: s = Qe,
  preStage: t = [],
  deployStage: n = [],
  postStage: a = [],
  env: l = [],
  app: o = [],
  tenantInstallation: r = [],
  releaseChannelId: i = []
}) => {
  const c = [];
  if (s && s !== Qe && c.push(`installationDeploymentRolloutStatus|${s}`), t.length && c.push(`stageWiseDeploymentStatus|${be.PRE}|${t}`), n.length && c.push(`stageWiseDeploymentStatus|${be.DEPLOY}|${n}`), a.length && c.push(`stageWiseDeploymentStatus|${be.POST}|${a}`), l.length && c.push(`environment|identifier|${l}`), o.length && c.push(`${G.devtronApplication}|identifier|${o}`), i.length && c.push(`${G.releaseChannel}|identifier|${i}`), r.length) {
    const d = r.reduce((p, u) => {
      const [_, h] = u?.split("/") ?? [];
      return p[_] ? p[_].push(h) : p[_] = [h], p;
    }, {}), m = Object.keys(
      d
    ).map(
      (p) => `tenant/installation|identifier|${p}|${d[p]}`
    );
    c.push(...m);
  }
  return { filterCriteria: c };
}, am = (s, t) => {
  const n = [];
  return s && n.push(`${pe.RELEASE_TRACK}|identifier|${s}`), t && n.push(`appWorkflow|id|${t}`), n;
}, lm = (s) => {
  const t = s?.groupedDeps;
  return t ? t.map((n) => {
    const { commitDetails: a, imageDetails: l } = mo(n.data);
    return {
      appName: n.identifier,
      commitDetails: a,
      imageDetails: l
    };
  }) : [];
}, rm = (s) => s ? s.sort((t, n) => Ka(t.performedAtTime, n.performedAtTime, Fn.ASC)).map((t) => ({
  appId: t.id,
  appName: t.identifier,
  userEmail: t.userEmail,
  type: t.state,
  performedAtTime: t.performedAtTime && t.performedAtTime !== Dt ? kt(t.performedAtTime).format(Bn.TWELVE_HOURS_FORMAT) : ""
})) : [], om = (s, t) => ({
  id: s,
  dependencyPatch: t.map(({ appName: n, type: a }) => ({
    dependencyInfo: zt(n),
    query: [
      {
        path: "application",
        op: a === pn.added ? he.add : he.remove
      }
    ]
  }))
}), _a = () => ({
  "software-release-management": {
    component: /* @__PURE__ */ e.jsx(
      ie,
      {
        dataTestId: "redirect-to-overview-btn",
        component: Rt.link,
        size: oe.xs,
        icon: /* @__PURE__ */ e.jsx(Me, { name: "ic-software-release-management", color: null }),
        variant: _e.borderLess,
        linkProps: {
          to: bn.SOFTWARE_RELEASE_MANAGEMENT
        },
        ariaLabel: "Software Release Management",
        showAriaLabelInTippy: !0
      }
    ),
    linked: !0
  }
}), im = Array.from(Array(3).keys()).map((s) => ({
  id: s,
  ...nt(s, !1),
  applications: Array.from(Array(3).keys()).map((t) => ({
    name: `app-${t}`,
    appId: t,
    description: "",
    isRequired: !1,
    isDeleted: !1
  }))
}));
var vl = /* @__PURE__ */ ((s) => (s.description = "description", s.application = "application", s))(vl || {});
const cm = (s) => {
  const t = s?.groupedDeps;
  return t ? t.map((n) => {
    const a = (n.groupedDeps ?? []).sort((o, r) => Ka(o.data?.triggeredAt, r.data?.triggeredAt, Fn.ASC)).map(({ id: o, data: r }) => ({
      appName: r.appName ?? "",
      appId: r.appId,
      envId: r.envId,
      envName: r.envName ?? "",
      cdWorkflowRunnerId: r.latestReleaseTriggerWfrId,
      pipelineId: o,
      lastTriggeredRelease: {
        version: r.runSource?.releaseVersion ?? "",
        name: r.runSource?.name ?? "",
        deployStatus: r.deploymentStatus ?? A.NOT_TRIGGERED,
        triggerTime: r.triggeredAt && r.triggeredAt !== Dt ? kt(r.triggeredAt).format(hr.TWELVE_HOURS_FORMAT) : ""
      }
    })), l = a[0]?.lastTriggeredRelease;
    return {
      tenantConfig: ks(n.data),
      lastTriggeredRelease: l,
      apps: a
    };
  }) : [];
}, dm = async (s) => {
  try {
    const t = ge({
      baseUrl: $.RESOURCE,
      version: ne.alpha1,
      kind: G.releaseTrack,
      queryParams: { identifier: s }
    }), { result: n } = await xe(t);
    return bl(n);
  } catch (t) {
    throw U(t), t;
  }
}, pm = (s) => {
  const t = ge({
    baseUrl: $.RESOURCE,
    kind: G.releaseTrack,
    version: ne.alpha1
  });
  return Ls(t, s);
}, mm = ({ id: s, description: t }) => {
  const n = {
    id: s,
    query: [
      {
        op: he.replace,
        path: vl.description,
        value: t
      }
    ]
  };
  return pm(n);
}, um = ({ id: s, appName: t }) => {
  const n = {
    id: s,
    dependencyPatch: [
      {
        dependencyInfo: zt(t),
        query: [
          {
            op: he.remove,
            path: vl.application
          }
        ]
      }
    ]
  }, a = ge({
    baseUrl: $.RESOURCE_DEPENDENCIES,
    kind: G.releaseTrack,
    version: ne.alpha1
  });
  return Ls(a, n);
}, _m = async (s) => {
  try {
    const t = ge({
      baseUrl: $.RESOURCE_SUMMARY,
      version: ne.alpha1,
      kind: G.releaseTrack,
      queryParams: { identifier: s }
    }), { result: n } = await xe(t);
    return cm(n);
  } catch (t) {
    throw U(t), t;
  }
}, hm = ({ appName: s, handleClose: t, handleSuccess: n }) => {
  const { name: a, id: l } = it(), [o, r] = T(!1), i = async () => {
    r(!0);
    const c = {
      id: l,
      appName: s
    };
    try {
      await um(c), await n(), r(!1), ae.showToast({
        variant: le.success,
        description: "Application deleted successfully"
      }), t();
    } catch (d) {
      U(d), r(!1);
    }
  };
  return /* @__PURE__ */ e.jsx(
    Hs,
    {
      variant: Gs.delete,
      title: `Remove '${s}' from '${a}'`,
      subtitle: "Removing the application from the track will remove it from all releases in the track.",
      buttonConfig: {
        secondaryButtonConfig: {
          onClick: t,
          text: "Cancel"
        },
        primaryButtonConfig: {
          isLoading: o,
          onClick: i,
          text: "Delete"
        }
      },
      confirmationConfig: {
        identifier: "delete-application-from-track",
        confirmationKeyword: "Remove"
      },
      handleClose: t,
      children: /* @__PURE__ */ e.jsxs("p", { className: "fs-13 cn-8 m-0 flexbox-col dc__gap-12", children: [
        /* @__PURE__ */ e.jsxs("span", { className: "lh-20", children: [
          "1. ",
          s,
          " will need to be removed from draft releases."
        ] }),
        /* @__PURE__ */ e.jsx("span", { className: "lh-20", children: "2. Already released releases will not be impacted." }),
        /* @__PURE__ */ e.jsx("span", { className: "lh-20 mt-22", children: "Are you sure?" })
      ] })
    }
  );
}, hn = () => /* @__PURE__ */ e.jsx("span", { className: "cr-5", children: "*" }), fm = () => {
  const [s, t] = T(!1), [n, a] = T(null), { name: l, id: o } = it(), [r, i, c, d] = K(
    () => Wn(o, G.releaseTrack),
    [l],
    !!l
  ), m = i?.releaseOrdering ?? [], p = !r && c, u = () => {
    t((g) => !g);
  }, _ = (g) => () => {
    a(g);
  }, h = () => {
    a(null);
  }, f = () => /* @__PURE__ */ e.jsxs("button", { type: "button", className: "cta flex dc__gap-8 h-36", onClick: u, children: [
    /* @__PURE__ */ e.jsx(Je, { className: "icon-dim-16 dc__no-shrink fcb-5" }),
    "Add Applications"
  ] });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    !r && !c && !m.length ? /* @__PURE__ */ e.jsx("section", { className: "flexbox-col dc__overflow-auto dc__border br-4 bg__primary flex-grow-1", children: /* @__PURE__ */ e.jsx(
      J,
      {
        title: `Add applications to '${l}'`,
        subTitle: "Add applications to define the components that make up this software. Applications added here will be automatically included in new release versions of this software.",
        image: Hn,
        classname: "flex-grow-1",
        isButtonAvailable: !0,
        renderButton: f
      }
    ) }) : /* @__PURE__ */ e.jsxs("section", { className: "flexbox-col dc__overflow-auto dc__border br-4 bg__primary", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space dc__gap-8 py-8 px-16 dc__border-bottom bg__secondary", children: [
        /* @__PURE__ */ e.jsxs("h4", { className: "cn-9 fs-13 fw-6 lh-20 dc__truncate m-0", children: [
          "Applications part of '",
          l,
          "'"
        ] }),
        m.length > 0 && /* @__PURE__ */ e.jsxs(
          "button",
          {
            type: "button",
            className: "dc__transparent p-0 dc__hover-n50 fs-13 fw-6 lh-20 cn-7 dc__no-shrink flex dc__gap-6",
            onClick: u,
            disabled: p,
            children: [
              /* @__PURE__ */ e.jsx(Ys, { className: "icon-dim-14 dc__no-shrink scn-7" }),
              /* @__PURE__ */ e.jsx("span", { children: "Edit" })
            ]
          }
        )
      ] }),
      /* @__PURE__ */ e.jsx(
        Ee,
        {
          isLoading: !1,
          error: p,
          genericSectionErrorProps: {
            reload: d
          },
          children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-auto", children: [
              /* @__PURE__ */ e.jsxs("div", { className: "display-grid dc__column-gap-16 releases__manage-apps-row releases__manage-apps-row--header dc__border-bottom-n1 fs-12 fw-6 lh-20 cn-7 dc__align-items-center px-16 dc__uppercase bg__primary", children: [
                /* @__PURE__ */ e.jsx("span", {}),
                /* @__PURE__ */ e.jsx(Z, { title: "Application", isSortable: !1 }),
                /* @__PURE__ */ e.jsx(Z, { title: "Description", isSortable: !1 })
              ] }),
              /* @__PURE__ */ e.jsx("div", { className: "dc__overflow-auto", children: r ? im.map((g) => /* @__PURE__ */ e.jsxs(
                "div",
                {
                  className: "display-grid dc__column-gap-16 releases__manage-apps-row fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-16 show-shimmer-loading",
                  children: [
                    /* @__PURE__ */ e.jsx("span", { className: "child-shimmer-loading" }),
                    /* @__PURE__ */ e.jsx("span", { className: "child-shimmer-loading" }),
                    /* @__PURE__ */ e.jsx("span", { className: "child-shimmer-loading" })
                  ]
                },
                g.id
              )) : m.map((g) => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                /* @__PURE__ */ e.jsxs(
                  "div",
                  {
                    className: "display-grid dc__column-gap-16 releases__manage-apps-row releases__manage-apps-row--header fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-16",
                    children: [
                      /* @__PURE__ */ e.jsx("span", { className: "flex", children: g.icon }),
                      /* @__PURE__ */ e.jsx("span", { className: "dc__truncate cn-7 fs-12 fw-6 dc__uppercase", children: g.title })
                    ]
                  },
                  g.id
                ),
                g.applications.map((b) => /* @__PURE__ */ e.jsxs(
                  "div",
                  {
                    className: "display-grid dc__column-gap-16 releases__manage-apps-row fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-16",
                    children: [
                      /* @__PURE__ */ e.jsx(cl, { className: "dc__no-shrink icon-dim-24" }),
                      /* @__PURE__ */ e.jsxs(
                        ke,
                        {
                          to: `${bn.APPLICATION_MANAGEMENT_APP}/${b.appId}/overview`,
                          className: `dc__truncate anchor ${b.isDeleted ? "cr-5" : ""}`,
                          target: "_blank",
                          children: [
                            b.name,
                            " ",
                            b.isRequired && /* @__PURE__ */ e.jsx(hn, {})
                          ]
                        }
                      ),
                      b.isDeleted ? /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-8", children: [
                        /* @__PURE__ */ e.jsx("span", { className: "cr-5", children: "Application not found" }),
                        /* @__PURE__ */ e.jsxs(
                          "button",
                          {
                            type: "button",
                            className: "flex dc__gap-4 left cta text h-20 lh-20-imp",
                            onClick: _(b.name),
                            children: [
                              /* @__PURE__ */ e.jsx("span", { children: "Remove application" }),
                              /* @__PURE__ */ e.jsx(jt, { className: "icon-dim-16 scb-5 dc__no-shrink" })
                            ]
                          }
                        )
                      ] }) : /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: b.description || "-" })
                    ]
                  },
                  b.name
                ))
              ] })) })
            ] }),
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__column-gap-8 dc__align-items-center px-16 py-8 dc__border-top-n1", children: [
              /* @__PURE__ */ e.jsx("div", { className: "px-4 flex", children: /* @__PURE__ */ e.jsx(od, { className: "dc__no-shrink icon-dim-16 fcn-6" }) }),
              /* @__PURE__ */ e.jsxs("span", { className: "dc__truncate fs-12 fw-4 lh-16 cn-8", children: [
                "Applications marked with ",
                /* @__PURE__ */ e.jsx(hn, {}),
                " must be part of releases in '",
                l,
                "'"
              ] })
            ] }),
            !!n && /* @__PURE__ */ e.jsx(
              hm,
              {
                appName: n,
                handleClose: h,
                handleSuccess: d
              }
            )
          ] })
        }
      )
    ] }),
    s && /* @__PURE__ */ e.jsx(
      Qr,
      {
        handleCloseManageReleaseModal: u,
        handleSuccess: d,
        parentResourceKind: G.releaseTrack,
        resourceName: l,
        resourceId: o
      }
    )
  ] });
}, gm = (s) => {
  const t = {};
  return s.forEach(
    (n) => n.applications.forEach((a, l) => {
      t[a.name] = {
        releaseOrderIndex: n.id,
        releaseOrderName: n.title,
        applicationIndex: l,
        applicationName: a.name,
        applicationId: a.appId,
        selectedImage: a.selectedImage,
        registryType: a.registryType,
        artifactId: a.artifactId,
        artifactSourceAppWorkflowId: a.artifactSourceAppWorkflowId,
        sourceReleaseConfiguration: a.sourceReleaseConfiguration,
        isRequired: a.isRequired,
        isDeleted: a.isDeleted
      };
    })
  ), t;
}, xm = (s) => {
  const t = {};
  return s.forEach(
    (n) => n.applications.forEach((a) => {
      t[a.name] = a.isRequired;
    })
  ), t;
}, Eo = (s, t, n) => {
  const { shouldCheckForSelectedImage: a = !0 } = n ?? {};
  return s.length !== t.length ? !0 : s.some((l, o) => {
    const r = t[o];
    return l.applications.length !== r.applications.length ? !0 : l.applications.some((i, c) => {
      const d = r.applications[c];
      return i.name !== d.name || i.isRequired !== d.isRequired || a && i.selectedImage !== d.selectedImage;
    });
  });
}, bm = (s) => s.reduce((t, n) => t + n.applications.length, 0), Ql = ({
  releaseOrdering: s,
  targetReleaseOrderIndex: t,
  targetApplicationIndex: n,
  clearReleaseOrdersIfEmpty: a = !1
}) => {
  const l = [...s], o = l[t], r = [
    ...o.applications.filter((c, d) => d !== n)
  ];
  l[t] = {
    ...o,
    applications: r
  };
  const i = bm(l);
  return a && i === 0 ? [] : l;
}, Em = ({
  releaseOrdering: s,
  applicationName: t,
  applicationId: n,
  isRequired: a
}) => {
  const l = [...s];
  return l.length > 0 ? [
    {
      ...l[0],
      applications: [
        ...l[0].applications,
        {
          name: t,
          appId: n,
          isRequired: a,
          // New app is not deleted by default
          isDeleted: null
        }
      ]
    },
    ...l.slice(1)
  ] : [
    {
      id: 0,
      ...nt(0, !0),
      applications: [
        {
          name: t,
          appId: n,
          isRequired: a,
          isDeleted: null
        }
      ]
    }
  ];
}, Nm = (s) => {
  const t = [...s], n = t.length - 1, a = t[n];
  t[n] = {
    ...a,
    ...nt(n, !1)
  };
  const l = {
    id: n + 1,
    applications: [],
    ...nt(n + 1, !0)
  };
  return [...t, l];
}, jm = (s) => s.map((t, n) => ({
  ...nt(n, n === s.length - 1),
  id: n,
  applications: t.applications
})), vm = (s, t) => {
  const n = [...s], a = n[t].applications, l = n[t - 1];
  n[t - 1] = {
    ...l,
    applications: [...l.applications, ...a]
  };
  const o = n.filter((r, i) => i !== t);
  return jm(o);
}, Cm = (s, t, n, a) => {
  const l = [...s], o = l[t], r = [...o?.applications ?? []];
  return l[t] = {
    ...o,
    applications: [
      ...r.slice(0, n),
      a,
      ...r.slice(n)
    ]
  }, l;
}, ym = (s, t, n, a) => {
  const l = [...s], o = l[t], r = [...o.applications];
  return l[t] = {
    ...o,
    applications: [
      ...r.slice(0, n),
      a,
      ...r.slice(n + 1)
    ]
  }, l;
}, Tm = (s, t) => {
  const n = [];
  let a = 1;
  return s.forEach((l) => {
    const { applications: o } = l, r = a;
    a += 1, o.length && (n.push({
      index: r,
      isLevelPropagatedFromParent: t,
      typeOfDependency: At.RELEASE_STAGE
    }), o.forEach((i) => {
      const { name: c, isRequired: d } = i;
      n.push({
        identifier: c,
        index: a,
        dependentOnIndexes: [r],
        typeOfDependency: At.APPLICATION,
        resourceKind: G.devtronApplication,
        resourceVersion: ne.v1,
        toPropagateOnChild: d ?? !1
      }), a += 1;
    }));
  }), n;
}, Sm = (s) => s ? s.map((t) => ({
  label: `${t.projectName} ${cp.GROUP_HEADING_SUFFIX}`,
  options: t.appList.map((n) => ({
    label: n.name,
    value: n.id,
    isRequired: n.toPropagateOnChild ?? !1
  })).sort((n, a) => te(n.label, a.label, Fn.ASC))
})).sort((t, n) => te(t.label, n.label, Fn.ASC)) : [], wm = (s, t) => t?.length ? t.reduce((n, a) => {
  const l = a.options.filter((o) => s[o.label]);
  return [...n, ...l];
}, []) : [], Rm = (s) => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
  s.label,
  " ",
  s.isRequired && /* @__PURE__ */ e.jsx(hn, {})
] }), No = async ({
  id: s,
  releaseTrack: t,
  releaseVersion: n
}) => {
  const a = s ? { id: s } : { identifier: `${t}-${n}` };
  try {
    const l = Ne({
      baseUrl: $.RESOURCE,
      kind: pe.RELEASE,
      payload: a
    }), { result: o } = await xe(l);
    return io(o);
  } catch (l) {
    throw U(l), l;
  }
}, Im = async ({
  id: s,
  name: t,
  description: n,
  version: a,
  tags: l,
  track: o,
  cloneSourceId: r
}) => {
  const i = Ne({
    baseUrl: r ? $.RESOURCE_CLONE : $.RESOURCE,
    kind: pe.RELEASE
  }), c = l.reduce((m, p) => (m[p.label] = {
    label: p.label,
    value: p.value
  }, m), {}), d = {
    id: s,
    name: t,
    parentConfig: {
      resourceKind: pe.RELEASE_TRACK,
      resourceVersion: _l.ALPHA_1,
      identifier: o
    },
    overview: {
      description: n.trim(),
      releaseVersion: a,
      tags: c
    },
    ...r ? {
      cloneFrom: {
        id: +r
      }
    } : {}
  };
  return Ue(i, d);
}, Am = async (s) => Ht(
  Ne({
    baseUrl: $.RESOURCE,
    kind: pe.RELEASE,
    payload: {
      id: s
    }
  })
), Kt = (s) => {
  const t = Ne({
    baseUrl: $.RESOURCE,
    kind: pe.RELEASE
  });
  return Ls(t, s);
}, Lm = ({ id: s, description: t }) => {
  const n = {
    id: s,
    query: [
      {
        op: he.replace,
        path: "description",
        value: t
      }
    ]
  };
  return Kt(n);
}, km = ({
  id: s,
  name: t,
  description: n
}) => {
  const a = {
    id: s,
    query: [
      {
        op: he.replace,
        path: "name",
        value: t
      },
      {
        op: he.replace,
        path: "description",
        value: n
      }
    ]
  };
  return Kt(a);
}, Dm = ({ id: s, status: t, comment: n }) => {
  const a = {
    id: s,
    query: [
      {
        op: he.replace,
        path: "status",
        value: {
          status: t,
          comment: n?.trim() ?? ""
        }
      }
    ]
  };
  return Kt(a);
}, Om = ({ id: s, releaseNote: t }) => {
  const n = {
    id: s,
    query: [
      {
        op: he.replace,
        path: "note",
        value: t
      }
    ]
  };
  return Kt(n);
}, Mm = ({ id: s, isLocked: t }) => {
  const n = {
    id: s,
    query: [
      {
        op: he.replace,
        path: "lock",
        value: t
      }
    ]
  };
  return Kt(n);
}, Wn = async (s, t) => {
  try {
    const n = t === G.releaseTrack, a = Ne({
      baseUrl: $.RESOURCE_DEPENDENCIES,
      kind: n ? pe.RELEASE_TRACK : pe.RELEASE,
      payload: {
        id: s,
        lite: n
      }
    }), { result: l } = await xe(a), o = l?.isDepsPresentOnParent ?? !1;
    if (!l?.dependencies?.length)
      return {
        isReleaseOrderActive: !0,
        isDepsPresentOnParent: o,
        applicationCount: 0,
        releaseOrdering: [],
        unmappedEnvironments: [],
        tenantInstallationDetailsMap: {},
        releaseChannelToTenantInstallationMap: {},
        tenantInstallationsNotSubscribedToReleaseChannel: /* @__PURE__ */ new Set()
      };
    const r = l.dependencies.filter(
      (u) => u.typeOfDependency === At.APPLICATION
    ).length, i = l.dependencies.reduce(
      (u, _) => {
        if (_.typeOfDependency === At.RELEASE_STAGE) {
          const { index: h } = _;
          u[h] = {
            index: h,
            isReleaseOrderActive: _.isLevelPropagatedFromParent ?? !1,
            applications: []
          };
        }
        return u;
      },
      {}
    );
    l.dependencies.forEach((u) => {
      if (u.typeOfDependency === At.APPLICATION) {
        const { dependentOnIndexes: _ } = u;
        i[_[0]] && i[_[0]].applications.push(u);
      }
    });
    const c = Object.values(i).filter((u) => u.applications.length).sort((u, _) => Us(u.index, _.index)).map((u) => ({
      ...u,
      applications: u.applications.sort((_, h) => Us(_.index, h.index))
    })), d = c.length, m = c[0]?.isReleaseOrderActive ?? !1, p = c.flatMap((u) => u.applications);
    return {
      applicationCount: r,
      releaseOrdering: c.map((u, _) => ({
        id: _,
        ...nt(_, _ === d - 1),
        applications: u.applications.map((h) => ({
          name: h.identifier ?? "-",
          appId: h.id,
          selectedImage: h.config?.artifactConfig?.image ?? "",
          registryType: h.config?.artifactConfig?.registryType || xn.OTHER,
          artifactId: h.config?.artifactConfig?.artifactId,
          artifactSourceAppWorkflowId: h.config?.artifactConfig?.artifactSourceAppWorkflowId,
          sourceReleaseConfiguration: h.config?.artifactConfig?.sourceReleaseConfiguration,
          isRequired: h.toPropagateOnChild ?? !1,
          description: h.metadata?.appDescription ?? "",
          isDeleted: h.deleted ?? !1
        }))
      })),
      isReleaseOrderActive: m,
      isDepsPresentOnParent: o,
      ...qp(p)
    };
  } catch (n) {
    throw U(n), n;
  }
}, Pm = (s, t, n, a) => {
  const l = Ne({
    baseUrl: $.RESOURCE_DEPENDENCIES,
    kind: t === G.releaseTrack ? pe.RELEASE_TRACK : pe.RELEASE
  }), o = {
    id: s,
    dependencies: Tm(n, a)
  };
  return $t(l, o);
}, Fm = async (s, t) => {
  const n = Ne({
    baseUrl: $.RESOURCE_DEPENDENCIES,
    kind: pe.RELEASE,
    payload: {
      id: s,
      dependencyInfo: `${G.devtronApplication}|${ne.v1}|identifier|${t}`
    }
  }), { result: a } = await xe(n), l = a?.dependencies?.[0];
  if (!l)
    throw new pi({
      code: Bt.NOT_FOUND,
      errors: []
    });
  return Vp(l);
}, Tn = (s) => {
  const t = Ne({
    baseUrl: $.RESOURCE_DEPENDENCIES,
    kind: pe.RELEASE
  });
  return Ls(t, s);
}, Um = ({ id: s, appName: t }) => {
  const n = {
    id: s,
    dependencyPatch: [
      {
        dependencyInfo: zt(t),
        query: [
          {
            op: he.remove,
            path: "application"
          }
        ]
      }
    ]
  };
  return Tn(n);
}, $m = ({
  id: s,
  appName: t,
  releaseInstructions: n
}) => {
  const a = {
    id: s,
    dependencyPatch: [
      {
        dependencyInfo: zt(t),
        query: [
          {
            op: he.replace,
            path: "releaseInstruction",
            value: n
          }
        ]
      }
    ]
  };
  return Tn(a);
}, Bm = ({
  id: s,
  appName: t,
  artifactId: n,
  registryName: a,
  registryType: l,
  artifactSourceAppWorkflowId: o,
  sourceReleaseConfiguration: r
}) => {
  const i = {
    id: s,
    dependencyPatch: [
      bo({
        appName: t,
        artifactId: n,
        registryName: a,
        registryType: l,
        artifactSourceAppWorkflowId: o,
        sourceReleaseConfiguration: r
      })
    ]
  };
  return Tn(i);
}, Hm = async (s, t, n) => Tn(em(s, t, n)), Gm = async (s, t) => {
  try {
    const { result: n } = await xe(`${$.APP_APP_WF_LIST_COMPONENTS}/${s}`, {
      signal: t
    });
    return Zp(n);
  } catch (n) {
    throw hs(n) || U(n), n;
  }
}, Cl = async ({
  releaseId: s,
  applicationName: t,
  searchInput: n,
  searchType: a,
  workflowId: l,
  trackName: o,
  offset: r = pl,
  signal: i
}) => {
  try {
    const c = t === Ua ? Ua : `identifier|${t}`, d = Ne({
      baseUrl: $.RESOURCE_DEPENDENCIES_CONFIG_OPTIONS,
      kind: pe.RELEASE,
      payload: {
        id: s,
        dependencyInfo: `${G.devtronApplication}|${ne.v1}|${c}`,
        configOption: ao.ARTIFACT,
        searchKey: n ? `${a}|${n}` : null,
        filterCriteria: am(o, l),
        offset: r
      }
    }), { result: m } = await xe(d, { signal: i });
    return m ? sm(m, r) : {
      applicationsToArtifactsMap: {},
      appNameToIdMap: {}
    };
  } catch (c) {
    throw hs(c) || U(c), c;
  }
}, jo = async ({
  lite: s = !1,
  fetchChild: t = !1
}) => {
  try {
    const {
      result: { data: n }
    } = await xe(
      Ne({
        baseUrl: $.RESOURCE_LIST,
        kind: pe.RELEASE_TRACK,
        payload: {
          lite: s,
          fetchChild: t
        }
      })
    );
    return Wp(n);
  } catch (n) {
    throw U(n), n;
  }
}, Wm = async () => (await jo({ lite: !0, fetchChild: !1 })).map((t) => t.name), Vm = async (s) => {
  try {
    if (!s || Number.isNaN(+s))
      throw new Error("Invalid release track id");
    const t = Ne({
      baseUrl: $.RESOURCE,
      kind: pe.RELEASE_TRACK,
      payload: {
        id: +s
      }
    }), { result: n } = await xe(t);
    return bl(n);
  } catch (t) {
    throw U(t), t;
  }
}, qm = async (s, t) => {
  const n = Ne({
    baseUrl: $.RESOURCE,
    kind: pe.RELEASE_TRACK
  }), { id: a, name: l, description: o } = s, r = o.trim();
  if (t) {
    const c = {
      id: a,
      query: [
        {
          op: he.replace,
          path: "description",
          value: r
        }
      ]
    };
    return Ls(n, c);
  }
  return Ue(n, {
    id: a,
    name: l,
    overview: {
      description: r
    }
  });
}, Ym = async (s) => Ht(
  Ne({
    baseUrl: $.RESOURCE,
    kind: pe.RELEASE_TRACK,
    payload: {
      id: s
    }
  })
), vo = async ({
  trackName: s,
  signal: t
}) => {
  const n = Ne({
    baseUrl: $.RESOURCE_LIST,
    kind: pe.RELEASE,
    payload: {
      filterCriteria: [`${pe.RELEASE_TRACK}|identifier|${s}`],
      lite: !0
    }
  }), { result: a } = await xe(n, { signal: t });
  return a?.data ? co(a.data).map(({ name: o, version: r, status: i, id: c }) => ({
    name: o,
    version: r,
    status: i,
    id: c
  })) : [];
}, zm = async ({
  releaseId: s
}) => {
  const t = Ne({
    baseUrl: $.RESOURCE_TASKS_INFO,
    kind: pe.RELEASE,
    payload: {
      id: s,
      lite: !1,
      fetchWithUnmappedData: !0
    }
  }), { result: n } = await Ue(t, {});
  return uo(n?.data);
}, Km = async ({
  releaseId: s
}) => {
  const t = Ne({
    baseUrl: $.RESOURCE_TASKS_INFO,
    kind: pe.RELEASE,
    payload: {
      id: s,
      lite: !1,
      fetchWithUnmappedData: !1
    }
  }), { result: n } = await Ue(t, {});
  return uo(n?.data);
}, Jm = async ({
  releaseId: s
}) => {
  const [t, n] = await Promise.allSettled([
    zm({ releaseId: s }),
    Km({ releaseId: s })
  ]);
  if (n.status === "rejected")
    throw n.reason;
  return {
    ...n.value,
    unmappedEnvironments: t.status === "fulfilled" ? t.value.unmappedEnvironments : []
  };
}, Qm = async ({ releaseId: s, filterConfig: t }, n) => {
  try {
    const a = Ne({
      baseUrl: $.RESOURCE_TASKS_INFO,
      kind: pe.RELEASE,
      payload: {
        id: s,
        lite: !1
      }
    }), { result: l } = await Ue(a, jl(t), {
      signal: n
    });
    return Yp(l?.data, l?.count);
  } catch (a) {
    throw hs(a) || U(a), a;
  }
}, Xm = async ({ releaseId: s, stageId: t, filterConfig: n }, a) => {
  try {
    const l = Ne({
      baseUrl: $.RESOURCE_TASKS_INFO,
      kind: pe.RELEASE,
      payload: {
        id: s,
        lite: !1,
        levelIndex: t
      }
    }), o = await Ue(l, jl(n), {
      signal: a
    });
    return {
      ...o,
      result: zp(o?.result?.data?.[0]?.dependencies)
    };
  } catch (l) {
    throw hs(l) || U(l), l;
  }
}, Zm = async ({
  id: s,
  bulkSelectionState: t,
  stage: n
}) => {
  try {
    const a = Ne({
      baseUrl: $.RESOURCE_TASKS_EXECUTE,
      kind: pe.RELEASE
    }), l = {
      id: s,
      tasks: go(t, n),
      dryRun: !0,
      taskType: yn.nonBundled
    }, o = await Ue(a, l);
    return { ...o, result: ho(o?.result) };
  } catch (a) {
    throw U(a), a;
  }
}, eu = async ({
  id: s,
  bulkSelectionState: t
}) => {
  try {
    const n = Ne({
      baseUrl: $.RESOURCE_TASKS_EXECUTE,
      kind: pe.RELEASE
    }), a = {
      id: s,
      tasks: Object.values(t),
      taskType: yn.bundled,
      dryRun: !0
    }, l = await Ue(n, a);
    return Jp(l?.result);
  } catch (n) {
    throw U(n), n;
  }
}, su = async ({
  id: s,
  bulkSelectionState: t,
  stage: n
}) => {
  try {
    const a = Ne({
      baseUrl: $.RESOURCE_TASKS_EXECUTE,
      kind: pe.RELEASE
    }), l = {
      id: s,
      tasks: go(t, n),
      dryRun: !1,
      taskType: yn.nonBundled
    }, o = await Ue(a, l);
    return { ...o, result: fo(o?.result) };
  } catch (a) {
    throw U(a), a;
  }
}, tu = async ({
  id: s,
  bulkSelectionState: t
}) => {
  try {
    const n = Ne({
      baseUrl: $.RESOURCE_TASKS_EXECUTE,
      kind: pe.RELEASE
    }), a = {
      id: s,
      taskType: yn.bundled,
      tasks: Object.values(t),
      dryRun: !1
    }, l = {
      timeout: window._env_.CONFIGURABLE_TIMEOUT ? parseInt(window._env_.CONFIGURABLE_TIMEOUT, 10) : null
    }, o = await Ue(n, a, l);
    return Xp(o?.result);
  } catch (n) {
    throw U(n), n;
  }
}, Co = async ({ releaseId: s, filterConfig: t }, n) => {
  try {
    const a = Ne({
      baseUrl: $.RESOURCE_TASKS_INFO,
      kind: pe.RELEASE,
      payload: {
        id: s,
        lite: !1,
        showAll: !0
      }
    }), { result: l } = await Ue(
      a,
      jl({
        ...t,
        // We are not sending the deployment status and rollout filter in rollout status
        preStage: [],
        deployStage: [],
        postStage: []
      }),
      {
        signal: n
      }
    );
    return nm(l?.data?.[0]?.dependencies, l?.count);
  } catch (a) {
    throw hs(a) || U(a), a;
  }
}, yo = async (s, t) => {
  const n = Ne({
    baseUrl: $.RESOURCE_DEPENDENCIES,
    kind: pe.RELEASE,
    payload: {
      id: s,
      dependencyInfo: `${G.devtronApplication}|${ne.v1}|id|${t}`
    }
  });
  try {
    const { result: a } = await xe(n), l = a?.dependencies?.[0]?.childObjects?.[0].data ?? [];
    return po(l);
  } catch (a) {
    throw U(a), a;
  }
}, To = async (s) => {
  const t = Ne({
    baseUrl: $.RESOURCE_DEPENDENCIES,
    kind: pe.RELEASE,
    payload: {
      id: s
    }
  });
  try {
    const { result: n } = await xe(t);
    return (n?.dependencies ?? []).filter((a) => a.resourceKind === G.devtronApplication).sort((a, l) => te(a.identifier, l.identifier)).map((a) => ({ value: a.id, label: a.identifier }));
  } catch (n) {
    throw U(n), n;
  }
}, nu = async (s) => {
  try {
    const t = JSON.parse(s), {
      result: { name: n }
    } = await mi(t?.eventId);
    return n;
  } catch (t) {
    throw U(t), t;
  }
}, au = async (s) => {
  try {
    const t = Ne({
      baseUrl: $.RESOURCE_SUMMARY,
      kind: pe.RELEASE,
      payload: { id: s }
    }), { result: n } = await xe(t);
    return lm(n);
  } catch (t) {
    throw U(t), t;
  }
}, So = async (s) => {
  try {
    const t = Ne({
      baseUrl: $.RESOURCE_DEPENDENCIES_OFFENDING,
      kind: pe.RELEASE,
      payload: {
        id: s
      }
    }), { result: n } = await xe(t);
    return rm(n?.depStateStatus);
  } catch (t) {
    throw U(t), t;
  }
}, lu = async (s, t) => {
  const n = om(s, t);
  return Tn(n);
}, wo = vt(null), ru = ({ value: s, children: t }) => {
  const [n, a] = T(), l = q(
    () => ({
      ...s,
      newReleaseStatus: n,
      setNewReleaseStatus: a
    }),
    [s, n]
  );
  return ee(() => {
    a(null);
  }, [s.status]), /* @__PURE__ */ e.jsx(wo.Provider, { value: l, children: t });
}, de = () => {
  const s = Ct(wo);
  if (!s)
    throw new Error("Wrap with ReleaseDetailProvider");
  return s;
}, Ro = vt(null), ou = ({ children: s }) => {
  const { id: t } = de(), { appId: n } = Te(), [a, l] = K(() => To(t), [t]), [o, r, , i] = K(
    () => Promise.allSettled([yo(t, +n), gc(+n)]),
    [n],
    !!n && !Number.isNaN(+n),
    { resetOnChange: !1 }
  ), { environments: c, envIdToEnvApprovalConfigurationMap: d } = q(() => {
    if (r && r[0].status === "fulfilled" && r[1].status === "fulfilled" && r[0].value && r[1].value) {
      const [{ value: p }, { value: u }] = r;
      return {
        environments: p.map(({ id: _, name: h }) => ({
          id: _,
          name: h
        })),
        envIdToEnvApprovalConfigurationMap: u
      };
    }
    return {
      environments: [],
      envIdToEnvApprovalConfigurationMap: {
        [ui]: null
      }
    };
  }, [r]), m = q(
    () => ({
      isAppListLoading: a,
      applications: l,
      environments: c,
      isEnvListLoading: o,
      reloadEnvironments: i,
      envIdToEnvApprovalConfigurationMap: d
    }),
    [c, l, o, a, d]
  );
  return /* @__PURE__ */ e.jsx(Ro.Provider, { value: m, children: s });
}, iu = () => {
  const s = Ct(Ro);
  if (!s)
    throw new Error("ReleaseConfigurationContext cannot be used outside Release Configuration scope");
  return s;
}, cu = () => {
  const { ReleaseConfigurations: s } = Qd();
  return /* @__PURE__ */ e.jsx(ou, { children: /* @__PURE__ */ e.jsx(s, {}) });
}, Io = ({ applicationsConfig: s, environmentsConfig: t }) => {
  const {
    appId: n,
    isLoading: a,
    onChange: l,
    options: o
  } = s, {
    envId: r,
    isLoading: i,
    onChange: c,
    options: d
  } = t;
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
    /* @__PURE__ */ e.jsx(
      st,
      {
        inputId: "release-configuration-app-selector",
        classNamePrefix: "release-configuration-app-selector",
        icon: /* @__PURE__ */ e.jsx(Yd, { className: "scb-5" }),
        placeholder: "Select Application",
        isLoading: a,
        isDisabled: a || i,
        options: [{ label: "Applications", options: o }],
        value: ln(o, n, null),
        onChange: l
      }
    ),
    /* @__PURE__ */ e.jsx(xt, { alwaysShowTippyOnHover: !n, content: "Select an application first", placement: "right", children: /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
      st,
      {
        inputId: "release-configuration-env-selector",
        classNamePrefix: "release-configuration-env-selector",
        icon: /* @__PURE__ */ e.jsx(il, {}),
        placeholder: "Select Environment",
        isLoading: i,
        isDisabled: i || !n,
        showSelectedOptionIcon: !1,
        options: [{ label: "Environments", options: d }],
        value: ln(d, r, null),
        onChange: c
      }
    ) }) })
  ] });
}, pE = () => {
  const s = fe(), { path: t, params: n } = gs(), { appId: a, envId: l } = n, { pathname: o } = fn(), {
    applications: r,
    environments: i,
    isAppListLoading: c,
    isEnvListLoading: d
  } = iu(), m = q(
    () => (i ?? []).map(({ id: f, name: g }) => ({
      label: g,
      value: f
    })),
    [i]
  ), p = (f = "push") => ({ value: g }) => {
    +a !== g && s[f](W(t, { ...n, appId: g }));
  }, u = (f = "push") => ({ value: g }) => {
    if (+l === g)
      return;
    const b = { ...n, envId: g }, [j, E] = o.split(`/${a}/${l}/`)[1]?.split("/") ?? [], v = j ? `/${j}` : "", x = `${E ? `/${E}` : ""}`;
    s[f](`${W(t, b)}${v}${x}`);
  };
  ee(() => {
    c || (r.length === 1 && (!a || !ln(r, +a, null)) ? p("replace")(r[0]) : r.length && !ln(r, +a, null) && s.replace(W(t, { ...n, appId: null, envId: null })));
  }, [a, r, c]), ee(() => {
    a && !d && m.length && !ln(m, +l, null) && u("replace")(m[0]);
  }, [l, m, d, a]);
  const _ = {
    appId: a ? +a : null,
    isLoading: c,
    onChange: p(),
    options: r
  }, h = {
    envId: l ? +l : null,
    isLoading: d,
    onChange: u(),
    options: m
  };
  return /* @__PURE__ */ e.jsx("div", { className: "p-12 dc__border-bottom-n1", children: /* @__PURE__ */ e.jsx(Io, { applicationsConfig: _, environmentsConfig: h }) });
};
var Jt = /* @__PURE__ */ ((s) => (s.releaseChannelId = "releaseChannelId", s))(Jt || {});
const at = {
  label: "Not subscribed",
  // This would be a known limitation of duplicate entries if a user creates a channel with same id
  // This is the identifier for BE as well
  value: "Not Subscribed"
}, du = {
  [Jt.releaseChannelId]: "Release Channel"
}, pu = (s) => /* @__PURE__ */ e.jsx(xt, { content: "Exception user at the time of deployment", alwaysShowTippyOnHover: !0, children: /* @__PURE__ */ e.jsx("span", { className: "flex left cursor", children: s }) }), mu = [
  es.DEPLOYMENT_INITIATED,
  es.HELM_PACKAGE_GENERATED,
  es.HELM_MANIFEST_PUSHED_TO_HELM_REPO
], uu = (s) => (t) => {
  switch (s) {
    case t.status:
      return !0;
    case es.HELM_PACKAGE_GENERATED:
      return t.status === es.HELM_PACKAGE_GENERATION_FAILED;
    case es.HELM_MANIFEST_PUSHED_TO_HELM_REPO:
      return t.status === es.HELM_MANIFEST_PUSHED_TO_HELM_REPO_FAILED;
    default:
      return !1;
  }
}, _u = (s) => {
  const t = {
    displaySubText: "",
    time: "",
    isCollapsed: !0,
    icon: "",
    timelineStatus: ""
  };
  return {
    deploymentAppType: s?.deploymentAppType,
    deploymentStatus: hi[s?.wfrStatus] || Ln.INPROGRESS,
    deploymentTriggerTime: s?.deploymentStartedOn || "",
    deploymentEndTime: s?.deploymentFinishedOn || "",
    triggeredBy: s?.triggeredBy || "",
    deploymentStatusBreakdown: {
      [es.DEPLOYMENT_INITIATED]: {
        ...t,
        icon: "success",
        displayText: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx("span", { children: "Deployment initiated" }),
          !!s?.triggeredBy && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx("span", { children: " by " }),
            /* @__PURE__ */ e.jsxs($e, { condition: s.isDeploymentWithoutApproval, wrap: pu, children: [
              s.isDeploymentWithoutApproval && /* @__PURE__ */ e.jsx(Me, { name: "ic-lightning-fill", color: "Y500" }),
              s.triggeredBy
            ] })
          ] })
        ] })
      },
      [es.HELM_PACKAGE_GENERATED]: {
        ...t,
        displayText: "Generate helm chart package"
      },
      [es.HELM_MANIFEST_PUSHED_TO_HELM_REPO]: {
        ...t,
        displayText: "Push package to repository",
        showHelmManifest: !1
      }
    }
  };
}, Ao = (s) => {
  const t = _u(s);
  return s?.timelines?.length && mu.forEach((n) => {
    const a = _i(s.timelines, uu(n)), l = t.deploymentStatusBreakdown[n];
    if (a)
      switch (l.time = a.statusTime, n) {
        case es.HELM_PACKAGE_GENERATED:
          l.icon = a.status === es.HELM_PACKAGE_GENERATION_FAILED ? "failed" : "success";
          break;
        case es.HELM_MANIFEST_PUSHED_TO_HELM_REPO: {
          const o = a.status === es.HELM_MANIFEST_PUSHED_TO_HELM_REPO_FAILED;
          l.showHelmManifest = !0, l.icon = o ? "failed" : "success", o && (l.displaySubText = "Failed", l.isCollapsed = !1, l.timelineStatus = /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
            /* @__PURE__ */ e.jsx("span", { className: "dc__word-break lh-20", children: a.statusDetail }),
            /* @__PURE__ */ e.jsxs("ol", { className: "m-0 pl-20", children: [
              /* @__PURE__ */ e.jsx("li", { children: "Ensure provided repository path is valid" }),
              /* @__PURE__ */ e.jsx("li", { children: "Check if credentials provided for OCI registry are valid and have PUSH permission" })
            ] })
          ] }));
          break;
        }
      }
  }), t;
}, ha = ({ isVirtualIcon: s, showVirtualText: t }) => /* @__PURE__ */ e.jsx(
  xr,
  {
    heading: s || t ? gt.isolatedEnvironment : gt.generateHelmManifest,
    infoText: `${s || t ? gt.isolatedEnvTippy : pt.deploymentToIsolatedEnvironment}`,
    children: /* @__PURE__ */ e.jsx("div", { children: s ? /* @__PURE__ */ e.jsx($c, { "data-testid": "virtual-environment", className: "flex cursor icon-dim-24 fcb-5 ml-16" }) : /* @__PURE__ */ e.jsx("div", { "data-testid": "virtual-environment-help", className: "ml-4 flex", children: /* @__PURE__ */ e.jsx(Cn, { className: "icon-dim-16 cursor mandatory-tag-info-icon" }) }) })
  }
), mE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ha
}, Symbol.toStringTag, { value: "Module" })), hu = ({ params: s }) => {
  const { isDownloading: t, handleDownload: n } = Ja(), a = nl(s), l = () => {
    n({
      downloadUrl: a,
      fileName: s.appName,
      downloadSuccessToastContent: "Manifest Downloaded Successfully"
    });
  }, o = () => /* @__PURE__ */ e.jsx(
    "button",
    {
      type: "button",
      className: `dc__transparent p-0 flex left dc__gap-4 ${t ? "cursor-not-allowed" : "cursor"}`,
      "data-testid": "virtual-app-detail-dowload-button",
      onClick: l,
      disabled: t,
      children: t ? /* @__PURE__ */ e.jsx("span", { className: "dc__loading-dots fs-12 lh-18 fw-6 cn-7", children: "Downloading" }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx("span", { className: "fs-12 lh-18 fw-6 cb-5", children: "Download" }),
        /* @__PURE__ */ e.jsx(Pc, { className: "icon-dim-14 fcb-5" })
      ] })
    }
  );
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "app-details-info-card flex left bg__primary br-8 mr-12 w-200 dc__overflow-initial--imp",
      "data-testid": "app-details-manifest-download-card",
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "app-details-info-card__top-container flexbox dc__gap-12", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "app-details-info-card__top-container__content", children: [
            /* @__PURE__ */ e.jsxs("div", { className: "app-details-info-card__top-container__content__title-wrapper", children: [
              /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-12 lh-20 fw-4 cn-7", children: gt.generateHelmManifest }),
              /* @__PURE__ */ e.jsx(ha, { isVirtualIcon: s.isVirtualIcon })
            ] }),
            /* @__PURE__ */ e.jsx(xt, { content: s.appName, children: /* @__PURE__ */ e.jsx("p", { className: "m-0 dc__truncate", children: s.appName }) })
          ] }),
          /* @__PURE__ */ e.jsx(Fc, { className: "icon-dim-24 dc__no-shrink" })
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "app-details-info-card__bottom-container", children: o() })
      ]
    }
  );
}, uE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hu
}, Symbol.toStringTag, { value: "Module" })), fu = () => /* @__PURE__ */ e.jsxs("div", { "data-testid": "generated-helm-download-card", className: "fs-13", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "flex left cn-7", children: [
    gt.generateHelmManifest,
    /* @__PURE__ */ e.jsx(ha, {})
  ] }),
  /* @__PURE__ */ e.jsxs("div", { className: "cn-9 flex left", children: [
    /* @__PURE__ */ e.jsx(Uc, { className: "icon-dim-16 mr-8" }),
    "Download on deployment"
  ] })
] }), _E = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fu
}, Symbol.toStringTag, { value: "Module" }));
var Dn = /* @__PURE__ */ ((s) => (s.PUSH = "PUSH", s.DO_NOT_PUSH = "DO_NOT_PUSH", s))(Dn || {});
const gu = ({
  generatedHelmPushAction: s,
  onChangeSetGeneratedHelmPush: t,
  dockerRegistries: n,
  selectedRegistry: a,
  handleRegistryChange: l,
  repositoryName: o,
  handleOnRepository: r,
  containerRegistryName: i,
  containerRegistryErrorForm: c,
  repositoryErrorForm: d
}) => {
  const m = n.map((f) => ({
    ...f,
    value: f.id,
    label: f.id,
    startIcon: /* @__PURE__ */ e.jsx(Mt, { registryType: f.registryType })
  })), p = (f) => f?.isValid ? null : f.message, u = () => {
    if (a?.id)
      return {
        ...a,
        startIcon: /* @__PURE__ */ e.jsx(Mt, { registryType: a.registryType })
      };
    const f = n.find((g) => g.isDefault === !0);
    return f?.id && l(f), f;
  }, _ = (f) => {
    t(f.target.value);
  }, h = () => /* @__PURE__ */ e.jsxs("div", { className: "pt-12", children: [
    /* @__PURE__ */ e.jsx("div", { className: "flex left mb-12", children: /* @__PURE__ */ e.jsxs(
      En,
      {
        className: "radio-group-no-border",
        value: s,
        name: "helmAction",
        onChange: _,
        children: [
          /* @__PURE__ */ e.jsx($s, { value: Dn.DO_NOT_PUSH, children: "Do not push" }),
          /* @__PURE__ */ e.jsx($s, { value: Dn.PUSH, children: "Push to registry" })
        ]
      }
    ) }),
    s === Dn.PUSH ? /* @__PURE__ */ e.jsxs("div", { className: "mb-4 form__row--two-third fs-13", children: [
      /* @__PURE__ */ e.jsx(
        st,
        {
          label: "Registry",
          required: !0,
          inputId: "container-registry",
          classNamePrefix: "cd-trigger__select-container-registry",
          isClearable: !1,
          options: m,
          value: u(),
          onChange: l,
          placeholder: "Select registry",
          size: oe.large,
          error: p(c)
        }
      ),
      (i || a || n.find((f) => f.isDefault === !0)) && /* @__PURE__ */ e.jsx(
        Fe,
        {
          placeholder: a && Pl[a.registryType]?.placeholderText || "Enter repository name",
          label: /* @__PURE__ */ e.jsxs("div", { children: [
            "Repository",
            /* @__PURE__ */ e.jsx("span", { className: "ml-4", children: a && Pl[a.registryType]?.desiredFormat })
          ] }),
          name: "repository_name",
          value: o,
          onChange: r,
          "data-testid": "container-repository-textbox",
          required: !0,
          helperText: `'${o || "repoName"}' repo must exist in the selected ECR
                                    registry.`,
          error: p(d)
        }
      )
    ] }) : /* @__PURE__ */ e.jsx(cs, { description: "The helm chart package will be generated and downloaded when you trigger the deployment. The package can be used to deploy to clusters not connected to Devtron." })
  ] });
  return /* @__PURE__ */ e.jsxs("div", { className: "fs-13", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex left", children: [
      /* @__PURE__ */ e.jsx("span", { children: gt.pushGeneratedHelmPackage }),
      /* @__PURE__ */ e.jsx(ha, {})
    ] }),
    h()
  ] });
}, hE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gu
}, Symbol.toStringTag, { value: "Module" })), xu = ({
  handleOCIRegistryStorageAction: s,
  disabledFields: t,
  isOCIRegistryHelmPush: n
}) => /* @__PURE__ */ e.jsx(
  js,
  {
    rootClassName: `${t.some((a) => a === wn.CHART_PUSH) ? "registry-disabled-checkbox" : ""} docker-default mb-12 mt-12`,
    id: wn.CHART_PUSH,
    isChecked: n,
    value: Oe.CHECKED,
    onChange: (a) => s(a, wn.CHART_PUSH),
    dataTestId: "store-container-and-chart",
    disabled: t.some((a) => a === wn.CHART_PUSH),
    children: "Push helm packages"
  }
), fE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xu
}, Symbol.toStringTag, { value: "Module" }));
function bu(s) {
  return Ue($.virtual_cluster, s);
}
function Eu(s) {
  return $t($.virtual_cluster, s);
}
function Nu(s) {
  return Ue($.virtual_env, s);
}
function ju(s) {
  return $t($.virtual_env, s);
}
function vu(s) {
  return Ht($.virtual_cluster, s);
}
function gE(s) {
  return s ? ju : Nu;
}
const Cu = ({ environmentName: s = "" }) => /* @__PURE__ */ e.jsx("div", { "data-testid": "virtual-app-details-empty-state-modal", className: "bg__primary h-100 dc__position-rel", children: /* @__PURE__ */ e.jsx(
  J,
  {
    image: Bc,
    title: `${s} ${Wl.TITLE}`,
    subTitle: Wl.SUBTITLE,
    imageClassName: "empty-medium-image"
  }
) }), xE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Cu
}, Symbol.toStringTag, { value: "Module" })), bE = ({
  id: s,
  clusterName: t = "",
  reload: n,
  handleModalClose: a,
  category: l,
  isProd: o
}) => {
  const { path: r } = gs(), { replace: i } = fe(), { serverMode: c } = br();
  ee(() => {
    if (c === fi.EA_ONLY) {
      const y = W(r, { type: "connect-cluster" });
      i(y);
    }
  }, []);
  const [d, m] = T(!1), [p, u] = T(!1), { data: _, errors: h, register: f, handleSubmit: g } = gi({
    initialValues: {
      cluster_name: t,
      category: l,
      isProd: o ?? !1
    },
    validations: {
      cluster_name: {
        required: !0,
        pattern: [
          { message: "Name is required", value: /^.*$/ },
          {
            message: "Use only lowercase alphanumeric characters, '-', '_' or '.'",
            value: /^[a-z0-9-._]+$/
          },
          { message: "Cannot start/end with '-', '_' or '.'", value: /^(?![-._]).*[^-._]$/ },
          { message: "Minimum 3 and Maximum 63 characters required", value: /^.{3,63}$/ }
        ]
      }
    }
  }), b = !!s, j = {
    id: s,
    clusterName: _.cluster_name
  }, E = async () => {
    const y = {
      id: s,
      clusterName: _.cluster_name,
      IsVirtualCluster: !0,
      category: Ec(_.category).category,
      isProd: _.isProd
    }, C = b ? Eu : bu;
    try {
      m(!0), await C(y), ae.showToast({
        variant: le.success,
        description: `Successfully ${b ? "updated" : "saved"}.`
      }), n(), a();
    } catch (S) {
      U(S);
    } finally {
      m(!1);
    }
  }, v = () => {
    u(!0);
  }, x = async () => {
    await vu(j), n(), a();
  }, N = () => {
    u(!1);
  };
  return /* @__PURE__ */ e.jsxs("form", { onSubmit: g(E), className: "flexbox-col flex-grow-1", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox flex-grow-1", children: [
      /* @__PURE__ */ e.jsx(xi, {}),
      /* @__PURE__ */ e.jsx("div", { className: "p-20 flexbox-col flex-grow-1 dc__overflow-auto bg__secondary", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16 br-8 bg__primary p-20 border__secondary", children: [
        /* @__PURE__ */ e.jsx(
          Fe,
          {
            name: pt.clusterNameInputName,
            label: pt.clusterNameInputLabel,
            placeholder: pt.clusterNameInputPlaceholder,
            value: _.cluster_name,
            error: h.cluster_name,
            ...f("cluster_name"),
            disabled: b,
            required: !0,
            autoFocus: !0
          }
        ),
        /* @__PURE__ */ e.jsx("div", { className: "w-250", children: /* @__PURE__ */ e.jsx(
          xc,
          {
            selectedCategory: _.category,
            setSelectedCategory: f("category", { isCustomComponent: !0 }).onChange
          }
        ) }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-24 fs-13", children: [
          /* @__PURE__ */ e.jsx("div", { className: "dc__required-field cn-7", children: "Type of Clusters" }),
          /* @__PURE__ */ e.jsxs(
            En,
            {
              name: "isProd",
              className: "radio-group-no-border",
              value: String(_.isProd),
              onChange: f("isProd", { sanitizeFn: (y) => y === "true" }).onChange,
              children: [
                /* @__PURE__ */ e.jsx($s, { value: "true", children: "Production" }),
                /* @__PURE__ */ e.jsx($s, { value: "false", children: "Non - Production" })
              ]
            }
          )
        ] }),
        /* @__PURE__ */ e.jsx(cs, { description: pt.isolatedClusterInfoMessage })
      ] }) })
    ] }),
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: `dc__border-top flexbox dc__align-items-center py-12 px-20 ${b ? "dc__content-space" : "dc__content-end"}`,
        children: [
          b && /* @__PURE__ */ e.jsx(
            ie,
            {
              dataTestId: "delete-virtual-cluster-button",
              style: qe.negative,
              onClick: v,
              variant: _e.secondary,
              size: oe.large,
              text: pt.deleteButtonLabel
            }
          ),
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12", children: [
            /* @__PURE__ */ e.jsx(
              ie,
              {
                dataTestId: "close-virtual-cluster-tab",
                style: qe.neutral,
                onClick: a,
                variant: _e.secondary,
                size: oe.large,
                text: pt.cancelButtonLabel,
                disabled: d
              }
            ),
            /* @__PURE__ */ e.jsx(
              ie,
              {
                dataTestId: "save-virtual-cluster-button",
                style: qe.default,
                buttonProps: { type: "submit" },
                variant: _e.primary,
                isLoading: d,
                size: oe.large,
                text: b ? "Update cluster" : "Save Cluster"
              }
            )
          ] }),
          p && /* @__PURE__ */ e.jsx(
            Gt,
            {
              title: t,
              component: bc.Cluster,
              onDelete: x,
              closeConfirmationModal: N,
              subtitle: bi.DELETE_CLUSTER_SUBTITLES,
              errorCodeToShowCannotDeleteDialog: Er.INTERNAL_SERVER_ERROR
            }
          )
        ]
      }
    )
  ] });
};
function yu() {
  return /* @__PURE__ */ e.jsx("div", { className: "fs-11 fw-4", children: gt.isolatedEnvironment });
}
const EE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yu
}, Symbol.toStringTag, { value: "Module" })), Lo = ({ titleName: s, status: t, params: n }) => {
  const { isDownloading: a, handleDownload: l } = Ja(), o = async () => {
    s || Ei(new Error("Cannot find helm package name in history artifact"));
    const i = s || "helm-package", c = nl(n);
    await l({
      downloadUrl: c,
      fileName: i,
      downloadSuccessToastContent: "Manifest Downloaded Successfully"
    });
  }, r = () => t.toLowerCase() === Ln.FAILED ? /* @__PURE__ */ e.jsx(
    J,
    {
      title: Rn.NO_ARTIFACTS_TITLE,
      subTitle: Rn.NO_ARTIFACT_SUBTITLE
    }
  ) : t.toLowerCase() === Ln.PROGRESSING || t.toLowerCase() === Ln.INPROGRESS ? /* @__PURE__ */ e.jsx(
    J,
    {
      SvgImage: bd,
      title: Rn.PIPELINE_PROGRESS_TITLE,
      subTitle: Rn.PIPELINE_PROGRESS_SUBTITLE
    }
  ) : /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "dc__border p-16 flex left bg__primary w-100 dc__mxw-800 br-4",
      "data-testid": "hover-on-virtual-artifact",
      children: [
        /* @__PURE__ */ e.jsx("div", { className: "bcn-1 br-4 h-40 w-40 flex icon-dim-40", children: /* @__PURE__ */ e.jsx(xd, { className: "icon-dim-24" }) }),
        /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-4 ml-12", children: s }),
        a ? /* @__PURE__ */ e.jsx("span", { className: "dc__align-right", children: /* @__PURE__ */ e.jsx(vs, { size: 16 }) }) : /* @__PURE__ */ e.jsx(
          dl,
          {
            className: "icon-dim-16 dc__align-right cursor",
            "data-testid": "virtual-artifact-download-button",
            onClick: o
          }
        )
      ]
    }
  );
  return /* @__PURE__ */ e.jsx("div", { className: "h-100 dc__position-rel p-20", children: r() });
}, NE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Lo
}, Symbol.toStringTag, { value: "Module" })), Ta = { offset: 0, size: 20 }, ko = () => {
  const { appId: s, envId: t, pipelineId: n, triggerId: a, releaseTrack: l, releaseVersion: o } = Te();
  return {
    appId: s ? Number(s) : null,
    envId: t ? Number(t) : null,
    pipelineId: n ? Number(n) : null,
    triggerId: a ? Number(a) : null,
    releaseTrack: l,
    releaseVersion: o
  };
}, Tu = ({ appOptions: s, envOptions: t, envOptionsLoading: n }) => {
  const { replace: a } = fe(), { path: l } = gs(), { appId: o, envId: r, ...i } = ko(), c = (u) => {
    o && o === Number(u.value) || a(
      W(l, {
        ...i,
        appId: u.value,
        envId: r ?? null,
        triggerId: null,
        pipelineId: null
      })
    );
  }, d = (u) => {
    r && r === Number(u.value) || a(
      W(l, {
        ...i,
        appId: o,
        envId: u.value,
        pipelineId: u.pipelineId,
        triggerId: null
      })
    );
  }, m = {
    appId: o ? +o : null,
    isLoading: !1,
    onChange: c,
    options: s
  }, p = {
    options: t,
    envId: r ? +r : null,
    isLoading: n,
    onChange: d
  };
  return /* @__PURE__ */ e.jsx(Io, { applicationsConfig: m, environmentsConfig: p });
}, Do = ({
  triggerMetaData: s,
  onlyRenderIcon: t
}) => {
  const n = () => s.includes(Ni.BLACKOUT.toLowerCase()) ? /* @__PURE__ */ e.jsx(fd, { className: "icon-dim-20 dc__no-shrink" }) : /* @__PURE__ */ e.jsx(gd, { className: "icon-dim-20 dc__no-shrink" });
  return t ? n() : /* @__PURE__ */ e.jsx("span", { className: "dc__align-left py-8 fw-6 fs-12", children: s });
}, jE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Do
}, Symbol.toStringTag, { value: "Module" })), yl = ({
  userApprovalMetadata: s,
  triggeredBy: t,
  appliedFilters: n,
  appliedFiltersTimestamp: a,
  promotionApprovalMetadata: l,
  selectedEnvironmentName: o,
  isDeploymentWithoutApproval: r
}) => /* @__PURE__ */ e.jsx(
  ri,
  {
    userApprovalMetadata: s,
    showApprovalCounts: !0,
    triggeredBy: t,
    appliedFilters: n ?? [],
    appliedFiltersTimestamp: a ?? "",
    promotionApprovalMetadata: l,
    selectedEnvironmentName: o,
    isDeploymentWithoutApproval: r
  }
), Su = (s) => /* @__PURE__ */ e.jsx(Nc, { userApprovalMetadata: s }), wu = (s, t = !1) => /* @__PURE__ */ e.jsx(Do, { triggerMetaData: s, onlyRenderIcon: t }), Ru = ({ status: s, title: t, params: n }) => /* @__PURE__ */ e.jsx(Lo, { status: s, titleName: t, params: n }), Oo = (s, t) => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
  /* @__PURE__ */ e.jsx(zs, { className: "icon-dim-14 dc__no-shrink" }),
  s ? /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-12 fw-5 lh-20", children: "This Release" }) : /* @__PURE__ */ e.jsxs("span", { className: "flexbox cn-9 fs-12 lh-20 dc__mxw-180", children: [
    /* @__PURE__ */ e.jsx("span", { className: "fw-4 dc__mxw-100 dc__ellipsis-right", children: t.releaseTrackName }),
    /* @__PURE__ */ e.jsx("span", { className: "fw-4", children: "/" }),
    /* @__PURE__ */ e.jsx("span", { className: "fw-5 dc__mxw-100 dc__ellipsis-right", children: t.releaseVersion })
  ] })
] }), Iu = (s, t) => s && s.kind === G.release ? /* @__PURE__ */ e.jsx(
  "div",
  {
    className: `flexbox dc__align-items-center dc__gap-4 pl-6 pr-6 br-6 dc__w-fit-content ${t ? "bcn-1" : "bg__primary"}`,
    children: Oo(t, s)
  }
) : null, Au = (s, t) => s && s.kind === G.release ? /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center dc__gap-4 pl-6 pr-6 br-6 dc__w-fit-content bg__primary", children: Oo(t, s) }) : null, vE = (s, { context: t }) => t === "menu" && s.tenantConfig.identifier ? /* @__PURE__ */ e.jsxs("span", { className: "flexbox-col dc__ellipsis-right", children: [
  /* @__PURE__ */ e.jsx("span", { className: "dc__ellipsis-right lh-20 fs-13 cn-9", children: s.label }),
  /* @__PURE__ */ e.jsx("span", { className: "dc__ellipsis-right lh-18 fs-12 cn-7", children: s.tenantConfig.displayText })
] }) : s.label, Lu = ({
  showCurrentReleaseDeployments: s,
  setShowCurrentReleaseDeployments: t
}) => {
  const { appId: n, envId: a, pipelineId: l, triggerId: o, ...r } = ko(), { replace: i } = fe(), c = fn(), { path: d } = gs(), { id: m } = de(), [p, u] = T(!1), [_, h] = T({ ...Ta }), [f, g] = T(null), [b, j] = T([]), [E, v] = T(null), [x, N] = T(!1), [y, C] = T(!1), [S, I] = T(/* @__PURE__ */ new Map()), [w, k] = T([]), [R, B] = T(!1), [P, L] = T(!1), F = S?.get(+o), [M, Y, O] = ji({
    autoBottomScroll: F && vi.includes(F.status.toLowerCase())
  }), [Q, je, ps, ts] = K(
    () => To(m),
    [m]
  ), [X, ce] = K(
    () => Promise.allSettled([
      yo(m, n),
      Ci(Nr.BLOB_STORAGE)
    ]),
    [n],
    !!n
  ), we = !!(!X && ce?.[0]?.status === "fulfilled" && ce?.[0]?.value?.some((se) => se.id === a)), [Ge, ye, Ds, Tt] = K(
    () => Fl({ appId: n, envId: a, pagination: _, releaseId: m, showCurrentReleaseDeployments: s }),
    [n, a, s, _.offset, _.size],
    !!n && !!a && we
  ), Zt = (se, Xe, Ie) => {
    if (Ie) {
      ye.result?.cdWorkflows?.length && I(Ul(ye.result.cdWorkflows, "id")), v(Rs.SUSPEND);
      return;
    }
    if (se === Xe?.id) {
      const Ss = S.get(se)?.appliedFilters ?? [], xs = S.get(se)?.appliedFiltersTimestamp, ws = S.get(se)?.promotionApprovalMetadata, V = S.get(se)?.runSource, Se = S.get(se)?.targetConfig, ms = S.get(se)?.userApprovalMetadata, Os = {
        ...Ss.length ? { appliedFilters: Ss } : {},
        ...xs ? { appliedFiltersTimestamp: xs } : {},
        ...ws ? { promotionApprovalMetadata: ws } : {},
        ...V ? { runSource: V } : {},
        ...Se ? { targetConfig: Se } : {},
        ...ms ? { userApprovalMetadata: ms } : {}
      };
      I((Ml) => (Ml.set(se, { ...Xe, ...Os }), new Map(Ml))), E === Rs.FETCHING && v(Rs.SUCCESS);
    }
  };
  ee(() => {
    if (X || !ye || !ye?.result?.cdWorkflows?.length || E === Rs.FETCHING || E === Rs.SUCCESS)
      return;
    ye.result?.cdWorkflows?.length !== _.size ? N(!1) : (N(!0), C(!0));
    let se = ye.result?.cdWorkflows?.[0]?.id;
    const Ie = new URLSearchParams(c.search).get("type");
    if (Ie === kn.PRECD || Ie === kn.POSTCD) {
      const xs = Ie === kn.PRECD ? be.PRE : be.POST, ws = ye.result?.cdWorkflows?.filter(
        (V) => V.stage === xs
      );
      ws?.[0] && (se = ws[0].id);
    }
    const Ss = (ye.result?.cdWorkflows || []).reduce((xs, ws) => (xs.set(ws.id, ws), xs), S);
    k(ye?.result?.appReleaseTagNames || []), B(ye?.result?.tagsEditable || !1), L(ye?.result?.hideImageTaggingHardDelete || !1), !o && a && l && ye.result?.cdWorkflows?.length && i(
      W(d, {
        ...r,
        appId: n,
        envId: a,
        pipelineId: l,
        triggerId: se
      })
    ), o && !Ss.has(+o) && E !== Rs.SUSPEND ? (v(Rs.FETCHING), Ss.clear()) : v(Rs.SUSPEND), I(new Map(Ss));
  }, [ye, X]), ee(() => {
    const se = [];
    if (ce && ce[0].status === Na.FULFILLED) {
      ce[0].value.forEach(
        (Ie) => se.push({
          pipelineId: Ie.pipelineId,
          value: Ie.id,
          label: Ie.name,
          tenantConfig: Ie.tenantConfig,
          description: Ie.tenantConfig.displayText
        })
      ), n && !a && i(
        W(d, {
          ...r,
          appId: n,
          envId: se?.[0]?.value,
          pipelineId: se?.[0]?.pipelineId
        })
      );
      const Xe = se.find((Ie) => a === Number(Ie.value))?.pipelineId;
      !l && a && i(Xe ? W(d, { ...r, appId: n, envId: a, pipelineId: Xe }) : se ? W(d, {
        ...r,
        appId: n,
        envId: se[0]?.value,
        pipelineId: se[0]?.pipelineId
      }) : W(d, { ...r, appId: n, envId: null })), n && a && l && l !== Xe && i(W(d, { ...r, appId: n, envId: a, pipelineId: Xe })), j(se);
    }
  }, [X, ce]), ee(() => (ce && ce[0].status === Na.FULFILLED && g(
    ce[0].value?.find((se) => se.id === a)?.deploymentAppType
  ), () => {
    I(/* @__PURE__ */ new Map()), C(!1), N(!1), v(null), h(Ta);
  }), [a, ce]);
  const en = () => {
    t(!s), I(/* @__PURE__ */ new Map()), h(Ta), i(W(d, { ...r, appId: n, envId: a, pipelineId: l }));
  }, ct = (!Q && je?.find((se) => Number(se.value) === n)) ?? null, dt = b.find((se) => Number(se.value) === a) ?? null, Ks = dt?.label;
  async function sn() {
    if (!a || !E || E !== Rs.SUSPEND)
      return;
    const [se, Xe] = await wi(
      Fl({
        appId: n,
        envId: a,
        pagination: { offset: 0, size: _.offset + _.size },
        releaseId: m,
        showCurrentReleaseDeployments: s
      })
    );
    if (se) {
      U(se);
      return;
    }
    Xe?.result?.cdWorkflows?.forEach((Ie) => Zt(Ie.id, Ie, se));
  }
  yi(sn, 3e4);
  const tn = () => {
    ye.result?.cdWorkflows?.length && I(Ul(ye.result.cdWorkflows, "id")), v(Rs.SUSPEND), i(
      W(d, {
        ...r,
        appId: n,
        envId: a,
        pipelineId: l,
        triggerId: ye.result?.cdWorkflows?.[0]?.id
      })
    );
  }, nn = () => {
    const { targetConfig: se, runSource: Xe } = S.get(o);
    if (!Ks || Xe?.kind !== G.release)
      return null;
    const Ie = ks({
      tenantIcon: se?.tenantIcon,
      tenantId: se?.tenantId,
      tenantName: se?.tenantName,
      installationId: se?.installationId,
      installationName: se?.installationName,
      releaseChannelId: se?.releaseChannelId,
      releaseChannelName: se?.releaseChannelName
    }), {
      displayText: Ss,
      installationConfig: { releaseChannelName: xs }
    } = Ie;
    return /* @__PURE__ */ e.jsx(
      xt,
      {
        alwaysShowTippyOnHover: !0,
        content: /* @__PURE__ */ e.jsxs("div", { className: "fs-12 lh-18 fw-4 flex column left top dc__gap-6", children: [
          Ks && /* @__PURE__ */ e.jsxs("div", { children: [
            /* @__PURE__ */ e.jsx("div", { className: "fw-6", children: "Environment" }),
            /* @__PURE__ */ e.jsx("div", { children: Ks })
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "w-100 dc__border-bottom--n7" }),
          /* @__PURE__ */ e.jsxs("div", { children: [
            /* @__PURE__ */ e.jsx("div", { className: "fw-6", children: "Tenant (Installation)" }),
            /* @__PURE__ */ e.jsx("div", { children: Ss })
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "w-100 dc__border-bottom--n7" }),
          /* @__PURE__ */ e.jsxs("div", { children: [
            /* @__PURE__ */ e.jsx("div", { className: "fw-6", children: "Release Channel" }),
            /* @__PURE__ */ e.jsx("div", { children: xs || at.label })
          ] })
        ] }),
        children: /* @__PURE__ */ e.jsx("div", { className: "flex", children: /* @__PURE__ */ e.jsx(ia, { className: "icon-dim-14 dc__no-shrink" }) })
      }
    );
  }, an = () => Ds ? /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1", children: /* @__PURE__ */ e.jsx(
    bt,
    {
      reload: Tt,
      code: Ds?.code,
      redirectURL: W(d, { ...r, appId: null })
    }
  ) }) : !ct || !dt ? /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1", children: /* @__PURE__ */ e.jsx(
    J,
    {
      title: "No application x environment selected",
      subTitle: "Select application and environment to view deployment history"
    }
  ) }) : S.size === 0 ? s ? /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1", children: /* @__PURE__ */ e.jsx(
    J,
    {
      title: "No deployments from this release",
      subTitle: "No deployments are done for selected application and environment from this release"
    }
  ) }) : /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1", children: /* @__PURE__ */ e.jsx(
    J,
    {
      title: "No deployments",
      subTitle: "No deployments are done for selected application and environment"
    }
  ) }) : /* @__PURE__ */ e.jsxs("div", { className: "ci-details__body", children: [
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto h-100", ref: M, children: /* @__PURE__ */ e.jsx(
      Ri,
      {
        fullScreenView: p,
        triggerHistory: S,
        deploymentHistoryResult: ye ?? null,
        setTriggerHistory: I,
        setFullScreenView: u,
        deploymentAppType: f,
        isBlobStorageConfigured: ce?.[1]?.status === Na.FULFILLED ? ce[1].value?.result?.enabled : !1,
        appReleaseTags: w,
        tagsEditable: R,
        hideImageTaggingHardDelete: P,
        fetchIdData: E,
        setFetchTriggerIdData: v,
        selectedEnvironmentName: Ks,
        renderRunSource: Au,
        resourceId: m,
        renderCIListHeader: yl,
        renderDeploymentApprovalInfo: Su,
        renderDeploymentHistoryTriggerMetaText: wu,
        renderVirtualHistoryArtifacts: Ru,
        processVirtualEnvironmentDeploymentData: Ao,
        scrollToTop: Y,
        scrollToBottom: O,
        renderTargetConfigInfo: nn,
        appName: ct?.label
      }
    ) }),
    /* @__PURE__ */ e.jsx(Ii, { fullScreenView: p, setFullScreenView: u })
  ] });
  return Q ? /* @__PURE__ */ e.jsx("div", { className: "flex flex-grow-1", children: /* @__PURE__ */ e.jsx(vs, { size: 48 }) }) : ps ? /* @__PURE__ */ e.jsx(
    bt,
    {
      reload: ts,
      code: ps?.code,
      redirectURL: W(d, { ...r, appId: null })
    }
  ) : !y && X || Ge && S.size === 0 ? /* @__PURE__ */ e.jsx(vs, { pageLoader: !0 }) : je.length === 0 ? /* @__PURE__ */ e.jsx(
    J,
    {
      image: dn,
      title: "No deployments from this release yet",
      subTitle: "History of deployments done from this release will be available here"
    }
  ) : /* @__PURE__ */ e.jsxs("div", { className: `ci-details  ${p ? "ci-details--full-screen" : ""}`, children: [
    !p && /* @__PURE__ */ e.jsx("div", { className: "releases__deployment-history flexbox-col dc__overflow-hidden dc__border-right dc__no-shrink", children: /* @__PURE__ */ e.jsx(
      Ti,
      {
        filterOptions: [],
        type: Si.CD,
        hasMore: x,
        triggerHistory: S,
        setPagination: h,
        fetchIdData: E,
        handleViewAllHistory: tn,
        renderRunSource: s ? null : Iu,
        resourceId: m,
        children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col px-16 py-12 dc__gap-12 fs-13-imp dc__border-bottom-n1 dc__zi-3", children: [
          /* @__PURE__ */ e.jsx(
            Tu,
            {
              appOptions: je,
              envOptions: b,
              envOptionsLoading: X
            }
          ),
          ct && dt && /* @__PURE__ */ e.jsxs("div", { className: "flexbox m-0", children: [
            /* @__PURE__ */ e.jsx(
              js,
              {
                id: "current-release-deployments",
                onChange: en,
                isChecked: s,
                value: Oe.CHECKED,
                rootClassName: "mb-0"
              }
            ),
            /* @__PURE__ */ e.jsx(
              "label",
              {
                className: "m-0 fw-4 fs-13 lh-20 cursor",
                htmlFor: "current-release-deployments",
                children: "Deployments from this release only"
              }
            )
          ] })
        ] })
      }
    ) }),
    an()
  ] });
}, ku = Array.from(Array(3).keys()).map(
  (s) => ({
    appId: s,
    envId: s,
    appName: `${s}`,
    envName: `${s}`,
    deployStatus: A.ABORTED,
    preStatus: A.DEPLOY_INITIATED,
    postStatus: A.FAILED,
    existingStages: {
      pre: !0,
      post: !0,
      deploy: !0
    },
    pipelineId: s,
    tenantConfig: qt(s),
    isDeployable: !1,
    preCdWorkflowRunnerId: s,
    cdWorkflowRunnerId: s,
    postCdWorkflowRunnerId: s,
    isVirtualEnvironment: !1
  })
), Mo = Array.from(Array(3).keys()).map((s) => ({
  appId: s,
  envId: s,
  appName: `${s}`,
  envName: `${s}`,
  feasibility: _o(Ce.CanTrigger),
  message: "",
  tenantConfig: qt(s)
})), Po = Array.from(Array(3).keys()).map((s) => ({
  appId: s,
  envId: s,
  appName: `${s}`,
  envName: `${s}`,
  triggerStatus: $a(
    {
      code: ve.processed
    },
    !1
  ),
  message: "",
  tenantConfig: qt(s),
  romStatus: null,
  stage: null,
  cdWorkflowType: null
}));
var bs = /* @__PURE__ */ ((s) => (s.appName = "application", s.tenantInstallation = "tenantInstallation", s.envName = "environment", s))(bs || {}), ls = /* @__PURE__ */ ((s) => (s.appName = "application", s.tenantInstallation = "tenantInstallation", s.envName = "environment", s.feasibility = "feasibility", s))(ls || {});
const Du = [
  {
    value: be.PRE,
    label: "Trigger Pre-deployment stage"
  },
  {
    value: be.DEPLOY,
    label: "Trigger Deployment"
  },
  {
    value: be.POST,
    label: "Trigger Post-deployment stage"
  }
], Ou = [
  H.HOLD,
  H.RESCINDED,
  ue.CORRUPTED
], Lt = "tab", Xl = "view";
var Cs = /* @__PURE__ */ ((s) => (s.triggerRelease = "trigger-release", s.rolloutStatus = "rollout-status", s))(Cs || {}), os = /* @__PURE__ */ ((s) => (s.installation = "installation", s.pipeline = "pipeline", s))(os || {});
const Ba = {
  rolloutStatus: Qe,
  preStage: [],
  deployStage: [],
  postStage: [],
  env: [],
  app: [],
  tenantInstallation: [],
  releaseChannelId: []
}, Ms = {
  selectedRolloutStatus: Qe,
  preStageMap: {},
  deployStageMap: {},
  postStageMap: {},
  envMap: {},
  appMap: {},
  tenantInstallationMap: {},
  releaseChannelIdMap: {}
};
var Le = /* @__PURE__ */ ((s) => (s.rolloutStatus = "rolloutStatus", s.preStage = "preStage", s.deployStage = "deployStage", s.postStage = "postStage", s.env = "env", s.app = "app", s.tenantInstallation = "tenantInstallation", s.releaseChannelId = "releaseChannelId", s))(Le || {});
const Qt = {
  rolloutStatus: "Rollout status",
  preStage: "Pre-deployment status",
  deployStage: "Deployment status",
  postStage: "Post-deployment status",
  env: "Environments",
  app: "Applications",
  tenantInstallation: "Tenant (Installations)",
  releaseChannelId: "Release channel"
}, Mu = Qs(Object.values(me)), Zl = 30, Pu = [
  {
    label: "Rollout Status",
    value: "rollout-status"
    /* rolloutStatus */
  },
  {
    label: "Trigger Release",
    value: "trigger-release"
    /* triggerRelease */
  }
], er = (s, t = {}) => Object.fromEntries(
  Object.entries(s ?? {}).map(([n, a]) => [
    n,
    Object.fromEntries(Object.entries(a).filter(([l]) => t[l]))
  ])
), Fo = (s) => {
  switch (s) {
    case H.READY_FOR_RELEASE:
      return Cs.triggerRelease;
    default:
      return Cs.rolloutStatus;
  }
}, Fu = (s) => Qt[s], Xt = (s) => s === Qe, Uu = (s, t) => {
  switch (s) {
    case Le.rolloutStatus:
      return Xt(t) ? "" : ua[t];
    case Le.preStage:
    case Le.deployStage:
    case Le.postStage:
      return _t[t];
    default:
      return t;
  }
}, Sa = (s, t) => s.getAll(t).filter(
  (n) => Mu[n]
), $u = (s) => {
  const t = s.get(
    Le.rolloutStatus
  );
  return {
    rolloutStatus: Xt(t) || Object.values(z).some((n) => n === t) ? t : Qe,
    preStage: Sa(s, Le.preStage),
    deployStage: Sa(s, Le.deployStage),
    postStage: Sa(s, Le.postStage),
    env: s.getAll(Le.env).filter((n) => !!n),
    app: s.getAll(Le.app).filter((n) => !!n),
    tenantInstallation: s.getAll(Le.tenantInstallation).filter((n) => !!n),
    releaseChannelId: s.getAll(Le.releaseChannelId).filter((n) => !!n)
  };
}, Bu = ({
  selectedRolloutStatus: s = Ms.selectedRolloutStatus,
  preStageMap: t = Ms.preStageMap,
  deployStageMap: n = Ms.deployStageMap,
  postStageMap: a = Ms.postStageMap,
  envMap: l = Ms.envMap,
  appMap: o = Ms.appMap,
  tenantInstallationMap: r = Ms.tenantInstallationMap,
  releaseChannelIdMap: i = Ms.releaseChannelIdMap
}) => ({
  rolloutStatus: s,
  preStage: Object.keys(t).filter((c) => t[c]),
  deployStage: Object.keys(n).filter((c) => n[c]),
  postStage: Object.keys(a).filter((c) => a[c]),
  env: Object.keys(l).filter((c) => !!l[c]),
  app: Object.keys(o).filter((c) => !!o[c]),
  tenantInstallation: Object.keys(r).filter(
    (c) => !!r[c]
  ),
  releaseChannelId: Object.keys(i).filter(
    (c) => !!i[c]
  )
}), Hu = (s) => (s ?? []).reduce((t, n) => (t[n.identifier] = n.displayText, t), {}), Tl = (s) => (s ?? []).reduce(
  (t, n) => (t[n.channelId] = n.name, t),
  {
    [at.value]: at.label
  }
), Ae = {
  [H.DRAFT]: {
    label: "Draft",
    value: H.DRAFT
  },
  [H.READY_FOR_RELEASE]: {
    label: "Ready for release",
    value: H.READY_FOR_RELEASE
  },
  [H.HOLD]: {
    label: "On hold",
    value: H.HOLD
  },
  [H.RESCINDED]: {
    label: "Rescinded",
    value: H.RESCINDED
  },
  [ue.PARTIALLY_RELEASED]: {
    label: "Partially released",
    value: ue.PARTIALLY_RELEASED
  },
  [ue.COMPLETELY_RELEASED]: {
    label: "Completely released",
    value: ue.COMPLETELY_RELEASED
  },
  [ue.CORRUPTED]: {
    label: "Corrupted",
    value: ue.CORRUPTED
  }
}, Gu = {
  [H.DRAFT]: [
    Ae[H.DRAFT],
    Ae[H.READY_FOR_RELEASE]
  ],
  [H.READY_FOR_RELEASE]: [
    Ae[H.DRAFT],
    Ae[H.READY_FOR_RELEASE]
  ],
  [H.HOLD]: [
    Ae[H.READY_FOR_RELEASE],
    Ae[H.HOLD],
    Ae[H.RESCINDED]
  ],
  [H.RESCINDED]: [],
  [ue.PARTIALLY_RELEASED]: [
    Ae[ue.PARTIALLY_RELEASED],
    Ae[H.HOLD],
    Ae[H.RESCINDED]
  ],
  [ue.COMPLETELY_RELEASED]: [
    Ae[ue.COMPLETELY_RELEASED],
    Ae[H.HOLD],
    Ae[H.RESCINDED]
  ],
  [ue.CORRUPTED]: []
}, fa = {
  [H.DRAFT]: /* @__PURE__ */ e.jsx(Ys, { className: "scn-7 w-100 h-100" }),
  [H.READY_FOR_RELEASE]: /* @__PURE__ */ e.jsx(Pr, { className: "fcy-5 w-100 h-100" }),
  [H.HOLD]: /* @__PURE__ */ e.jsx(_d, { className: "w-100 h-100" }),
  [H.RESCINDED]: /* @__PURE__ */ e.jsx(ud, { className: "w-100 h-100 dc__flip-y scn-0" }),
  [ue.PARTIALLY_RELEASED]: /* @__PURE__ */ e.jsx(Ur, { className: "w-100 h-100" }),
  [ue.COMPLETELY_RELEASED]: /* @__PURE__ */ e.jsx(qr, { className: "w-100 h-100" }),
  [ue.CORRUPTED]: /* @__PURE__ */ e.jsx(Me, { name: "ic-warning", color: null })
}, Wu = {
  [H.DRAFT]: "cn-8",
  [H.READY_FOR_RELEASE]: "cn-8",
  [H.HOLD]: "co-7",
  [H.RESCINDED]: "cn-0",
  [ue.PARTIALLY_RELEASED]: "cn-8",
  [ue.COMPLETELY_RELEASED]: "cg-7",
  [ue.CORRUPTED]: "text__white"
}, Vu = ({
  type: s,
  userEmail: t,
  track: n
}) => {
  switch (s) {
    case pn.added:
      return `Added to '${n}' by ${t}`;
    case pn.removed:
      return `Removed from '${n}' by ${t}`;
    case pn.deleted:
      return `Application deleted by ${t}`;
    default:
      return "";
  }
}, Uo = ({ changesForReview: s, trackName: t, handleClose: n, handleSuccess: a }) => {
  const [l, o] = T(!1), { id: r, refetchReleaseDetail: i } = de(), c = () => /* @__PURE__ */ e.jsxs("span", { className: "flex column left fs-13 fw-4 lh-20 cn-9", children: [
    /* @__PURE__ */ e.jsxs("span", { className: "fw-6", children: [
      s.length,
      " updates pending review"
    ] }),
    /* @__PURE__ */ e.jsx("span", { children: "Accept changes to apply them to this release" })
  ] }), d = async () => {
    try {
      o(!0);
      const m = await lu(r, s), { userMessage: p } = m?.result ?? {};
      await i(), a(), ae.showToast({
        variant: le.success,
        description: p || "Changes accepted successfully"
      }), o(!1), n();
    } catch (m) {
      o(!1), U(m);
    }
  };
  return /* @__PURE__ */ e.jsx(Nn, { className: "visible-modal__body", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__content-space dc__overflow-hidden dc__m-auto mt-40 br-8 bg__primary w-450 mxh-600", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space px-20 py-12 dc__border-bottom", children: [
        /* @__PURE__ */ e.jsxs("h2", { className: "m-0 fs-16 fw-6 lh-24 cn-9 dc__truncate", children: [
          "Applications updated in '",
          t,
          "'"
        ] }),
        /* @__PURE__ */ e.jsx(
          "button",
          {
            type: "button",
            className: "dc__transparent dc__no-shrink flexbox",
            "aria-label": "close-modal",
            onClick: n,
            children: /* @__PURE__ */ e.jsx(Ts, { className: "icon-dim-20 fcn-6" })
          }
        )
      ] }),
      /* @__PURE__ */ e.jsx(
        cs,
        {
          description: c(),
          borderConfig: { top: !1, left: !1, right: !1 },
          borderRadiusConfig: { top: !1, left: !1, right: !1, bottom: !1 }
        }
      ),
      /* @__PURE__ */ e.jsx("div", { className: "px-20 py-16 flexbox-col flex-grow-1 dc__overflow-auto", children: s.map((m) => /* @__PURE__ */ e.jsxs("div", { className: "flex top left dc__gap-8 py-8", children: [
        /* @__PURE__ */ e.jsx("div", { className: "icon-dim-20 dc__no-shrink p-2", children: Pp[m.type] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1", children: [
          /* @__PURE__ */ e.jsx(
            ke,
            {
              to: `${bn.APPLICATION_MANAGEMENT_APP}/${m.appId}`,
              target: "_blank",
              className: "anchor fs-13 fw-4 lh-20 cb-5 dc__truncate",
              children: m.appName
            }
          ),
          /* @__PURE__ */ e.jsxs("div", { className: "flex top dc__content-space dc__gap-8 fs-12 fw-4 lh-18 cn-7 dc__gap-8", children: [
            /* @__PURE__ */ e.jsx("span", { className: "dc__ellipsis-right__2nd-line", children: Vu({
              type: m.type,
              userEmail: m.userEmail,
              track: t
            }) }),
            /* @__PURE__ */ e.jsx("span", { className: "dc__no-shrink", children: Qa(m.performedAtTime, !0) })
          ] })
        ] })
      ] }, m.appName)) })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "px-20 py-16 flex dc__gap-12 dc__content-end", children: [
      /* @__PURE__ */ e.jsx("button", { type: "button", className: "cta cancel", disabled: l, onClick: n, children: "Cancel" }),
      /* @__PURE__ */ e.jsx(
        Ws,
        {
          type: "button",
          rootClassName: "cta",
          disabled: l,
          onClick: d,
          isLoading: l,
          children: "Accept Changes"
        }
      )
    ] })
  ] }) });
}, $o = vt({
  isCountSummaryLoading: !0,
  filterCountSummary: null,
  updateFilterCountSummary: We,
  resetFilterCountSummary: We,
  areFiltersActive: !1,
  urlFilterConfig: {
    ...Ba
  },
  urlFilterConfigMap: {
    ...Ms
  },
  handleRolloutStatusUpdate: We,
  updateFilters: We,
  updateFiltersByMap: We,
  clearFilters: We,
  stageListAccordionExpansionMap: {},
  setStageListAccordionExpansionMap: We,
  appEnvAndTenantListApiState: {
    isAppEnvAndTenantLoading: !1,
    appEnvAndTenantList: {},
    appEnvAndTenantListError: null,
    refetchAppEnvAndTenantList: We
  },
  triggerReleaseView: null,
  handleTriggerReleaseViewChange: We,
  shouldPoll: !1,
  handleUpdateShouldPoll: We,
  selectedTab: null,
  handleTabChange: We,
  appStatusModalConfig: null,
  setAppStatusModalConfig: We
}), qu = ({ children: s, appEnvAndTenantListApiState: t }) => {
  const n = fe(), [a, l] = T({}), [o, r] = T(null), [i, c] = T(!1), [d, m] = T(null), { queryParams: p } = jr(), { status: u } = de(), _ = p.get(Lt), h = p.get(Xl), f = !o, {
    rolloutStatus: g,
    preStage: b,
    deployStage: j,
    postStage: E,
    env: v,
    app: x,
    tenantInstallation: N,
    updateSearchParams: y,
    releaseChannelId: C
  } = Xn({
    parseSearchParams: $u
  });
  ee(() => {
    if (!_ || !Object.values(Cs).some((O) => O === _)) {
      const O = new URLSearchParams(p);
      O.set(Lt, Fo(u)), n.replace({ search: O.toString() });
    }
  }, [p]);
  const S = (O) => {
    const Q = new URLSearchParams(p);
    Q.set(Lt, String(O.value)), n.replace({ search: Q.toString() });
  }, I = (O) => {
    const Q = new URLSearchParams(p);
    Q.set(
      Xl,
      Object.values(os).some((je) => je === O) ? O : os.pipeline
    ), n.replace({ search: Q.toString() });
  }, w = (O) => {
    y({ ...Ba, ...O });
  }, k = (O) => {
    y(
      Bu({
        ...O
      })
    );
  }, R = () => {
    y({
      ...Ba
    });
  }, B = (O) => {
    y({
      rolloutStatus: O
    });
  }, P = (O) => {
    r(O);
  }, L = () => {
    r(null);
  }, F = () => {
    if (_ === Cs.triggerRelease) {
      const O = g && !Xt(g) || C.length;
      return h === os.installation ? O : O || b.length || j.length || E.length || v.length || x.length || N.length;
    }
    return v.length || x.length || N.length || C.length;
  }, M = (O) => {
    c(O);
  }, Y = q(
    () => ({
      isCountSummaryLoading: f,
      areFiltersActive: !!F(),
      urlFilterConfig: {
        rolloutStatus: g,
        preStage: b,
        deployStage: j,
        postStage: E,
        env: v,
        app: x,
        tenantInstallation: N,
        releaseChannelId: C
      },
      urlFilterConfigMap: {
        selectedRolloutStatus: g,
        preStageMap: Qs(b),
        deployStageMap: Qs(j),
        postStageMap: Qs(E),
        envMap: Qs(v),
        appMap: Qs(x),
        tenantInstallationMap: Qs(N),
        releaseChannelIdMap: Qs(C)
      },
      // Setting default
      filterCountSummary: o ?? El(null),
      updateFilterCountSummary: P,
      resetFilterCountSummary: L,
      updateFiltersByMap: k,
      handleRolloutStatusUpdate: B,
      updateFilters: w,
      clearFilters: R,
      stageListAccordionExpansionMap: a,
      setStageListAccordionExpansionMap: l,
      appEnvAndTenantListApiState: t,
      triggerReleaseView: h,
      handleTriggerReleaseViewChange: I,
      shouldPoll: i,
      handleUpdateShouldPoll: M,
      selectedTab: _,
      handleTabChange: S,
      appStatusModalConfig: d,
      setAppStatusModalConfig: m
    }),
    [
      a,
      _,
      o,
      g,
      b,
      j,
      E,
      v,
      x,
      N,
      C,
      t,
      h,
      i
    ]
  );
  return /* @__PURE__ */ e.jsx($o.Provider, { value: Y, children: s });
}, ze = () => {
  const s = Ct($o);
  if (!s)
    throw new Error("Please wrap with DeployFilterProvider");
  return s;
}, Yu = ({ label: s, value: t, onClick: n }) => {
  const a = () => {
    n(t);
  };
  return /* @__PURE__ */ e.jsx(
    "button",
    {
      type: "button",
      className: "dc__transparent dc__ellipsis-right flex dc__content-start dc__gap-8 pt-6 pb-6 pl-8 pr-8 cursor w-100 dc__hover-n50",
      onClick: a,
      children: /* @__PURE__ */ e.jsx("span", { className: "dc__ellipsis-right lh-20 fs-13 cn-9 fw-4", children: s })
    },
    t
  );
}, zu = ({
  existingStagesInBulkSelection: s,
  parentRef: t,
  count: n,
  handleButtonClick: a,
  handleClearBulkSelection: l
}) => {
  const [o, r] = T(!1), [i, c] = T(!1), [d, m] = T([]), { push: p } = fe(), u = Te(), { id: _, track: h } = de(), { isCountSummaryLoading: f, triggerReleaseView: g } = ze(), b = i || f, j = g === os.installation, E = (I) => {
    a(I);
  }, v = async (I) => {
    try {
      c(!0);
      const w = await So(_);
      if (w.length === 0) {
        j ? a(null) : E(I);
        return;
      }
      m(w), r(!0);
    } catch (w) {
      U(w);
    } finally {
      c(!1);
    }
  }, x = async () => {
    await v(null);
  }, N = async () => {
    await v(be.DEPLOY);
  }, y = () => {
    const I = W(D.RELEASE_DETAIL_REQUIREMENTS, {
      ...u
    });
    p(I);
  }, C = Du.filter(
    (I) => s[I.value.toLowerCase()]
  ), S = () => {
    r(!1);
  };
  return /* @__PURE__ */ e.jsxs(
    Ai,
    {
      dragSelector: ".drag-selector",
      positionVariant: Li.PARENT_BOTTOM_CENTER,
      parentRef: t,
      zIndex: "calc(var(--modal-index) - 1)",
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-8 pt-12 pb-12 pr-12 pl-8 bulk-selection-widget br-8", children: [
          /* @__PURE__ */ e.jsx(ki, { dragClassName: "drag-selector" }),
          /* @__PURE__ */ e.jsxs("div", { className: "fs-13 lh-20 fw-6 flex dc__gap-12", children: [
            /* @__PURE__ */ e.jsx("span", { className: "flex dc__gap-2 bcb-5 cn-0 br-4 pr-6 pl-6", children: n }),
            /* @__PURE__ */ e.jsx("span", { className: "cn-9", children: "Selected" })
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "dc__divider h-16" }),
          j ? /* @__PURE__ */ e.jsx(
            ie,
            {
              text: "Deploy",
              dataTestId: "installation-view-deploy",
              startIcon: /* @__PURE__ */ e.jsx(_n, {}),
              onClick: x,
              size: oe.small,
              disabled: b,
              isLoading: i
            }
          ) : /* @__PURE__ */ e.jsx(
            Di,
            {
              content: /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-8", children: [
                /* @__PURE__ */ e.jsx(_n, { className: "icon-stroke__white dc__no-svg-fill dc__no-shrink icon-dim-16" }),
                "Deploy"
              ] }),
              className: "fs-13",
              onClick: N,
              popUpBodyClassName: "mb-5",
              showPopUp: C.length > 1,
              disabled: b,
              isLoading: i,
              children: C.map((I) => /* @__PURE__ */ fs(Yu, { ...I, key: I.value, onClick: v }))
            }
          ),
          /* @__PURE__ */ e.jsx("div", { className: "dc__divider h-16" }),
          /* @__PURE__ */ e.jsx(re, { className: "default-tt", arrow: !1, placement: "top", content: "Clear Selection(s)", children: /* @__PURE__ */ e.jsx(
            "button",
            {
              type: "button",
              className: "dc__transparent flex p-0 dc__hover-remove-btn",
              onClick: l,
              "aria-label": "Clear bulk selection",
              disabled: b,
              children: /* @__PURE__ */ e.jsx(Ts, { className: "fcn-6 icon-dim-28 p-6" })
            }
          ) })
        ] }),
        o && /* @__PURE__ */ e.jsx(
          Uo,
          {
            changesForReview: d,
            handleClose: S,
            handleSuccess: y,
            trackName: h
          }
        )
      ]
    }
  );
};
var rs = /* @__PURE__ */ ((s) => (s.appName = "application", s.tenantInstallation = "tenantInstallation", s.envName = "environment", s.triggerStatus = "triggerStatus", s))(rs || {});
const sr = 36, tr = (s) => `${(s / 8).toFixed(2)}px`, Ku = ({
  rootClassName: s,
  showEditIcon: t = !1,
  height: n = 48,
  width: a = 48
}) => {
  const l = a > sr && n > sr;
  return /* @__PURE__ */ e.jsx(
    "div",
    {
      className: `flex dc__align-self-start dc__no-shrink br-4 ${l ? "tenants__tenant-fallback-image" : ""} ${t ? "base-image" : ""} ${s || ""}`,
      style: {
        height: n,
        width: a,
        ...l && {
          paddingBlock: tr(n),
          paddingInline: tr(a)
        }
      },
      children: /* @__PURE__ */ e.jsx(Yc, { className: `w-100 h-100 dc__opacity-1 ${l ? "fcb-4" : ""}` })
    }
  );
}, is = ({ imageProps: s, fallbackImageProps: t }) => {
  const n = s?.height ?? 48, a = s?.width ?? 48;
  return /* @__PURE__ */ e.jsx(
    Oi,
    {
      imageProps: {
        alt: "tenant-logo",
        ...s,
        height: n,
        width: a,
        className: "base-image dc__chart-grid-item__icon br-4 dc__no-shrink"
      },
      fallbackImage: /* @__PURE__ */ e.jsx(Ku, { ...t, height: n, width: a })
    }
  );
}, Ju = ({ appId: s, appName: t, envId: n, envName: a, triggerStatus: l, tenantConfig: o }) => /* @__PURE__ */ e.jsxs(
  "div",
  {
    className: "display-grid dc__column-gap-16 releases__deploy-feasibility-table-row fs-13 fw-4 lh-20 cn-9 py-8 px-20",
    children: [
      /* @__PURE__ */ e.jsx(
        ke,
        {
          to: `${bn.APPLICATION_MANAGEMENT_APP}/${s}/details/${n}`,
          className: "anchor dc__truncate",
          target: "_blank",
          children: t
        }
      ),
      /* @__PURE__ */ e.jsx("span", { children: /* @__PURE__ */ e.jsxs("span", { className: "flexbox dc__align-items-center dc__gap-8", children: [
        /* @__PURE__ */ e.jsx(
          is,
          {
            imageProps: {
              src: o.image,
              height: 20,
              width: 20
            }
          }
        ),
        /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: o.displayText })
      ] }) }),
      /* @__PURE__ */ e.jsx("span", { className: "flexbox-col", children: /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: a }) }),
      /* @__PURE__ */ e.jsx("span", { children: /* @__PURE__ */ e.jsxs("span", { className: "flexbox dc__gap-4", children: [
        /* @__PURE__ */ e.jsx("span", { className: "icon-dim-20 dc__no-shrink p-2", children: l.icon }),
        /* @__PURE__ */ e.jsxs("span", { className: "flexbox-col", children: [
          /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: l.text }),
          l.message && /* @__PURE__ */ e.jsx("span", { className: "dc__first-letter-capitalize fs-12 fw-4 lh-18 cn-9 dc__word-break", children: l.message })
        ] })
      ] }) })
    ]
  },
  `${t}-${a}-feasibility`
), Qu = ({
  isLoading: s,
  deployStatusList: t,
  filterConfig: { sortBy: n, sortOrder: a, handleSorting: l }
}) => {
  const o = t.some(
    (m) => m.isVirtualEnv && m.triggerStatus.code === ve.processed
  ), r = () => {
    l(rs.appName);
  }, i = () => {
    l(rs.tenantInstallation);
  }, c = () => {
    l(rs.envName);
  }, d = () => {
    l(rs.triggerStatus);
  };
  return /* @__PURE__ */ e.jsxs("div", { children: [
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: `display-grid dc__column-gap-16 releases__deploy-feasibility-table-row releases__deploy-feasibility-table-row--header ${o ? "releases__deploy-feasibility-table-row--with-virtual-env" : ""} dc__border-bottom fs-12 fw-6 lh-20 cn-7 dc__align-items-center dc__uppercase dc__position-sticky dc__top-49 dc__zi-4 bg__primary px-20`,
        children: [
          /* @__PURE__ */ e.jsx(
            Z,
            {
              isSorted: n === rs.appName,
              sortOrder: a,
              title: "Application",
              triggerSorting: r,
              disabled: s
            }
          ),
          /* @__PURE__ */ e.jsx(
            Z,
            {
              isSorted: n === rs.tenantInstallation,
              sortOrder: a,
              title: "Tenant (Installation)",
              triggerSorting: i,
              disabled: s
            }
          ),
          /* @__PURE__ */ e.jsx(
            Z,
            {
              isSorted: n === rs.envName,
              sortOrder: a,
              title: "Environment",
              triggerSorting: c,
              disabled: s
            }
          ),
          /* @__PURE__ */ e.jsx(
            Z,
            {
              isSorted: n === rs.triggerStatus,
              sortOrder: a,
              title: "Trigger Status",
              triggerSorting: d,
              disabled: s
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ e.jsx("div", { className: "dc__even-child--bcn-50", children: s ? Po.map((m) => /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: `display-grid dc__column-gap-16 releases__deploy-feasibility-table-row ${o ? "releases__deploy-feasibility-table-row--with-virtual-env" : ""} py-8 show-shimmer-loading px-20`,
        children: [
          /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
          /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
          /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
          /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" })
        ]
      },
      `${m.appName}-${m.envName}-feasibility-loading`
    )) : t.map((m) => /* @__PURE__ */ fs(Ju, { ...m, key: `${m.appName}-${m.envName}` })) })
  ] });
}, Xu = ({
  handleClose: s,
  stage: t,
  filteredBulkSelectionState: n,
  handleRetryDeployment: a
}) => {
  const l = Te(), { push: o } = fe(), { search: r } = fn(), { id: i } = de(), { sortBy: c, sortOrder: d, handleSorting: m } = ds({
    initialSortKey: rs.triggerStatus
  }), p = q(
    () => ({
      sortBy: c,
      sortOrder: d
    }),
    [c, d]
  ), [u, _, h, f] = K(
    () => su({
      id: i,
      bulkSelectionState: n,
      stage: t
    }),
    [n],
    Object.keys(n).length > 0,
    {
      resetOnChange: !1
    }
  ), g = u && !_, b = q(() => {
    if (_?.result?.length) {
      const { result: N } = _;
      return N.sort((y, C) => c === rs.envName ? te(y.envName, C.envName, d) : c === rs.triggerStatus ? Us(
        y.triggerStatus.sortPriority,
        C.triggerStatus.sortPriority,
        d
      ) : c === rs.tenantInstallation ? te(
        y.tenantConfig.displayText,
        C.tenantConfig.displayText,
        d
      ) : te(y.appName, C.appName, d));
    }
    return [];
  }, [_, p]), j = b?.some(
    (N) => N.triggerStatus?.code === ve.notProcessed
  ), E = () => /* @__PURE__ */ e.jsx("button", { type: "button", className: "cta secondary flex", onClick: s, children: "Close" });
  if (!t || !Object.keys(n).length)
    return /* @__PURE__ */ e.jsx(
      J,
      {
        title: "Couldn't verify the images for selected deployment",
        classname: "flex-grow-1",
        isButtonAvailable: !0,
        renderButton: E
      }
    );
  const v = (N) => {
    N.stopPropagation();
    const y = b.reduce(
      (C, S) => (C[Pt(S)] = S.triggerStatus.code === ve.notProcessed, C),
      {}
    );
    a(y);
  }, x = () => {
    s();
    const N = W(D.RELEASE_DETAIL_ROLLOUT_RELEASE, {
      ...l
    }), y = new URLSearchParams(r);
    y.set(Lt, Cs.rolloutStatus), o({
      pathname: N,
      search: y.toString()
    });
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
      /* @__PURE__ */ e.jsx("div", { className: "dc__position-sticky dc__top-0 bg__primary dc__zi-20", children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-justify dc__border-bottom pt-10 pr-20 pb-10 pl-20", children: [
        /* @__PURE__ */ e.jsxs("h2", { className: "fs-16 fw-6 lh-24 m-0 dc__ellipsis-right", children: [
          /* @__PURE__ */ e.jsx("span", { className: "dc__inline-block dc__first-letter-capitalize", children: Zn(t) }),
          " trigger status"
        ] }),
        /* @__PURE__ */ e.jsx(
          "button",
          {
            type: "button",
            className: "dc__transparent dc__no-shrink flexbox",
            "aria-label": "close-modal",
            onClick: s,
            children: /* @__PURE__ */ e.jsx(ys, { className: "icon-dim-24 icon-use-fill-n6" })
          }
        )
      ] }) }),
      /* @__PURE__ */ e.jsx(
        Ee,
        {
          isLoading: g,
          customLoader: /* @__PURE__ */ e.jsx(
            J,
            {
              title: "Fetching deployment trigger status...",
              subTitle: "It might take some time depending upon the number of deployments",
              classname: "flex-grow-1",
              image: ca
            }
          ),
          error: h,
          errorScreenManagerProps: {
            code: h?.code,
            reload: f
          },
          children: /* @__PURE__ */ e.jsx("div", {
            className: "flexbox-col flex-grow-1",
            // The null state would be applicable if the app or env has been deleted
            children: !u && !b?.length ? /* @__PURE__ */ e.jsx(
              J,
              {
                title: "Could not find selected deployment pipeline(s)",
                subTitle: "Looks like the deployment pipeline(s) selected by you do not exist anymore",
                classname: "dc__text-center flex flex-grow-1"
              }
            ) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              /* @__PURE__ */ e.jsx(
                cs,
                {
                  description: "Pipelines are triggered asynchronously. You can close this drawer, the actions will be performed in the background.",
                  borderConfig: { top: !1, left: !1, right: !1 },
                  borderRadiusConfig: {
                    top: !1,
                    left: !1,
                    right: !1,
                    bottom: !1
                  }
                }
              ),
              /* @__PURE__ */ e.jsx(
                Qu,
                {
                  deployStatusList: b,
                  isLoading: u,
                  filterConfig: {
                    ...p,
                    handleSorting: m
                  }
                }
              )
            ] })
          })
        }
      )
    ] }) }),
    !g && !h && /* @__PURE__ */ e.jsxs("div", { className: "px-20 py-16 flex dc__content-end dc__gap-12 dc__border-top", children: [
      /* @__PURE__ */ e.jsxs(
        "button",
        {
          className: `cta ${j ? "secondary" : ""} flex dc__no-shrink dc__gap-8 h-36`,
          type: "button",
          disabled: u,
          onClick: x,
          children: [
            "Go to rollout status",
            /* @__PURE__ */ e.jsx(
              jt,
              {
                className: `${j ? "scn-6" : "scn-0"} dc__no-shrink icon-dim-16`
              }
            )
          ]
        }
      ),
      j && /* @__PURE__ */ e.jsxs(
        Ws,
        {
          rootClassName: "cta flex dc__no-shrink dc__gap-8 h-36",
          type: "button",
          disabled: u,
          onClick: v,
          isLoading: u,
          children: [
            /* @__PURE__ */ e.jsx(zr, { className: "scn-0 dc__no-svg-fill dc__no-shrink icon-dim-16" }),
            "Retry Failed"
          ]
        }
      )
    ] })
  ] });
}, Zu = (s) => {
  const { handleClose: t } = s;
  return /* @__PURE__ */ e.jsx(rt, { position: "right", width: "1024px", onEscape: t, children: /* @__PURE__ */ e.jsx("div", { className: "bg__primary h-100 flexbox-col show-shimmer-loading", children: /* @__PURE__ */ e.jsx(Xu, { ...s }) }) });
}, nr = ({ isLoading: s, filteredCount: t, totalCount: n, filterTargetText: a }) => /* @__PURE__ */ e.jsxs("p", { className: "m-0 cn-9 fs-13 fw-4 lh-20 dc__truncate", children: [
  "Showing filtered results ",
  /* @__PURE__ */ e.jsxs("span", { className: "fw-6", children: [
    s ? "--" : t,
    " out of ",
    s ? "--" : n,
    " ",
    a
  ] })
] }), e_ = ({
  filterCountSummary: s,
  isCountSummaryLoading: t,
  showTenantSummary: n
}) => n ? /* @__PURE__ */ e.jsx(
  nr,
  {
    isLoading: t,
    filteredCount: s.tenantsCount.filteredCount,
    totalCount: s.tenantsCount.totalCount,
    filterTargetText: "tenants (installation)"
  }
) : /* @__PURE__ */ e.jsx(
  nr,
  {
    isLoading: t,
    filteredCount: s.deploymentsCount.filteredCount,
    totalCount: s.deploymentsCount.totalCount,
    filterTargetText: "deployment pipeline(s)"
  }
), s_ = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4 lh-20", children: [
  /* @__PURE__ */ e.jsx("div", { children: "Map these environments to a tenant installation to deploy this release." }),
  /* @__PURE__ */ e.jsxs(
    ke,
    {
      to: D.TENANTS,
      target: "_blank",
      className: "anchor fs-13 fw-4 lh-18 cb-5 flexbox dc__align-items-center dc__gap-6",
      children: [
        /* @__PURE__ */ e.jsx("span", { className: "dc__underline", children: "Map environments to tenant" }),
        /* @__PURE__ */ e.jsx(Sd, { className: "icon-dim-14 dc__no-shrink scb-5" })
      ]
    }
  )
] }), t_ = ({ unmappedEnvironments: s }) => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
  /* @__PURE__ */ e.jsx("div", { className: "p-8", children: /* @__PURE__ */ e.jsx(cs, { variant: "warning", description: /* @__PURE__ */ e.jsx(s_, {}) }) }),
  /* @__PURE__ */ e.jsx("div", { className: "p-8", children: s.map((t) => /* @__PURE__ */ e.jsxs("div", { className: "px-8 py-6 cn-9 fs-13 lh-20 flexbox dc__align-items-center dc__gap-8", children: [
    /* @__PURE__ */ e.jsx(il, { className: "dc__no-shrink icon-dim-16 scn-6" }),
    /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: t })
  ] }, t)) })
] }), Sl = ({ unmappedEnvironments: s, handleClose: t }) => /* @__PURE__ */ e.jsx(rt, { position: "right", width: "420px", onEscape: t, onClose: t, children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto h-100 bg__primary", onClick: lt, children: [
  /* @__PURE__ */ e.jsx("div", { className: "dc__position-sticky dc__top-0 bg__primary dc__zi-20", children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-justify dc__border-bottom pt-10 pr-20 pb-10 pl-20", children: [
    /* @__PURE__ */ e.jsxs("h2", { className: "fs-16 fw-6 lh-24 m-0 dc__ellipsis-right", children: [
      s.length,
      " unmapped environment(s) in this release"
    ] }),
    /* @__PURE__ */ e.jsx(
      "button",
      {
        type: "button",
        className: "dc__transparent dc__no-shrink flexbox",
        "aria-label": "close-modal",
        onClick: t,
        children: /* @__PURE__ */ e.jsx(ys, { className: "icon-dim-20 icon-use-fill-n6" })
      }
    )
  ] }) }),
  /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: /* @__PURE__ */ e.jsx(t_, { unmappedEnvironments: s }) })
] }) }), wl = ({
  reloadData: s,
  isLoading: t,
  lastSyncedTimestamp: n,
  hidePollingToggle: a = !1,
  children: l
}) => {
  const [o, r] = T("0s ago"), i = Ye(null), {
    urlFilterConfig: c,
    updateFilters: d,
    clearFilters: m,
    selectedTab: p,
    handleTabChange: u,
    triggerReleaseView: _,
    areFiltersActive: h,
    appEnvAndTenantListApiState: {
      appEnvAndTenantList: { tenantsWithInstallations: f, unmappedEnvironments: g, releaseChannels: b },
      isAppEnvAndTenantLoading: j
    },
    handleTriggerReleaseViewChange: E,
    shouldPoll: v,
    handleUpdateShouldPoll: x,
    filterCountSummary: N,
    isCountSummaryLoading: y
  } = ze(), C = () => `${n ? Mi({
    startTime: n,
    endTime: (/* @__PURE__ */ new Date()).toISOString(),
    fallbackString: ""
  }) : "0s"} ago`;
  ee(() => (n && (r(C()), i.current = setInterval(() => {
    r(C());
  }, 1e3)), () => {
    i.current && clearInterval(i.current);
  }), [n]);
  const [S, I] = T(!1), { tenantWithInstallationIdentifierToDisplayTextMap: w, releaseChannelIdToNameMap: k } = q(
    () => ({
      tenantWithInstallationIdentifierToDisplayTextMap: Hu(f),
      releaseChannelIdToNameMap: Tl(b)
    }),
    [f, b]
  ), R = p === Cs.rolloutStatus, B = g.length, P = p === Cs.triggerRelease && _ === os.installation, L = () => {
    E(
      P ? os.pipeline : os.installation
    );
  }, F = () => {
    x(!v);
  }, M = () => {
    I((Q) => !Q);
  }, Y = (Q, je) => Q === Le.tenantInstallation ? w[je] : Q === Le.releaseChannelId ? k[je] : Uu(Q, je), O = () => v ? t ? /* @__PURE__ */ e.jsx(Me, { name: "ic-circle-loader", color: "O500", size: 20 }) : /* @__PURE__ */ e.jsx(
    Pi,
    {
      duration: Zl,
      onComplete: s,
      size: 20,
      tooltipContent: `Syncing every ${Zl} Seconds`
    }
  ) : t ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-6 py-2 px-8 dc__align-items-center", children: [
    /* @__PURE__ */ e.jsx(Me, { name: "ic-circle-loader", color: "O500", size: 14 }),
    /* @__PURE__ */ e.jsx("span", { className: "dc__loading-dots cn-7 fs-12 fw-6 lh-20", children: "Syncing" })
  ] }) : /* @__PURE__ */ e.jsx(
    ie,
    {
      dataTestId: "reload-content-button",
      onClick: s,
      variant: _e.borderLess,
      size: oe.xs,
      style: qe.neutral,
      startIcon: /* @__PURE__ */ e.jsx(Me, { name: "ic-arrow-clockwise", color: null }),
      text: o
    }
  );
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "w-100 flex dc__content-space dc__gap-8 bg__primary border__primary--bottom", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-12 p-12", children: [
        /* @__PURE__ */ e.jsx(
          ea,
          {
            segments: Pu,
            value: p,
            size: oe.xs,
            name: "release-deploy-tabs",
            onChange: u
          }
        ),
        !R && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx("div", { className: "dc__divider h-20" }),
          /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-8", children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-4", children: [
              /* @__PURE__ */ e.jsx(
                vr,
                {
                  theme: Cr.white,
                  className: "w-400 dc__align-left",
                  placement: "bottom-start",
                  Icon: $r,
                  iconClass: "fcv-5",
                  infoText: /* @__PURE__ */ e.jsxs("div", { className: "fs-13 fw-4 lh-20 cn-9", children: [
                    /* @__PURE__ */ e.jsx("div", { children: "Installation view allows you to initiate deployment for all applications to a tenant installation at once." }),
                    /* @__PURE__ */ e.jsx("div", { className: "mt-20", children: "As of now, deployment from installation view is only available for installations with isolated environments." })
                  ] }),
                  heading: "Installation view",
                  showCloseButton: !0,
                  trigger: "click",
                  interactive: !0,
                  documentationLink: "RELEASE_HUB",
                  documentationLinkText: "View documentation",
                  children: /* @__PURE__ */ e.jsx("div", { className: "flex cursor", children: /* @__PURE__ */ e.jsx(Cn, { className: "fcn-6 icon-dim-20 dc__no-shrink" }) })
                }
              ),
              /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-20 cn-9", children: "Installation view" })
            ] }),
            _ && /* @__PURE__ */ e.jsx(
              Pn,
              {
                name: "installation-view-toggle",
                ariaLabel: "Toggle installation view",
                isChecked: P,
                onChange: L,
                size: oe.small
              }
            )
          ] })
        ] })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-start dc__gap-8 fs-13 lh-20 fw-6 cn-9 h-100", children: [
        (j || B > 0) && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          j ? /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-150 h-24 br-2" }) : /* @__PURE__ */ e.jsxs(
            "button",
            {
              type: "button",
              className: "dc__transparent bcy-1 br-4 px-8 py-2 fs-12 fw-4 lh-20 cn-9 flexbox dc__align-items-center dc__gap-6",
              onClick: M,
              children: [
                /* @__PURE__ */ e.jsx(Me, { name: "ic-warning", color: null, size: 16 }),
                /* @__PURE__ */ e.jsxs("span", { children: [
                  B,
                  " unmapped ",
                  B === 1 ? "env" : "envs"
                ] })
              ]
            }
          ),
          /* @__PURE__ */ e.jsx("div", { className: "divider__secondary h-100" })
        ] }),
        !a && /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 pr-12 py-12 dc__align-items-center", children: [
          O(),
          /* @__PURE__ */ e.jsx(
            Pn,
            {
              name: "should-poll-toggle",
              ariaLabel: "Toggle auto-sync",
              tooltipContent: `${v ? "Disable" : "Enable"} auto-sync`,
              isChecked: v,
              onChange: F,
              shape: "square",
              variant: "positive",
              iconName: "ic-arrows-clockwise"
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__align-items-center dc__gap-12 flex-grow-1 dc__overflow-auto", children: [
      h && /* @__PURE__ */ e.jsxs("div", { className: "w-100 flexbox-col dc__gap-8 px-12 pt-12", children: [
        /* @__PURE__ */ e.jsx(
          sa,
          {
            filterConfig: {
              ...c,
              ...R && {
                preStage: [],
                deployStage: [],
                postStage: [],
                rolloutStatus: null
              },
              ...P && {
                preStage: [],
                deployStage: [],
                postStage: [],
                app: [],
                env: [],
                tenantInstallation: []
              }
            },
            onRemoveFilter: d,
            clearFilters: m,
            getFormattedLabel: Fu,
            getFormattedValue: Y,
            className: "p-0 w-100",
            clearButtonClassName: "dc__no-background-imp dc__no-border-imp dc__tab-focus"
          }
        ),
        /* @__PURE__ */ e.jsx("div", { className: "dc__no-shrink dc__mxw-1400", children: /* @__PURE__ */ e.jsx(
          e_,
          {
            isCountSummaryLoading: y,
            filterCountSummary: N,
            showTenantSummary: R || P
          }
        ) })
      ] }),
      l
    ] }),
    S && /* @__PURE__ */ e.jsx(
      Sl,
      {
        handleClose: M,
        unmappedEnvironments: g
      }
    )
  ] });
}, Rl = ({
  urlFilterConfig: s,
  serviceHandler: t,
  additionalRequestMap: n
}) => {
  const { refetchReleaseDetail: a } = de(), [l, o] = T(!1), [r, i] = T(null), [c, d] = T(""), m = async () => {
    const v = await t();
    return await a(), d((/* @__PURE__ */ new Date()).toISOString()), v;
  }, [p, u, _, h, f] = K(
    m,
    [JSON.stringify(s)]
  ), g = async () => {
    try {
      o(!0), i(null);
      const v = await m();
      await Promise.all(
        Object.values(n?.current || {}).map((x) => x ? x() : null)
      ), v && f(v);
    } catch (v) {
      i(v);
    } finally {
      o(!1);
    }
  }, b = l || hs(r), j = p || hs(_);
  return {
    handleExternalSync: g,
    isExternalSyncLoading: b,
    isContentLoading: j,
    lastSyncedTimestamp: c,
    refetchResponse: h,
    initialError: _,
    ...{
      responseData: u
    }
  };
}, Bo = ({ type: s, setActionButtonDisabled: t, rootClassName: n = "" }) => {
  const [a, l] = T(""), o = () => {
    let i = "";
    switch (s) {
      case rn.RESOURCE:
      case rn.PIPELINE:
        i = "Delete ";
        break;
      default:
        i = "";
    }
    return `${i}${yr(rn[s].toLowerCase())}`;
  }, r = (i) => {
    l(i.target.value), t(i.target.value ? i.target.value !== o() : !0);
  };
  return /* @__PURE__ */ e.jsx("div", { className: n, children: /* @__PURE__ */ e.jsx(
    Fe,
    {
      placeholder: "Type to confirm",
      value: a,
      name: "delete-dialog-input",
      label: /* @__PURE__ */ e.jsxs("span", { children: [
        "Type ",
        /* @__PURE__ */ e.jsx("span", { className: "fw-6", children: `'${o()}'` }),
        "  to confirm"
      ] }),
      onChange: r,
      autoFocus: !0
    }
  ) });
}, CE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Bo
}, Symbol.toStringTag, { value: "Module" })), Il = ({ actionHandler: s, handleOnClose: t, modalType: n }) => {
  const [a, l] = T(!0), o = (r) => {
    a || s(r);
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "dc__border bg__primary br-4 w-300 dc__position-abs dc__right-20 dc__bottom-12 dc__box-shadow--overlay", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "dc__word-break dc__hyphens-auto flex left p-12 cn-9 dc__border-bottom-n1", children: [
      /* @__PURE__ */ e.jsxs("span", { className: "fs-14 fw-6 lh-20 mr-6", children: [
        Vl[n],
        " is blocked"
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "icon-dim-16 ml-auto", children: /* @__PURE__ */ e.jsx(ys, { className: "icon-dim-16 cursor fcn-9", onClick: t }) })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "dc__word-break dc__hyphens-auto fs-13 fw-4 lh-20 p-12", children: [
      Vl[n],
      " for some applications is blocked due to deployment window"
    ] }),
    /* @__PURE__ */ e.jsx(
      Bo,
      {
        type: n,
        rootClassName: "pl-12 pr-12",
        setActionButtonDisabled: l
      }
    ),
    /* @__PURE__ */ e.jsx("hr", { className: "mt-12 mb-12" }),
    /* @__PURE__ */ e.jsx("div", { className: "flex flex-justify-end h-32 mb-12 mr-12", children: /* @__PURE__ */ e.jsxs(
      "button",
      {
        className: `flex cta h-32 ${a ? "disabled-opacity" : ""}`,
        "data-testid": "bulk-deploy-confirm-button",
        type: "button",
        onClick: o,
        children: [
          /* @__PURE__ */ e.jsx(Wd, { className: "icon-dim-16 dc__no-svg-fill mr-8" }),
          yr(n)
        ]
      }
    ) })
  ] });
}, yE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Il
}, Symbol.toStringTag, { value: "Module" })), Ho = ({ handleClose: s, handleSuccess: t }) => /* @__PURE__ */ e.jsx(
  Hs,
  {
    variant: Gs.warning,
    title: "Cannot change images once deployment is initiated",
    subtitle: "You will not be able to change images for this release once deployment is initiated",
    handleClose: s,
    buttonConfig: {
      secondaryButtonConfig: {
        text: "Cancel",
        onClick: s
      },
      primaryButtonConfig: {
        text: "Deploy",
        onClick: t
      }
    },
    children: /* @__PURE__ */ e.jsx("span", { className: "fs-13 cn-7 lh-20", children: "Are you sure to initiate deployment?" })
  }
), n_ = ({
  isLoading: s,
  feasibilityList: t,
  filterConfig: { sortBy: n, sortOrder: a, handleSorting: l }
}) => {
  const o = () => {
    l(ls.appName);
  }, r = () => {
    l(ls.tenantInstallation);
  }, i = () => {
    l(ls.envName);
  }, c = () => {
    l(ls.feasibility);
  };
  return !s && !t?.length ? /* @__PURE__ */ e.jsx(
    J,
    {
      title: "Could not find selected deployment pipeline(s)",
      subTitle: "Looks like the deployment pipeline(s) selected by you do not exist anymore",
      classname: "dc__text-center"
    }
  ) : /* @__PURE__ */ e.jsxs("div", { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "display-grid dc__column-gap-16 releases__deploy-feasibility-table-row releases__deploy-feasibility-table-row--header dc__border-bottom fs-12 fw-6 lh-20 cn-7 dc__align-items-center dc__uppercase dc__position-sticky dc__top-49 dc__zi-4 bg__primary px-20", children: [
      /* @__PURE__ */ e.jsx(
        Z,
        {
          isSorted: n === ls.appName,
          sortOrder: a,
          title: "Application",
          triggerSorting: o,
          disabled: s
        }
      ),
      /* @__PURE__ */ e.jsx(
        Z,
        {
          isSorted: n === ls.tenantInstallation,
          sortOrder: a,
          title: "Tenant (Installation)",
          triggerSorting: r,
          disabled: s
        }
      ),
      /* @__PURE__ */ e.jsx(
        Z,
        {
          isSorted: n === ls.envName,
          sortOrder: a,
          title: "Environment",
          triggerSorting: i,
          disabled: s
        }
      ),
      /* @__PURE__ */ e.jsx(
        Z,
        {
          isSorted: n === ls.feasibility,
          sortOrder: a,
          title: "Feasibility",
          triggerSorting: c,
          disabled: s
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "dc__even-child--bcn-50", children: s ? Mo.map((d) => /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: "display-grid dc__column-gap-16 releases__deploy-feasibility-table-row py-8 show-shimmer-loading px-20",
        children: [
          /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
          /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
          /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
          /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" })
        ]
      },
      `${d.appName}-${d.envName}-feasibility-loading`
    )) : t.map((d) => /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: "display-grid dc__column-gap-16 releases__deploy-feasibility-table-row fs-13 fw-4 lh-20 cn-9 py-8 px-20",
        children: [
          /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: d.appName }),
          /* @__PURE__ */ e.jsx("span", { children: /* @__PURE__ */ e.jsxs("span", { className: "flexbox dc__align-items-center dc__gap-8", children: [
            /* @__PURE__ */ e.jsx(
              is,
              {
                imageProps: {
                  src: d.tenantConfig.image,
                  height: 20,
                  width: 20
                }
              }
            ),
            /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: d.tenantConfig.displayText })
          ] }) }),
          /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: d.envName }),
          /* @__PURE__ */ e.jsx("span", { children: /* @__PURE__ */ e.jsxs("span", { className: "flexbox dc__gap-4", children: [
            /* @__PURE__ */ e.jsx("span", { className: "icon-dim-20 dc__no-shrink p-2", children: d.feasibility.icon }),
            /* @__PURE__ */ e.jsxs("span", { className: "flexbox-col", children: [
              /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: d.feasibility.text }),
              d.message && /* @__PURE__ */ e.jsx(
                "span",
                {
                  "data-testid": "release-feasibility-message",
                  className: "dc__first-letter-capitalize fs-12 fw-4 lh-18 cn-9 dc__word-break",
                  children: d.message
                }
              )
            ] })
          ] }) })
        ]
      },
      `${d.appName}-${d.envName}-feasibility`
    )) })
  ] });
}, a_ = ({
  handleClose: s,
  handleSuccess: t,
  bulkSelectionState: n = {},
  stage: a
}) => {
  const { id: l, status: o } = de(), [r, i] = T(!1), [c, d] = T(!1), { sortBy: m, sortOrder: p, handleSorting: u } = ds({
    initialSortKey: ls.feasibility
  }), _ = q(
    () => ({
      sortBy: m,
      sortOrder: p
    }),
    [m, p]
  ), [h, f, g, b] = K(
    () => Zm({
      id: l,
      bulkSelectionState: n,
      stage: a
    }),
    [],
    Object.keys(n).length > 0,
    {
      resetOnChange: !1
    }
  ), j = h && !f, E = q(() => {
    if (f?.result?.length) {
      const { result: k } = f;
      return k.sort((R, B) => m === ls.envName ? te(R.envName, B.envName, p) : m === ls.feasibility ? Us(
        R.feasibility.sortPriority,
        B.feasibility.sortPriority,
        p
      ) : m === ls.tenantInstallation ? te(
        R.tenantConfig.displayText,
        B.tenantConfig.displayText,
        p
      ) : te(R.appName, B.appName, p));
    }
    return [];
  }, [f, _]), v = () => /* @__PURE__ */ e.jsx("button", { type: "button", className: "cta secondary flex", onClick: s, children: "Close" });
  if (!a || !Object.keys(n).length)
    return /* @__PURE__ */ e.jsx(
      J,
      {
        title: "Couldn't verify the images for selected deployment",
        classname: "flex-grow-1",
        isButtonAvailable: !0,
        renderButton: v
      }
    );
  const x = E.length, N = E.filter((k) => ro.includes(k.feasibility.code)).length || 0, y = () => {
    i(!1);
  }, C = () => {
    d(!1);
  }, S = () => {
    i(!0);
  }, I = () => {
    if (c) {
      d(!1), S();
      return;
    }
    r && i(!1);
    const k = E.reduce(
      (R, B) => (R[Pt(B)] = B.feasibility.statusCode === Ce.CanTrigger, R),
      {}
    );
    t(k);
  }, w = () => {
    if (E.some(
      (R) => R.feasibility.code === Ce.CanTriggerInDeploymentWindow
    )) {
      d(!0);
      return;
    }
    if (o === H.READY_FOR_RELEASE) {
      S();
      return;
    }
    I();
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
        /* @__PURE__ */ e.jsx("div", { className: "dc__position-sticky dc__top-0 bg__primary dc__zi-20", children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-justify dc__border-bottom pt-10 pr-20 pb-10 pl-20", children: [
          /* @__PURE__ */ e.jsxs("h2", { className: "fs-16 fw-6 lh-24 m-0 dc__ellipsis-right", children: [
            "Review feasibility for ",
            Zn(a),
            "(s)"
          ] }),
          /* @__PURE__ */ e.jsx(
            "button",
            {
              type: "button",
              className: "dc__transparent dc__no-shrink flexbox",
              "aria-label": "close-modal",
              onClick: s,
              children: /* @__PURE__ */ e.jsx(Ts, { className: "icon-dim-24 icon-use-fill-n6" })
            }
          )
        ] }) }),
        /* @__PURE__ */ e.jsx(
          Ee,
          {
            isLoading: j,
            customLoader: /* @__PURE__ */ e.jsx(
              J,
              {
                title: "Verifying selected images for deployment",
                subTitle: "It might take some time depending upon the number of applications and environments",
                classname: "flex-grow-1",
                image: ca
              }
            ),
            error: g,
            errorScreenManagerProps: {
              code: g?.code,
              reload: b
            },
            children: /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1", children: /* @__PURE__ */ e.jsx(
              n_,
              {
                feasibilityList: E,
                isLoading: h,
                filterConfig: {
                  ..._,
                  handleSorting: u
                }
              }
            ) })
          }
        )
      ] }),
      !j && !g && /* @__PURE__ */ e.jsxs("div", { className: "px-20 py-10 flex dc__content-space dc__gap-12 dc__border-top", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox py-6 dc__gap-8", children: [
          /* @__PURE__ */ e.jsx(da, { className: "icon-dim-20 dc__no-shrink warning-icon-y5-imp" }),
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
            /* @__PURE__ */ e.jsxs("span", { className: "fs-13 fw-6 lh-20 cn-9 dc__truncate", children: [
              N,
              "/",
              x,
              " selected deployments can be initiated"
            ] }),
            /* @__PURE__ */ e.jsx("span", { className: "fs-12 lh-18 cn-7 fw-4 dc__truncate", children: "You will not be able to change images for this release once deployment is initiated" })
          ] })
        ] }),
        /* @__PURE__ */ e.jsxs(
          "button",
          {
            className: "cta flex dc__no-shrink dc__gap-8 h-36",
            type: "button",
            disabled: !N || h,
            onClick: w,
            children: [
              /* @__PURE__ */ e.jsx(_n, { className: "scn-0 dc__no-svg-fill dc__no-shrink icon-dim-16" }),
              "Deploy"
            ]
          }
        )
      ] })
    ] }),
    c && /* @__PURE__ */ e.jsx(
      Il,
      {
        actionHandler: I,
        handleOnClose: C,
        modalType: rn.DEPLOY
      }
    ),
    r && /* @__PURE__ */ e.jsx(Ho, { handleClose: y, handleSuccess: I })
  ] });
}, l_ = (s) => {
  const { handleClose: t } = s;
  return /* @__PURE__ */ e.jsx(rt, { position: "right", width: "1024px", onEscape: t, children: /* @__PURE__ */ e.jsx("div", { className: "bg__primary h-100 flexbox-col show-shimmer-loading", children: /* @__PURE__ */ e.jsx(a_, { ...s }) }) });
}, ga = ({
  children: s,
  tenantConfig: t
}) => /* @__PURE__ */ e.jsx(
  re,
  {
    content: /* @__PURE__ */ e.jsxs("div", { className: "flex column left dc__gap-4 fs-12 lh-18 fw-4", children: [
      /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("div", { className: "fw-6", children: "Tenant (Installation)" }),
        /* @__PURE__ */ e.jsx("div", { children: t.displayText })
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom--n7 w-100" }),
      /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("div", { className: "fw-6", children: "Release Channel" }),
        /* @__PURE__ */ e.jsx("div", { children: t.installationConfig.releaseChannelName || at.label })
      ] })
    ] }),
    className: "default-tt",
    arrow: !1,
    placement: "right",
    children: s
  }
), Ha = (s) => {
  let t = null;
  switch (s) {
    case A.DEPLOY_INITIATED:
    case A.PRE_POST_INITIATED:
    case A.PRE_POST_RUNNING:
    case A.PROGRESSING:
    case A.WAITING_TO_START:
      t = Js.PROGRESSING;
      break;
    case A.QUEUED:
      t = Js.QUEUED;
      break;
    case A.CANCELLED:
      t = Js.CANCELLED;
      break;
    case A.ABORTED:
      t = Js.ABORTED;
      break;
    case A.FAILED:
      t = Js.FAILED;
      break;
    case A.ERROR:
    case A.UNABLE_TO_FETCH:
      t = Js.ERROR;
      break;
    case A.HEALTHY:
    case A.SUCCEEDED:
      t = Js.SUCCEEDED;
      break;
    case A.TIMED_OUT:
      t = Js.TIMED_OUT;
      break;
    case A.NOT_TRIGGERED:
      return /* @__PURE__ */ e.jsx("div", { className: "dc__no-shrink flex icon-dim-16", children: /* @__PURE__ */ e.jsx(
        Fi,
        {
          rootClassName: "dc__no-shrink",
          backgroundColorClass: "bcn-3",
          iconSizeClass: "icon-dim-8"
        }
      ) });
    default:
      return /* @__PURE__ */ e.jsx(
        "span",
        {
          className: `dc__cd-trigger-status__icon ${(Object.values(A).includes(s) ? s : A.UNKNOWN).toLowerCase()} mr-0 w-16 h-16`
        }
      );
  }
  return /* @__PURE__ */ e.jsx(Ui, { status: t, iconSize: 16, hideMessage: !0, hideIconTooltip: !0 });
}, r_ = (s) => {
  switch (s) {
    case A.DEPLOY_INITIATED:
    case A.PRE_POST_INITIATED:
    case A.PRE_POST_RUNNING:
    case A.QUEUED:
    case A.PROGRESSING:
      return "co-7";
    case A.SUCCEEDED:
    case A.HEALTHY:
      return "cg-7";
    case A.FAILED:
    case A.ABORTED:
    case A.TIMED_OUT:
    case A.DEGRADED:
    case A.ERROR:
    case A.CANCELLED:
    case A.UNABLE_TO_FETCH:
      return "cr-7";
    default:
      return "cn-9";
  }
}, Ga = (s) => {
  switch (s) {
    case A.DEPLOY_INITIATED:
    case A.PRE_POST_INITIATED:
    case A.PRE_POST_RUNNING:
    case A.QUEUED:
    case A.PROGRESSING:
      return "eo-2 bw-1";
    case A.SUCCEEDED:
    case A.HEALTHY:
      return "eg-2 bw-1";
    case A.FAILED:
    case A.ABORTED:
    case A.TIMED_OUT:
    case A.DEGRADED:
    case A.ERROR:
    case A.CANCELLED:
    case A.UNABLE_TO_FETCH:
      return "er-2 bw-1";
    default:
      return "en-2 bw-1";
  }
}, Go = (s, t) => {
  switch (s) {
    // Redirect to app details
    case A.DEPLOY_INITIATED:
    case A.PROGRESSING:
    case A.UNKNOWN:
    case A.MISSING:
    case A.UNABLE_TO_FETCH:
      return `${bn.APPLICATION_MANAGEMENT_APP}/${t.appId}/details/${t.envId}`;
    // Redirect to release history
    case A.PRE_POST_INITIATED:
    case A.PRE_POST_RUNNING:
    case A.QUEUED:
    case A.SUCCEEDED:
    case A.HEALTHY:
    case A.FAILED:
    case A.ABORTED:
    case A.TIMED_OUT:
    case A.DEGRADED:
    case A.ERROR:
    case A.CANCELLED:
      return t.triggerId ? W(D.RELEASE_DETAIL_HISTORY, t) : null;
    default:
      return null;
  }
}, wa = ({
  tippyContent: s,
  status: t,
  expandedModeProps: n = {},
  stageType: a,
  redirectionParams: l,
  handleShowAppStatusModal: o
}) => {
  const r = () => /* @__PURE__ */ e.jsx(
    "div",
    {
      className: `flex dc__no-shrink icon-dim-24 dc__border-radius-50-per bg__primary ${Ga(t)}`,
      children: Ha(t)
    }
  ), i = () => {
    if (a === be.DEPLOY) {
      const { isExpandedMode: m, appName: p, envName: u } = n;
      return /* @__PURE__ */ e.jsx(
        "button",
        {
          type: "button",
          onClick: o,
          className: `dc__transparent ${m ? "flex-grow-1" : ""}`,
          "data-testid": `deployment-stage-status-${p}-${u}`,
          children: /* @__PURE__ */ e.jsxs(
            "div",
            {
              className: `flexbox dc__align-items-center py-4 px-8 br-4 bg__primary ${m ? "w-100 dc__gap-4" : "dc__gap-8"} ${Ga(t)}`,
              children: [
                Ha(t),
                m ? /* @__PURE__ */ e.jsxs("span", { className: `fs-12 fw-4 lh-20 ${r_(t)} dc__truncate`, children: [
                  p,
                  " (",
                  u,
                  ")"
                ] }) : /* @__PURE__ */ e.jsx(_n, { className: "icon-dim-16 dc__no-shrink" })
              ]
            }
          )
        }
      );
    }
    const c = Go(t, l), d = n?.isExpandedMode ?? !1;
    return c ? /* @__PURE__ */ e.jsx(
      ke,
      {
        to: c,
        target: "_blank",
        className: `dc__no-decor ${d ? "flex-grow-1" : ""}`,
        children: r()
      }
    ) : r();
  };
  return /* @__PURE__ */ e.jsx(re, { content: s, arrow: !1, className: "default-tt", children: i() });
}, Ra = (s, t, n) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__content-center dc__gap-8", children: [
  n.isExpandedMode && /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__align-items-center p-6", children: [
      /* @__PURE__ */ e.jsx("div", { className: "w-8 h-8 dc__border-radius-50-per border__white" }),
      /* @__PURE__ */ e.jsx("div", { className: "dc__divider bcn-6" }),
      /* @__PURE__ */ e.jsx("div", { className: "w-8 h-8 dc__border-radius-50-per bg__white" })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
      /* @__PURE__ */ e.jsx("p", { className: "m-0 text__white fs-12 fw-6 lh-20 dc__truncate", children: n.appName }),
      /* @__PURE__ */ e.jsx("p", { className: "m-0 text__white fs-12 fw-6 lh-20 dc__truncate", children: n.envName })
    ] })
  ] }),
  /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
    /* @__PURE__ */ e.jsx("h4", { className: "m-0 text__white fs-12 fw-6 lh-18", children: s }),
    /* @__PURE__ */ e.jsx("p", { className: "m-0 text__white fs-12 fw-4 lh-18", children: Zs[t] })
  ] })
] }), Al = ({
  deployStatus: s,
  preStatus: t,
  postStatus: n,
  isPreConfigured: a,
  isPostConfigured: l,
  expandedModeProps: o = {},
  appId: r,
  envId: i,
  appName: c,
  envName: d,
  pipelineId: m,
  preCdWorkflowRunnerId: p,
  postCdWorkflowRunnerId: u
}) => {
  const { track: _, version: h } = de(), { setAppStatusModalConfig: f } = ze(), { isExpandedMode: g } = o, b = !g || a, j = !g || l, E = {
    appId: r,
    envId: i,
    pipelineId: m,
    releaseTrack: _,
    releaseVersion: h
  }, v = () => {
    f({
      appId: r,
      envId: i,
      titleSegments: [c, d]
    });
  };
  return /* @__PURE__ */ e.jsxs("div", { className: `flexbox ${g ? "w-214" : ""}`, children: [
    b && /* @__PURE__ */ e.jsxs("div", { className: `flexbox dc__align-items-center ${a ? "" : "dc__visibility-hidden"}`, children: [
      /* @__PURE__ */ e.jsx(
        wa,
        {
          status: t,
          tippyContent: Ra(
            Ca.PRE_DEPLOY,
            t,
            o
          ),
          redirectionParams: {
            ...E,
            triggerId: p
          },
          stageType: be.PRE
        }
      ),
      /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom w-10" })
    ] }),
    /* @__PURE__ */ e.jsx(
      wa,
      {
        tippyContent: Ra(
          Ca.DEPLOY,
          s,
          o
        ),
        status: s,
        stageType: be.DEPLOY,
        handleShowAppStatusModal: v,
        ...g && {
          expandedModeProps: o
        }
      }
    ),
    j && /* @__PURE__ */ e.jsxs("div", { className: `flexbox dc__align-items-center ${l ? "" : "dc__visibility-hidden"}`, children: [
      /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom w-10" }),
      /* @__PURE__ */ e.jsx(
        wa,
        {
          status: n,
          tippyContent: Ra(
            Ca.POST_DEPLOY,
            n,
            o
          ),
          redirectionParams: {
            ...E,
            triggerId: u
          },
          stageType: be.POST
        }
      )
    ] })
  ] });
}, Wo = ({ status: s, showTippy: t }) => {
  const n = (a) => /* @__PURE__ */ e.jsx(
    re,
    {
      className: "default-tt",
      arrow: !1,
      content: /* @__PURE__ */ e.jsxs("div", { className: "dc__first-letter-capitalize", children: [
        "Deployment is ",
        Zs[s]
      ] }),
      children: a
    }
  );
  return /* @__PURE__ */ e.jsx($e, { condition: t, wrap: n, children: /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-start dc__gap-4 dc__no-shrink", children: [
    /* @__PURE__ */ e.jsx(
      "div",
      {
        className: `flex dc__no-shrink icon-dim-14 dc__border-radius-50-per bg__primary ${Ga(s)}`,
        children: Ha(s)
      }
    ),
    /* @__PURE__ */ e.jsx("div", { children: Zs[s] })
  ] }) });
}, o_ = (s) => /* @__PURE__ */ e.jsx(re, { content: "No deployable pipeline(s) in this stage", placement: "top", className: "default-tt w-200", arrow: !1, children: /* @__PURE__ */ e.jsx("span", { children: s }) }), i_ = ({ appEnv: s, isSomeRowChecked: t, bulkSelectionStateForStage: n, levelIndex: a }) => {
  const {
    appName: l,
    envName: o,
    deployStatus: r,
    preStatus: i,
    postStatus: c,
    existingStages: d,
    appId: m,
    envId: p,
    preCdWorkflowRunnerId: u,
    postCdWorkflowRunnerId: _,
    pipelineId: h
  } = s, { pre: f, post: g } = d, { isBulkSelectionApplied: b, handleBulkSelection: j } = Tr(), E = Pt(s), v = b || !!n[E], x = t || v, N = () => {
    if (b) {
      j({
        action: on.CLEAR_IDENTIFIERS_AFTER_ACROSS_SELECTION,
        data: {
          identifierIds: [E]
        }
      });
      return;
    }
    j(
      n[E] ? {
        action: on.CLEAR_IDENTIFIERS,
        data: {
          identifierIds: [E]
        }
      } : {
        action: on.SELECT_IDENTIFIER,
        data: {
          identifierObject: {
            ...n,
            [E]: lo(s, a)
          }
        }
      }
    );
  }, y = (C) => /* @__PURE__ */ e.jsx(
    re,
    {
      content: s.isDeployable ? "From the pipeline view, deployment is not available for isolated installations" : `Above application(s) in previous stage(s) must be deployed first on ${s.tenantConfig.displayText}`,
      placement: "top",
      className: "default-tt w-200",
      arrow: !1,
      children: /* @__PURE__ */ e.jsx("span", { children: C })
    }
  );
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `display-grid dc__column-gap-16 releases__deploy-table-row dc__border-bottom-n1 fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-20 dc__visible-hover dc__visible-hover--parent ${v ? "bc-b50" : ""} dc__hover-n50`,
      children: [
        /* @__PURE__ */ e.jsxs("span", { className: "flex dc__content-start", children: [
          !x && /* @__PURE__ */ e.jsx(Fr, { className: "icon-dim-20 dc__visible-hover--hide-child" }),
          /* @__PURE__ */ e.jsx($e, { condition: !s.isDeployable || s.isVirtualEnvironment, wrap: y, children: /* @__PURE__ */ e.jsx(
            js,
            {
              isChecked: v ?? !1,
              onChange: N,
              rootClassName: `mb-0 ${x ? "" : "dc__visible-hover--child"}`,
              value: Oe.CHECKED,
              disabled: !s.isDeployable || s.isVirtualEnvironment
            }
          ) })
        ] }),
        /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: l }),
        /* @__PURE__ */ e.jsx(ga, { tenantConfig: s.tenantConfig, children: /* @__PURE__ */ e.jsx("span", { className: "dc__truncate dc__w-fit-content", children: s.tenantConfig.displayText }) }),
        /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: o }),
        /* @__PURE__ */ e.jsx(
          Al,
          {
            deployStatus: r,
            preStatus: i,
            postStatus: c,
            isPreConfigured: f,
            isPostConfigured: g,
            appId: m,
            envId: p,
            appName: l,
            envName: o,
            preCdWorkflowRunnerId: u,
            postCdWorkflowRunnerId: _,
            pipelineId: h
          }
        )
      ]
    }
  );
}, c_ = ({
  id: s,
  isLoading: t,
  appEnvList: n,
  bulkSelectionStateConfig: { bulkSelectionStateForStage: a, setBulkSelectionState: l },
  filterConfig: { sortBy: o, sortOrder: r, handleSorting: i },
  allowedAllSelectionsLength: c
}) => {
  const { selectedIdentifiers: d, handleBulkSelection: m, getSelectedIdentifiersCount: p } = Tr(), u = p() > 0, _ = c === 0;
  ee(() => {
    m({
      action: on.SELECT_IDENTIFIER,
      data: {
        identifierObject: a
      }
    });
  }, []), ee(() => {
    Object.keys(a).length || m({
      action: on.CLEAR_ALL_SELECTIONS
    });
  }, [a]), ee(() => {
    const b = Object.keys(d).length, j = Object.keys(a).length;
    !t && j !== b && l((E) => ({
      ...E,
      [s]: JSON.parse(JSON.stringify(d))
    }));
  }, [d, t]);
  const h = () => {
    i(bs.appName);
  }, f = () => {
    i(bs.tenantInstallation);
  }, g = () => {
    i(bs.envName);
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "bg__primary", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "display-grid dc__column-gap-16 dc__position-sticky dc__top-0 dc__zi-1 bg__primary releases__deploy-table-row releases__deploy-table-row--header dc__border-bottom-n1 fs-12 fw-6 lh-20 cn-7 dc__align-items-center px-20 dc__uppercase", children: [
      /* @__PURE__ */ e.jsx("div", { className: `flex dc__content-start ${t ? "show-shimmer-loading" : ""}`, children: t ? /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading w-100" }) : /* @__PURE__ */ e.jsx($e, { condition: _, wrap: o_, children: /* @__PURE__ */ e.jsx($i, { showPagination: !1, disabled: _ }) }) }),
      /* @__PURE__ */ e.jsx(
        Z,
        {
          isSorted: o === bs.appName,
          sortOrder: r,
          title: "Application",
          triggerSorting: h,
          disabled: t
        }
      ),
      /* @__PURE__ */ e.jsx(
        Z,
        {
          isSorted: o === bs.tenantInstallation,
          sortOrder: r,
          title: "Tenant (Installation)",
          triggerSorting: f,
          disabled: t
        }
      ),
      /* @__PURE__ */ e.jsx(
        Z,
        {
          isSorted: o === bs.envName,
          sortOrder: r,
          title: "Environment",
          triggerSorting: g,
          disabled: t
        }
      ),
      /* @__PURE__ */ e.jsx("span", { children: "Deployment Status" })
    ] }),
    /* @__PURE__ */ e.jsx("div", { children: t ? ku.map((b) => /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: "display-grid dc__column-gap-16 releases__deploy-table-row dc__border-bottom-n1 dc__align-items-center px-20 show-shimmer-loading",
        children: [
          /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
          /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
          /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
          /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
          /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" })
        ]
      },
      `app-env-row--loading-${Pt(b)}`
    )) : n.map((b) => /* @__PURE__ */ e.jsx(
      i_,
      {
        appEnv: b,
        isSomeRowChecked: u,
        bulkSelectionStateForStage: a,
        levelIndex: s
      },
      `app-env-row-${Pt(b)}`
    )) })
  ] });
}, Ia = {
  [bs.appName]: "appName",
  [bs.envName]: "envName",
  [bs.tenantInstallation]: "tenantConfig.displayText"
}, ar = (s, t) => t.split(".").reduce((n, a) => n[a], s), d_ = (s, t, n) => s.sort((a, l) => {
  const o = Ia[n], r = a[o], i = l[o];
  return r === i ? Object.keys(Ia).filter((d) => d !== n).map((d) => Ia[d]).reduce((d, m) => d !== 0 ? d : te(
    ar(a, m),
    ar(l, m),
    t
  ), 0) : te(r, i, t);
}), p_ = () => Hi.OPEN, m_ = ({ id: s, handleUpdateIdToRefetchMapping: t, ...n }) => {
  const { id: a } = de(), { sortBy: l, sortOrder: o, handleSorting: r } = ds({
    initialSortKey: bs.appName
  }), { urlFilterConfig: i, areFiltersActive: c } = ze(), d = Ye(new AbortController()), m = async () => await Vs(
    () => Xm(
      {
        releaseId: a,
        stageId: s,
        filterConfig: i
      },
      d.current.signal
    ),
    d
  ), [p, u, _, h, f] = K(
    m,
    // Not added the url filters as dependency here because the list is anyways refetch
    [s]
  ), g = async () => {
    const x = await m();
    f(x);
  };
  ee(() => (t(s, g), () => {
    d.current.abort(), t(s, null);
  }), []);
  const b = p || hs(_), j = q(
    () => ({
      sortBy: l,
      sortOrder: o
    }),
    [l, o]
  ), E = q(() => {
    if (u?.result?.length) {
      const { result: x } = u;
      return d_(x, o, l);
    }
    return [];
  }, [u, j]), v = q(
    () => E?.filter((x) => x.isDeployable && !x.isVirtualEnvironment)?.reduce((x, N) => (x[Pt(N)] = lo(N, s), x), {}) ?? {},
    [u]
  );
  if (!b) {
    if (_)
      return /* @__PURE__ */ e.jsx(As, { reload: h, rootClassName: "bg__primary" });
    if (!E?.length)
      return /* @__PURE__ */ e.jsx(
        As,
        {
          useInfoIcon: !0,
          title: c ? "No matching results found for selected filters" : "Could not find any mapped deployment pipeline(s)",
          subTitle: "",
          description: "",
          rootClassName: "p-32 bg__primary"
        }
      );
  }
  return /* @__PURE__ */ e.jsx(
    Bi,
    {
      identifiers: v,
      getSelectAllDialogStatus: p_,
      children: /* @__PURE__ */ e.jsx(
        c_,
        {
          ...n,
          id: s,
          isLoading: b,
          appEnvList: E,
          filterConfig: {
            ...j,
            handleSorting: r
          },
          allowedAllSelectionsLength: Object.keys(v).length
        }
      )
    }
  );
}, u_ = ({ title: s, getContent: t, toggleAccordion: n, isExpanded: a }) => /* @__PURE__ */ e.jsxs("div", { className: "shadow__card--10 border__secondary br-8 dc__contain--paint", children: [
  /* @__PURE__ */ e.jsxs(
    "button",
    {
      className: `dc__transparent py-10 pl-20 pr-8 flex dc__content-space dc__gap-8 w-100 ${a ? "bg__secondary" : "bg__primary"}`,
      type: "button",
      role: "tab",
      onClick: n,
      children: [
        /* @__PURE__ */ e.jsx("div", { className: "dc__truncate w-100", children: s }),
        /* @__PURE__ */ e.jsx(
          tt,
          {
            className: `icon-dim-24 p-2 dc__no-shrink dc__transition--transform ${a ? "dc__flip-180" : ""}`
          }
        )
      ]
    }
  ),
  a && /* @__PURE__ */ e.jsx("div", { children: t() })
] }), __ = ({
  id: s,
  icon: t,
  title: n,
  bulkSelectionStateConfig: a,
  handleUpdateIdToRefetchMapping: l
}) => {
  const { stageListAccordionExpansionMap: o, setStageListAccordionExpansionMap: r } = ze(), i = () => {
    r((m) => ({
      ...m,
      [s]: !m[s]
    }));
  }, c = () => /* @__PURE__ */ e.jsx("div", { className: "flex dc__gap-8 dc__content-space fs-13 lh-20", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8", children: [
    t,
    /* @__PURE__ */ e.jsx("span", { className: "dc__truncate dc__uppercase fw-6 cn-7", children: n })
  ] }) }), d = () => /* @__PURE__ */ e.jsx(
    m_,
    {
      id: s,
      bulkSelectionStateConfig: a,
      handleUpdateIdToRefetchMapping: l
    }
  );
  return /* @__PURE__ */ e.jsx(
    u_,
    {
      title: c(),
      getContent: d,
      isExpanded: o[s],
      toggleAccordion: i
    }
  );
}, h_ = ({
  selectedStage: s,
  setSelectedStage: t,
  isFeasibilityModalOpen: n,
  setIsFeasibilityModalOpen: a,
  handleClearBulkSelection: l,
  bulkSelectionState: o,
  setBulkSelectionState: r
}) => {
  const { id: i, refetchReleaseDetail: c } = de(), {
    urlFilterConfig: d,
    updateFilterCountSummary: m,
    resetFilterCountSummary: p,
    stageListAccordionExpansionMap: u,
    setStageListAccordionExpansionMap: _,
    triggerReleaseView: h,
    handleTriggerReleaseViewChange: f
  } = ze(), g = Ye({}), b = Ye(new AbortController()), j = async () => await Vs(
    () => Qm(
      {
        releaseId: i,
        filterConfig: d
      },
      b.current.signal
    ),
    b
  ), {
    handleExternalSync: E,
    isExternalSyncLoading: v,
    isContentLoading: x,
    lastSyncedTimestamp: N,
    refetchResponse: y,
    initialError: C,
    responseData: S
  } = Rl({
    urlFilterConfig: d,
    serviceHandler: j,
    additionalRequestMap: g
  }), [I, w] = T({}), k = !!s && !n;
  ee(() => {
    if (S && (Object.keys(u).length === 0 && _({
      // First stage is expanded by default
      [S?.releaseStageList?.[0].id]: !0
    }), m(S?.countSummary), !h || !Object.values(os).some((Y) => Y === h))) {
      const Y = S.releaseStageList.flatMap((O) => O.applications).some((O) => O.isVirtualEnvironment);
      f(
        Y ? os.installation : os.pipeline
      );
    }
    return () => {
      p();
    };
  }, [S]);
  const R = () => {
    t(null), a(!1);
  }, B = (Y) => {
    const O = er(o, Y);
    w(O), a(!1);
  }, P = (Y) => {
    const O = er(
      I,
      Y
    );
    w(O);
  }, L = async () => {
    t(null), l(), w({}), y(), await c();
  }, F = (Y, O) => {
    g.current[Y] = O;
  }, M = () => {
    if (x || !h)
      return /* @__PURE__ */ e.jsx("div", { className: "flex h-100", children: /* @__PURE__ */ e.jsx(vs, { pageLoader: !0 }) });
    if (C)
      return /* @__PURE__ */ e.jsx(bt, { code: C?.code, reload: y });
    const { releaseStageList: Y } = S, O = Y.length;
    return O ? /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__mxw-1400 w-100 p-12", children: Y.map((Q, je) => /* @__PURE__ */ e.jsxs(_r, { children: [
      /* @__PURE__ */ e.jsx(
        __,
        {
          ...Q,
          handleUpdateIdToRefetchMapping: F,
          bulkSelectionStateConfig: {
            bulkSelectionStateForStage: o[Q.id] ?? {},
            setBulkSelectionState: r
          }
        }
      ),
      je !== O - 1 && /* @__PURE__ */ e.jsx("div", { className: "w-28 h-24 dc__border-dashed--n3-right" })
    ] }, Q.id)) }) : /* @__PURE__ */ e.jsx(J, { title: "No release stages found", subTitle: "There are no stages in given release" });
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      wl,
      {
        reloadData: E,
        isLoading: v,
        lastSyncedTimestamp: N,
        hidePollingToggle: !!C || x || !h,
        children: M()
      }
    ),
    n && /* @__PURE__ */ e.jsx(
      l_,
      {
        handleClose: R,
        handleSuccess: B,
        bulkSelectionState: o,
        stage: s
      }
    ),
    k && /* @__PURE__ */ e.jsx(
      Zu,
      {
        filteredBulkSelectionState: I,
        handleClose: L,
        stage: s,
        handleRetryDeployment: P
      }
    )
  ] });
};
var On = /* @__PURE__ */ ((s) => (s.tenantInstallation = "tenantInstallation", s))(On || {}), ht = /* @__PURE__ */ ((s) => (s.tenantInstallation = "tenantInstallation", s.feasibility = "feasibility", s))(ht || {});
const f_ = ({
  tenantConfig: s,
  tenantFeasibility: t,
  feasibilityList: n
}) => {
  const [a, l] = T(!1), o = () => {
    l((r) => !r);
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: "display-grid dc__column-gap-16 releases__installation-feasibility-table-row fs-13 fw-4 lh-20 cn-9 py-8 px-20",
        children: [
          /* @__PURE__ */ e.jsx(
            is,
            {
              imageProps: {
                src: s.image,
                height: 20,
                width: 20
              }
            }
          ),
          /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: s.displayText }),
          /* @__PURE__ */ e.jsx("span", { children: /* @__PURE__ */ e.jsxs("span", { className: "flexbox dc__gap-4", children: [
            /* @__PURE__ */ e.jsx("span", { className: "icon-dim-20 dc__no-shrink p-2", children: t.icon }),
            /* @__PURE__ */ e.jsxs("span", { className: "flexbox-col", children: [
              /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: t.text }),
              t.message && /* @__PURE__ */ e.jsx("span", { className: "dc__first-letter-capitalize fs-12 fw-4 lh-18 cn-9", children: t.message })
            ] })
          ] }) }),
          t.statusCode === Ce.CannotTrigger && /* @__PURE__ */ e.jsx(
            "button",
            {
              type: "button",
              "aria-label": "expand",
              className: `p-8 dc__transparent br-4 dc__hover-n50 dc__h-fit-content flex dc__transition--transform ${a ? "dc__flip-180" : ""}`,
              onClick: o,
              children: /* @__PURE__ */ e.jsx(tt, { className: "icon-dim-16 dc__no-shrink scn-6" })
            }
          )
        ]
      },
      s.identifier
    ),
    a && /* @__PURE__ */ e.jsxs("div", { className: "bg__secondary", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "display-grid dc__column-gap-16 releases__installation-feasibility-pipeline-row releases__installation-feasibility-pipeline-row--header dc__border-bottom-n1 fs-12 fw-6 lh-20 cn-7 dc__align-items-center px-20 dc__uppercase", children: [
        /* @__PURE__ */ e.jsx(Z, { isSortable: !1, title: "Application" }),
        /* @__PURE__ */ e.jsx(Z, { isSortable: !1, title: "Environment" }),
        /* @__PURE__ */ e.jsx("span", {})
      ] }),
      /* @__PURE__ */ e.jsx("div", { children: n.map(({ appName: r, envName: i, feasibility: c, message: d }) => /* @__PURE__ */ e.jsxs(
        "div",
        {
          className: "display-grid dc__column-gap-16 releases__installation-feasibility-pipeline-row dc__border-bottom-n1 fs-13 fw-4 lh-20 cn-9 px-20 pt-8 pb-7",
          children: [
            /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: r }),
            /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: i }),
            /* @__PURE__ */ e.jsx("span", { children: /* @__PURE__ */ e.jsxs("span", { className: "flexbox dc__gap-4", children: [
              /* @__PURE__ */ e.jsx("span", { className: "icon-dim-20 dc__no-shrink p-2", children: c.icon }),
              /* @__PURE__ */ e.jsx("span", { className: "dc__first-letter-capitalize fs-13 fw-4 lh-20 cn-9 dc__word-break", children: d || c.text })
            ] }) })
          ]
        },
        `${r}-${i}`
      )) })
    ] })
  ] });
}, g_ = ({
  isLoading: s,
  groupedFeasibilityList: t,
  filterConfig: { sortBy: n, sortOrder: a, handleSorting: l }
}) => {
  const o = (r) => () => {
    l(r);
  };
  return !s && !t?.length ? /* @__PURE__ */ e.jsx(
    J,
    {
      title: "Could not find selected installation(s)",
      subTitle: "Looks like the installation(s) selected by you do not exist anymore",
      classname: "dc__text-center"
    }
  ) : /* @__PURE__ */ e.jsxs("div", { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "display-grid dc__column-gap-16 releases__installation-feasibility-table-row releases__installation-feasibility-table-row--header dc__border-bottom fs-12 fw-6 lh-20 cn-7 dc__align-items-center dc__uppercase dc__position-sticky dc__top-49 dc__zi-4 bg__primary px-20", children: [
      /* @__PURE__ */ e.jsx("span", {}),
      /* @__PURE__ */ e.jsx(
        Z,
        {
          isSorted: n === ht.tenantInstallation,
          sortOrder: a,
          title: "Tenant (Installation)",
          triggerSorting: o(ht.tenantInstallation),
          disabled: s
        }
      ),
      /* @__PURE__ */ e.jsx(
        Z,
        {
          isSorted: n === ht.feasibility,
          sortOrder: a,
          title: "Feasibility",
          triggerSorting: o(ht.feasibility),
          disabled: s
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "dc__even-child--bcn-50", children: s ? Mo.map((r) => /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: "display-grid dc__column-gap-16 releases__installation-feasibility-table-row py-8 show-shimmer-loading px-20",
        children: [
          /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
          /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
          /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" })
        ]
      },
      `${r.appName}-${r.envName}-feasibility-loading`
    )) : t.map((r) => /* @__PURE__ */ fs(f_, { ...r, key: r.tenantConfig.identifier })) })
  ] });
}, x_ = ({
  handleClose: s,
  handleSuccess: t,
  bulkSelectionState: n = {}
}) => {
  const { id: a, status: l } = de(), [o, r] = T(!1), [i, c] = T(!1), { sortBy: d, sortOrder: m, handleSorting: p } = ds({
    initialSortKey: ht.feasibility
  }), u = q(
    () => ({
      sortBy: d,
      sortOrder: m
    }),
    [d, m]
  ), [_, h, f, g] = K(
    () => eu({
      id: a,
      bulkSelectionState: n
    }),
    [],
    Object.keys(n).length > 0,
    {
      resetOnChange: !1
    }
  ), b = _ && !h, j = q(() => h?.length ? d === ht.feasibility ? h.sort(
    (w, k) => Us(
      w.tenantFeasibility.sortPriority,
      k.tenantFeasibility.sortPriority,
      m
    )
  ) : h.sort(
    (w, k) => te(w.tenantConfig.displayText, k.tenantConfig.displayText, m)
  ) : [], [h, u]), E = () => /* @__PURE__ */ e.jsx(ie, { text: "close", dataTestId: "close-modal", onClick: s, variant: _e.secondary });
  if (!Object.keys(n).length)
    return /* @__PURE__ */ e.jsx(
      J,
      {
        title: "Couldn't verify the images for selected deployment",
        classname: "flex-grow-1",
        isButtonAvailable: !0,
        renderButton: E
      }
    );
  const v = j.length, x = j.filter(
    ({ tenantFeasibility: w }) => w.statusCode === Ce.CanTrigger
  ).length || 0, N = () => {
    r(!1);
  }, y = () => {
    c(!1);
  }, C = () => {
    r(!0);
  }, S = () => {
    if (i) {
      c(!1), C();
      return;
    }
    o && r(!1);
    const w = j.filter(({ tenantFeasibility: k }) => k.statusCode === Ce.CanTrigger).reduce((k, { tenantConfig: R }) => (k[R.identifier] = {
      tenantId: R.tenantId,
      installationId: R.installationConfig.installationId
    }, k), {});
    t(w);
  }, I = () => {
    if (j.some(
      (k) => k.feasibilityList.some(
        ({ feasibility: R }) => R.code === Ce.CanTriggerInDeploymentWindow
      )
    )) {
      c(!0);
      return;
    }
    if (l === H.READY_FOR_RELEASE) {
      C();
      return;
    }
    S();
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
        /* @__PURE__ */ e.jsx("div", { className: "dc__position-sticky dc__top-0 bg__primary dc__zi-20", children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-justify dc__border-bottom pt-10 pr-20 pb-10 pl-20", children: [
          /* @__PURE__ */ e.jsx("h2", { className: "fs-16 fw-6 lh-24 m-0 dc__ellipsis-right", children: "Review feasibility for deployments" }),
          /* @__PURE__ */ e.jsx(
            "button",
            {
              type: "button",
              className: "dc__transparent dc__no-shrink flexbox",
              "aria-label": "close-modal",
              onClick: s,
              children: /* @__PURE__ */ e.jsx(Ts, { className: "icon-dim-24 icon-use-fill-n6" })
            }
          )
        ] }) }),
        /* @__PURE__ */ e.jsx(
          Ee,
          {
            isLoading: b,
            customLoader: /* @__PURE__ */ e.jsx(
              J,
              {
                title: "Verifying selected images for deployment",
                subTitle: "It might take some time depending upon the number of applications and environments",
                classname: "flex-grow-1",
                image: ca
              }
            ),
            error: f,
            errorScreenManagerProps: {
              code: f?.code,
              reload: g
            },
            children: /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1", children: /* @__PURE__ */ e.jsx(
              g_,
              {
                groupedFeasibilityList: j,
                isLoading: _,
                filterConfig: {
                  ...u,
                  handleSorting: p
                }
              }
            ) })
          }
        )
      ] }),
      !b && !f && /* @__PURE__ */ e.jsxs("div", { className: "px-20 py-10 flex dc__content-space dc__gap-12 dc__border-top", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox py-6 dc__gap-8", children: [
          /* @__PURE__ */ e.jsx(da, { className: "icon-dim-20 dc__no-shrink warning-icon-y5-imp" }),
          /* @__PURE__ */ e.jsxs("span", { className: "fs-13 fw-6 lh-20 cn-9 dc__truncate", children: [
            x,
            "/",
            v,
            " selected installation(s) can be triggered"
          ] })
        ] }),
        /* @__PURE__ */ e.jsx(
          ie,
          {
            text: "Deploy",
            startIcon: /* @__PURE__ */ e.jsx(_n, {}),
            disabled: !x || _,
            dataTestId: "deploy",
            onClick: I
          }
        )
      ] })
    ] }),
    i && /* @__PURE__ */ e.jsx(
      Il,
      {
        actionHandler: S,
        handleOnClose: y,
        modalType: rn.DEPLOY
      }
    ),
    o && /* @__PURE__ */ e.jsx(Ho, { handleClose: N, handleSuccess: S })
  ] });
}, b_ = (s) => {
  const { handleClose: t } = s;
  return /* @__PURE__ */ e.jsx(rt, { position: "right", width: "1024px", onEscape: t, children: /* @__PURE__ */ e.jsx("div", { className: "bg__primary h-100 flexbox-col show-shimmer-loading", children: /* @__PURE__ */ e.jsx(x_, { ...s }) }) });
};
var ft = /* @__PURE__ */ ((s) => (s.tenantInstallation = "tenantInstallation", s.triggerStatus = "triggerStatus", s))(ft || {});
const E_ = ({
  appId: s,
  envId: t,
  envName: n,
  appName: a,
  helmPackageName: l,
  cdWorkflowType: o
}) => {
  const [r, i] = T(!1), { isDownloading: c, handleDownload: d } = Ja(), m = async (p) => {
    p.stopPropagation();
    const u = {
      appId: s,
      envId: t,
      appName: l || "helm-package",
      cdWorkflowType: o
    }, _ = nl(u);
    await d({
      downloadUrl: _,
      fileName: u.appName,
      showSuccessfulToast: !1
    }) || i(!0);
  };
  return /* @__PURE__ */ e.jsx(
    ie,
    {
      variant: _e.text,
      size: oe.medium,
      startIcon: /* @__PURE__ */ e.jsx(dl, {}),
      text: "Download",
      dataTestId: `download-package-${a}-${n}`,
      onClick: m,
      isLoading: c,
      disabled: c,
      ...r && {
        style: qe.neutral
      }
    }
  );
}, N_ = ({
  tenantConfig: s,
  tenantTriggerStatus: t,
  deploymentList: n,
  romStatus: a
}) => {
  const [l, o] = T(!1), r = t.code === ve.processed || t.code === ve.processedAndPushed, i = () => {
    o((c) => !c);
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: "display-grid dc__column-gap-16 releases__installation-feasibility-table-row releases__installation-feasibility-table-row--with-virtual-env fs-13 fw-4 lh-20 cn-9 py-8 px-20",
        children: [
          /* @__PURE__ */ e.jsx(
            is,
            {
              imageProps: {
                src: s.image,
                height: 20,
                width: 20
              }
            }
          ),
          /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: s.displayText }),
          /* @__PURE__ */ e.jsx("span", { children: /* @__PURE__ */ e.jsxs("span", { className: "flexbox dc__gap-4", children: [
            /* @__PURE__ */ e.jsx("span", { className: "icon-dim-20 dc__no-shrink p-2", children: t.icon }),
            /* @__PURE__ */ e.jsxs("span", { className: "flexbox-col", children: [
              /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: t.text }),
              t.message && /* @__PURE__ */ e.jsx("span", { className: "dc__first-letter-capitalize fs-12 fw-4 lh-18 cn-9", children: t.message })
            ] })
          ] }) }),
          /* @__PURE__ */ e.jsx("div", { className: "flex right", children: r ? /* @__PURE__ */ e.jsx(
            ie,
            {
              variant: _e.text,
              size: oe.medium,
              style: qe.neutral,
              text: l ? "Hide Downloads" : "View Downloads",
              dataTestId: "toggle-downloads",
              onClick: i,
              endIcon: /* @__PURE__ */ e.jsx(
                tt,
                {
                  className: `dc__transition--transform ${l ? "dc__flip-180" : ""}`
                }
              )
            }
          ) : /* @__PURE__ */ e.jsx(
            "button",
            {
              type: "button",
              "aria-label": "expand",
              className: "p-2 dc__transparent br-4 dc__hover-n50 dc__h-fit-content flex",
              onClick: i,
              children: /* @__PURE__ */ e.jsx(
                tt,
                {
                  className: `icon-dim-16 dc__no-shrink scn-6 dc__transition--transform ${l ? "dc__flip-180" : ""}`
                }
              )
            }
          ) })
        ]
      },
      `${s.identifier}-deploy`
    ),
    l && /* @__PURE__ */ e.jsxs("div", { className: "bg__secondary", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "display-grid dc__column-gap-16 releases__installation-deploy-pipeline-row releases__installation-deploy-pipeline-row--rom-status dc__border-bottom-n1 fs-13 fw-4 lh-20 cn-9 px-20 pt-8 pb-7", children: [
        /* @__PURE__ */ e.jsx(Vd, { className: "icon-dim-20 scn-6" }),
        /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: "Release orchestration manifest" }),
        /* @__PURE__ */ e.jsx("span", { children: /* @__PURE__ */ e.jsxs("span", { className: "flexbox dc__gap-4", children: [
          /* @__PURE__ */ e.jsx("span", { className: "icon-dim-20 dc__no-shrink p-2", children: a.icon }),
          /* @__PURE__ */ e.jsx("span", { className: "dc__first-letter-capitalize fs-13 fw-4 lh-20 cn-9 dc__word-break", children: a.message || a.text || "-" })
        ] }) }),
        /* @__PURE__ */ e.jsx("span", {})
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "display-grid dc__column-gap-16 releases__installation-deploy-pipeline-row releases__installation-deploy-pipeline-row--header dc__border-bottom-n1 fs-12 fw-6 lh-20 cn-7 dc__align-items-center px-20 dc__uppercase", children: [
        /* @__PURE__ */ e.jsx("span", {}),
        /* @__PURE__ */ e.jsx(Z, { isSortable: !1, title: "Application" }),
        /* @__PURE__ */ e.jsx(Z, { isSortable: !1, title: "Environment" }),
        /* @__PURE__ */ e.jsx(Z, { isSortable: !1, title: "Stage" }),
        /* @__PURE__ */ e.jsx("span", {})
      ] }),
      /* @__PURE__ */ e.jsx("div", { children: n.map(
        ({ appId: c, appName: d, envId: m, envName: p, triggerStatus: u, stage: _, helmPackageName: h }) => /* @__PURE__ */ e.jsxs(
          "div",
          {
            className: "display-grid dc__column-gap-16 releases__installation-deploy-pipeline-row dc__border-bottom-n1 fs-13 fw-4 lh-20 cn-9 px-20 pt-8 pb-7",
            children: [
              /* @__PURE__ */ e.jsx(qd, { className: "icon-dim-20 scn-6" }),
              /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: d }),
              /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: p }),
              /* @__PURE__ */ e.jsx("div", { className: "dc__ellipsis-right dc__first-letter-capitalize", children: Zn(_) }),
              /* @__PURE__ */ e.jsx("span", { children: /* @__PURE__ */ e.jsxs("span", { className: "flexbox dc__gap-4", children: [
                /* @__PURE__ */ e.jsx("span", { className: "icon-dim-20 dc__no-shrink p-2", children: u.icon }),
                /* @__PURE__ */ e.jsx("span", { className: "dc__first-letter-capitalize fs-13 fw-4 lh-20 cn-9 dc__word-break", children: u.message || u.text || "-" })
              ] }) }),
              r && /* @__PURE__ */ e.jsx(
                E_,
                {
                  appId: c,
                  appName: d,
                  envId: m,
                  envName: p,
                  helmPackageName: h,
                  cdWorkflowType: Gi[_]
                }
              )
            ]
          },
          `${d}-${p}`
        )
      ) })
    ] })
  ] });
}, j_ = ({
  isLoading: s,
  groupedDeployStatusList: t,
  filterConfig: { sortBy: n, sortOrder: a, handleSorting: l }
}) => {
  const o = (r) => () => {
    l(r);
  };
  return /* @__PURE__ */ e.jsxs("div", { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "display-grid dc__column-gap-16 releases__installation-feasibility-table-row releases__installation-feasibility-table-row--header releases__installation-feasibility-table-row--with-virtual-env dc__border-bottom fs-12 fw-6 lh-20 cn-7 dc__align-items-center dc__uppercase dc__position-sticky dc__top-49 dc__zi-4 bg__primary px-20", children: [
      /* @__PURE__ */ e.jsx("span", {}),
      /* @__PURE__ */ e.jsx(
        Z,
        {
          isSorted: n === ft.tenantInstallation,
          sortOrder: a,
          title: "Tenant (Installation)",
          triggerSorting: o(ft.tenantInstallation),
          disabled: s
        }
      ),
      /* @__PURE__ */ e.jsx(
        Z,
        {
          isSorted: n === ft.triggerStatus,
          sortOrder: a,
          title: "Trigger Status",
          triggerSorting: o(ft.triggerStatus),
          disabled: s
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "dc__even-child--bcn-50", children: s ? Po.map(({ tenantConfig: r }) => /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: "display-grid dc__column-gap-16 releases__installation-feasibility-table-row releases__installation-feasibility-table-row--with-virtual-env py-8 show-shimmer-loading px-20",
        children: [
          /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
          /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
          /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" })
        ]
      },
      `${r.identifier}-feasibility-loading`
    )) : t.map((r) => /* @__PURE__ */ fs(N_, { ...r, key: r.tenantConfig.identifier })) })
  ] });
}, v_ = ({
  handleClose: s,
  filteredBulkSelectionState: t,
  handleRetryDeployment: n
}) => {
  const a = Te(), { push: l } = fe(), { search: o } = fn(), { id: r } = de(), { sortBy: i, sortOrder: c, handleSorting: d } = ds({
    initialSortKey: ft.triggerStatus
  }), m = q(
    () => ({
      sortBy: i,
      sortOrder: c
    }),
    [i, c]
  ), [p, u, _, h] = K(
    () => tu({
      id: r,
      bulkSelectionState: t
    }),
    [t],
    Object.keys(t).length > 0,
    {
      resetOnChange: !1
    }
  ), f = p && !u, g = q(() => u?.length ? i === ft.tenantInstallation ? u.sort(
    (x, N) => te(x.tenantConfig.displayText, N.tenantConfig.displayText, c)
  ) : u.sort(
    (x, N) => Us(
      x.tenantTriggerStatus.sortPriority,
      N.tenantTriggerStatus.sortPriority,
      c
    )
  ) : [], [u, m]), b = g?.some(
    (x) => x.tenantTriggerStatus?.code === ve.notProcessed
  ), j = () => /* @__PURE__ */ e.jsx(ie, { text: "close", dataTestId: "close-modal", onClick: s, variant: _e.secondary });
  if (!Object.keys(t).length)
    return /* @__PURE__ */ e.jsx(
      J,
      {
        title: "Couldn't verify the images for selected deployment",
        classname: "flex-grow-1",
        isButtonAvailable: !0,
        renderButton: j
      }
    );
  const E = (x) => {
    x.stopPropagation();
    const N = g.filter((y) => y.tenantTriggerStatus.code === ve.notProcessed).reduce((y, { tenantConfig: C }) => (y[C.identifier] = {
      tenantId: C.tenantId,
      installationId: C.installationConfig.installationId
    }, y), {});
    n(N);
  }, v = () => {
    s();
    const x = W(D.RELEASE_DETAIL_ROLLOUT_RELEASE, {
      ...a
    }), N = new URLSearchParams(o);
    N.set(Lt, Cs.rolloutStatus), l({
      pathname: x,
      search: N.toString()
    });
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
      /* @__PURE__ */ e.jsx("div", { className: "dc__position-sticky dc__top-0 bg__primary dc__zi-20", children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-justify dc__border-bottom pt-10 pr-20 pb-10 pl-20", children: [
        /* @__PURE__ */ e.jsx("h2", { className: "fs-16 fw-6 lh-24 m-0 dc__ellipsis-right", children: "Deployment status" }),
        /* @__PURE__ */ e.jsx(
          "button",
          {
            type: "button",
            className: "dc__transparent dc__no-shrink flexbox",
            "aria-label": "close-modal",
            onClick: s,
            children: /* @__PURE__ */ e.jsx(ys, { className: "icon-dim-24 icon-use-fill-n6" })
          }
        )
      ] }) }),
      /* @__PURE__ */ e.jsx(
        Ee,
        {
          isLoading: f,
          customLoader: /* @__PURE__ */ e.jsx(
            J,
            {
              title: "Fetching deployment trigger status...",
              subTitle: "It might take some time depending upon the number of deployments",
              classname: "flex-grow-1",
              image: ca
            }
          ),
          error: _,
          errorScreenManagerProps: {
            code: _?.code,
            reload: h
          },
          children: /* @__PURE__ */ e.jsx("div", {
            className: "flexbox-col flex-grow-1",
            // The null state would be applicable if the app or env has been deleted
            children: !p && !g?.length ? /* @__PURE__ */ e.jsx(
              J,
              {
                title: "Could not find selected installation(s)",
                subTitle: "Looks like the installation(s) selected by you do not exist anymore",
                classname: "dc__text-center flex flex-grow-1"
              }
            ) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              /* @__PURE__ */ e.jsx(
                cs,
                {
                  description: "Pipelines are triggered asynchronously. You can close this drawer, the actions will be performed in the background.",
                  borderConfig: { top: !1, left: !1, right: !1 },
                  borderRadiusConfig: {
                    top: !1,
                    left: !1,
                    right: !1,
                    bottom: !1
                  }
                }
              ),
              /* @__PURE__ */ e.jsx(
                j_,
                {
                  groupedDeployStatusList: g,
                  isLoading: p,
                  filterConfig: {
                    ...m,
                    handleSorting: d
                  }
                }
              )
            ] })
          })
        }
      )
    ] }) }),
    !f && !_ && /* @__PURE__ */ e.jsxs("div", { className: "px-20 py-16 flex dc__content-end dc__gap-12 dc__border-top", children: [
      /* @__PURE__ */ e.jsx(
        ie,
        {
          text: "Go to rollout status",
          endIcon: /* @__PURE__ */ e.jsx(jt, {}),
          variant: b ? _e.secondary : _e.primary,
          disabled: p,
          onClick: v,
          dataTestId: "go-to-rollout-status"
        }
      ),
      b && /* @__PURE__ */ e.jsx(
        ie,
        {
          disabled: p,
          onClick: E,
          isLoading: p,
          text: "Retry Failed",
          startIcon: /* @__PURE__ */ e.jsx(zr, {}),
          dataTestId: "retry-failed-deployments"
        }
      )
    ] })
  ] });
}, C_ = (s) => {
  const { handleClose: t } = s;
  return /* @__PURE__ */ e.jsx(rt, { position: "right", width: "1024px", onEscape: t, children: /* @__PURE__ */ e.jsx("div", { className: "bg__primary h-100 flexbox-col show-shimmer-loading", children: /* @__PURE__ */ e.jsx(v_, { ...s }) }) });
}, y_ = ({
  installationViewBulkSelectionState: s,
  setInstallationViewBulkSelectionState: t,
  isFeasibilityModalOpen: n,
  setIsFeasibilityModalOpen: a,
  handleClearBulkSelection: l
}) => {
  const [o, r] = T(!1), [i, c] = T({}), [d, m] = T({}), { id: p, refetchReleaseDetail: u } = de(), { urlFilterConfig: _, updateFilterCountSummary: h, resetFilterCountSummary: f, areFiltersActive: g } = ze(), b = Ye(new AbortController()), { sortBy: j, sortOrder: E, handleSorting: v } = ds({
    initialSortKey: On.tenantInstallation
  }), x = async () => await Vs(
    () => Co(
      {
        releaseId: p,
        filterConfig: {
          ..._,
          env: [],
          app: [],
          tenantInstallation: []
        }
      },
      b.current.signal
    ),
    b
  ), {
    handleExternalSync: N,
    isExternalSyncLoading: y,
    isContentLoading: C,
    lastSyncedTimestamp: S,
    refetchResponse: I,
    initialError: w,
    responseData: k
  } = Rl({
    urlFilterConfig: _,
    serviceHandler: x
  }), R = q(() => k?.rolloutStatusList?.length ? k.rolloutStatusList.sort(
    (X, ce) => te(X.tenantConfig.displayText, ce.tenantConfig.displayText, E)
  ) : [], [k, E]), B = q(() => {
    if (R.length > 0 && R.map(({ tenantConfig: ce }) => ce.identifier).every((ce) => s[ce]))
      return Oe.CHECKED;
    if (Object.keys(s).length > 0)
      return Oe.INTERMEDIATE;
  }, [R, s]), P = B === Oe.CHECKED || B === Oe.INTERMEDIATE;
  ee(() => (k && h(k?.countSummary), () => {
    f();
  }), [k]);
  const L = (X) => () => {
    v(X);
  }, F = (X) => () => {
    m((ce) => {
      const we = structuredClone(ce);
      return we[X] ? delete we[X] : we[X] = !0, we;
    });
  }, M = (X, ce) => () => {
    t((we) => {
      const Ge = structuredClone(we);
      return Ge[X] ? delete Ge[X] : Ge[X] = ce, Ge;
    });
  }, Y = () => {
    if (P) {
      t({});
      return;
    }
    const X = R.reduce(
      (ce, { tenantConfig: we, isTenantInstallationIsolated: Ge }) => (Ge && (ce[we.identifier] = {
        tenantId: we.tenantId,
        installationId: we.installationConfig.installationId
      }), ce),
      {}
    );
    t(X);
  }, O = () => {
    a(!1);
  }, Q = (X) => {
    a(!1), r(!0), c(X);
  }, je = async () => {
    r(!1), l(), c({}), I(), await u();
  }, ps = (X) => {
    c(X);
  }, ts = w && !C;
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      wl,
      {
        isLoading: y,
        lastSyncedTimestamp: S,
        reloadData: N,
        hidePollingToggle: ts || C,
        children: /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__mxw-1400 w-100 p-12 flex-grow-1", children: /* @__PURE__ */ e.jsx(
          Ee,
          {
            isLoading: C,
            progressingProps: {
              pageLoader: !0
            },
            error: w,
            errorScreenManagerProps: {
              code: w?.code,
              reload: I
            },
            children: /* @__PURE__ */ e.jsxs("div", { className: "w-100 br-8 dc__contain--paint dc__info-card dc__info-card--no-hover bg__primary", children: [
              /* @__PURE__ */ e.jsxs("div", { className: "px-20 pt-8 pb-7 flex left dc__gap-16 dc__border-bottom-n1 fs-12 fw-6 lh-20 dc__uppercase cn-7", children: [
                /* @__PURE__ */ e.jsx(
                  js,
                  {
                    isChecked: P,
                    onChange: Y,
                    value: B,
                    rootClassName: "mb-0 w-20 h-20"
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  Z,
                  {
                    disabled: C,
                    isSorted: j === On.tenantInstallation,
                    sortOrder: E,
                    title: "Tenant (Installation)",
                    triggerSorting: L(
                      On.tenantInstallation
                    )
                  }
                )
              ] }),
              /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-4 lh-20 cn-9", children: R.length ? R.map(
                ({ tenantConfig: X, apps: ce, isTenantInstallationIsolated: we }) => {
                  const Ge = !!s[X.identifier];
                  return /* @__PURE__ */ e.jsxs(_r, { children: [
                    /* @__PURE__ */ e.jsxs(
                      "div",
                      {
                        className: `px-20 pt-10 pb-9 flex dc__content-space dc__gap-8 dc__border-bottom-n1 last-child__no-border bg__hover--opaque dc__position-sticky dc__top-0 dc__zi-1 bg__primary ${Ge ? "bc-b50" : ""}`,
                        children: [
                          /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-16", children: [
                            /* @__PURE__ */ e.jsx(
                              xt,
                              {
                                alwaysShowTippyOnHover: !we,
                                content: "From the installation view, deployment is not available for connected installations",
                                children: /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
                                  js,
                                  {
                                    isChecked: Ge,
                                    onChange: M(
                                      X.identifier,
                                      {
                                        tenantId: X.tenantId,
                                        installationId: X.installationConfig.installationId
                                      }
                                    ),
                                    value: Oe.CHECKED,
                                    rootClassName: "mb-0 w-20 h-20",
                                    disabled: !we
                                  }
                                ) })
                              }
                            ),
                            /* @__PURE__ */ e.jsx(
                              ga,
                              {
                                tenantConfig: X,
                                children: /* @__PURE__ */ e.jsx("div", { className: "dc__truncate", children: X.displayText })
                              }
                            )
                          ] }),
                          /* @__PURE__ */ e.jsxs(
                            "button",
                            {
                              type: "button",
                              className: "flex left dc__gap-4 dc__transparent p-0 br-4 dc__content-end flex-grow-1",
                              onClick: F(
                                X.identifier
                              ),
                              children: [
                                /* @__PURE__ */ e.jsxs("div", { className: "dc__truncate", children: [
                                  ce.length,
                                  " Pipelines"
                                ] }),
                                /* @__PURE__ */ e.jsx(
                                  Gd,
                                  {
                                    className: `icon-dim-16 scn-7 dc__no-shrink dc__transition--transform ${d[X.identifier] ? "dc__flip-90" : "dc__flip-270"}`
                                  }
                                )
                              ]
                            }
                          )
                        ]
                      }
                    ),
                    d[X.identifier] && /* @__PURE__ */ e.jsxs("div", { className: "bg__secondary", children: [
                      /* @__PURE__ */ e.jsxs("div", { className: "display-grid dc__column-gap-16 releases__installation-deploy-table-row releases__installation-deploy-table-row--header dc__border-bottom-n1 fs-12 fw-6 lh-20 cn-7 dc__align-items-center px-20 dc__uppercase", children: [
                        /* @__PURE__ */ e.jsx(
                          Z,
                          {
                            isSortable: !1,
                            title: "Application"
                          }
                        ),
                        /* @__PURE__ */ e.jsx(
                          Z,
                          {
                            isSortable: !1,
                            title: "Environment"
                          }
                        ),
                        /* @__PURE__ */ e.jsx(
                          Z,
                          {
                            isSortable: !1,
                            title: "Deployment Status"
                          }
                        )
                      ] }),
                      /* @__PURE__ */ e.jsx("div", { children: ce.map(
                        ({
                          appName: ye,
                          envName: Ds,
                          deployStatus: Tt,
                          preStatus: Zt,
                          existingStages: { pre: en, post: ct },
                          postStatus: dt,
                          appId: Ks,
                          envId: sn,
                          postCdWorkflowRunnerId: tn,
                          preCdWorkflowRunnerId: nn,
                          pipelineId: an
                        }) => /* @__PURE__ */ e.jsxs(
                          "div",
                          {
                            className: "display-grid dc__column-gap-16 releases__installation-deploy-table-row dc__border-bottom-n1 fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-20",
                            children: [
                              /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: ye }),
                              /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: Ds }),
                              /* @__PURE__ */ e.jsx(
                                Al,
                                {
                                  deployStatus: Tt,
                                  preStatus: Zt,
                                  postStatus: dt,
                                  isPreConfigured: en,
                                  isPostConfigured: ct,
                                  appId: Ks,
                                  envId: sn,
                                  appName: ye,
                                  envName: Ds,
                                  preCdWorkflowRunnerId: nn,
                                  postCdWorkflowRunnerId: tn,
                                  pipelineId: an
                                }
                              )
                            ]
                          },
                          `${ye}-${Ds}`
                        )
                      ) })
                    ] })
                  ] }, X.identifier);
                }
              ) : /* @__PURE__ */ e.jsx(
                As,
                {
                  useInfoIcon: !0,
                  title: g ? "No matching results found for selected filters" : "Could not find any tenant installation(s)",
                  subTitle: "",
                  description: "",
                  rootClassName: "p-32 bg__primary"
                }
              ) })
            ] })
          }
        ) })
      }
    ),
    n && /* @__PURE__ */ e.jsx(
      b_,
      {
        handleClose: O,
        handleSuccess: Q,
        bulkSelectionState: s
      }
    ),
    o && /* @__PURE__ */ e.jsx(
      C_,
      {
        filteredBulkSelectionState: i,
        handleClose: je,
        handleRetryDeployment: ps
      }
    )
  ] });
}, Sn = ({
  label: s,
  value: t,
  isChecked: n,
  testIdPrefix: a,
  onChange: l
}) => {
  const o = (r) => {
    r.preventDefault(), r.stopPropagation(), l(t, !n);
  };
  return /* @__PURE__ */ e.jsxs(
    "button",
    {
      type: "button",
      className: "dc__transparent w-100 br-4 px-8 py-6 dc__hover-n50 flexbox dc__align-items-center dc__gap-8",
      onClick: o,
      children: [
        /* @__PURE__ */ e.jsx(
          js,
          {
            isChecked: n ?? !1,
            onChange: We,
            value: Oe.CHECKED,
            dataTestId: `${a}-${t}`,
            rootClassName: "dc__align-items-center mb-0"
          }
        ),
        /* @__PURE__ */ e.jsx("span", { className: "dc__truncate fs-13 fw-4 lh-20 cn-9 dc__align-left", children: s })
      ]
    }
  );
}, Ft = ({
  title: s,
  getContent: t,
  defaultExpanded: n = !1,
  showSearch: a = !1,
  searchBarProps: l
}) => {
  const [o, r] = T(n);
  ee(() => {
    r(n);
  }, [n]);
  const i = () => {
    r(!o);
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4 bg__primary", children: [
    /* @__PURE__ */ e.jsxs(
      "button",
      {
        className: "dc__transparent py-8 px-16 flex dc__content-space dc__gap-8 w-100 dc__hover-n50 dc__position-sticky dc__top-0 bg__primary dc__zi-4",
        type: "button",
        role: "tab",
        onClick: i,
        children: [
          /* @__PURE__ */ e.jsx("div", { className: "dc__align-left dc__truncate w-100 cn-9 fs-13 fw-6 lh-20", children: s }),
          /* @__PURE__ */ e.jsx(
            tt,
            {
              className: `icon-dim-16 dc__no-shrink dc__transition--transform ${o ? "dc__flip-180" : ""}`
            }
          )
        ]
      }
    ),
    o && /* @__PURE__ */ e.jsxs("div", { className: "px-8", children: [
      a && l && /* @__PURE__ */ e.jsx(qs, { ...l, noBackgroundAndBorder: !0 }),
      t()
    ] })
  ] });
}, T_ = () => /* @__PURE__ */ e.jsxs("div", { className: "px-8 show-shimmer-loading", children: [
  /* @__PURE__ */ e.jsx("div", { className: "px-8 py-6", children: /* @__PURE__ */ e.jsx("div", { className: "child-shimmer-loading h-20 mt-0-imp w-100" }) }),
  /* @__PURE__ */ e.jsx("div", { className: "px-8 py-6", children: /* @__PURE__ */ e.jsx("div", { className: "child-shimmer-loading h-20 mt-0-imp w-100" }) }),
  /* @__PURE__ */ e.jsx("div", { className: "px-8 py-6", children: /* @__PURE__ */ e.jsx("div", { className: "child-shimmer-loading h-20 mt-0-imp w-100" }) })
] }), xa = ({
  isLoading: s,
  error: t,
  children: n,
  genericSectionErrorStateProps: a
}) => /* @__PURE__ */ e.jsx(
  Ee,
  {
    isLoading: s,
    customLoader: /* @__PURE__ */ e.jsx(T_, {}),
    error: t,
    genericSectionErrorProps: {
      ...a,
      withBorder: !0,
      description: "",
      rootClassName: "mt-4 mb-4"
    },
    children: n
  }
), ba = () => /* @__PURE__ */ e.jsx(
  As,
  {
    withBorder: !0,
    title: "No results",
    subTitle: "We could not find any matching results",
    description: "",
    rootClassName: "mt-4 mb-4",
    useInfoIcon: !0
  }
), S_ = ({ appMap: s, handleApplicationUpdate: t, applicationsByStages: n }) => /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-4", children: n.map(({ title: a, applications: l }) => /* @__PURE__ */ e.jsxs("div", { children: [
  /* @__PURE__ */ e.jsx("div", { className: "dc__truncate fs-12 fw-6 lh-20 cn-7 dc__uppercase px-8 py-4 dc__position-sticky dc__top-36 bg__primary dc__zi-2", children: a }),
  /* @__PURE__ */ e.jsx("div", { children: l.map((o) => /* @__PURE__ */ e.jsx(
    Sn,
    {
      label: o,
      value: o,
      isChecked: s[o],
      testIdPrefix: "app-option",
      onChange: t
    },
    `${a}-app-option-${o}`
  )) })
] }, a)) }), w_ = ({ handleApplicationUpdate: s, appMap: t }) => {
  const [n, a] = T(""), { appEnvAndTenantListApiState: l } = ze(), {
    isAppEnvAndTenantLoading: o,
    appEnvAndTenantListError: r,
    refetchAppEnvAndTenantList: i,
    appEnvAndTenantList: { applicationsByStages: c }
  } = l, d = !o && !r, m = (_) => {
    a(_);
  }, p = q(() => {
    const _ = n.trim().toLowerCase();
    return _ ? c.map(({ applications: h, ...f }) => ({
      ...f,
      applications: h.filter(
        (g) => g.toLowerCase().includes(_)
      )
    })).filter(({ applications: h }) => !!h.length) : c;
  }, [l.appEnvAndTenantList.applicationsByStages, n]), u = () => /* @__PURE__ */ e.jsx(
    xa,
    {
      isLoading: o,
      error: r,
      genericSectionErrorStateProps: {
        reload: i,
        subTitle: "Could not load applications."
      },
      children: p?.length ? /* @__PURE__ */ e.jsx(
        S_,
        {
          appMap: t,
          handleApplicationUpdate: s,
          applicationsByStages: p
        }
      ) : /* @__PURE__ */ e.jsx(ba, {})
    }
  );
  return /* @__PURE__ */ e.jsx(
    Ft,
    {
      title: Qt[Le.app],
      showSearch: d,
      searchBarProps: {
        inputProps: {
          placeholder: "Search application"
        },
        initialSearchText: n,
        handleSearchChange: m
      },
      getContent: u
    }
  );
}, R_ = ({
  preStageMap: s,
  deployStageMap: t,
  postStageMap: n,
  handleDeploymentStatusUpdate: a
}) => {
  const { filterCountSummary: l } = ze(), o = (i, c) => {
    switch (i) {
      case be.PRE:
        return s[c];
      case be.DEPLOY:
        return t[c];
      case be.POST:
        return n[c];
      default:
        return !1;
    }
  }, r = (i) => (c, d) => {
    a(i, c, d);
  };
  return /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-4", children: Mp.map(({ stageType: i, options: c }) => {
    const d = l.filterDeploymentStatus[i];
    return /* @__PURE__ */ e.jsxs("div", { children: [
      /* @__PURE__ */ e.jsxs("div", { className: "dc__truncate fs-12 fw-6 lh-20 cn-7 dc__uppercase px-8 py-4 dc__position-sticky dc__top-36 bg__primary dc__zi-2", children: [
        Zn(i),
        " Stage"
      ] }),
      /* @__PURE__ */ e.jsx("div", { children: c.map(
        ({ label: m, value: p, hideIfCountZero: u }) => !(u && d[p] === 0) && /* @__PURE__ */ e.jsx(
          Sn,
          {
            label: m,
            value: p,
            isChecked: o(i, p),
            testIdPrefix: `${i}-status-option`,
            onChange: r(i)
          },
          `${p}-${i}-status-option`
        )
      ) })
    ] }, `${i}-status-filter`);
  }) });
}, I_ = ({ environments: s, handleEnvironmentUpdate: t, envMap: n }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: s.map((a) => /* @__PURE__ */ e.jsx(
  Sn,
  {
    label: a,
    value: a,
    isChecked: n[a],
    testIdPrefix: "env-option",
    onChange: t
  },
  `env-option-${a}`
)) }), A_ = ({ envMap: s, handleEnvironmentUpdate: t }) => {
  const [n, a] = T(""), { appEnvAndTenantListApiState: l } = ze(), {
    isAppEnvAndTenantLoading: o,
    appEnvAndTenantListError: r,
    refetchAppEnvAndTenantList: i,
    appEnvAndTenantList: { environments: c }
  } = l, d = !o && !r, m = (_) => {
    a(_);
  }, p = q(() => {
    const _ = n.trim().toLowerCase();
    return _ ? c.filter((h) => h.toLowerCase().includes(_)) : c;
  }, [l.appEnvAndTenantList.environments, n]), u = () => /* @__PURE__ */ e.jsx(
    xa,
    {
      isLoading: o,
      error: r,
      genericSectionErrorStateProps: {
        reload: i,
        subTitle: "Could not load environments."
      },
      children: p?.length ? /* @__PURE__ */ e.jsx(
        I_,
        {
          envMap: s,
          handleEnvironmentUpdate: t,
          environments: p
        }
      ) : /* @__PURE__ */ e.jsx(ba, {})
    }
  );
  return /* @__PURE__ */ e.jsx(
    Ft,
    {
      title: Qt[Le.env],
      showSearch: d,
      searchBarProps: {
        inputProps: {
          placeholder: "Search environment"
        },
        initialSearchText: n,
        handleSearchChange: m
      },
      getContent: u
    }
  );
}, L_ = ({
  releaseChannelIdMap: s,
  handleReleaseChannelUpdate: t,
  releaseChannels: n
}) => /* @__PURE__ */ e.jsx(e.Fragment, { children: n.map(({ name: a, channelId: l }) => /* @__PURE__ */ e.jsx(
  Sn,
  {
    label: a,
    value: l,
    isChecked: s[l],
    testIdPrefix: "release-channel-option",
    onChange: t
  },
  `release-channel-option-${l}`
)) }), k_ = ({
  handleReleaseChannelUpdate: s,
  releaseChannelIdMap: t
}) => {
  const [n, a] = T(""), { appEnvAndTenantListApiState: l } = ze(), {
    isAppEnvAndTenantLoading: o,
    appEnvAndTenantListError: r,
    refetchAppEnvAndTenantList: i,
    appEnvAndTenantList: { releaseChannels: c }
  } = l, d = !o && !r, m = (_) => {
    a(_);
  }, p = q(() => {
    const _ = n.trim().toLowerCase(), h = [
      {
        name: at.label,
        channelId: at.value
      },
      ...structuredClone(c)
    ];
    return _ ? h.filter(
      (f) => f.name.toLowerCase().includes(_)
    ) : h;
  }, [l.appEnvAndTenantList.releaseChannels, n]), u = () => /* @__PURE__ */ e.jsx(
    xa,
    {
      isLoading: o,
      error: r,
      genericSectionErrorStateProps: {
        reload: i,
        subTitle: "Could not load release channels."
      },
      children: p?.length ? /* @__PURE__ */ e.jsx(
        L_,
        {
          releaseChannelIdMap: t,
          handleReleaseChannelUpdate: s,
          releaseChannels: p
        }
      ) : /* @__PURE__ */ e.jsx(ba, {})
    }
  );
  return /* @__PURE__ */ e.jsx(
    Ft,
    {
      title: Qt[Le.releaseChannelId],
      showSearch: d,
      searchBarProps: {
        inputProps: {
          placeholder: "Search release channel"
        },
        initialSearchText: n,
        handleSearchChange: m
      },
      getContent: u
    }
  );
}, D_ = ({ handleRolloutStatusUpdate: s, selectedRolloutStatus: t }) => {
  const n = (a) => {
    s(a.target.value);
  };
  return /* @__PURE__ */ e.jsx(
    En,
    {
      name: "rollout-status-filter",
      className: "dc__no-border-imp flexbox-col",
      value: t,
      disabled: !1,
      onChange: n,
      children: Op.map((a) => /* @__PURE__ */ e.jsx($s, { value: a, disabled: !1, dataTestId: a, children: /* @__PURE__ */ e.jsx("span", { className: "dc__truncate fs-13 fw-4 lh-20 cn-9 dc__align-left", children: ua[a] }) }, a))
    }
  );
}, O_ = ({
  tenantInstallationMap: s,
  handleTenantInstallationUpdate: t,
  tenantsWithInstallations: n
}) => /* @__PURE__ */ e.jsx(e.Fragment, { children: n.map(({ identifier: a, displayText: l }) => /* @__PURE__ */ e.jsx(
  Sn,
  {
    label: l,
    value: a,
    isChecked: s[a],
    testIdPrefix: "tenant-installation-option",
    onChange: t
  },
  `tenant-installation-option-${a}`
)) }), M_ = ({
  handleTenantInstallationUpdate: s,
  tenantInstallationMap: t
}) => {
  const [n, a] = T(""), { appEnvAndTenantListApiState: l } = ze(), {
    isAppEnvAndTenantLoading: o,
    appEnvAndTenantListError: r,
    refetchAppEnvAndTenantList: i,
    appEnvAndTenantList: { tenantsWithInstallations: c }
  } = l, d = !o && !r, m = (_) => {
    a(_);
  }, p = q(() => {
    const _ = n.trim().toLowerCase();
    return _ ? c.filter(
      ({ tenantId: h, installationConfig: f, name: g }) => h.toLowerCase().includes(_) || g.toLowerCase().includes(_) || f.installationId.toLowerCase().includes(_) || f.name.toLowerCase().includes(_)
    ) : c;
  }, [c, n]), u = () => /* @__PURE__ */ e.jsx(
    xa,
    {
      isLoading: o,
      error: r,
      genericSectionErrorStateProps: {
        reload: i,
        subTitle: "Could not load tenant (installations)."
      },
      children: p?.length ? /* @__PURE__ */ e.jsx(
        O_,
        {
          tenantInstallationMap: t,
          handleTenantInstallationUpdate: s,
          tenantsWithInstallations: p
        }
      ) : /* @__PURE__ */ e.jsx(ba, {})
    }
  );
  return /* @__PURE__ */ e.jsx(
    Ft,
    {
      title: Qt[Le.tenantInstallation],
      showSearch: d,
      searchBarProps: {
        inputProps: {
          placeholder: "Search tenant (installations)"
        },
        initialSearchText: n,
        handleSearchChange: m
      },
      getContent: u
    }
  );
}, P_ = ({ showRolloutFilter: s }) => {
  const { triggerAutoClickTimestamp: t, setTriggerAutoClickTimestampToNow: n } = Wi(), { updateFiltersByMap: a, urlFilterConfigMap: l, triggerReleaseView: o } = ze(), r = s && o && o === os.installation, [i, c] = T(structuredClone(l)), {
    selectedRolloutStatus: d,
    envMap: m,
    appMap: p,
    preStageMap: u,
    postStageMap: _,
    deployStageMap: h,
    tenantInstallationMap: f,
    releaseChannelIdMap: g
  } = i;
  ee(() => {
    c(structuredClone(l));
  }, [JSON.stringify(l)]);
  const b = (w) => {
    n(), c((k) => ({
      ...k,
      ...w
    }));
  }, j = (w) => {
    b({
      selectedRolloutStatus: w
    });
  }, E = (w, k) => {
    b({
      envMap: {
        ...m,
        [w]: k
      }
    });
  }, v = (w, k) => {
    b({
      appMap: {
        ...p,
        [w]: k
      }
    });
  }, x = (w, k) => {
    b({
      releaseChannelIdMap: {
        ...g,
        [w]: k
      }
    });
  }, N = (w, k) => {
    b({
      tenantInstallationMap: {
        ...f,
        [w]: k
      }
    });
  }, y = (w, k, R) => {
    switch (w) {
      case be.PRE:
        b({
          preStageMap: {
            ...u,
            [k]: R
          }
        });
        return;
      case be.DEPLOY:
        b({
          deployStageMap: {
            ...h,
            [k]: R
          }
        });
        return;
      case be.POST:
        b({
          postStageMap: {
            ..._,
            [k]: R
          }
        });
        return;
      default:
        throw new Error(`Unsupported stage type: ${w}`);
    }
  }, C = () => /* @__PURE__ */ e.jsx(
    D_,
    {
      selectedRolloutStatus: d,
      handleRolloutStatusUpdate: j
    }
  ), S = () => /* @__PURE__ */ e.jsx(
    R_,
    {
      preStageMap: u,
      deployStageMap: h,
      postStageMap: _,
      handleDeploymentStatusUpdate: y
    }
  ), I = () => {
    a(i);
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "w-250 dc__no-shrink bg__primary border__primary--right flexbox-col dc__overflow-auto dc__content-space releases__deploy-filter-sidebar", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
      /* @__PURE__ */ e.jsx("div", { className: "fs-13 lh-24 cn-9 fw-6 dc__uppercase px-16 py-12 border__primary--bottom", children: "Filters" }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4 flex-grow-1 dc__overflow-auto", children: [
        s && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(
            Ft,
            {
              title: Qt[Le.rolloutStatus],
              getContent: C,
              defaultExpanded: !0
            }
          ),
          /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom-n1" }),
          !r && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx(Ft, { title: "Deployment status", getContent: S }),
            /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom-n1" })
          ] })
        ] }),
        !r && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(
            w_,
            {
              appMap: p,
              handleApplicationUpdate: v
            }
          ),
          /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom-n1" })
        ] }),
        /* @__PURE__ */ e.jsx(
          k_,
          {
            releaseChannelIdMap: g,
            handleReleaseChannelUpdate: x
          }
        ),
        !r && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom-n1" }),
          /* @__PURE__ */ e.jsx(
            M_,
            {
              tenantInstallationMap: f,
              handleTenantInstallationUpdate: N
            }
          ),
          /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom-n1" }),
          /* @__PURE__ */ e.jsx(
            A_,
            {
              envMap: m,
              handleEnvironmentUpdate: E
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "py-12 px-16 dc__border-top-n1", children: /* @__PURE__ */ e.jsx(
      ie,
      {
        size: oe.medium,
        fullWidth: !0,
        text: "Apply Filters",
        onClick: I,
        dataTestId: "apply-filters",
        triggerAutoClickTimestamp: t
      }
    ) })
  ] });
}, F_ = ({ count: s = 0, countBackgroundClass: t = "", iconClass: n = "", isLoading: a = !1 }) => /* @__PURE__ */ e.jsxs("div", { className: `px-6 flex dc__gap-4 br-10 mw-32 ${t}`, children: [
  /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-12 fw-6 lh-20 dc__truncate", children: a ? "--" : Vi(s) }),
  /* @__PURE__ */ e.jsx("div", { className: `dc__border-radius-50-per icon-dim-6 dc__no-shrink ${n}` })
] }), U_ = ({ title: s, count: t, countBackgroundClass: n, iconClass: a }) => (
  // Wrapping div shouldn't be added to ensure that the divider is hidden for the last child
  /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-6 dc__align-items-center", children: [
      /* @__PURE__ */ e.jsx("div", { className: "cn-9 fs-13 fw-4 lh-20", children: s }),
      /* @__PURE__ */ e.jsx(F_, { count: t, countBackgroundClass: n, iconClass: a })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "dc__divider bcn-1 h-12 last-child__display-none" })
  ] })
), $_ = ({
  tenantId: s,
  rolloutStatusSummary: t
}) => /* @__PURE__ */ e.jsx("div", { className: "flex dc__content-start dc__gap-12 flex-wrap", children: Dp.map((n) => {
  const a = t[n];
  return a > 0 && /* @__PURE__ */ fs(
    U_,
    {
      ...kp[n],
      key: `${s}-${n}`,
      title: ua[n],
      count: a
    }
  );
}) }), B_ = ({ tenantId: s, apps: t, rolloutStatusSummary: n }) => {
  const [a, l] = T(!1);
  if (!t?.length)
    return /* @__PURE__ */ e.jsx(e.Fragment, { children: "-" });
  const o = !a && t?.length > 0, r = o ? (c) => {
    c.preventDefault(), l(!0);
  } : We, i = () => {
    l(!1);
  };
  return a ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8 flex-grow-1", children: [
    /* @__PURE__ */ e.jsxs(
      "button",
      {
        type: "button",
        className: "dc__transparent p-0 flex dc__content-space dc__gap-6",
        onClick: i,
        children: [
          /* @__PURE__ */ e.jsx("span", { className: "dc__truncate fs-12 fw-6 lh-20 cn-7 py-2", children: "Applications with stages and status" }),
          /* @__PURE__ */ e.jsx(
            re,
            {
              content: "Hide deployment status for the app(s)",
              arrow: !1,
              className: "default-tt",
              placement: "top",
              children: /* @__PURE__ */ e.jsx("div", { className: "flexbox", children: /* @__PURE__ */ e.jsx(tt, { className: "icon-dim-24 p-2 dc__no-shrink dc__flip-180" }) })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ e.jsx("div", { className: "p-12 bg__secondary dc__border-n1 br-4 flexbox dc__column-gap-12 dc__row-gap-8 flex-wrap releases__rollout-status-table--expanded-app-list", children: t.map(
      ({
        deployStatus: c,
        preStatus: d,
        postStatus: m,
        existingStages: { pre: p, post: u },
        appId: _,
        appName: h,
        envId: f,
        envName: g,
        preCdWorkflowRunnerId: b,
        postCdWorkflowRunnerId: j,
        pipelineId: E
      }) => /* @__PURE__ */ e.jsx(
        Al,
        {
          deployStatus: c,
          preStatus: d,
          postStatus: m,
          isPreConfigured: p,
          isPostConfigured: u,
          appId: _,
          envId: f,
          appName: h,
          envName: g,
          preCdWorkflowRunnerId: b,
          postCdWorkflowRunnerId: j,
          pipelineId: E,
          expandedModeProps: {
            isExpandedMode: !0,
            appName: h,
            envName: g
          }
        },
        `${f}-${_}-status`
      )
    ) })
  ] }) : /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `flex dc__content-space flex-grow-1 dc__gap-6 dc__visible-hover dc__visible-hover--parent ${a ? "cursor" : ""}`,
      onClick: r,
      role: "button",
      tabIndex: o ? 0 : -1,
      onKeyDown: r,
      children: [
        /* @__PURE__ */ e.jsx($_, { tenantId: s, rolloutStatusSummary: n }),
        /* @__PURE__ */ e.jsx(re, { content: "Show deployment status for the app(s)", arrow: !1, className: "default-tt", placement: "top", children: /* @__PURE__ */ e.jsx(
          "div",
          {
            className: "cursor dc__no-shrink dc__visible-hover--child flex dc__align-self-start",
            "aria-label": "Expand rollout status row",
            children: /* @__PURE__ */ e.jsx(tt, { className: "icon-dim-24 p-2 dc__no-shrink" })
          }
        ) })
      ]
    }
  );
}, H_ = ({ tenantConfig: s, apps: t, rolloutStatusSummary: n }) => /* @__PURE__ */ e.jsxs("div", { className: "display-grid releases__rollout-status-table fs-13 lh-20 cn-9 dc__border-bottom-n1 dc__hover-n50", children: [
  /* @__PURE__ */ e.jsx("div", { className: "px-16 py-10 dc__border-right--n1", children: /* @__PURE__ */ e.jsx(ga, { tenantConfig: s, children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8 dc__w-fit-content", children: [
    /* @__PURE__ */ e.jsx(
      is,
      {
        imageProps: {
          src: s.image,
          height: 20,
          width: 20
        }
      }
    ),
    /* @__PURE__ */ e.jsx("span", { className: "dc__truncate ", children: s.displayText })
  ] }) }) }),
  /* @__PURE__ */ e.jsx("div", { className: "px-12 py-8 flexbox dc__align-items-center", children: /* @__PURE__ */ e.jsx(B_, { tenantId: s.tenantId, apps: t, rolloutStatusSummary: n }) })
] }), G_ = (s) => {
  switch (s) {
    case z.yetToTrigger:
      return "var(--N500)";
    case z.onGoing:
      return "var(--O500)";
    case z.failed:
      return "var(--R500)";
    case z.completed:
      return "var(--G500)";
    default:
      return "var(--B500)";
  }
}, W_ = (s) => {
  switch (s) {
    case z.yetToTrigger:
      return {
        title: "Release rollout triggered for all tenants",
        subTitle: "Some or all application deployments are triggered for all tenants",
        image: Bd
      };
    case z.onGoing:
      return {
        title: "No active rollouts",
        subTitle: "Tenants for which rollout is ongoing will be shown here. Failed and Completed rollouts will be shown in respective tabs.",
        image: Hd
      };
    case z.failed:
      return {
        title: "No failed deployments",
        subTitle: "This space is reserved for failed executions. When a deployment fails for any tenant, it will be shown here.",
        image: dn
      };
    case z.completed:
      return {
        title: "Rollout is not complete for any tenant",
        subTitle: "This space is reserved for completed rollouts. When all deployments stages are completed for a tenant (installation), it will be shown here.",
        image: dn
      };
    default:
      return {
        title: "No deployments available",
        subTitle: "This space is reserved for for all rollouts.",
        image: dn
      };
  }
}, V_ = (s, t) => s ? t && !Xt(t) ? s.filter(
  ({ tenantInstallationRolloutStatus: n, apps: a }) => (
    // selectedTab has value from RolloutStatus
    n === t && a.length > 0
  )
) : s : [], q_ = ({
  selectedTab: s,
  tab: { value: t, tippyContent: n, icon: a },
  handleTabChange: l,
  isLoading: o,
  countSummary: r
}) => {
  const { areFiltersActive: i } = ze(), c = s === t, d = G_(t), m = r?.rolloutStatus?.[t] ?? 0, p = r?.tenantsCount?.filteredCount ?? 0, u = () => {
    c || l(t);
  }, _ = (h) => /* @__PURE__ */ e.jsx(re, { className: "default-tt w-200", arrow: !1, content: n, placement: "top", children: h });
  return /* @__PURE__ */ e.jsx($e, { condition: !c, wrap: _, children: /* @__PURE__ */ e.jsxs(
    "button",
    {
      type: "button",
      className: `${c ? "bg__primary dc__position-rel cursor-default releases__rollout-status-tabs--item releases__rollout-status-tabs--selected" : ""} dc__transparent flexbox dc__content-space dc__gap-12 p-16 dc__hover-n0 dc__overflow-hidden`,
      onClick: u,
      style: {
        "--tabHighlightColor": d
      },
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: `flexbox-col dc__align-start ${c ? "fw-6" : ""}`, children: [
          /* @__PURE__ */ e.jsx("div", { className: "fs-13 lh-20 cn-7", children: Xt(t) && i ? "Filtered Tenants" : ua[t] }),
          /* @__PURE__ */ e.jsx(
            "div",
            {
              className: "fs-20 lh-26 dc__truncate cn-9",
              style: c && t !== z.yetToTrigger ? {
                color: d
              } : {},
              children: o ? "--" : `${m}/${p}`
            }
          )
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "icon-dim-24 dc__no-shrink dc__zi-1", children: a }),
        c && /* @__PURE__ */ e.jsx("div", { className: "w-80px h-80 dc__position-abs dc__blur-12 dc__opacity-0_2 dc__border-radius-50-per releases__rollout-status-tabs--selected-bg" })
      ]
    },
    t
  ) });
}, Y_ = ({
  sortBy: s,
  sortOrder: t,
  handleSorting: n
}) => {
  const { id: a } = de(), {
    // Implemented this way to avoid api calls on tab switch
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    urlFilterConfig: { rolloutStatus: l, ...o },
    urlFilterConfigMap: { selectedRolloutStatus: r },
    handleRolloutStatusUpdate: i,
    areFiltersActive: c,
    clearFilters: d,
    updateFilterCountSummary: m,
    resetFilterCountSummary: p
  } = ze(), u = Ye(new AbortController()), _ = async () => await Vs(
    () => Co(
      {
        releaseId: a,
        filterConfig: {
          ...o,
          rolloutStatus: Qe
        }
      },
      u.current.signal
    ),
    u
  ), {
    handleExternalSync: h,
    isExternalSyncLoading: f,
    isContentLoading: g,
    lastSyncedTimestamp: b,
    refetchResponse: j,
    initialError: E,
    responseData: v
  } = Rl({
    urlFilterConfig: o,
    serviceHandler: _
  }), x = q(
    () => ({
      sortBy: s,
      sortOrder: t
    }),
    [s, t]
  ), N = q(() => {
    if (v?.rolloutStatusList?.length) {
      const { rolloutStatusList: w } = v;
      return V_(w, r).sort(
        (R, B) => te(R.tenantConfig.displayText, B.tenantConfig.displayText, t)
      );
    }
    return [];
  }, [v, x, r]);
  ee(() => (v && m(v?.countSummary), () => {
    p();
  }), [v]);
  const y = !g && !N?.length, C = E && !g, S = (w) => {
    i(w);
  }, I = () => {
    n(Gn.tenantInstallation);
  };
  return /* @__PURE__ */ e.jsx(
    wl,
    {
      reloadData: h,
      isLoading: f,
      lastSyncedTimestamp: b,
      hidePollingToggle: C || g,
      children: C ? /* @__PURE__ */ e.jsx(bt, { code: E.code, reload: j }) : /* @__PURE__ */ e.jsx("div", { className: "h-100 flexbox-col dc__align-items-center dc__mxw-1400 w-100 p-12", children: /* @__PURE__ */ e.jsxs("div", { className: "releases__rollout-status dc__top-radius-4 dc__contain--paint bg__primary flexbox-col w-100 flex-grow-1", children: [
        /* @__PURE__ */ e.jsx("div", { className: "display-grid releases__rollout-status-tabs dc__no-shrink", children: Lp.map((w) => /* @__PURE__ */ e.jsx(
          q_,
          {
            tab: w,
            handleTabChange: S,
            isLoading: g,
            selectedTab: r,
            countSummary: v?.countSummary
          },
          w.value
        )) }),
        /* @__PURE__ */ e.jsx("div", { className: "h-100", children: y ? /* @__PURE__ */ e.jsx("div", { className: "flex h-100", children: c ? /* @__PURE__ */ e.jsx(yt, { handleClearFilters: d }) : /* @__PURE__ */ e.jsx(
          J,
          {
            ...W_(r)
          }
        ) }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsxs("div", { className: "display-grid releases__rollout-status-table releases__rollout-status-table--header dc__align-items-center fs-12 lh-20 fw-6 cn-7 dc__uppercase dc__border-bottom-n1 bg__primary dc__position-sticky dc__top-0 dc__zi-4", children: [
            /* @__PURE__ */ e.jsx("div", { className: "px-16 py-8 dc__border-right--n1", children: /* @__PURE__ */ e.jsx(
              Z,
              {
                disabled: g,
                isSorted: s === Gn.tenantInstallation,
                sortOrder: t,
                title: "Tenant (Installation)",
                triggerSorting: I
              }
            ) }),
            /* @__PURE__ */ e.jsx("div", { className: "px-12 py-8", children: Xt(r) ? "Release Status" : "Applications with status" })
          ] }),
          /* @__PURE__ */ e.jsx("div", { children: g ? Ap.map((w) => /* @__PURE__ */ e.jsxs(
            "div",
            {
              className: "display-grid releases__rollout-status-table fs-13 lh-20 cn-9 dc__border-bottom-n1 show-shimmer-loading",
              children: [
                /* @__PURE__ */ e.jsx("div", { className: "px-16 py-10 dc__border-right--n1", children: /* @__PURE__ */ e.jsx("div", { className: "child-shimmer-loading h-16 w-100" }) }),
                /* @__PURE__ */ e.jsx("div", { className: "px-12 py-10", children: /* @__PURE__ */ e.jsx("div", { className: "child-shimmer-loading h-16 w-100" }) })
              ]
            },
            `${w.tenantConfig.tenantId}-loading`
          )) : N.map((w) => /* @__PURE__ */ fs(
            H_,
            {
              ...w,
              key: w.tenantConfig.identifier
            }
          )) })
        ] }) }, r)
      ] }) })
    }
  );
}, z_ = () => {
  const s = Ye(null), t = ds({
    initialSortKey: Gn.tenantInstallation
  }), { triggerReleaseView: n, selectedTab: a, appStatusModalConfig: l, setAppStatusModalConfig: o } = ze(), { status: r } = de(), i = a === Cs.triggerRelease && n === os.installation, [c, d] = T({}), [m, p] = T(), [u, _] = T(!1), [h, f] = T({}), g = a === Cs.rolloutStatus, { existingStagesInBulkSelection: b, selectedCount: j } = q(
    () => ({
      selectedCount: i ? Object.keys(h).length : Object.keys(c).reduce(
        (y, C) => y + Object.keys(c[C]).length,
        0
      ),
      existingStagesInBulkSelection: Object.values(c).reduce(
        (y, C) => (Object.values(C).forEach(({ existingStages: S }) => {
          y.pre = y.pre || S.pre, y.post = y.post || S.post;
        }), y),
        { pre: !1, post: !1, deploy: !0 }
      )
    }),
    [c, h, i]
  ), E = () => {
    if (i) {
      f({});
      return;
    }
    d({});
  }, v = (y) => {
    if (Ou.includes(r)) {
      const { label: C } = Ae[r];
      ae.showToast({
        variant: le.warn,
        title: `Release is ${C}`,
        description: `Cannot trigger deployments in ${C} state`
      });
      return;
    }
    y && p(y), _(!0);
  }, x = () => {
    o(null);
  }, N = () => g ? /* @__PURE__ */ e.jsx(Y_, { ...t }) : i ? /* @__PURE__ */ e.jsx(
    y_,
    {
      installationViewBulkSelectionState: h,
      setInstallationViewBulkSelectionState: f,
      isFeasibilityModalOpen: u,
      setIsFeasibilityModalOpen: _,
      handleClearBulkSelection: E
    }
  ) : /* @__PURE__ */ e.jsx(
    h_,
    {
      selectedStage: m,
      isFeasibilityModalOpen: u,
      setSelectedStage: p,
      setIsFeasibilityModalOpen: _,
      bulkSelectionState: c,
      setBulkSelectionState: d,
      handleClearBulkSelection: E
    }
  );
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox flex-grow-1 dc__overflow-auto", children: [
      /* @__PURE__ */ e.jsx(P_, { showRolloutFilter: !g }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", ref: s, children: [
        !g && j > 0 && /* @__PURE__ */ e.jsx(
          zu,
          {
            existingStagesInBulkSelection: b,
            count: j,
            parentRef: s,
            handleButtonClick: v,
            handleClearBulkSelection: E
          }
        ),
        N()
      ] })
    ] }),
    l && /* @__PURE__ */ e.jsx(
      qi,
      {
        titleSegments: l.titleSegments,
        handleClose: x,
        type: "release",
        appId: l.appId,
        envId: l.envId,
        isConfigDriftEnabled: !0,
        configDriftModal: jc,
        processVirtualEnvironmentDeploymentData: Ao,
        debugWithAIButton: vc
      }
    )
  ] });
}, K_ = () => {
  const {
    status: s,
    isLocked: t,
    setNewReleaseStatus: n,
    id: a,
    areAllImagesSelected: l,
    areDepPresent: o,
    installationsMappedToRelease: r
  } = de(), i = Te(), c = !t && (!l || !o), d = s === H.DRAFT, [m, p, u, _] = K(
    () => Jm({ releaseId: a }),
    [],
    !c && !d
  ), [h, f] = T(!1), g = q(
    () => ({
      isAppEnvAndTenantLoading: m,
      appEnvAndTenantList: {
        applicationsByStages: p?.applicationsByStages ?? [],
        environments: p?.environments ?? [],
        tenantsWithInstallations: p?.tenantsWithInstallations ?? [],
        unmappedEnvironments: p?.unmappedEnvironments ?? [],
        releaseChannels: p?.releaseChannels ?? []
      },
      appEnvAndTenantListError: u,
      refetchAppEnvAndTenantList: _
    }),
    [m, p, u]
  ), b = W(D.RELEASE_DETAIL_REQUIREMENTS, {
    ...i
  });
  if (c) {
    const j = () => /* @__PURE__ */ e.jsx(ke, { to: b, className: "cta secondary flex anchor", children: "Go to requirements" });
    return /* @__PURE__ */ e.jsx(
      J,
      {
        title: "Complete and lock requirements to deploy",
        subTitle: "Add applications and their images for deployment in this release. Create task lists for each deployment to manage critical changes.",
        isButtonAvailable: !0,
        renderButton: j,
        image: $d,
        classname: "flex-grow-1",
        contentClassName: "dc__align-center"
      }
    );
  }
  if (d) {
    const j = () => {
      n(H.READY_FOR_RELEASE);
    }, E = () => /* @__PURE__ */ e.jsxs("button", { type: "button", className: "cta secondary flex anchor", onClick: j, children: [
      "Mark '",
      Ae[H.READY_FOR_RELEASE].label,
      "'"
    ] });
    return /* @__PURE__ */ e.jsx(
      J,
      {
        title: "This release is not yet ready",
        subTitle: `Change release status to '${Ae[H.READY_FOR_RELEASE].label}' to start deploying`,
        isButtonAvailable: !0,
        renderButton: E,
        image: Ud,
        classname: "flex-grow-1"
      }
    );
  }
  if (r.installations && r.installations.length === 0) {
    const j = () => /* @__PURE__ */ e.jsx(
      ie,
      {
        dataTestId: "go-to-requirements",
        component: Rt.link,
        linkProps: {
          to: b
        },
        text: "Go to Requirements",
        endIcon: /* @__PURE__ */ e.jsx(Me, { name: "ic-arrow-right", color: null }),
        size: oe.large
      }
    );
    return /* @__PURE__ */ e.jsx(
      J,
      {
        title: "Deployment is not enabled for any Tenant Installation",
        subTitle: "Enable tenant installations you want to rollout this release to and come back here",
        image: Fd,
        isButtonAvailable: !0,
        renderButton: j,
        classname: "flex-grow-1"
      }
    );
  }
  if (!m && !u && !g?.appEnvAndTenantList?.environments?.length) {
    const j = g?.appEnvAndTenantList?.unmappedEnvironments?.length > 0, E = () => {
      f(!0);
    }, v = () => {
      f(!1);
    }, x = () => /* @__PURE__ */ e.jsx(
      ie,
      {
        dataTestId: "view-unmapped-environments",
        text: "View Unmapped Environments",
        onClick: E,
        variant: _e.text,
        size: oe.large
      }
    );
    return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(
        J,
        {
          title: j ? "No environments are mapped to Tenant Installations" : "No deployment pipelines exist in applications in this release",
          subTitle: j ? "Environments must be mapped to a tenant (installation) to deploy this release" : "Create deployment pipelines for applications in this release and map the corresponding environments to tenant installations",
          image: Fa,
          isButtonAvailable: j,
          renderButton: x,
          classname: "flex-grow-1"
        }
      ),
      h && /* @__PURE__ */ e.jsx(
        Sl,
        {
          unmappedEnvironments: g.appEnvAndTenantList.unmappedEnvironments,
          handleClose: v
        }
      )
    ] });
  }
  return /* @__PURE__ */ e.jsx(qu, { appEnvAndTenantListApiState: g, children: /* @__PURE__ */ e.jsx(z_, {}) });
}, J_ = (s) => {
  const { label: t } = Ae[s], n = {
    icon: fa[s],
    iconContainerClass: "",
    title: `Change status to '${t}'`,
    buttonConfig: {
      text: `Change status to '${t}'`,
      style: qe.default
    }
  };
  switch (s) {
    case H.DRAFT:
      return {
        ...n,
        subTitle: "Draft state enables requirement open to modify."
      };
    case H.READY_FOR_RELEASE:
      return {
        ...n,
        subTitle: "You can start deploying once the release is ready.",
        buttonConfig: {
          ...n.buttonConfig,
          text: "Mark ready for release"
        }
      };
    case H.HOLD:
      return {
        ...n,
        iconContainerClass: "scr-7 fcr-1",
        subTitle: "In 'On Hold' state, deployments cannot be triggered.",
        buttonConfig: {
          ...n.buttonConfig,
          text: "Put release on hold",
          style: qe.negative
        },
        isCommentRequired: !0
      };
    case H.RESCINDED:
      return {
        ...n,
        iconContainerClass: "scr-5",
        subTitle: "Rescind release to mark it as buggy. Rescinded release cannot be modified or used for further deployments",
        buttonConfig: {
          ...n.buttonConfig,
          text: "Rescind release",
          style: qe.negative
        },
        confirmationText: "rescind release",
        isCommentRequired: !0
      };
    default:
      throw new Error(`Unknown release status ${s}`);
  }
}, Q_ = (s) => {
  switch (s) {
    case H.RESCINDED:
    case H.HOLD:
      return "scn-6";
    default:
      return "";
  }
}, X_ = (s) => {
  switch (s) {
    case H.RESCINDED:
      return "scr-7";
    case ue.COMPLETELY_RELEASED:
      return "scg-7";
    default:
      return "";
  }
}, Z_ = (s) => {
  switch (s) {
    case H.HOLD:
    case H.RESCINDED:
      return "cr-7";
    case ue.CORRUPTED:
      return "cy-7";
    case ue.COMPLETELY_RELEASED:
      return "cg-7";
    default:
      return "cn-7";
  }
}, An = fr(), eh = (s) => {
  switch (s) {
    case H.READY_FOR_RELEASE:
    case ue.PARTIALLY_RELEASED:
      return {
        backgroundColor: "var(--Y100)"
      };
    case H.HOLD:
      return {
        backgroundColor: "var(--O100)"
      };
    case H.RESCINDED:
      return {
        backgroundColor: "var(--R700)"
      };
    case ue.COMPLETELY_RELEASED:
      return {
        backgroundColor: "var(--G100)"
      };
    case ue.CORRUPTED:
      return {
        backgroundColor: "var(--N500)"
      };
    case H.DRAFT:
    default:
      return {
        backgroundColor: "var(--bg-secondary)"
      };
  }
}, sh = (s) => ({
  ...An,
  control: (t, n) => ({
    ...An.control(t, n),
    minHeight: "26px",
    borderRadius: "20px",
    border: "none",
    padding: "4px 8px",
    ...eh(s),
    // For the single value and indicator container
    "> div": {
      padding: 0
    },
    // Display the indicator if the menu is open
    "&.release-status-dropdown__control--menu-is-open .release-status-dropdown__indicator": {
      display: "flex"
    },
    // Show the indicator container only on hover
    ":hover": {
      "&:not(.release-status-dropdown__control--is-disabled) .release-status-dropdown__indicator": {
        display: "flex"
      }
    }
  }),
  dropdownIndicator: (t, n) => ({
    ...An.dropdownIndicator(t, n),
    padding: 0,
    paddingLeft: "2px",
    display: "none"
  }),
  menu: (t, n) => ({
    ...An.menu(t, n),
    width: "185px"
  })
}), th = (s) => {
  switch (s) {
    case ue.COMPLETELY_RELEASED:
    case ue.PARTIALLY_RELEASED:
      return Ae[H.READY_FOR_RELEASE].label;
    default:
      return "";
  }
}, nh = ({ value: s, label: t }) => {
  const n = s, a = th(n);
  return /* @__PURE__ */ e.jsxs("span", { className: `dc__ellipsis-right flexbox dc__gap-8 ${a ? "" : "dc__align-items-center"}`, children: [
    /* @__PURE__ */ e.jsx("span", { className: `dc__no-shrink flex icon-dim-16 ${a ? "mt-2" : ""} ${Q_(n)}`, children: fa[s] }),
    a ? /* @__PURE__ */ e.jsxs("span", { className: "flex column left dc__ellipsis-right", children: [
      /* @__PURE__ */ e.jsx("span", { className: "dc__ellipsis-right lh-20 fs-13 cn-9", children: a }),
      /* @__PURE__ */ e.jsx("span", { className: "dc__ellipsis-right lh-18 fs-12 cn-7", children: t })
    ] }) : /* @__PURE__ */ e.jsx("span", { className: "dc__ellipsis-right lh-20 fs-13", children: t })
  ] });
}, ah = ({
  handleClose: s,
  handleSuccess: t,
  updatedStatus: n,
  id: a
}) => {
  const { icon: l, iconContainerClass: o, title: r, subTitle: i, confirmationText: c, buttonConfig: d, isCommentRequired: m } = J_(n), [p, u] = T(!1), [_, h] = T(""), [f, g] = T(""), b = p || c && f !== c, j = () => /* @__PURE__ */ e.jsxs("span", { children: [
    "Type",
    /* @__PURE__ */ e.jsxs("span", { className: "fw-6", children: [
      " '",
      c,
      "' "
    ] }),
    "to confirm"
  ] }), E = (y) => {
    h(y.target.value);
  }, v = (y) => {
    g(y.target.value);
  }, x = async () => {
    if (p)
      return;
    if (m && !_?.trim()) {
      ae.showToast({
        variant: le.error,
        description: "Add a comment why you want to change status"
      });
      return;
    }
    if (b) {
      ae.showToast({
        variant: le.error,
        description: `Type '${c}' to confirm`
      });
      return;
    }
    u(!0);
    const y = {
      id: a,
      status: n,
      comment: _
    };
    try {
      const C = await Dm(y);
      await t();
      const { userMessage: S = "Status updated successfully", detailMessage: I } = C?.result ?? {};
      ae.showToast({
        variant: le.success,
        ...I ? {
          title: S,
          description: I
        } : {
          description: S
        }
      }), u(!1), s();
    } catch (C) {
      if (C?.code === Bt.BAD_REQUEST) {
        const { userMessage: S = "Cannot update status", internalMessage: I } = C?.errors?.[0] ?? {};
        ae.showToast({
          variant: le.warn,
          ...I ? {
            title: S,
            description: I
          } : {
            description: S
          }
        });
      } else
        U(C);
      u(!1);
    }
  }, N = async (y) => {
    y.key === "Enter" && (y.preventDefault(), await x());
  };
  return /* @__PURE__ */ e.jsx(
    Hs,
    {
      variant: Gs.custom,
      Icon: /* @__PURE__ */ e.jsx("div", { className: `dc__fill-available-space ${o}`, children: l }),
      title: r,
      subtitle: i,
      handleClose: s,
      buttonConfig: {
        secondaryButtonConfig: {
          text: "Cancel",
          onClick: s,
          disabled: p
        },
        primaryButtonConfig: {
          text: d.text,
          onClick: x,
          isLoading: p,
          style: d.style
        }
      },
      children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 w-100", children: [
        /* @__PURE__ */ e.jsx(
          jn,
          {
            name: "release-comment",
            label: `Add comment${m ? "" : " (Optional)"}`,
            onChange: E,
            placeholder: "Add a reason why you want to change status...",
            value: _,
            required: m
          }
        ),
        c && /* @__PURE__ */ e.jsx(
          Fe,
          {
            name: "status-change-confirmation",
            label: j(),
            required: !0,
            placeholder: "Type to confirm",
            onChange: v,
            value: f,
            onKeyDown: N
          }
        )
      ] })
    }
  );
}, lh = (s) => {
  const {
    // eslint-disable-next-line react/prop-types
    data: { label: t, value: n }
  } = s;
  return /* @__PURE__ */ e.jsx(Vr.SingleValue, { ...s, children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-6", children: [
    /* @__PURE__ */ e.jsx("span", { className: "icon-dim-14 dc__no-shrink dc__fill-available-space flex", children: fa[n] }),
    /* @__PURE__ */ e.jsx("span", { className: `dc__truncate fs-12 fw-6 lh-18 ${Wu[n]}`, children: t })
  ] }) });
}, Vo = ({
  currentStatus: s,
  id: t,
  handleStatusChangeSuccess: n,
  newReleaseStatus: a,
  setNewReleaseStatus: l = We
}) => {
  const [o, r] = T(a), [i, c] = T(!1), d = s === ue.CORRUPTED || s === H.RESCINDED, m = Gu[s] ?? [], p = sh(s);
  ee(() => {
    r(a), c(!!(a && a !== s));
  }, [a]);
  const u = ({ value: h }) => {
    const f = h;
    f !== s && Object.values(H).includes(f) && (r(f), c(!0));
  }, _ = () => {
    c(!1), l(null);
  };
  return (
    // Need to stop the propagation since this is being used on stop of interactive elements
    /* @__PURE__ */ e.jsxs("div", { onClick: lt, children: [
      /* @__PURE__ */ e.jsx(
        Wr,
        {
          options: m,
          placeholder: "Select release status",
          components: {
            IndicatorSeparator: null,
            SingleValue: lh,
            LoadingIndicator: Sr,
            ClearIndicator: null
          },
          onChange: u,
          formatOptionLabel: nh,
          value: Ae[s],
          isSearchable: !1,
          styles: p,
          menuPlacement: "auto",
          menuPosition: "fixed",
          isDisabled: d,
          classNamePrefix: "release-status-dropdown"
        }
      ),
      i && o && /* @__PURE__ */ e.jsx(
        ah,
        {
          id: t,
          updatedStatus: o,
          handleClose: _,
          handleSuccess: n
        }
      )
    ] })
  );
}, rh = () => {
  const s = fe(), { path: t, params: n, url: a } = gs(), { name: l, version: o, track: r } = de(), i = { label: l, value: o }, [c, d, m, p] = K(() => vo({ trackName: r }), [r]), u = () => [
    {
      label: "All Releases",
      options: (d ?? []).map((h) => ({
        label: h.name,
        value: h.version,
        description: h.version
      }))
    }
  ], _ = (h) => {
    if (h.value === o) return;
    Rr({
      category: "Release Selector",
      action: oo.SDH_SWITCH_RELEASE_ITEM_CLICKED
    });
    const f = s.location.pathname.replace(a, "").split("/")[1], g = W(t, {
      ...n,
      releaseVersion: h.value
    });
    s.push(`${g}/${f}`);
  };
  return /* @__PURE__ */ e.jsx(
    wr,
    {
      options: u(),
      onChange: _,
      value: i,
      inputId: `release-switcher-${r}`,
      isLoading: c,
      optionListError: m,
      reloadOptionList: p,
      resource: "Release"
    }
  );
}, oh = () => {
  const s = Te(), { id: t, track: n, status: a, refetchReleaseDetail: l, isLocked: o, newReleaseStatus: r, setNewReleaseStatus: i } = de(), { breadcrumbs: c } = ta({
    alias: {
      ..._a(),
      releases: {
        component: /* @__PURE__ */ e.jsx(Et, { heading: "Release Hub" }),
        linked: !0
      },
      tenants: {
        component: /* @__PURE__ */ e.jsx(Et, { heading: "Tenants", isActive: !0 }),
        linked: !1
      },
      detail: {
        component: null
      },
      ":releaseTrack": {
        // The hyper link is different so linked prop cannot be used
        component: /* @__PURE__ */ e.jsx(
          ke,
          {
            to: W(D.RELEASE_TRACK_DETAIL, {
              trackName: n
            }),
            className: "anchor cb-5 fs-16 fw-4 lh-24 dc__ellipsis-right dc__mxw-155",
            children: n
          }
        )
      },
      ":releaseVersion": {
        component: /* @__PURE__ */ e.jsx(rh, {})
      }
    }
  }), d = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12 dc__align-items-center", children: [
    /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center", children: /* @__PURE__ */ e.jsx(Xa, { breadcrumbs: c }) }),
    /* @__PURE__ */ e.jsx("div", { className: "dc__border-right lh-20 h-20" }),
    /* @__PURE__ */ e.jsx(
      Vo,
      {
        id: t,
        currentStatus: a,
        handleStatusChangeSuccess: l,
        newReleaseStatus: r,
        setNewReleaseStatus: i
      },
      a
    )
  ] }), m = (_) => W(_, {
    ...s
  }), p = [
    {
      id: "releases-overview-tab",
      tabType: "navLink",
      label: "Overview",
      props: {
        to: m(D.RELEASE_DETAIL_OVERVIEW),
        "data-action": "Overview Clicked",
        "data-testid": "Overview-click"
      }
    },
    {
      id: "releases-requirements-tab",
      tabType: "navLink",
      label: "Requirements",
      props: {
        to: m(D.RELEASE_DETAIL_REQUIREMENTS),
        "data-action": "Requirement Clicked",
        "data-testid": "Requirement-click"
      },
      icon: o ? rl : Ys
    },
    {
      id: "releases-rollout-tab",
      tabType: "navLink",
      label: "Rollout Release",
      props: {
        to: m(D.RELEASE_DETAIL_ROLLOUT_RELEASE),
        "data-action": "Rollout Release Clicked",
        "data-testid": "Rollout-Release-click"
      }
    },
    {
      id: "releases-history-tab",
      tabType: "navLink",
      label: "Rollout History",
      props: {
        to: m(D.RELEASE_DETAIL_HISTORY),
        "data-action": "Release Rollout History Clicked",
        "data-testid": "Release-Rollout-History-click"
      }
    },
    {
      id: "releases-configurations-tab",
      tabType: "navLink",
      label: "Configurations",
      props: {
        to: m(D.RELEASE_DETAIL_CONFIGURATIONS),
        "data-action": "Release Configurations Clicked",
        "data-testid": "Release-configurations-click"
      }
    }
  ], u = () => /* @__PURE__ */ e.jsx(Ir, { tabs: p, hideTopPadding: !0 });
  return /* @__PURE__ */ e.jsx(
    na,
    {
      showTabs: !0,
      renderHeaderTabs: u,
      isBreadcrumbs: !0,
      breadCrumbs: d,
      docPath: aa.SOFTWARE_DISTRIBUTION_HUB
    }
  );
}, Vn = {
  SCHEMA: "schema",
  SAMPLE_SCHEMA: "sample-schema"
}, Ke = {
  name: "schema-name",
  kind: "schema-kind",
  description: "schema-description"
}, lr = (s) => `Max ${s} characters allowed`, ih = "Please provide schema name", rr = 50, qn = 300, Wa = (s) => JSON.stringify(JSON.parse(s ?? "{}"), null, 2), ch = ({
  name: s,
  schema: t,
  description: n,
  ...a
}) => ({
  ...a,
  displayName: s?.trim(),
  schema: Wa(t?.trim()),
  description: n?.trim()
}), dh = ({
  devtronResourceId: s,
  displayName: t,
  kind: n,
  description: a
}) => ({
  id: s,
  name: t ?? "",
  kind: kr[n] ?? n,
  description: a
}), ph = [
  {
    label: "Schema",
    value: Vn.SCHEMA
  },
  {
    label: "Sample Schema",
    value: Vn.SAMPLE_SCHEMA
  }
], mh = async (s) => {
  try {
    const { result: t } = await xe(
      Qn("resource/schema", {
        resourceId: s
      })
    ), { versionSchemaDetails: n, displayName: a, description: l, kind: o, devtronResourceId: r } = t;
    return {
      ...dh({ displayName: a, description: l, kind: o, devtronResourceId: r }),
      schema: Wa(n[0].schema),
      sampleSchema: Wa(n[0].sampleSchema),
      devtronResourceSchemaId: n[0].devtronResourceSchemaId
    };
  } catch (t) {
    throw U(t), t;
  }
}, uh = (s, t = !1) => $t(
  Qn("resource/schema", {
    dryRun: t
  }),
  ch(s)
), _h = ({ formState: s, handleFieldUpdate: t }) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 pr-20 pl-20 dc__mxw-960", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-16", children: [
    /* @__PURE__ */ e.jsx("div", { className: "flex-1", children: /* @__PURE__ */ e.jsx(
      Fe,
      {
        label: "Name",
        required: !0,
        placeholder: "Name for the schema",
        name: Ke.name,
        value: s[Ke.name].value,
        onChange: t,
        error: s[Ke.name].error
      }
    ) }),
    /* @__PURE__ */ e.jsx("div", { className: "flex-1", children: /* @__PURE__ */ e.jsx(
      Fe,
      {
        label: "Kind",
        required: !0,
        placeholder: "Kind for the schema",
        name: Ke.kind,
        value: s[Ke.kind].value,
        disabled: !0,
        onChange: null
      }
    ) })
  ] }),
  /* @__PURE__ */ e.jsx(
    Fe,
    {
      label: "Description",
      placeholder: "Description for the schema",
      name: Ke.description,
      value: s[Ke.description].value,
      onChange: t,
      error: s[Ke.description].error,
      fullWidth: !0
    }
  )
] }), hh = ({
  schema: s,
  sampleSchema: t,
  validateSchema: n,
  isLoading: a,
  handleCancelManageSchema: l
}) => {
  const [o, r] = T(
    Vn.SCHEMA
  ), [i, c] = T(!1), [d, m] = T(s), p = o === Vn.SCHEMA, u = p ? d : t, _ = a, h = (j) => {
    m(j);
  }, f = () => {
    c(!i);
  }, g = () => {
    n(d);
  };
  ee(() => {
    m(s);
  }, [s]);
  const b = (j) => {
    r(j.value);
  };
  return /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__align-start dc__align-self-stretch flex-grow-1 dc__no-shrink", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__align-start flex-grow-1 dc__no-shrink dc__align-self-stretch", children: [
    !i && /* @__PURE__ */ e.jsxs("div", { className: "flex flex-justify pr-20 pl-20 pt-8 pb-8 dc__align-self-stretch dc__border-bottom-n1", children: [
      /* @__PURE__ */ e.jsx(
        ea,
        {
          name: "resource-detail-tabs",
          segments: ph,
          value: o,
          onChange: b
        }
      ),
      /* @__PURE__ */ e.jsx(
        Un,
        {
          content: u,
          copiedTippyText: p ? "Copied schema" : "Copied sample schema"
        }
      )
    ] }),
    p ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      i && /* @__PURE__ */ e.jsxs("div", { className: "bcn-1 flexbox dc__content-space w-100 h-32 dc__align-items-center", children: [
        /* @__PURE__ */ e.jsxs(
          "div",
          {
            className: "dc__border-right fs-12 fw-6 cn-7 pt-8 pb-8 pl-12 pr-12 flex flex-justify",
            style: { width: "48.5%" },
            children: [
              "Saved",
              /* @__PURE__ */ e.jsx(ys, { className: "icon-dim-16 mw-16 cursor", onClick: f })
            ]
          }
        ),
        /* @__PURE__ */ e.jsx("div", { className: "fs-12 fw-6 cn-7 flex-grow-1 dc__gap-4 flexbox pt-8 pb-8 pl-12 pr-12", children: "Editing" })
      ] }),
      /* @__PURE__ */ e.jsx(
        $l,
        {
          mode: Bl.JSON,
          diffView: i,
          noParsing: !0,
          height: "fitToParent",
          ...i ? {
            diffView: !0,
            modifiedValue: u,
            originalValue: p ? s : t,
            onModifiedValueChange: h
          } : {
            diffView: !1,
            value: u,
            onChange: h
          }
        }
      ),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox pt-16 pb-16 pl-20 pr-20 dc__border-top-n1 dc__align-items-center dc__content-end dc__align-self-stretch dc__gap-8", children: [
        /* @__PURE__ */ e.jsx(
          ie,
          {
            dataTestId: "cancel-edit-schema",
            disabled: _,
            onClick: i ? f : l,
            text: "Cancel",
            variant: _e.secondary,
            style: qe.neutral,
            size: oe.medium
          }
        ),
        /* @__PURE__ */ e.jsx(
          ie,
          {
            dataTestId: "schema-editor-save-button",
            disabled: _,
            onClick: i ? g : f,
            isLoading: a,
            text: i ? "Save" : "Review Changes",
            endIcon: i ? null : /* @__PURE__ */ e.jsx(Me, { name: "ic-arrow-right", color: null }),
            size: oe.medium
          }
        )
      ] })
    ] }) : /* @__PURE__ */ e.jsx($l, { mode: Bl.JSON, noParsing: !0, readOnly: !0, value: u, height: "fitToParent" })
  ] }) });
}, fh = ({ devtronResourceId: s, handleCancelManageSchema: t, resourceType: n }) => {
  const a = Ye(), [l, o, r, i] = K(
    () => mh(s)
  ), [c, d] = T({}), [m, p] = T(!1), [u, _] = T(!1), h = l || !o || Object.keys(c).length === 0;
  ee(() => {
    o && d({
      [Ke.name]: {
        value: o.name ?? "",
        error: null
      },
      [Ke.description]: {
        value: o.description ?? "",
        error: null
      },
      [Ke.kind]: {
        value: o.kind,
        error: null
      }
    });
  }, [o]);
  const f = (v) => {
    const x = v.target.name, N = v.target.value ?? "", y = N.trim();
    let C;
    x === Ke.name ? y ? y.length > rr && (C = lr(rr)) : C = ih : x === Ke.description && y.length > qn && (C = lr(qn)), d({
      ...c,
      [x]: {
        ...c[x],
        value: N,
        error: C
      }
    });
  }, g = () => {
    p(!m);
  }, b = (v, x) => {
    if (Object.values(c).some((C) => !!C.error))
      return Promise.reject(new Error(ot));
    const y = {
      name: c[Ke.name].value,
      description: c[Ke.description].value,
      devtronResourceSchemaId: o.devtronResourceSchemaId,
      schema: v
    };
    return uh(y, x);
  }, j = async () => {
    try {
      _(!0), await b(a.current, !1), ae.showToast({
        variant: le.success,
        description: "Schema updated successfully"
      }), i(), p(!1), t();
    } catch (v) {
      U(v);
    } finally {
      _(!1);
    }
  }, E = async (v) => {
    _(!0), a.current = v;
    try {
      const {
        result: { pathsToRemove: x = [] }
      } = await b(v, !0);
      x.length ? (_(!1), g()) : await j();
    } catch (x) {
      U(x), _(!1);
    }
  };
  if (r) {
    if (r.code === 404) {
      const v = () => /* @__PURE__ */ e.jsx(ie, { dataTestId: "go-to-overview", text: "Go to Overview", onClick: t });
      return /* @__PURE__ */ e.jsx(
        J,
        {
          title: "The requested resource doesn't exist",
          classname: "flex-grow-1",
          isButtonAvailable: !0,
          renderButton: v
        }
      );
    }
    return /* @__PURE__ */ e.jsx(Yi, { reload: i });
  }
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      cs,
      {
        heading: `Following catalog schema will be applied for all ${Dr[n].toLowerCase()}s`
      }
    ),
    /* @__PURE__ */ e.jsx("section", { className: "flexbox-col dc__content-space dc__gap-16 flex-grow-1 dc__overflow-hidden pt-16", children: h ? /* @__PURE__ */ e.jsx(vs, { pageLoader: !0 }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(_h, { handleFieldUpdate: f, formState: c }),
      /* @__PURE__ */ e.jsx(
        hh,
        {
          schema: o.schema,
          sampleSchema: o.sampleSchema,
          validateSchema: E,
          isLoading: u,
          handleCancelManageSchema: t
        }
      ),
      m && /* @__PURE__ */ e.jsx(
        Hs,
        {
          variant: Gs.warning,
          title: "Data will be cleared for updated fields",
          subtitle: "Some existing fields have been updated. Any saved values for the updated fields will be cleared and will need to be provided again.",
          buttonConfig: {
            secondaryButtonConfig: {
              text: "Cancel",
              disabled: u,
              onClick: g
            },
            primaryButtonConfig: {
              text: "Save changes",
              isLoading: u,
              onClick: j
            }
          },
          handleClose: g,
          children: /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-21 cn-7 fw-4", children: "Are you sure you want to proceed?" })
        }
      )
    ] }) })
  ] });
}, gh = async ({
  resourceType: s,
  version: t = ne.v1,
  searchParams: { resourceId: n, resourceIdentifier: a }
}) => {
  try {
    const l = ge({
      baseUrl: $.RESOURCE,
      kind: s,
      version: t
    }), o = Or({
      resourceId: n,
      resourceIdentifier: a
    }), {
      result: { schema: r = "", objectData: i = "", catalogSchemaResourceId: c, kind: d }
    } = await xe(Qn(l, o));
    return {
      result: {
        schema: r === "" ? {} : JSON.parse(r),
        objectData: i === "" ? null : JSON.parse(i),
        kind: kr[d] || d,
        catalogSchemaResourceId: c
      }
    };
  } catch (l) {
    throw U(l), l;
  }
}, xh = ({
  resourceType: s,
  version: t = ne.v1,
  data: { resourceId: n, resourceIdentifier: a, ...l }
}) => {
  const o = Or({
    resourceId: n,
    resourceIdentifier: a
  }), r = ge({
    baseUrl: $.RESOURCE,
    kind: s,
    version: t
  });
  return $t(r, { ...l, ...o });
};
function bh({
  resourceId: s,
  resourceType: t,
  onClose: n,
  schema: a,
  formData: l = {},
  version: o,
  resourceIdentifier: r
}) {
  const i = Ye(null), [c, d] = T(!1), [m, p] = T(l), u = (f) => {
    f && f.key === "Escape" && typeof n == "function" && (f.preventDefault(), n(f));
  };
  ee(() => {
    p(l);
  }, [l]), ee(() => (document.addEventListener("keydown", u), () => {
    document.removeEventListener("keydown", u);
  }), [u]);
  const _ = (f, g) => {
    const b = f.formData;
    d(!0), p(b);
    const j = {
      resourceId: Number(s),
      resourceIdentifier: r,
      objectData: JSON.stringify(b)
    };
    xh({ resourceType: t, version: o, data: j }).then(() => {
      n(g, { shouldRefetchDetails: !0 });
    }).catch((E) => {
      U(E), d(!1);
    });
  }, h = (f = []) => {
    U(new Error(ot)), console.error("Form Validation Error", f);
  };
  return /* @__PURE__ */ e.jsx(rt, { position: "right", width: "800px", children: /* @__PURE__ */ e.jsxs("div", { className: "h-100 bg__primary edit-catalog-modal flexbox-col", ref: i, children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space pt-16 pb-16 pl-20 pr-20 dc__border-bottom", children: [
      /* @__PURE__ */ e.jsx("h2", { className: "fs-16 cn-9 fw-6 m-0", children: "Edit catalog details" }),
      /* @__PURE__ */ e.jsx(ys, { className: "icon-dim-20 cursor", onClick: n })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "edit-catalog-modal__form dc__overflow-auto", children: /* @__PURE__ */ e.jsx(zi, { schema: a, onSubmit: _, formData: m, onError: h, children: /* @__PURE__ */ e.jsxs("footer", { className: "dc__border-top flex right bg__primary pt-16 pr-20 pb-16 pl-20 dc__position-fixed dc__bottom-0 w-800", children: [
      /* @__PURE__ */ e.jsx(
        "button",
        {
          type: "button",
          className: "cta cancel flex h-36 mr-12",
          onClick: n,
          disabled: c,
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ e.jsx("button", { type: "submit", className: "cta flex h-36", disabled: c, children: c ? /* @__PURE__ */ e.jsx(vs, {}) : "Save" })
    ] }) }) })
  ] }) });
}
function Eh({ kind: s, handleManageSchema: t }) {
  return /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 dc__mxw-600", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4 cn-9 lh-20", children: [
        /* @__PURE__ */ e.jsxs("h3", { className: "fs-14 fw-6 m-0", children: [
          "Define Catalog Framework for ",
          s
        ] }),
        /* @__PURE__ */ e.jsx("p", { className: "fs-13 fw-4 m-0", children: "Catalog Framework (Schema) enables you to define and collaboratively collect information that matters the most to you, so you never have to look anywhere else." })
      ] }),
      /* @__PURE__ */ e.jsx(
        ie,
        {
          dataTestId: "create-catalog-framework",
          text: "Create Catalog Framework",
          onClick: t,
          endIcon: /* @__PURE__ */ e.jsx(Me, { name: "ic-arrow-right", color: null }),
          variant: _e.secondary
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "catalog__null-state-image", children: /* @__PURE__ */ e.jsx(Jc, { className: "w-100 h-100" }) })
  ] });
}
const Yn = (s) => /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading h-16", style: { width: s } }), Aa = () => /* @__PURE__ */ e.jsxs("div", { className: "catalog__item", children: [
  Yn("100%"),
  Yn("100%")
] });
function Nh() {
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    Yn(150),
    /* @__PURE__ */ e.jsx("div", { className: "dc__border-n1 w-100" }),
    /* @__PURE__ */ e.jsx("div", { className: "catalog__section", children: Aa() }),
    Yn(250),
    /* @__PURE__ */ e.jsx("div", { className: "dc__border-n1 w-100" }),
    /* @__PURE__ */ e.jsxs("div", { className: "catalog__section", children: [
      Aa(),
      Aa()
    ] })
  ] });
}
function qo({ resourceId: s, resourceType: t, version: n, resourceIdentifier: a }) {
  const { setTempAppWindowConfig: l } = br(), [o, r] = T(!1), [i, c] = T(
    {}
  ), [d, m] = T(In.GUI), p = Object.entries(i).every(([, M]) => M) ? va : Cc, u = Object.keys(i).length > 0, [_, h, f, g] = K(
    () => gh({ resourceType: t, version: n, searchParams: { resourceId: s, resourceIdentifier: a } })
  ), {
    result: {
      objectData: b = null,
      schema: j = {},
      kind: E,
      catalogSchemaResourceId: v
    } = {}
  } = h ?? {}, x = !j || !Object.keys(j).length || !j.type, N = yc(b), y = !(_ || f) && !x, C = (M, { shouldRefetchDetails: Y = !1 } = {}) => {
    r(!1), Y && g();
  }, S = () => {
    const M = p === va;
    c(
      Object.keys(i).reduce((Y, O) => (Y[O] = M ? null : !0, Y), {})
    );
  }, I = (M, Y) => {
    c((O) => ({
      // Using the value from callback to handle the batch updates
      ...O,
      [M]: Y
    }));
  }, w = () => {
    l({
      open: !1,
      title: "",
      component: null
    });
  }, k = () => {
    l({
      open: !0,
      title: `${Dr[t]} Catalog Schema`,
      component: /* @__PURE__ */ e.jsx(
        fh,
        {
          devtronResourceId: v,
          handleCancelManageSchema: w,
          resourceType: t
        }
      )
    });
  }, R = () => {
    const M = JSON.stringify(b, null, 2);
    return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx("div", { className: "catalog__json-tab-copy dc__position-abs", children: /* @__PURE__ */ e.jsx(Un, { content: M }) }),
      /* @__PURE__ */ e.jsx("code", { className: "dc__word-break dc__block cn-9 dc__white-space-pre mono fs-14 lh-20 dc__transparent p-0", children: JSON.stringify(b, null, 2) })
    ] });
  }, B = () => d === In.JSON ? R() : /* @__PURE__ */ e.jsx(
    Sc,
    {
      value: {
        jsonViewExpansionMap: i,
        updateJsonViewExpansionMap: I,
        currentView: p
      },
      children: /* @__PURE__ */ e.jsx(wc, { originalFormData: b, originalSchema: j })
    }
  ), P = () => N ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
      /* @__PURE__ */ e.jsx("div", { children: "Sharing is caring! ✨" }),
      /* @__PURE__ */ e.jsx("div", { children: "Provide some required details about this application." }),
      /* @__PURE__ */ e.jsx("div", { children: "Your insights help everyone understand this application better, so that they can do their best work." })
    ] }),
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        onClick: () => {
          r(!0);
        },
        className: "flex fw-6 dc__gap-4 btn-start-sharing dc__hover-n50",
        children: [
          "Start Sharing",
          /* @__PURE__ */ e.jsx(jt, { className: "icon-dim-12 scb-5 dc__no-shrink" })
        ]
      }
    )
  ] }) : B(), L = () => _ ? /* @__PURE__ */ e.jsx(Nh, {}) : f ? /* @__PURE__ */ e.jsx(As, { reload: g }) : x ? /* @__PURE__ */ e.jsx(Eh, { kind: E, handleManageSchema: k }) : P(), F = (M) => {
    m(M.value);
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("section", { className: "bg__primary en-2 br-4 bw-1 fs-13 fw-4 lh-20 cn-7 mb-12", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "dc__border-bottom dc__top-radius-4 bg__secondary flex flex-justify pl-16 pr-16 pt-8 pb-8", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox flex-align-center dc__gap-12", children: [
          /* @__PURE__ */ e.jsx("span", { className: "fw-6 cn-9 mr-8", children: "Catalog" }),
          y && !N && /* @__PURE__ */ e.jsx(
            ea,
            {
              name: "catalog-tabs",
              onChange: F,
              segments: Tc,
              value: d,
              size: oe.small
            }
          )
        ] }),
        y && /* @__PURE__ */ e.jsxs("div", { className: "flexbox flex-align-center dc__gap-16", children: [
          d === In.GUI && u && /* @__PURE__ */ e.jsx("div", { onClick: S, className: "fw-6 cursor flex dc__gap-6", children: p === va ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx(zc, { className: "icon-dim-16 scn-6 cursor" }),
            /* @__PURE__ */ e.jsx("span", { children: "Collapse all" })
          ] }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx(Kc, { className: "icon-dim-16 fcn-6 cursor" }),
            /* @__PURE__ */ e.jsx("span", { children: "Expand all" })
          ] }) }),
          v && /* @__PURE__ */ e.jsx(
            ie,
            {
              dataTestId: "manage-catalog-schema",
              startIcon: /* @__PURE__ */ e.jsx(Me, { name: "ic-edit-lines", color: null }),
              text: "Manage Schema",
              onClick: k,
              style: qe.neutral,
              size: oe.small,
              variant: _e.text
            }
          ),
          /* @__PURE__ */ e.jsx(
            ie,
            {
              dataTestId: "edit-catalog",
              startIcon: /* @__PURE__ */ e.jsx(Me, { name: "ic-pencil", color: null }),
              text: "Edit",
              onClick: () => {
                r(!0);
              },
              style: qe.neutral,
              size: oe.small,
              variant: _e.text
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: d === In.JSON ? "dc__position-rel" : "", children: /* @__PURE__ */ e.jsx("div", { className: "dc__overflow-auto mxh-504", children: /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-20 pl-16 pr-16 pt-16 pb-16", children: L() }) }) })
    ] }),
    o && /* @__PURE__ */ e.jsx(
      bh,
      {
        resourceType: t,
        resourceId: s,
        resourceIdentifier: a,
        onClose: C,
        schema: j,
        formData: b,
        version: n
      }
    )
  ] });
}
const jh = () => {
  const { id: s, note: t, refetchReleaseDetail: n } = de(), a = async (l) => {
    try {
      await Om({
        id: s,
        releaseNote: l
      }), ae.showToast({
        variant: le.success,
        description: xl
      }), await n();
    } catch (o) {
      U(o);
    }
  };
  return /* @__PURE__ */ e.jsx(
    Za,
    {
      text: t.value,
      updatedBy: t.updatedBy.name,
      updatedOn: t.updatedOn,
      updateDescription: a,
      title: "Release Note",
      emptyStateConfig: {
        img: hd,
        subtitle: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx("p", { className: "m-0", children: "Capture all new features, bug fixes, and enhancements in release notes for each software version." }),
          /* @__PURE__ */ e.jsx("p", { className: "m-0", children: "These detailed notes ensure transparency, enable seamless collaboration across teams, and serve as a comprehensive changelog for future reference." })
        ] })
      }
    }
  );
}, vh = `## Release instructions

This section is to add instructions for this release`, Ch = Array.from(Array(3).keys()).map((s) => ({
  appName: `app-${s}`,
  imageDetails: {
    artifactId: s,
    image: `image-${s}`,
    imagePath: "",
    registryType: xn.DOCKER,
    sourceMessage: ""
  },
  commitDetails: [
    {
      hash: "",
      shortHash: "",
      message: ""
    }
  ]
}));
var Mn = /* @__PURE__ */ ((s) => (s.application = "application", s))(Mn || {});
const yh = ({
  appName: s,
  imageDetails: t,
  commitDetails: n,
  imageColumnClassName: a,
  isImageColumnExpanded: l,
  openArtifactInfoModal: o
}) => {
  const { push: r } = fe(), i = Te(), c = n?.map(({ hash: p }) => p) ?? [], d = () => {
    const p = W(D.RELEASE_DETAIL_REQUIREMENTS_DEPLOYMENT_SOURCE, {
      ...i,
      appName: s
    });
    r(p);
  }, m = () => {
    o({
      ciArtifactId: t?.artifactId
    });
  };
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `display-grid dc__column-gap-16 releases__req-summary-row ${a} fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-20`,
      children: [
        /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: s }),
        t?.image ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(
            Ki,
            {
              handleClick: m,
              imagePath: t.image,
              isExpanded: l,
              registryType: t.registryType
            }
          ),
          /* @__PURE__ */ e.jsx(Ji, { handleClick: m, commits: c })
        ] }) : /* @__PURE__ */ e.jsxs(
          "button",
          {
            type: "button",
            className: "cta text flex dc__content-start dc__gap-4 lh-20-imp cb-5 h-20 p-0-imp dc__w-fit-content",
            onClick: d,
            children: [
              /* @__PURE__ */ e.jsx(Je, { className: "icon-dim-16 dc__no-shrink fcb-5" }),
              /* @__PURE__ */ e.jsx("span", { children: "Add Image" })
            ]
          }
        )
      ]
    }
  );
}, Th = () => {
  const [s, t] = T(null), { push: n } = fe(), a = Te(), { id: l } = de(), [o, r] = T(!1), i = o ? "image-column-expanded" : "", { sortBy: c, sortOrder: d, handleSorting: m } = ds({
    initialSortKey: Mn.application
  }), [p, u, _, h] = K(
    () => au(l)
  ), f = q(() => u?.length ? u.sort(
    (x, N) => te(x.appName, N.appName, d)
  ) : [], [u, d]), g = () => {
    r((x) => !x);
  }, b = () => {
    m(Mn.application);
  }, j = () => {
    const x = W(D.RELEASE_DETAIL_REQUIREMENTS, {
      ...a
    });
    n(x);
  }, E = () => {
    t(null);
  }, v = (x) => {
    t(x);
  };
  return /* @__PURE__ */ e.jsxs("section", { className: "dc__overflow-hidden dc__border br-4 bg__primary", children: [
    /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx("h4", { className: "cn-9 fs-13 fw-6 lh-20 dc__truncate py-8 px-16 dc__border-bottom bg__secondary m-0", children: "Release requirements" }) }),
    /* @__PURE__ */ e.jsx(
      Ee,
      {
        isLoading: !1,
        error: !p && _,
        genericSectionErrorProps: {
          reload: h
        },
        children: p || f?.length ? /* @__PURE__ */ e.jsxs("div", { children: [
          /* @__PURE__ */ e.jsxs(
            "div",
            {
              className: `display-grid dc__column-gap-16 releases__req-summary-row releases__req-summary-row--header ${i} dc__border-bottom-n1 fs-12 fw-6 lh-20 cn-7 dc__align-items-center px-20 dc__uppercase bg__primary`,
              children: [
                /* @__PURE__ */ e.jsx(
                  Z,
                  {
                    disabled: p,
                    isSorted: c === Mn.application,
                    sortOrder: d,
                    title: "Application",
                    triggerSorting: b
                  }
                ),
                /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-4", children: [
                  /* @__PURE__ */ e.jsx("span", { children: "Image" }),
                  /* @__PURE__ */ e.jsx(
                    "button",
                    {
                      type: "button",
                      className: "dc__outline-none-imp p-0 dc__transparent flex",
                      onClick: g,
                      "aria-label": o ? "Collapse column" : "Expand image column",
                      children: /* @__PURE__ */ e.jsx(
                        dl,
                        {
                          className: `icon-dim-14 scn-7 dc__transition--transform ${o ? "dc__flip-90" : "dc__flip-270"}`
                        }
                      )
                    }
                  )
                ] }),
                /* @__PURE__ */ e.jsx("span", { children: "Commit" })
              ]
            }
          ),
          /* @__PURE__ */ e.jsx("div", { className: "dc__overflow-auto mxh-400", children: p ? Ch.map((x) => /* @__PURE__ */ e.jsxs(
            "div",
            {
              className: `display-grid dc__column-gap-16 releases__req-summary-row ${i} fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-20 show-shimmer-loading`,
              children: [
                /* @__PURE__ */ e.jsx("span", { className: "child-shimmer-loading" }),
                /* @__PURE__ */ e.jsx("span", { className: "child-shimmer-loading" }),
                /* @__PURE__ */ e.jsx("span", { className: "child-shimmer-loading" })
              ]
            },
            x.appName
          )) : f.map((x) => /* @__PURE__ */ fs(
            yh,
            {
              ...x,
              imageColumnClassName: i,
              isImageColumnExpanded: o,
              openArtifactInfoModal: v,
              key: x.appName
            }
          )) }),
          s && /* @__PURE__ */ e.jsx(
            Ar,
            {
              ...s,
              handleClose: E,
              renderCIListHeader: yl,
              fetchOnlyArtifactInfo: !0
            }
          )
        ] }) : /* @__PURE__ */ e.jsx(
          As,
          {
            title: "No applications is added in this release",
            buttonText: "Add Application",
            reload: j,
            useInfoIcon: !0
          }
        )
      }
    )
  ] });
}, Sh = () => {
  const { id: s, track: t, version: n, name: a, description: l, createdBy: o, createdOn: r, refetchReleaseDetail: i } = de(), c = async (d) => {
    const m = {
      id: s,
      description: d
    };
    try {
      await Lm(m), ae.showToast({
        variant: le.success,
        description: "Saved successfully"
      }), await i();
    } catch (p) {
      throw U(p), p;
    }
  };
  return /* @__PURE__ */ e.jsxs("aside", { className: "flexbox-col dc__gap-16", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
      /* @__PURE__ */ e.jsx(zs, { className: "icon-dim-48 dc__icon-bg-color br-4 p-8" }),
      /* @__PURE__ */ e.jsx("h3", { className: "fs-16 fw-7 lh-24 cn-9 dc__word-break font-merriweather m-0", children: a }),
      /* @__PURE__ */ e.jsx(
        el,
        {
          emptyState: "Write a short description for this release",
          placeholder: "Write a short description for this release",
          initialText: l,
          updateContent: c,
          validations: {
            maxLength: {
              value: 350,
              message: "Max 350 characters allowed"
            }
          }
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "dc__border-top-n1" }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
      /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-4 lh-20 cn-7 mb-4", children: "Release track" }),
        /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-6 lh-20 cn-9 dc__truncate", children: t })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-4 lh-20 cn-7 mb-4", children: "Release version" }),
        /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-6 lh-20 cn-9 dc__truncate", children: n })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-4 lh-20 cn-7 mb-4", children: "Created by" }),
        /* @__PURE__ */ e.jsxs("div", { className: "fs-13 fw-6 lh-20 cn-9 dc__word-break flexbox flex-align-center dc__gap-8", children: [
          /* @__PURE__ */ e.jsx(
            "div",
            {
              className: "icon-dim-20 mw-20 flexbox flex-justify-center flex-align-center dc__border-radius-50-per dc__uppercase cn-0 fw-4",
              style: { backgroundColor: la(o) },
              children: o[0]
            }
          ),
          o
        ] })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-4 lh-20 cn-7 mb-4", children: "Created on" }),
        /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-6 lh-20 cn-9 dc__truncate", children: r })
      ] })
    ] })
  ] });
}, wh = () => {
  const { id: s } = de();
  return /* @__PURE__ */ e.jsxs("div", { className: "pl-20 pr-20 pt-20 pb-20 software-hub__overview display-grid dc__gap-32 dc__content-center flex-grow-1 dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsx(Sh, {}),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 flex-grow-1", children: [
      /* @__PURE__ */ e.jsx(Th, {}),
      /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx(
          qo,
          {
            resourceType: G.release,
            resourceId: s,
            version: ne.alpha1
          }
        ),
        /* @__PURE__ */ e.jsx(jh, {})
      ] })
    ] })
  ] });
}, Yo = ({ releaseVersion: s, isCardView: t }) => /* @__PURE__ */ e.jsxs("div", { className: `flexbox dc__align-items-center dc__gap-4 br-4 dc__mxw-160 ${t ? "px-6 py-4 bcn-1" : ""}`, children: [
  /* @__PURE__ */ e.jsx(zs, { className: "dc__no-shrink icon-dim-16" }),
  /* @__PURE__ */ e.jsx("span", { className: `dc__truncate lh-16 ${t ? "cn-9 fs-12 fw-5" : "cn-7 fs-13 fw-4"}`, children: s })
] }), zo = ({
  selectedImage: s,
  registryType: t,
  releaseVersion: n,
  showNoSelectionText: a,
  children: l,
  selectedImageClass: o
}) => {
  const r = (i) => /* @__PURE__ */ e.jsx(re, { content: l, arrow: !1, className: "default-tt", placement: "right", children: i });
  return n ? /* @__PURE__ */ e.jsx(Yo, { releaseVersion: n }) : s ? /* @__PURE__ */ e.jsx($e, { wrap: r, condition: !!l, children: /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-4 dc__content-start", children: [
    /* @__PURE__ */ e.jsx(Mt, { registryType: t, size: 16 }),
    /* @__PURE__ */ e.jsx("p", { className: `m-0 dc__truncate text-left mono lh-16 ${o || ""}`, children: gr(s) })
  ] }) }) : a ? /* @__PURE__ */ e.jsx("span", { className: "m-0 fs-12 lh-16 cn-7 dc__truncate text-left", children: "Image not selected" }) : null;
}, Ko = ({
  appName: s,
  handleClose: t,
  handleSuccess: n
}) => {
  const { name: a, id: l } = de(), [o, r] = T(!1), i = async () => {
    r(!0);
    const c = {
      id: l,
      appName: s
    };
    try {
      await Um(c), r(!1), await n(), ae.showToast({
        variant: le.success,
        description: "Application deleted successfully"
      }), t();
    } catch (d) {
      U(d), r(!1);
    }
  };
  return /* @__PURE__ */ e.jsx(
    Hs,
    {
      variant: Gs.delete,
      title: `Remove '${s}' from '${a}'`,
      subtitle: "Removing the application from the release will remove all requirements added against the application.",
      buttonConfig: {
        secondaryButtonConfig: {
          onClick: t,
          text: "Cancel"
        },
        primaryButtonConfig: {
          isLoading: o,
          onClick: i,
          text: "Delete"
        }
      },
      confirmationConfig: {
        identifier: "delete-application-from-track",
        confirmationKeyword: "Remove"
      },
      handleClose: t,
      children: /* @__PURE__ */ e.jsx("p", { className: "fs-13 cn-7 lh-20 m-0", children: "Are you sure?" })
    }
  );
}, Rh = ({ applications: s, title: t, appName: n, icon: a, reload: l }) => {
  const { path: o, params: r } = gs(), i = fe(), [c, d] = T(null), { refetchReleaseDetail: m } = de(), p = !!c, u = () => {
    d(null);
  }, _ = (f) => {
    const g = n === f.name, b = (j) => {
      j.stopPropagation(), j.preventDefault(), d({
        appName: f.name
      });
    };
    return /* @__PURE__ */ e.jsxs(
      ke,
      {
        to: W(o, { ...r, appName: f.name }),
        className: `anchor flexbox dc__content-space dc__gap-8 py-8 pl-12 pr-8 br-4 cursor dc__transparent w-100 dc__visible-hover dc__visible-hover--parent ${g ? "bcb-1" : "dc__hover-n50"}`,
        children: [
          /* @__PURE__ */ e.jsxs("div", { children: [
            /* @__PURE__ */ e.jsx("h4", { className: `m-0 fs-13 lh-20 cn-9 dc__truncate text-left fw-4 ${g ? "cb-5" : ""}`, children: f.name }),
            f.isDeleted ? /* @__PURE__ */ e.jsx("span", { className: "fs-12 fw-4 lh-16 cr-5", children: "Application not found" }) : /* @__PURE__ */ e.jsx(
              zo,
              {
                selectedImage: f.selectedImage,
                registryType: f.registryType,
                releaseVersion: f.sourceReleaseConfiguration?.releaseVersion,
                showNoSelectionText: !0,
                selectedImageClass: "fs-14 cn-7",
                children: f.selectedImage
              }
            )
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "dc__visible-hover--child", children: /* @__PURE__ */ e.jsx(
            "button",
            {
              type: "button",
              className: "dc__transparent p-4 cursor dc__no-shrink flex h-24",
              "aria-label": `Delete ${f.name} from release order`,
              onClick: b,
              children: /* @__PURE__ */ e.jsx(Wt, { className: "icon-dim-16 dc__no-shrink scr-5" })
            }
          ) })
        ]
      },
      f.name
    );
  }, h = async () => {
    await l(), m(), i.push(W(o, { ...r, appName: void 0 }));
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "py-8 dc__border-bottom-n1 last-child__no-border", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox flex-align-center dc__gap-8 px-8 py-4", children: [
      /* @__PURE__ */ e.jsx("div", { className: "p-4 flex dc__no-shrink", children: a }),
      /* @__PURE__ */ e.jsx("h3", { className: "m-0 dc__uppercase cn-7 fs-12 lh-20 fw-6 dc__truncate", children: t })
    ] }),
    /* @__PURE__ */ e.jsx("div", { children: s.map(_) }),
    p && /* @__PURE__ */ e.jsx(
      Ko,
      {
        ...c,
        handleSuccess: h,
        handleClose: u
      }
    )
  ] });
}, Jo = ({
  handleClose: s,
  handleSuccess: t,
  id: n,
  name: a
}) => {
  const l = (r) => {
    r?.code === Bt.BAD_REQUEST ? ae.showToast({
      variant: le.warn,
      title: "Cannot Delete Release",
      description: "The release cannot be deleted since deployment is triggered for some of its releases."
    }) : U(r);
  }, o = async () => {
    await Am(n), t();
  };
  return /* @__PURE__ */ e.jsx(
    Gt,
    {
      title: a,
      onDelete: o,
      subtitle: "Deleting a release will delete all the requirements added against it.",
      closeConfirmationModal: s,
      confirmationConfig: {
        identifier: "release",
        confirmationKeyword: a
      },
      successToastMessage: "Release deleted successfully",
      onError: l
    }
  );
}, Ih = (s) => s ? {
  Icon: vd,
  title: "Unlock Requirement",
  subTitle: "Once unlocked, Requirement will be opened to edit.",
  buttonText: "Unlock"
} : {
  Icon: jd,
  title: "Lock Requirement",
  subTitle: "No one will be able to edit requirement in locked state. You can unlock to edit.",
  buttonText: "Lock"
}, Ah = ({ handleClose: s }) => {
  const { id: t, isLocked: n, refetchReleaseDetail: a } = de(), [l, o] = T(!1), { Icon: r, title: i, subTitle: c, buttonText: d } = Ih(n), m = async () => {
    o(!0);
    try {
      const u = await Mm({
        id: t,
        isLocked: !n
      });
      await a();
      const {
        userMessage: _ = `Requirement is ${n ? "unlocked" : "locked"}`,
        detailMessage: h
      } = u?.result ?? {};
      s(), ae.showToast({
        variant: le.success,
        ...h ? {
          title: _,
          description: h
        } : {
          description: _
        }
      });
    } catch (p) {
      if (p?.code === Bt.BAD_REQUEST) {
        const {
          userMessage: u = `Cannot ${n ? "unlock" : "lock"} requirements`,
          internalMessage: _
        } = p?.errors?.[0] ?? {};
        ae.showToast({
          variant: le.warn,
          ..._ ? {
            title: u,
            description: _
          } : {
            description: u
          }
        });
      } else
        U(p);
    } finally {
      o(!1);
    }
  };
  return /* @__PURE__ */ e.jsx(
    Hs,
    {
      variant: Gs.custom,
      Icon: /* @__PURE__ */ e.jsx(r, {}),
      title: i,
      subtitle: c,
      buttonConfig: {
        secondaryButtonConfig: {
          text: "Cancel",
          disabled: l,
          onClick: s
        },
        primaryButtonConfig: {
          text: d,
          isLoading: l,
          onClick: m
        }
      },
      handleClose: s,
      children: /* @__PURE__ */ e.jsx("span", { className: "fs-13 cn-7 lh-20", children: "Are you sure?" })
    }
  );
}, Lh = ({
  releaseOrdering: s,
  appName: t,
  applicationCount: n,
  handleShowManageReleaseModal: a,
  reload: l,
  changesForReview: o
}) => {
  const r = fe(), { id: i, name: c, isLocked: d, track: m } = de(), p = o.length, [u, _] = T(!1), [h, f] = T(!1), [g, b] = T(!1), j = () => {
    _(!u);
  }, E = () => {
    f(!h);
  }, v = () => {
    r.push(D.RELEASES);
  }, x = () => {
    b((y) => !y);
  }, N = () => /* @__PURE__ */ e.jsxs("span", { className: "flex column left top dc__gap-4", children: [
    /* @__PURE__ */ e.jsxs("span", { className: "flexbox-col fs-13 fw-4 lh-20 cn-9", children: [
      /* @__PURE__ */ e.jsx("span", { className: "fw-6", children: "Action required" }),
      /* @__PURE__ */ e.jsxs("span", { children: [
        p,
        " ",
        p === 1 ? "update" : "updates",
        " pending review"
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(
      "button",
      {
        type: "button",
        className: "dc__transparent p-0 fs-13 lh-20 fw-6 cb-5",
        onClick: x,
        children: "Review update"
      }
    )
  ] });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "bg__primary flexbox-col dc__content-space h-100 border__primary--right w-250 dc__no-shrink", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space pl-20 border__secondary--bottom dc__gap-4 dc__no-shrink", children: [
          /* @__PURE__ */ e.jsxs("h3", { className: "m-0 cn-7 fs-13 fw-6 lh-20 dc__ellipsis-right py-12", children: [
            n,
            " ",
            n === 1 ? "Application" : "Applications"
          ] }),
          /* @__PURE__ */ e.jsxs("div", { className: "flex dc__no-shrink", children: [
            /* @__PURE__ */ e.jsx(re, { content: "Manage release order", arrow: !1, className: "default-tt", placement: "top", children: /* @__PURE__ */ e.jsx(
              "button",
              {
                type: "button",
                className: "p-14 dc__transparent flex border__secondary--left",
                "aria-label": "Manage release order",
                onClick: a,
                children: /* @__PURE__ */ e.jsx(Nd, { className: "icon-dim-20 scb-5 dc__flip-90" })
              }
            ) }),
            /* @__PURE__ */ e.jsx(
              re,
              {
                content: "Add application(s) to release",
                arrow: !1,
                className: "default-tt",
                placement: "top",
                children: /* @__PURE__ */ e.jsx(
                  "button",
                  {
                    type: "button",
                    className: "p-14 dc__transparent flex border__secondary--left",
                    "aria-label": "Add applications",
                    onClick: a,
                    children: /* @__PURE__ */ e.jsx(Je, { className: "icon-dim-20 fcb-5" })
                  }
                )
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto px-12 py-8", children: [
          p > 0 && /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
            /* @__PURE__ */ e.jsx(cs, { description: N(), variant: "warning" }),
            g && /* @__PURE__ */ e.jsx(
              Uo,
              {
                changesForReview: o,
                handleClose: x,
                handleSuccess: l,
                trackName: m
              }
            )
          ] }),
          s.map((y) => /* @__PURE__ */ fs(
            Rh,
            {
              ...y,
              appName: t,
              reload: l,
              key: y.id
            }
          ))
        ] })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "px-16 py-12 flex dc__gap-8 dc__content-space dc__no-shrink", children: [
        /* @__PURE__ */ e.jsx(
          ie,
          {
            dataTestId: "delete-release",
            ariaLabel: "Delete release",
            onClick: j,
            showAriaLabelInTippy: !1,
            icon: /* @__PURE__ */ e.jsx(Me, { name: "ic-delete", color: null }),
            variant: _e.secondary,
            style: qe.negative,
            size: oe.medium
          }
        ),
        /* @__PURE__ */ e.jsx(
          ie,
          {
            dataTestId: "lock-unlock-release",
            onClick: E,
            variant: _e.secondary,
            disabled: h,
            text: d ? "Unlock to edit" : "Lock requirements",
            startIcon: d ? null : /* @__PURE__ */ e.jsx(rl, {}),
            size: oe.medium,
            fullWidth: !0
          }
        )
      ] })
    ] }),
    u && /* @__PURE__ */ e.jsx(
      Jo,
      {
        handleClose: j,
        handleSuccess: v,
        id: i,
        name: c
      }
    ),
    h && /* @__PURE__ */ e.jsx(Ah, { handleClose: E })
  ] });
}, kh = ({
  handleImageSelection: s,
  selectedArtifactId: t,
  artifactId: n,
  selectedReleaseVersion: a,
  currentRelease: l
}) => {
  const o = n === t, r = a ? l && o && a === l.releaseVersion : !l && o, i = () => {
    s(n, l);
  };
  return r ? /* @__PURE__ */ e.jsx(
    un,
    {
      className: "dc__align-right icon-dim-24 cursor circle-fill-b5",
      "data-testid": `deployment-source-artifact-check-${n}`
    }
  ) : /* @__PURE__ */ e.jsx(
    "button",
    {
      className: "p-0 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus dc__tab-focus dc__uppercase",
      type: "button",
      onClick: i,
      "data-testid": `deployment-source-artifact-select-${n}`,
      children: Be.SELECT_ARTIFACT_CTA
    }
  );
}, Dh = ({
  materialResponse: s,
  isSecurityModuleInstalled: t,
  isFetchingMoreImages: n,
  handleFetchMoreImages: a,
  applicationId: l,
  handleImageSelection: o,
  selectedArtifactId: r,
  isReleaseFilterActive: i,
  selectedReleaseVersion: c
}) => {
  const { isSuperAdmin: d } = Qi(), [m, p] = T(/* @__PURE__ */ new Map()), u = s?.materials || [], _ = u.length < s?.totalCount, h = (E) => {
    const v = new Map(m);
    v.set(E, !v.get(E)), p(v);
  }, f = (E, v) => ({
    // Sending it null to make in case release filter is active, so that last run is not visible
    isLatest: i ? null : E.latest,
    isRunningOnParentCD: E.runningOnParentCd,
    artifactStatus: E.artifactStatus,
    environmentName: null,
    parentEnvironmentName: null,
    // Sending it null to make it same view as pre/post cd for release filter view
    stageType: i ? null : kn.CD,
    showLatestTag: !1,
    isVirtualEnvironment: !1,
    deployedOn: E.deployedOnEnvironments,
    additionalInfo: v ? /* @__PURE__ */ e.jsx(Yo, { releaseVersion: v, isCardView: !0 }) : null,
    targetPlatforms: E.targetPlatforms
  }), g = (E) => ({
    imagePath: E.imagePath,
    registryName: E.registryName,
    registryType: E.registryType,
    image: E.image,
    deployedTime: null,
    deployedBy: E.deployedBy,
    isRollbackTrigger: !1,
    excludedImagePathNode: null,
    approvalChecksNode: null
  }), b = (E) => ({
    ciPipelineId: null,
    artifactId: +E.id,
    imageComment: E.imageComment,
    imageReleaseTags: E.imageReleaseTags,
    appReleaseTagNames: s?.appReleaseTagNames,
    setAppReleaseTagNames: null,
    tagsEditable: s?.tagsEditable,
    setTagsEditable: null,
    toggleCardMode: h,
    hideHardDelete: s?.hideImageTaggingHardDelete,
    updateCurrentAppMaterial: null,
    isSuperAdmin: d,
    forceReInit: !0
  }), j = (E, v) => {
    const x = Xi(E.materialInfo), N = m.get(+E.id), y = i ? `${E.id}-${v?.releaseVersion}` : E.id;
    return /* @__PURE__ */ e.jsx(
      Zi,
      {
        testIdLocator: y,
        cta: /* @__PURE__ */ e.jsx(
          kh,
          {
            handleImageSelection: o,
            selectedArtifactId: r,
            artifactId: +E.id,
            currentRelease: v,
            selectedReleaseVersion: c
          }
        ),
        sequentialCDCardTitleProps: f(E, v?.releaseVersion),
        artifactInfoProps: g(E),
        imageTagContainerProps: b(E),
        children: E.materialInfo.length > 0 && !N && x && /* @__PURE__ */ e.jsx(
          ec,
          {
            environmentId: null,
            isSecurityModuleInstalled: t,
            artifactId: +E.id,
            applicationId: l,
            changesCard: /* @__PURE__ */ e.jsx(Ic, { materialInformationList: E.materialInfo }),
            isScanned: E.scanned,
            isScanEnabled: E.scanEnabled,
            SecurityModalSidebar: Ac
          }
        )
      },
      y
    );
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
    u.map((E) => {
      if (i) {
        const { configuredInReleases: v } = E;
        return v.map((x) => j(E, x));
      }
      return j(E);
    }),
    _ && /* @__PURE__ */ e.jsx(Rc, { isLoading: n, handleFetchMoreData: a })
  ] });
}, Oh = ({
  handleImageSelection: s,
  selectedApplicationName: t,
  applicationDetailsMap: n
}) => {
  const { id: a, track: l } = de(), { getModuleInfo: o } = sc(), [r, i] = T(""), c = Ye(new AbortController()), { selectedWorkflowId: d, artifactSourceAppWorkflowId: m } = n[t], [p, u] = T(
    m === +d && !!n[t].sourceReleaseConfiguration?.releaseVersion
  ), _ = (O) => Vs(
    () => Cl({
      releaseId: a,
      applicationName: t,
      workflowId: d,
      searchInput: r,
      searchType: r ? ma.IMAGE_TAG : null,
      trackName: p ? l : null,
      signal: c.current.signal,
      offset: O ?? pl
    }),
    c
  ), [h, f, g, b] = K(
    _,
    // selectedAppName is not a dependency, since workflowId will automatically change when selectedAppName changes
    [a, d, r, p]
  ), [j, E] = T(null), [v, x] = T(!1), [N, y] = T(!1), [C, S] = T(!1), I = async () => {
    try {
      const { result: O } = await o(Nr.SECURITY);
      O?.status === tc.INSTALLED && x(!0);
    } catch (O) {
      U(O);
    }
  };
  ee(() => {
    I();
  }, []), ee(() => {
    !h && f && E(f.applicationsToArtifactsMap[t]);
  }, [h, f]);
  const w = async () => {
    try {
      S(!0);
      const { applicationsToArtifactsMap: O } = await _(
        j?.materials?.length
      );
      E((Q) => ({
        ...O[t],
        materials: [...Q.materials, ...O[t].materials]
      }));
    } catch {
    } finally {
      S(!1);
    }
  }, k = () => {
    y(!0);
  }, R = () => {
    y(!1), i("");
  }, B = (O) => {
    i(O);
  }, P = () => {
    b(), r || R();
  }, L = (O, Q) => {
    const je = j.materials.find((Ge) => +Ge.id === O), { imagePath: ps, registryType: ts, registryName: X, id: ce, appWorkflowId: we } = je;
    s({
      selectedImage: ps,
      registryType: ts,
      registryName: X,
      artifactId: +ce,
      sourceReleaseConfiguration: Q || null,
      // Can also send selectedWorkflowId from applicationDetailsMap[selectedApplicationName]
      artifactSourceAppWorkflowId: we
    });
  }, F = () => {
    u((O) => !O);
  }, M = () => /* @__PURE__ */ e.jsx(
    "button",
    {
      className: "cta secondary h-36 flex",
      type: "button",
      onClick: R,
      "data-testid": "clear-filters",
      children: Be.CLEAR_ARTIFACT_FILTERS
    }
  ), Y = () => h || hs(g) ? /* @__PURE__ */ e.jsx(Lc, { count: 4 }) : g ? /* @__PURE__ */ e.jsx(bt, { code: g.code, reload: b }) : j?.materials?.length ? /* @__PURE__ */ e.jsx(
    Dh,
    {
      materialResponse: j,
      isSecurityModuleInstalled: v,
      isFetchingMoreImages: C,
      handleFetchMoreImages: w,
      applicationId: n[t].appId,
      selectedArtifactId: n[t].artifactId,
      handleImageSelection: L,
      isReleaseFilterActive: p,
      selectedReleaseVersion: n[t].sourceReleaseConfiguration?.releaseVersion
    }
  ) : r ? /* @__PURE__ */ e.jsx(
    J,
    {
      title: Be.NO_ARTIFACT_FROM_SEARCH.title,
      subTitle: Be.NO_ARTIFACT_FROM_SEARCH.subTitle,
      isButtonAvailable: !0,
      renderButton: M
    }
  ) : p ? /* @__PURE__ */ e.jsx(
    J,
    {
      title: Xd(t, l),
      subTitle: Zd(t, l),
      image: Fa
    }
  ) : /* @__PURE__ */ e.jsx(
    J,
    {
      title: Be.NO_ARTIFACT_FOUND.title,
      subTitle: Be.NO_ARTIFACT_FOUND.subTitle,
      image: Fa
    }
  );
  return /* @__PURE__ */ e.jsx("div", { className: "flexbox-col w-100 h-100", children: /* @__PURE__ */ e.jsxs("div", { className: "px-16 dc__overflow-auto h-100", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__position-sticky dc__top-0 dc__zi-1 bg__secondary py-16", children: [
      /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center", children: /* @__PURE__ */ e.jsx(
        js,
        {
          isChecked: p,
          onChange: F,
          rootClassName: "icon-dim-20 w-100 mb-0",
          dataTestId: "toggle-image-selection",
          tabIndex: 0,
          value: Oe.CHECKED,
          children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20 dc__truncate", children: ep(l) })
        }
      ) }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4", children: [
        N ? /* @__PURE__ */ e.jsx(
          qs,
          {
            initialSearchText: r ?? "",
            containerClassName: "dc__mxw-250 flex-grow-1",
            handleEnter: B,
            inputProps: {
              placeholder: Be.SEARCH_SOURCE.SEARCH_IMAGE_TAG,
              autoFocus: !0
            }
          }
        ) : /* @__PURE__ */ e.jsx(
          "button",
          {
            type: "button",
            className: "flex dc__align-center dc__outline-none-imp dc__no-background dc__no-border dc__tab-focus",
            onClick: k,
            "data-testid": "show-search-bar",
            "aria-label": "show search bar",
            children: /* @__PURE__ */ e.jsx(Br, { className: `icon-dim-18 ${N ? "" : "icon-color-n6"}` })
          }
        ),
        /* @__PURE__ */ e.jsx(
          "button",
          {
            className: "pt-0 pb-0 pl-0 pr-8 flex dc__outline-none-imp dc__no-background dc__no-border dc__tab-focus",
            onClick: P,
            type: "button",
            "aria-label": "refresh materials",
            children: /* @__PURE__ */ e.jsx(Ad, { className: "icon-dim-16 scn-6 cursor" })
          }
        )
      ] })
    ] }),
    Y()
  ] }) });
}, Mh = () => /* @__PURE__ */ e.jsx("div", { className: "px-16 py-10", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8 p-12 dc__border-dashed br-4", children: [
  /* @__PURE__ */ e.jsx("div", { className: "flex", children: /* @__PURE__ */ e.jsx(ia, { className: "icon-dim-24 dc__no-shrink" }) }),
  /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-2 dc__text-center", children: [
    /* @__PURE__ */ e.jsx("h4", { className: "m-0 cn-7 fs-12 fw-6 lh-20", children: Be.NO_WORKFLOW_EMPTY_STATE.title }),
    /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-7 fs-12 fw-4", children: Be.NO_WORKFLOW_EMPTY_STATE.subTitle })
  ] })
] }) }), Va = (s) => {
  switch (s) {
    case Ns.CI_JOB:
      return /* @__PURE__ */ e.jsx(Dd, { className: "icon-dim-16 mt-2 dc__no-shrink" });
    case Ns.WEBHOOK:
      return /* @__PURE__ */ e.jsx(Pd, { className: "icon-dim-16 mt-2 dc__no-shrink" });
    case Ns.LINKED_CI:
      return /* @__PURE__ */ e.jsx(Md, { className: "icon-dim-16 mt-2 dc__no-shrink" });
    case Ns.LINKED_CD:
      return /* @__PURE__ */ e.jsx(Od, { className: "icon-dim-16 mt-2 dc__no-shrink" });
    default:
      return /* @__PURE__ */ e.jsx(Yr, { className: "icon-dim-16 dc__no-shrink" });
  }
}, Ph = (s, t) => {
  const n = fl(s), a = Object.keys(n), l = Object.keys(t);
  return a.length !== l.length ? !0 : l.some((o) => {
    const { sourceReleaseConfiguration: r, artifactId: i } = t[o];
    return xo(n[o], r, i);
  });
}, Fh = ({ repositoryName: s, sourceValue: t, sourceType: n, pipelineType: a }) => {
  const [l, o] = K(
    () => nu(t),
    [t],
    n === Oa.WEBHOOK
  ), r = () => n !== Oa.WEBHOOK ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
      Va(a),
      /* @__PURE__ */ e.jsx(kd, { className: "icon-dim-12 dc__no-shrink" })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
      /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-9 fs-12 fw-4 lh-16 dc__align-left dc__truncate", children: s || "-" }),
      /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-7 fs-12 fw-4 lh-14 dc__align-left dc__truncate", children: t ?? "-" })
    ] })
  ] }) : l ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4 w-100", children: [
    /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading h-16 w-75" }),
    /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading h-16 w-50" })
  ] }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
      Va(a),
      nc(o)
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
      /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-9 fs-12 fw-4 lh-16 dc__align-left dc__truncate", children: s || "-" }),
      /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-7 fs-12 fw-4 lh-14 dc__align-left dc__truncate", children: o || Be.UNABLE_TO_FETCH_EVENT_NAME })
    ] })
  ] });
  return /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-8 w-100", children: /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__gap-4 w-100", children: r() }) });
}, La = ({ children: s }) => /* @__PURE__ */ e.jsx("div", { className: "flexbox-col p-10 dc__gap-8 br-4 dc__border bg__primary w-100", children: s }), or = ({ isLoading: s, ...t }) => {
  if (s)
    return /* @__PURE__ */ e.jsx(La, { children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
      /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading h-16 w-75" }),
      /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading h-16 w-50" })
    ] }) });
  const { pipelineType: n, sourceInfo: a, pipelineName: l } = t, o = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-6 w-100", children: [
    Va(n),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
      /* @__PURE__ */ e.jsx("h4", { className: "m-0 cn-9 fs-13 fw-4 lh-20 dc__align-left dc__truncate", children: ap(n) }),
      /* @__PURE__ */ e.jsx("p", { className: "m-0 dc__truncate cn-9 fs-12 fw-4 lh-18 dc__align-left", children: lp(n, l) })
    ] })
  ] });
  return n !== Ns.CI ? /* @__PURE__ */ e.jsx(La, { children: o() }) : /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-6 w-100", children: a.map((r) => {
    const { ciMaterialId: i, repositoryName: c, sourceValue: d, sourceType: m } = r;
    return /* @__PURE__ */ e.jsx(La, { children: /* @__PURE__ */ e.jsx(
      Fh,
      {
        repositoryName: c,
        sourceValue: d,
        sourceType: m,
        pipelineType: n
      }
    ) }, i);
  }) });
}, ka = ({ isLoading: s, ...t }) => {
  if (s)
    return /* @__PURE__ */ e.jsxs("div", { className: "py-10 px-16 flexbox-col dc__gap-4", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8", children: [
        /* @__PURE__ */ e.jsx(Yl, { className: "icon-dim-16 dc__no-shrink" }),
        /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading h-16 w-100" })
      ] }),
      /* @__PURE__ */ e.jsx(or, { isLoading: !0 })
    ] });
  const { workflow: n, handleWorkflowSelection: a, selectedWorkflowId: l } = t, { id: o, workflowName: r, pipelineType: i, sourceInfo: c, environments: d, pipelineName: m } = n, p = +o == +l, u = () => {
    a(o);
  }, _ = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
    /* @__PURE__ */ e.jsx("h4", { className: "m-0 text__white fs-12 fw-6 lh-18 dc__ellipsis-right", children: Be.RIGHT_PANEL_ENVIRONMENTS_HEADING }),
    d.map((f) => /* @__PURE__ */ e.jsx("p", { className: "m-0 text__white fs-12 fw-4 lh-18 dc__ellipsis-right", children: f.environmentName }, f.environmentId))
  ] }), h = (f) => /* @__PURE__ */ e.jsx(
    re,
    {
      content: _(),
      className: "default-tt w-200 mxh-210 dc__overflow-auto",
      interactive: !0,
      placement: "right",
      arrow: !1,
      children: f
    }
  );
  return /* @__PURE__ */ e.jsx($e, { condition: d.length > 0, wrap: h, children: /* @__PURE__ */ e.jsxs(
    "button",
    {
      className: `py-10 px-16 flexbox-col dc__gap-4 dc__tab-focus dc__outline-none-imp dc__no-border dc__select-text ${p ? "bg__secondary" : "bg__primary"}`,
      onClick: u,
      type: "button",
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8", children: [
          /* @__PURE__ */ e.jsx(Yl, { className: "icon-dim-16 dc__no-shrink" }),
          /* @__PURE__ */ e.jsx("h4", { className: "m-0 cn-9 fs-12 fw-6 lh-20 dc__truncate", children: r })
        ] }),
        /* @__PURE__ */ e.jsx(or, { pipelineType: i, sourceInfo: c, pipelineName: m })
      ]
    },
    o
  ) });
}, Uh = ({
  selectedApplicationName: s,
  handleApplicationSelection: t,
  selectedLabel: n,
  currentApplicationName: a,
  handleWorkflowSelection: l,
  registryType: o,
  selectedImage: r,
  selectedWorkflowId: i,
  workflowDetailsAsyncResponse: c,
  sourceReleaseConfiguration: d
}) => {
  const { isLoadingWorkflows: m, workflowDetails: p, workflowError: u, reloadWorkflows: _ } = c, h = s === a, f = n && !r, g = () => {
    t(a);
  }, b = () => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(ka, { isLoading: !0 }),
    /* @__PURE__ */ e.jsx(ka, { isLoading: !0 })
  ] });
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `flexbox-col dc__border-top-n1 last-child__border-bottom-n1 ${h ? "releases__deployment-source-active-card-border" : ""}`,
      children: [
        /* @__PURE__ */ e.jsxs(
          "button",
          {
            className: `flexbox dc__content-space pr-8 py-12 dc__tab-focus dc__outline-none-imp dc__no-border bg__primary dc__select-text ${h ? "pl-13" : "pl-16 dc__hover-n50"}`,
            type: "button",
            onClick: g,
            disabled: h,
            children: [
              /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
                /* @__PURE__ */ e.jsx(
                  "h4",
                  {
                    className: `m-0 fs-13 fw-6 lh-16 dc__truncate dc__align-left ${h ? "cb-5" : "cn-9"}`,
                    children: a
                  }
                ),
                f && /* @__PURE__ */ e.jsx("p", { className: "m-0 cr-5 dc__truncate fs-12 fw-4 lh-16", children: ip(n) }),
                /* @__PURE__ */ e.jsx(
                  zo,
                  {
                    selectedImage: r,
                    registryType: o,
                    releaseVersion: d?.releaseVersion,
                    selectedImageClass: "fs-13 cn-7"
                  }
                )
              ] }),
              f && /* @__PURE__ */ e.jsx(da, { className: "icon-dim-16 dc__no-shrink form__icon--error" })
            ]
          }
        ),
        h && /* @__PURE__ */ e.jsx(
          Ee,
          {
            isLoading: m,
            customLoader: b(),
            error: u,
            genericSectionErrorProps: {
              reload: _
            },
            children: p?.length ? p.map((j) => /* @__PURE__ */ e.jsx(
              ka,
              {
                workflow: j,
                handleWorkflowSelection: l,
                selectedWorkflowId: i
              },
              j.id
            )) : /* @__PURE__ */ e.jsx(Mh, {})
          }
        )
      ]
    }
  );
}, $h = ({
  selectedApplicationName: s,
  applicationDetailsMap: t,
  handleApplicationSelection: n,
  handleWorkflowSelection: a,
  handleLabelSelection: l,
  selectedLabel: o,
  workflowDetailsAsyncResponse: r
}) => {
  const i = Object.keys(t), [c, d] = K(
    () => kc(i),
    [JSON.stringify(i)],
    i.length > 0
  ), m = (u) => {
    l(u.value);
  }, p = d?.map((u) => ({
    value: u,
    label: u,
    startIcon: /* @__PURE__ */ e.jsx(Ld, { className: "icon-dim-16 mr-4 mw-18" })
  })) ?? [];
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__mxw-234 w-100 h-100 flex-grow-1 dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6 px-16 pt-12", children: [
      /* @__PURE__ */ e.jsx("label", { htmlFor: zl, className: "m-0 cn-9 fs-13 fw-4 lh-20", children: Be.SELECT_LABEL.LABEL }),
      /* @__PURE__ */ e.jsx(
        st,
        {
          inputId: zl,
          value: o ? { value: o, label: o } : null,
          options: p,
          placeholder: Be.SELECT_LABEL.PLACEHOLDER,
          isSearchable: !0,
          isLoading: c,
          onChange: m
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "py-12 px-16 flexbox dc__align-items-center dc__gap-8", children: /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-9 fs-13 fw-6 lh-20 dc__uppercase dc__ellipsis-right", children: np(i.length) }) }),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col h-100 dc__overflow-auto", children: i.map((u) => {
      const { selectedImage: _, registryType: h, sourceReleaseConfiguration: f } = t[u];
      return /* @__PURE__ */ e.jsx(
        Uh,
        {
          selectedApplicationName: s,
          handleApplicationSelection: n,
          selectedLabel: o,
          currentApplicationName: u,
          handleWorkflowSelection: a,
          registryType: h,
          selectedImage: _,
          selectedWorkflowId: t[u].selectedWorkflowId,
          workflowDetailsAsyncResponse: r,
          sourceReleaseConfiguration: f
        },
        u
      );
    }) })
  ] });
}, Bh = ({ environments: s = [], workflowName: t }) => {
  const n = () => s.length ? /* @__PURE__ */ e.jsx("div", { className: "flexbox-col", children: s.map((a) => /* @__PURE__ */ e.jsx("p", { className: "py-6 cn-9 fs-13 lh-20 dc__truncate m-0", children: a.environmentName }, a.environmentName)) }) : /* @__PURE__ */ e.jsxs("div", { className: "p-24 flex column dc__text-center fs-12 lh-20 cn-7 dc__gap-8", children: [
    /* @__PURE__ */ e.jsx(ia, { className: "icon-dim-24 dc__no-shrink fcn-6" }),
    op(t)
  ] });
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col h-100 dc__mxw-250 w-100 p-16 dc__overflow-auto dc__border-left-n1 dc__gap-12", children: [
    /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-9 fs-13 fw-6 lh-20", children: Be.RIGHT_PANEL_ENVIRONMENTS_HEADING }),
    n()
  ] });
}, Hh = ({
  selectedApplicationName: s,
  handleApplicationSelection: t,
  applicationDetailsMap: n,
  handleWorkflowSelection: a,
  handleImageSelection: l,
  handleLabelSelection: o,
  selectedLabel: r
}) => {
  const i = Ye(new AbortController()), [c, d, m, p] = K(
    () => Vs(
      () => Gm(s, i.current.signal),
      i
    ),
    [s, !!n[s]],
    !!s && !!n[s]
  );
  ee(() => {
    if (!c && d?.length > 0) {
      d.length === 1 && a(d[0].id);
      const f = n[s]?.artifactSourceAppWorkflowId;
      d.find(
        (b) => f === +b.id
      ) && a(f);
    }
  }, [c, JSON.stringify(d)]);
  const u = c || hs(m), _ = q(
    () => ({
      isLoadingWorkflows: u,
      workflowDetails: d,
      workflowError: m,
      reloadWorkflows: p
    }),
    [c, d, m, p]
  ), h = () => {
    if (!s || !n[s]?.selectedWorkflowId || _.isLoadingWorkflows)
      return /* @__PURE__ */ e.jsx(
        J,
        {
          title: tp(
            n[s] ? s : null
          ),
          SvgImage: Id,
          imageType: ac.Large,
          classname: "dc__align-center w-100"
        }
      );
    if (m)
      return /* @__PURE__ */ e.jsx("div", { className: "h-100 w-100 flexbox-col flex-grow-1", children: /* @__PURE__ */ e.jsx(bt, { code: m.code, reload: p }) });
    const { selectedWorkflowId: f } = n[s], g = d?.find((j) => j.id === f), b = g?.environments || [];
    return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(
        Oh,
        {
          handleImageSelection: l,
          selectedApplicationName: s,
          applicationDetailsMap: n
        },
        `${f}-content`
      ),
      /* @__PURE__ */ e.jsx(
        Bh,
        {
          environments: b,
          workflowName: g?.workflowName
        },
        `${f}-right-panel`
      )
    ] });
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__overflow-auto h-100", children: [
    /* @__PURE__ */ e.jsx(
      $h,
      {
        selectedApplicationName: s,
        applicationDetailsMap: n,
        handleApplicationSelection: t,
        handleWorkflowSelection: a,
        handleLabelSelection: o,
        selectedLabel: r,
        workflowDetailsAsyncResponse: _
      }
    ),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox bg__secondary w-100 h-100 dc__overflow-auto", children: h() })
  ] });
}, Gh = ({
  originalReleaseOrdering: s,
  applicationDetailsMap: t,
  handleSuccess: n
}) => {
  const { id: a } = de(), l = q(
    () => Ph(s, t),
    [t, JSON.stringify(s)]
  ), [o, r] = T(!1), i = rp(o, l), c = (m) => /* @__PURE__ */ e.jsx(re, { content: i, className: "default-tt", arrow: !1, children: /* @__PURE__ */ e.jsx("span", { children: m }) }), d = async () => {
    try {
      r(!0), await Hm(a, s, t), await n(), ae.showToast({
        variant: le.success,
        description: Be.SUCCESS_SAVE_MESSAGE
      });
    } catch (m) {
      U(m), r(!1);
    }
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__content-end dc__gap-12 pt-12 pb-12 pl-16 pr-16 bg__primary dc__border-top dc__no-shrink", children: [
    l && /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-item-center dc__gap-6", children: [
      /* @__PURE__ */ e.jsx(Hr, { className: "icon-dim-20 dc__no-shrink" }),
      /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: Be.UNSAVED_CHANGES_INDICATOR })
    ] }),
    /* @__PURE__ */ e.jsx($e, { wrap: c, condition: !!i, children: /* @__PURE__ */ e.jsx(
      Ws,
      {
        rootClassName: "flex cta h-32",
        isLoading: o,
        disabled: !!i,
        onClick: d,
        children: Be.IMAGE_CTA
      }
    ) })
  ] });
}, Wh = ({ releaseOrdering: s, handleSuccess: t }) => {
  const n = fe(), { appName: a } = Te(), { id: l, name: o } = de(), [r, i] = T(fl(s)), [c, d] = T(a), [m, p] = T(!1), [u, _] = T(""), h = () => {
    n.push(n.location.pathname.split("/").slice(0, -1).join("/"));
  }, f = (x) => {
    d(x);
    const N = {
      ...r,
      // Resetting the selected workflow id, since will be setting workflowId based on selected artifact of previously selected application
      [c]: {
        ...r[c],
        selectedWorkflowId: null
      }
    };
    i(N);
  }, g = (x) => {
    const N = {
      ...r,
      [c]: {
        ...r[c],
        selectedWorkflowId: x
      }
    };
    i(N);
  }, b = async (x) => {
    if (!x) {
      _("");
      return;
    }
    _(x);
    try {
      p(!0);
      const { applicationsToArtifactsMap: N, appNameToIdMap: y } = await Cl({
        releaseId: l,
        applicationName: Ua,
        searchInput: x,
        searchType: ma.IMAGE_LABEL
      }), S = Object.keys(N).reduce(
        (I, w) => {
          const k = N[w]?.materials?.[0];
          return I[w] = {
            name: w,
            selectedImage: k?.imagePath ?? "",
            registryName: k?.registryName ?? "",
            registryType: k?.registryType || xn.OTHER,
            artifactId: k?.id ? +k.id : null,
            appId: y[w],
            artifactSourceAppWorkflowId: k?.appWorkflowId ?? null,
            sourceReleaseConfiguration: null,
            selectedWorkflowId: null,
            isRequired: null,
            isDeleted: null
          }, I;
        },
        {}
      );
      i(S);
    } catch {
      _("");
    } finally {
      p(!1);
    }
  }, j = ({
    selectedImage: x,
    registryType: N,
    registryName: y,
    artifactId: C,
    sourceReleaseConfiguration: S,
    artifactSourceAppWorkflowId: I
  }) => {
    b();
    const w = {
      ...r,
      [c]: {
        ...r[c],
        selectedImage: x,
        registryType: N,
        registryName: y,
        artifactId: C,
        sourceReleaseConfiguration: S,
        artifactSourceAppWorkflowId: I
      }
    };
    i(w);
  }, E = async () => {
    await t(), h();
  }, v = () => /* @__PURE__ */ e.jsx(
    Ee,
    {
      isLoading: m,
      progressingProps: {
        pageLoader: !0
      },
      children: /* @__PURE__ */ e.jsx(
        Hh,
        {
          selectedApplicationName: c,
          applicationDetailsMap: r,
          handleApplicationSelection: f,
          handleWorkflowSelection: g,
          handleImageSelection: j,
          handleLabelSelection: b,
          selectedLabel: u
        }
      )
    }
  );
  return /* @__PURE__ */ e.jsx(Ut, { className: "", onEscape: h, close: h, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "bg__primary dc__position-fixed dc__right-0 dc__top-0 h-100 flexbox-col dc__content-space w-1200",
      onClick: lt,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col h-100 dc__content-space bg__primary dc__overflow-auto", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__align-items-center dc__border-bottom-n1 pb-12 pt-12 pl-20 pr-20", children: [
            /* @__PURE__ */ e.jsx("h2", { className: "m-0 cn-9 fs-16 fw-6 lh-24 dc__ellipsis-right", children: sp(o) }),
            /* @__PURE__ */ e.jsx(
              "button",
              {
                className: "flex dc__transparent dc__outline-none-imp dc__no-border p-0 dc__tab-focus",
                type: "button",
                onClick: h,
                "aria-label": "close-deployment-source-modal",
                children: /* @__PURE__ */ e.jsx(Ts, { className: "icon-dim-24 dc__no-shrink fcn-6" })
              }
            )
          ] }),
          v()
        ] }),
        /* @__PURE__ */ e.jsx(
          Gh,
          {
            originalReleaseOrdering: s,
            applicationDetailsMap: r,
            handleSuccess: E
          }
        )
      ]
    }
  ) });
};
var et = /* @__PURE__ */ ((s) => (s.manageApplication = "manageApplications", s.activeReleases = "activeReleases", s))(et || {});
const zn = "tab", Vh = ({ handleClose: s }) => {
  const { track: t } = de(), n = `/dashboard${W(D.RELEASE_TRACK_DETAIL, {
    trackName: t
  })}?${zn}=${et.manageApplication}`;
  return /* @__PURE__ */ e.jsx(
    Hs,
    {
      variant: Gs.info,
      title: `No applications added to '${t}'`,
      subtitle: `Only applications added to '${t}' can be included in the release.`,
      buttonConfig: {
        secondaryButtonConfig: {
          onClick: s,
          text: "Cancel"
        },
        primaryButtonConfig: {
          onClick: lc(n),
          text: "Add applications",
          endIcon: /* @__PURE__ */ e.jsx(jt, {})
        }
      },
      handleClose: s,
      children: /* @__PURE__ */ e.jsxs("span", { className: "fs-13 lh-20 cn-8", children: [
        "Please add applications to ",
        /* @__PURE__ */ e.jsx("span", { className: "dc__word-break", children: t }),
        " first."
      ] })
    }
  );
}, qh = ({ shortHash: s, message: t, handleOpenArtifactInfoModal: n }) => s ? /* @__PURE__ */ e.jsxs("div", { className: "releases__commit-info-card--shadow br-8 dc__info-card dc__info-card--no-hover bg__primary dc__backdrop-filter dc__overflow-hidden h-96 flexbox-col dc__content-space", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "px-12 pt-12 pb-8 flexbox dc__gap-12 dc__border-bottom-n1 w-100 dc__border-bottom-n1", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col w-100", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4", children: [
        /* @__PURE__ */ e.jsx("h4", { className: "m-0 cn-7 fs-12 fw-4 lh-20", children: "Commit" }),
        /* @__PURE__ */ e.jsx(
          re,
          {
            className: "default-tt w-200",
            arrow: !1,
            content: "Commit(s) selected to be deployed for this application",
            children: /* @__PURE__ */ e.jsx("span", { className: "flex", children: /* @__PURE__ */ e.jsx(Cn, { className: "icon-dim-14 dc__no-shrink fcn-5" }) })
          }
        )
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4 dc__align-items-center", children: [
        /* @__PURE__ */ e.jsx(wd, { className: "icon-dim-14 dc__no-shrink scn-6" }),
        /* @__PURE__ */ e.jsx("span", { className: "dc__truncate cn-9 fs-14 fw-4 lh-20 mono", children: s })
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(Yr, { className: "icon-dim-24 dc__no-shrink" })
  ] }),
  /* @__PURE__ */ e.jsxs("div", { className: "px-12 py-8 flex dc__content-space dc__gap-4", children: [
    /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-9 fs-12 fw-4 lh-18 dc__ellipsis-right", children: t || "-" }),
    /* @__PURE__ */ e.jsx(
      "button",
      {
        className: "p-0 dc__no-border dc__outline-none-imp flex dc__no-shrink fs-12 fw-6 lh-18 anchor",
        type: "button",
        onClick: n,
        children: "Details"
      }
    )
  ] })
] }) : null, Yh = ({
  imagePath: s,
  registryType: t,
  sourceMessage: n,
  handleOpenDeploymentSourceModal: a,
  handleOpenArtifactInfoModal: l
}) => /* @__PURE__ */ e.jsxs("div", { className: "w-200 br-8 dc__info-card dc__info-card--no-hover bg__primary dc__backdrop-filter dc__overflow-hidden h-96 flexbox-col dc__content-space", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "px-12 pt-12 pb-8 flexbox dc__content-space dc__gap-12", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-4", children: [
        /* @__PURE__ */ e.jsx("span", { className: "fs-12 lh-20 cn-7", children: "Image" }),
        /* @__PURE__ */ e.jsx(
          re,
          {
            className: "default-tt w-200",
            arrow: !1,
            content: "Image selected to be deployed for this application",
            children: /* @__PURE__ */ e.jsx("span", { className: "flex", children: /* @__PURE__ */ e.jsx(Cn, { className: "icon-dim-14 dc__no-shrink fcn-5" }) })
          }
        )
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "fs-13 lh-20", children: s ? /* @__PURE__ */ e.jsx("span", { className: "dc__truncate cn-9 mono fs-14", children: s }) : /* @__PURE__ */ e.jsx("span", { className: "cn-7", children: "Not Selected" }) })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "dc__no-shrink", children: s ? /* @__PURE__ */ e.jsx(Mt, { registryType: t, size: 24 }) : /* @__PURE__ */ e.jsx(Rd, { className: "icon-dim-24" }) })
  ] }),
  /* @__PURE__ */ e.jsx("div", { className: "py-8 px-12 dc__border-top-n1 flex dc__content-space dc__gap-4", children: s ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-12 lh-18 dc__truncate", children: n || "-" }),
    /* @__PURE__ */ e.jsx(
      "button",
      {
        className: "p-0 dc__no-border dc__outline-none-imp flex dc__no-shrink fs-12 fw-6 lh-18 anchor",
        type: "button",
        onClick: l,
        children: "Details"
      }
    )
  ] }) : /* @__PURE__ */ e.jsx(
    "button",
    {
      className: "p-0 dc__no-border dc__outline-none-imp flex dc__no-shrink fs-12 fw-6 lh-18 anchor",
      type: "button",
      onClick: a,
      children: "Select an image"
    }
  ) })
] }), ir = 3, zh = "not-subscribed-release-channel-block", Da = ({
  tenantInstallationDetailsMap: s,
  installationsMappedToRelease: t
}) => {
  const n = Object.values(t.installations || {}).reduce((a, l) => (a[l.identifier] = l, a), {});
  return Object.entries(s).reduce(
    (a, [l, o]) => (a[l] = {
      ...o,
      isSelected: o.tenantInstallationConfig.isReleaseTriggered || t.areAllInstallationsTargeted || !!n[l],
      isLoading: !1
    }, a),
    {}
  );
}, qa = (s, t) => t ? zh : `release-channel-${s}`, Kh = (s, t) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-2 dc__overflow-auto", children: [
  /* @__PURE__ */ e.jsx("h6", { className: "m-0 fs-12 fw-6 lh-18 dc__word-break dc__align-left", children: t }),
  /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-12 fw-4 lh-18 dc__align-left", children: "Environments" }),
  /* @__PURE__ */ e.jsx("ul", { className: "flexbox-col dc__gap-4 pt-4 pl-16 m-0", children: s.map((n) => /* @__PURE__ */ e.jsx("li", { className: "dc__word-break fs-12 fw-4 lh-18 dc__align-left", children: n }, n)) })
] }), Jh = ({
  formState: s,
  handleToggleTenantInstallationSelection: t,
  hasRequestedUpdate: n,
  sortedTenantInstallations: a
}) => a.map((l) => {
  const o = s[l], { isReleaseTriggered: r, image: i, displayText: c } = o.tenantInstallationConfig, d = Array.from(o.environments).sort(te);
  return {
    type: "item",
    id: `map-tenant-installation-${l}`,
    as: "div",
    title: c,
    customTooltipConfig: {
      alwaysShowTippyOnHover: !0,
      placement: "left",
      className: "mxh-250 dc__overflow-auto mr-42",
      interactive: !0,
      content: Kh(d, c)
    },
    startIconConfig: {
      customIcon: /* @__PURE__ */ e.jsx(
        is,
        {
          imageProps: {
            src: i,
            height: 20,
            width: 20,
            alt: c
          }
        }
      )
    },
    trailingItem: {
      type: "switch",
      config: {
        name: `map-tenant-installation-${l}`,
        ariaLabel: `Toggle tenant installation ${c}`,
        tooltipContent: r ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-2", children: [
          /* @__PURE__ */ e.jsx("h6", { className: "m-0 fs-12 fw-6 lh-18", children: "Not allowed" }),
          /* @__PURE__ */ e.jsxs("p", { className: "m-0 fs-12 fw-4 lh-18 dc__word-break", children: [
            "This release has already been rolled out to ",
            c
          ] })
        ] }) : null,
        isChecked: o.isSelected,
        isDisabled: r || n,
        isLoading: o.isLoading,
        onChange: () => {
          t({
            installationIdentifier: l
          });
        }
      }
    }
  };
}), cr = ({
  formState: s,
  handleToggleTenantInstallationSelection: t,
  tenantInstallationsNotSubscribedToReleaseChannel: n,
  releaseChannelToTenantInstallationMap: a,
  hasRequestedUpdate: l,
  releaseChannelId: o,
  isNotSubscribedBlock: r
}) => {
  const i = r ? n : a[o].tenantDetails, c = Array.from(i).sort((_, h) => {
    const f = s[_]?.tenantInstallationConfig.displayText || "", g = s[h]?.tenantInstallationConfig.displayText || "";
    return te(f, g);
  }), d = r ? "Not subscribed Installations" : a[o].releaseChannelName, m = c.filter(
    (_) => s[_]?.isSelected
  ).length, p = c.every(
    (_) => s[_]?.tenantInstallationConfig.isReleaseTriggered
  ), u = c.some(
    (_) => s[_].isLoading
  );
  return {
    type: "heading",
    id: qa(o, r),
    customTooltipConfig: r ? {
      alwaysShowTippyOnHover: !0,
      content: "Installations are not subscribed to any release channel"
    } : null,
    title: d,
    subtitle: `${m} of ${i.size} Tenant Installations selected`,
    trailingItem: {
      type: "switch",
      config: {
        name: `map-complete-release-channel-${o || "not-subscribed-block"}`,
        ariaLabel: `Toggle complete release channel ${d}`,
        tooltipContent: p ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-2", children: [
          /* @__PURE__ */ e.jsx("h6", { className: "m-0 fs-12 fw-6 lh-18", children: "Not allowed" }),
          /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-12 fw-4 lh-18", children: "Release has already been rolled out for all tenant installations in this channel" })
        ] }) : null,
        isChecked: m > 0,
        indeterminate: m !== i.size,
        onChange: () => {
          t({
            channelSelectionDetails: r ? {
              isNotSubscribedBlock: !0
            } : {
              channelId: o
            }
          });
        },
        isDisabled: p || l,
        isLoading: u
      }
    },
    items: Jh({
      formState: s,
      handleToggleTenantInstallationSelection: t,
      hasRequestedUpdate: l,
      sortedTenantInstallations: c
    })
  };
}, Qh = ({
  releaseChannelToTenantInstallationMap: s,
  formState: t,
  handleToggleTenantInstallationSelection: n,
  hasRequestedUpdate: a,
  tenantInstallationsNotSubscribedToReleaseChannel: l
}) => {
  const o = Object.keys(s).sort(
    (c, d) => te(
      s[c].releaseChannelName,
      s[d].releaseChannelName
    )
  ), r = () => o.length === 1 && l.size === 0 ? {
    [qa(o[0], !1)]: !0
  } : o.length === 0 && l.size > 0 ? {
    [qa("", !0)]: !0
  } : {}, i = () => {
    const c = o.map(
      (d) => cr({
        releaseChannelId: d,
        formState: t,
        handleToggleTenantInstallationSelection: n,
        tenantInstallationsNotSubscribedToReleaseChannel: l,
        releaseChannelToTenantInstallationMap: s,
        hasRequestedUpdate: a
      })
    );
    return l.size > 0 ? [
      ...c,
      cr({
        isNotSubscribedBlock: !0,
        formState: t,
        handleToggleTenantInstallationSelection: n,
        tenantInstallationsNotSubscribedToReleaseChannel: l,
        releaseChannelToTenantInstallationMap: s,
        hasRequestedUpdate: a
      })
    ] : c;
  };
  return /* @__PURE__ */ e.jsx(
    rc,
    {
      mode: "form",
      defaultExpandedMap: r(),
      nodes: i(),
      variant: "secondary"
    }
  );
}, Xh = async ({
  mapTenantInstallationFormState: s,
  releaseId: t
}) => {
  try {
    const n = Object.keys(s).filter(
      (l) => s[l].isSelected
    ), a = {
      id: t,
      query: [
        {
          op: he.replace,
          path: "target",
          value: n
        }
      ]
    };
    return await Kt(a), !0;
  } catch (n) {
    return U(n), !1;
  }
}, Zh = ({
  unmappedEnvironments: s
}) => {
  const [t, n] = T(!1), a = () => {
    n(!0);
  }, l = () => {
    n(!1);
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "p-12", children: [
    /* @__PURE__ */ e.jsx(
      cs,
      {
        layout: "column",
        variant: "warning",
        heading: `${s.length} Unmapped Environments`,
        description: "Map these environments to a tenant installation to deploy this release",
        buttonProps: {
          dataTestId: "view-unmapped-environments",
          text: "View Unmapped Environments",
          onClick: a,
          variant: _e.text
        }
      }
    ),
    t && /* @__PURE__ */ e.jsx(
      Sl,
      {
        unmappedEnvironments: s,
        handleClose: l
      }
    )
  ] });
}, ef = ({
  unmappedEnvironments: s,
  tenantInstallationDetailsMap: t,
  releaseChannelToTenantInstallationMap: n,
  tenantInstallationsNotSubscribedToReleaseChannel: a
}) => {
  const {
    installationsMappedToRelease: l,
    track: o,
    version: r,
    areAllImagesSelected: i,
    refetchReleaseDetail: c,
    id: d
  } = de(), [m, p] = T(
    Da({
      tenantInstallationDetailsMap: t,
      installationsMappedToRelease: l
    })
  ), [u, _] = T(!1);
  ee(() => {
    p(
      Da({
        tenantInstallationDetailsMap: t,
        installationsMappedToRelease: l
      })
    );
  }, [JSON.stringify(l), t]);
  const f = oc(
    async (v) => {
      if (_(!0), !await Xh({
        mapTenantInstallationFormState: v,
        releaseId: d
      })) {
        p(
          Da({
            tenantInstallationDetailsMap: t,
            installationsMappedToRelease: l
          })
        ), _(!1);
        return;
      }
      await c(), _(!1);
    },
    1500
  ), g = Object.keys(n).length + a.size > 0, b = W(D.RELEASE_DETAIL_ROLLOUT_RELEASE, {
    releaseTrack: o,
    releaseVersion: r
  }), j = ({
    installationIdentifier: v,
    channelSelectionDetails: x
  }) => {
    const N = structuredClone(m);
    if (v)
      N[v] = {
        ...N[v],
        isSelected: !N[v].isSelected,
        isLoading: !0
      };
    else {
      const { channelId: y, isNotSubscribedBlock: C } = x, S = Array.from(
        C ? a : n[y].tenantDetails
      ), I = S.every(
        (w) => N[w].isSelected
      );
      Array.from(S).forEach((w) => {
        N[w] = {
          ...N[w],
          isSelected: N[w].tenantInstallationConfig.isReleaseTriggered || !I,
          isLoading: !N[w].tenantInstallationConfig.isReleaseTriggered
        };
      });
    }
    p(N), f(N);
  }, E = () => g ? /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto px-6 pt-6", children: /* @__PURE__ */ e.jsx(
    Qh,
    {
      releaseChannelToTenantInstallationMap: n,
      formState: m,
      handleToggleTenantInstallationSelection: j,
      hasRequestedUpdate: u,
      tenantInstallationsNotSubscribedToReleaseChannel: a
    }
  ) }) : /* @__PURE__ */ e.jsx("div", { className: "flex p-12 flex-grow-1", children: /* @__PURE__ */ e.jsx(
    As,
    {
      title: s.length === 0 ? "No deployment pipelines exist in applications in this release" : "No environments are mapped to Tenant Installations",
      subTitle: s.length === 0 ? "Create deployment pipelines for applications in this release and map the corresponding environments to tenant installations" : "",
      description: "",
      useInfoIcon: !0
    }
  ) });
  return /* @__PURE__ */ e.jsxs(
    "aside",
    {
      className: "flexbox-col dc__content-space bg__secondary border__secondary--bottom w-300 dc__no-shrink dc__overflow-auto",
      "aria-labelledby": "map-target-tenant-installations-heading",
      children: [
        /* @__PURE__ */ e.jsxs("header", { className: "px-16 py-12 border__secondary--bottom flexbox dc__gap-8 dc__content-space dc__no-shrink dc__align-items-center", children: [
          /* @__PURE__ */ e.jsx("h4", { className: "m-0 cn-9 fs-13 fw-6 lh-20", id: "map-target-tenant-installations-heading", children: "Target Tenant Installations" }),
          /* @__PURE__ */ e.jsx(
            xr,
            {
              heading: "Target Tenant Installations",
              documentationLinkText: "What is Tenant Installation",
              documentationLink: "TENANT_INSTALLATION",
              additionalContent: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-20 fs-13 fw-4 lh-20 p-12", children: [
                /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-9", children: "Enable Tenant Installations on which this release will be deployed." }),
                /* @__PURE__ */ e.jsxs("p", { className: "m-0 cn-9", children: [
                  "Only enabled Tenant Installations will be available in ",
                  /* @__PURE__ */ e.jsx(ke, { to: b, className: "anchor", children: "Rollout Release" }),
                  "."
                ] })
              ] }),
              buttonPadding: "p-4",
              iconClassName: "icon-dim-16 dc__no-shrink"
            }
          )
        ] }),
        /* @__PURE__ */ e.jsxs("section", { className: "flexbox-col dc__content-space flex-grow-1 dc__overflow-auto", children: [
          E(),
          (s.length > 0 || i) && /* @__PURE__ */ e.jsxs("footer", { className: "flexbox-col", children: [
            s.length > 0 && /* @__PURE__ */ e.jsx(Zh, { unmappedEnvironments: s }),
            i && /* @__PURE__ */ e.jsx("div", { className: "p-12", children: /* @__PURE__ */ e.jsx(
              ie,
              {
                dataTestId: "footer__cta--go-to-rollout-release",
                fullWidth: !0,
                component: Rt.link,
                text: "Go to rollout release",
                endIcon: /* @__PURE__ */ e.jsx(Me, { name: "ic-arrow-right", color: null }),
                size: oe.large,
                linkProps: {
                  to: b
                }
              }
            ) })
          ] })
        ] })
      ]
    }
  );
}, sf = ({
  handleClose: s,
  selectedAppName: t,
  handleSuccess: n
}) => {
  const [a, l] = T(!1), [o, r] = T(!1), [i, c] = T(!1), [d, m] = T(null), [p, u] = T(null), _ = Ye(new AbortController()), { id: h, track: f } = de(), { searchKey: g, handleSearch: b, clearFilters: j } = ds(), E = (L) => Vs(
    () => Cl({
      releaseId: h,
      applicationName: t,
      workflowId: null,
      trackName: f,
      searchInput: g,
      searchType: ma.RELEASE,
      signal: _.current.signal,
      offset: L ?? pl
    }),
    _
  ), [v, x, N, y] = K(
    () => E(),
    [g, t]
  ), { flatArtifactListForApp: C, shouldShowViewAllButton: S } = q(() => {
    const L = (p?.materials ?? []).reduce((M, { configuredInReleases: Y, ...O }) => (M.push(
      ...Y.map((Q) => ({
        ...O,
        releaseConfig: Q
      }))
    ), M), []), F = !i && L.length > ir;
    return {
      flatArtifactListForApp: F ? L.slice(0, ir) : L,
      shouldShowViewAllButton: F
    };
  }, [p, i]), I = !S && p?.materials?.length < p?.totalCount, w = !!g;
  ee(() => {
    !v && x && u(x.applicationsToArtifactsMap[t]);
  }, [v, x]);
  const k = () => {
    c(!0);
  }, R = async () => {
    try {
      r(!0);
      const { applicationsToArtifactsMap: L } = await E(
        p?.materials?.length
      );
      u((F) => ({
        ...L[t],
        materials: [...F.materials, ...L[t].materials]
      }));
    } catch {
    } finally {
      r(!1);
    }
  }, B = async () => {
    try {
      l(!0), await Bm({
        id: h,
        appName: t,
        ...d
      }), n(), s(), ae.showToast({
        variant: le.success,
        description: "Image updated successfully"
      });
    } catch (L) {
      U(L), l(!1);
    }
  }, P = (L) => () => {
    m(L);
  };
  return /* @__PURE__ */ e.jsx(Nn, { className: "visible-modal__body", children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `flexbox-col ${v || N ? "dc__content-center" : "dc__content-space"} dc__overflow-hidden dc__m-auto mt-40 br-8 bg__primary w-450 mh-300 mxh-600`,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space px-20 py-12 dc__border-bottom", children: [
            /* @__PURE__ */ e.jsx("h2", { className: "m-0 fs-16 fw-6 lh-24 cn-9", children: "Select image from previous release" }),
            /* @__PURE__ */ e.jsx(
              "button",
              {
                type: "button",
                className: "dc__transparent dc__no-shrink flexbox",
                "aria-label": "close-modal",
                onClick: s,
                children: /* @__PURE__ */ e.jsx(Ts, { className: "icon-dim-20 fcn-6" })
              }
            )
          ] }),
          /* @__PURE__ */ e.jsx(
            Ee,
            {
              isLoading: v,
              progressingProps: {
                pageLoader: !0,
                styles: {
                  flexGrow: 1
                }
              },
              error: N,
              genericSectionErrorProps: {
                rootClassName: "flex-grow-1",
                reload: y
              },
              children: C.length ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
                /* @__PURE__ */ e.jsx(
                  qs,
                  {
                    containerClassName: "px-20 py-12",
                    initialSearchText: g,
                    inputProps: {
                      placeholder: `Search previous releases of '${t}'`
                    },
                    handleSearchChange: b,
                    shouldDebounce: !0
                  }
                ),
                /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-auto flex-grow-1", children: [
                  C.map(({ releaseConfig: L, ...F }) => {
                    const M = d?.artifactId === +F.id && d?.sourceReleaseConfiguration?.id === L.id;
                    return /* @__PURE__ */ e.jsxs(
                      "button",
                      {
                        type: "button",
                        className: `flex top left dc__gap-8 w-100 dc__no-border px-20 py-8 ${M ? "bcb-1" : "dc__hover-n50 bg__primary"}`,
                        onClick: P({
                          artifactId: +F.id,
                          artifactSourceAppWorkflowId: F.appWorkflowId,
                          registryName: F.registryName,
                          registryType: F.registryType,
                          sourceReleaseConfiguration: L
                        }),
                        children: [
                          /* @__PURE__ */ e.jsx(zs, { className: "dc__no-shrink icon-dim-20" }),
                          /* @__PURE__ */ e.jsxs("div", { className: "flex column top left flex-grow-1", children: [
                            /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-20 cn-9 dc__truncate", children: L.name }),
                            /* @__PURE__ */ e.jsx("span", { className: "fs-14 fw-4 lh-20 cn-7 mono dc__truncate", children: L.releaseVersion })
                          ] }),
                          M && /* @__PURE__ */ e.jsx(al, { className: "dc__no-shrink scb-5 icon-dim-20 dc__align-self-center" })
                        ]
                      },
                      `${L.id}-${F.id}`
                    );
                  }),
                  o && /* @__PURE__ */ e.jsx(vs, {}),
                  S && /* @__PURE__ */ e.jsxs(
                    "button",
                    {
                      type: "button",
                      className: "flex left dc__gap-8 w-100 dc__no-border px-20 py-12 dc__hover-n50 bg__primary",
                      onClick: k,
                      children: [
                        /* @__PURE__ */ e.jsx(ol, { className: "dc__no-shrink icon-dim-20 icon-color-n6 dc__flip-90" }),
                        /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-20 cb-5", children: "View all releases" })
                      ]
                    }
                  ),
                  I && !o && /* @__PURE__ */ e.jsx(ic, { callback: R })
                ] })
              ] }) : /* @__PURE__ */ e.jsx(
                As,
                {
                  title: w ? "No results" : `No previous releases of '${t}'`,
                  useInfoIcon: !0,
                  subTitle: w ? "We couldn’t find any matching results" : "",
                  description: "",
                  rootClassName: "flex-grow-1",
                  ...w && {
                    reload: j,
                    buttonText: "Clear Filters"
                  }
                }
              )
            }
          )
        ] }),
        !N && /* @__PURE__ */ e.jsxs("div", { className: "px-20 py-16 flex dc__gap-12 dc__content-end", children: [
          /* @__PURE__ */ e.jsx(
            "button",
            {
              type: "button",
              className: "cta cancel",
              disabled: v,
              onClick: s,
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ e.jsx(
            Ws,
            {
              type: "button",
              rootClassName: "cta",
              disabled: v || !d || a,
              onClick: B,
              isLoading: a,
              children: "Use Image"
            }
          )
        ] })
      ]
    }
  ) });
}, tf = ({
  appName: s,
  refetchReleaseOrdering: t,
  releaseOrderingResponse: n
}) => {
  const [a, l] = T(null), [o, r] = T(!1), [i, c] = T(!1), { id: d, track: m } = de(), p = fe(), { path: u } = gs(), _ = Te(), [h, f, g, b] = K(
    () => Fm(d, s),
    [d, s],
    !!s,
    {
      resetOnChange: !1
    }
  ), j = () => {
    c((F) => !F);
  }, E = async () => {
    await t(), p.push(W(u, { ..._, appName: null }));
  }, v = () => {
    const F = `${W(D.RELEASE_TRACK_DETAIL, {
      trackName: m
    })}?${zn}=${et.manageApplication}`;
    return /* @__PURE__ */ e.jsxs("div", { className: "flex column dc__gap-20", children: [
      /* @__PURE__ */ e.jsxs(
        "button",
        {
          type: "button",
          className: "cta delete flex dc__gap-8 releases__remove-from-release-btn",
          onClick: j,
          children: [
            /* @__PURE__ */ e.jsx(Wt, { className: "icon-dim-16 dc__no-shrink scr-5 dc__no-svg-fill" }),
            "Remove from release"
          ]
        }
      ),
      /* @__PURE__ */ e.jsxs(ke, { to: F, target: "_blank", className: "anchor flex dc__gap-4 fs-13 fw-6 lh-20 cb-5", children: [
        "Remove from Release Track",
        /* @__PURE__ */ e.jsx(jt, { className: "dc__no-shrink icon-dim-16 scb-5" })
      ] })
    ] });
  };
  if (!s)
    return /* @__PURE__ */ e.jsx(
      J,
      {
        title: "Please select an application",
        subTitle: "Select an application to configure the release requirements",
        classname: "flex-grow-1"
      }
    );
  if (h && !f)
    return /* @__PURE__ */ e.jsx("div", { className: "flex flex-grow-1", children: /* @__PURE__ */ e.jsx(vs, { pageLoader: !0 }) });
  if (g || f?.isDeleted)
    return f?.isDeleted ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(
        J,
        {
          title: `'${s}' not found`,
          subTitle: `Application '${s}' is not found in the system`,
          classname: "flex-grow-1",
          image: Td,
          isButtonAvailable: !0,
          renderButton: v
        }
      ),
      i && /* @__PURE__ */ e.jsx(
        Ko,
        {
          appName: s,
          handleClose: j,
          handleSuccess: E
        }
      )
    ] }) : g.code === Bt.NOT_FOUND ? /* @__PURE__ */ e.jsx(
      J,
      {
        title: `'${s}' not found`,
        subTitle: `Application '${s}' is not available in the system`,
        classname: "flex-grow-1"
      }
    ) : /* @__PURE__ */ e.jsx("div", { className: "flex flex-grow-1", children: /* @__PURE__ */ e.jsx(bt, { code: g.code, redirectURL: D.RELEASES, reload: b }) });
  const { imageDetails: x, name: N, releaseInstructions: y, commitDetails: C } = f, S = !!x?.image, I = () => {
    r((F) => !F);
  }, w = async (F) => {
    try {
      await $m({
        id: d,
        releaseInstructions: F,
        appName: s
      }), ae.showToast({
        variant: le.success,
        description: xl
      }), await b();
    } catch (M) {
      U(M);
    }
  }, k = () => {
    if (p.location.pathname.endsWith(Nt.DEPLOYMENT_SOURCE))
      return;
    const M = W(D.RELEASE_DETAIL_REQUIREMENTS_DEPLOYMENT_SOURCE, {
      ..._
    });
    p.push(M);
  }, R = () => /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-20", children: [
    /* @__PURE__ */ e.jsxs(
      "button",
      {
        type: "button",
        className: "w-200 h-200 dc__border-dashed--n3 br-12 flex column dc__gap-12 p-24 dc__bg-transparent dc__hover-n0",
        onClick: k,
        children: [
          /* @__PURE__ */ e.jsx("div", { className: "p-4 h-56 w-56", children: /* @__PURE__ */ e.jsx(Cd, { className: "h-100-imp w-100-imp" }) }),
          /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-20 cb-5", children: "Select a image" })
        ]
      }
    ),
    /* @__PURE__ */ e.jsxs(
      "button",
      {
        type: "button",
        className: "w-200 h-200 dc__border-dashed--n3 br-12 flex column dc__gap-12 p-24 dc__bg-transparent dc__hover-n0",
        onClick: I,
        children: [
          /* @__PURE__ */ e.jsx("div", { className: "p-4 h-56 w-56", children: /* @__PURE__ */ e.jsx(yd, { className: "h-100-imp w-100-imp" }) }),
          /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-20 cb-5", children: "Select from previous release version" })
        ]
      }
    )
  ] }), B = () => {
    l(null);
  }, P = () => {
    l({
      ciArtifactId: x?.artifactId
    });
  }, L = C?.some((F) => F.shortHash) || !1;
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox flex-grow-1 w-100", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "w-100 flexbox-col h-100 border__primary--right", children: [
      /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__content-space border__secondary--bottom px-16 py-12 dc__no-shrink", children: /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-start dc__gap-8", children: [
        /* @__PURE__ */ e.jsx(cl, { className: "icon-dim-24 dc__no-shrink" }),
        /* @__PURE__ */ e.jsx("h3", { className: "m-0 fs-13 lh-20 fw-6 cn-9 dc__truncate", children: N })
      ] }) }),
      S ? /* @__PURE__ */ e.jsxs("div", { className: "px-16 py-12 flexbox-col flex-grow-1 dc__gap-12 dc__overflow-auto", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8", children: [
          L && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx("div", { className: "flexbox releases__commit-info-card", children: C.map((F, M) => /* @__PURE__ */ e.jsx(
              qh,
              {
                shortHash: F.shortHash,
                message: F.message,
                handleOpenArtifactInfoModal: P
              },
              M
            )) }),
            /* @__PURE__ */ e.jsxs("div", { className: "flex column dc__gap-6", children: [
              /* @__PURE__ */ e.jsx("div", { className: "h-20 dc__border-dashed--n3-right" }),
              /* @__PURE__ */ e.jsx(jt, { className: "icon-dim-16 dc__no-shrink scn-6" }),
              /* @__PURE__ */ e.jsx("div", { className: "h-20 dc__border-dashed--n3-right" })
            ] })
          ] }),
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12", children: [
            /* @__PURE__ */ e.jsx(
              Yh,
              {
                ...x,
                handleOpenDeploymentSourceModal: k,
                handleOpenArtifactInfoModal: P
              }
            ),
            /* @__PURE__ */ e.jsx(re, { content: "Change image", className: "default-tt", arrow: !1, placement: "right", children: /* @__PURE__ */ e.jsx(
              "button",
              {
                className: "flex h-100 px-8 br-8 bg__primary dc__tab-focus dc__info-card dc__hover-border-b5 dc__no-shrink",
                type: "button",
                "aria-label": "open-deployment-source-modal",
                onClick: k,
                children: /* @__PURE__ */ e.jsx(Ys, { className: "icon-dim-20 dc__no-shrink" })
              }
            ) })
          ] })
        ] }),
        /* @__PURE__ */ e.jsx(
          Za,
          {
            text: y || vh,
            title: "Instructions",
            updateDescription: w
          }
        )
      ] }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(
          J,
          {
            title: `Select an image for ${s}`,
            subTitle: "Select an image to be included in this release",
            isButtonAvailable: !0,
            renderButton: R,
            classname: "flex-grow-1",
            noImage: !0
          }
        ),
        o && /* @__PURE__ */ e.jsx(
          sf,
          {
            handleClose: I,
            selectedAppName: s,
            handleSuccess: t
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(
      ef,
      {
        unmappedEnvironments: n.unmappedEnvironments,
        tenantInstallationDetailsMap: n.tenantInstallationDetailsMap,
        releaseChannelToTenantInstallationMap: n.releaseChannelToTenantInstallationMap,
        tenantInstallationsNotSubscribedToReleaseChannel: n.tenantInstallationsNotSubscribedToReleaseChannel
      }
    ),
    a && /* @__PURE__ */ e.jsx(
      Ar,
      {
        ...a,
        handleClose: B,
        renderCIListHeader: yl,
        fetchOnlyArtifactInfo: !0
      }
    )
  ] });
}, nf = () => {
  const { id: s, name: t, trackId: n, refetchReleaseDetail: a } = de(), { appName: l } = Te(), [o, r, i, c] = K(
    () => Promise.all([Wn(s, G.release), So(s)]),
    [s]
  ), { replace: d } = fe(), { params: m, path: p } = gs(), [u, _] = T(!1), [h, f] = T(!1), g = r?.[0] ?? {}, b = r?.[1] ?? [];
  ee(() => {
    r && g?.releaseOrdering?.length && !l && d(
      W(p, {
        ...m,
        appName: g.releaseOrdering[0].applications?.[0]?.name
      })
    );
  }, [r, l]);
  const j = () => {
    _(!0);
  }, E = () => {
    _(!1);
  }, v = () => {
    f(!1);
  }, { releaseOrdering: x, applicationCount: N } = g ?? {
    releaseOrdering: [],
    applicationCount: 0
  }, y = () => {
    if (g.isDepsPresentOnParent) {
      j();
      return;
    }
    f(!0);
  }, C = async () => {
    await a(), c();
  }, S = () => /* @__PURE__ */ e.jsxs("button", { className: "cta flex dc__gap-8", type: "button", onClick: y, children: [
    /* @__PURE__ */ e.jsx(Je, { className: "icon-dim-16 dc__no-shrink" }),
    /* @__PURE__ */ e.jsx("span", { children: "Add Application" })
  ] }), I = () => !N || !x.length ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      J,
      {
        title: "Add Applications to this release",
        subTitle: "Applications are missing from your release! Add them now to kickstart your deployment.",
        isButtonAvailable: !0,
        renderButton: S,
        image: Ed,
        classname: "w-100"
      }
    ),
    h && /* @__PURE__ */ e.jsx(Vh, { handleClose: v })
  ] }) : /* @__PURE__ */ e.jsxs("div", { className: "flexbox flex-grow-1", children: [
    /* @__PURE__ */ e.jsx(
      Lh,
      {
        appName: l,
        applicationCount: N,
        releaseOrdering: x,
        handleShowManageReleaseModal: j,
        reload: c,
        changesForReview: b
      }
    ),
    /* @__PURE__ */ e.jsx(
      tf,
      {
        appName: l,
        refetchReleaseOrdering: c,
        releaseOrderingResponse: g
      },
      l
    )
  ] });
  return /* @__PURE__ */ e.jsx(
    Ee,
    {
      isLoading: o,
      customLoader: /* @__PURE__ */ e.jsx("div", { className: "flex flex-grow-1", children: /* @__PURE__ */ e.jsx(ra, {}) }),
      error: i,
      errorScreenManagerProps: {
        code: i?.code,
        reload: c,
        redirectURL: D.RELEASES
      },
      children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox bg__primary flex-grow-1 h-100 dc__overflow-hidden", children: [
        I(),
        u && /* @__PURE__ */ e.jsx(
          Qr,
          {
            handleCloseManageReleaseModal: E,
            handleSuccess: C,
            parentResourceKind: G.release,
            resourceName: t,
            resourceId: s,
            trackId: n
          }
        ),
        /* @__PURE__ */ e.jsx(Re, { path: D.RELEASE_DETAIL_REQUIREMENTS_DEPLOYMENT_SOURCE, exact: !0, children: /* @__PURE__ */ e.jsx(
          Wh,
          {
            releaseOrdering: x,
            handleSuccess: C
          }
        ) })
      ] })
    }
  );
}, af = () => {
  const s = Te(), { releaseTrack: t, releaseVersion: n } = s, [a, l] = T(!0), [o, r, i, c] = K(
    () => No({ releaseTrack: t, releaseVersion: n }),
    [t, n],
    !0,
    {
      resetOnChange: !1
    }
  ), d = q(
    () => ({
      ...r,
      refetchReleaseDetail: c
    }),
    [r]
  ), m = () => {
    switch (r?.status) {
      case H.READY_FOR_RELEASE:
      case ue.PARTIALLY_RELEASED:
      case ue.COMPLETELY_RELEASED:
        return `${W(D.RELEASE_DETAIL_ROLLOUT_RELEASE, {
          ...s
        })}?${Lt}=${Fo(r.status)}`;
      default:
        return W(D.RELEASE_DETAIL_REQUIREMENTS, {
          ...s
        });
    }
  };
  return /* @__PURE__ */ e.jsx(
    Ee,
    {
      isLoading: o && !r,
      customLoader: /* @__PURE__ */ e.jsx("div", { className: "flex h-100 w-100", children: /* @__PURE__ */ e.jsx(ra, {}) }),
      error: i,
      errorScreenManagerProps: {
        code: i?.code,
        reload: c,
        redirectURL: D.RELEASES
      },
      children: /* @__PURE__ */ e.jsx(ru, { value: d, children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col h-100 dc__overflow-hidden", children: [
        /* @__PURE__ */ e.jsx(oh, {}),
        /* @__PURE__ */ e.jsxs(Bs, { children: [
          /* @__PURE__ */ e.jsx(Re, { path: D.RELEASE_DETAIL_OVERVIEW, component: wh }),
          /* @__PURE__ */ e.jsx(Re, { path: D.RELEASE_DETAIL_REQUIREMENTS, component: nf }),
          /* @__PURE__ */ e.jsx(Re, { path: D.RELEASE_DETAIL_ROLLOUT_RELEASE, component: K_ }),
          /* @__PURE__ */ e.jsx(
            Re,
            {
              path: D.RELEASE_DETAIL_HISTORY,
              render: ({ match: p }) => /* @__PURE__ */ e.jsx(
                Lu,
                {
                  showCurrentReleaseDeployments: a,
                  setShowCurrentReleaseDeployments: l
                },
                `release-history-${p.params.appId}-${p.params.envId}`
              )
            }
          ),
          /* @__PURE__ */ e.jsx(Re, { path: D.RELEASE_DETAIL_CONFIGURATIONS, children: /* @__PURE__ */ e.jsx(cu, {}) }),
          /* @__PURE__ */ e.jsx(gn, { to: m() })
        ] })
      ] }) })
    }
  );
}, lf = (s) => s ? s.map((t) => {
  const n = t?.overview?.releaseChannelId, a = t?.name ?? "", l = (t?.mappingConfig ?? []).map(
    (o) => ks({
      ...o,
      releaseChannelId: n,
      releaseChannelName: a
    })
  );
  return {
    channelId: n,
    description: t?.overview?.description ?? "",
    name: a,
    subscribedInstallations: l,
    subscribedInstallationsCount: l.length,
    isDefault: t?.overview.isDefault ?? !1
  };
}) : [], Ea = async ({
  lite: s = !0
} = {}) => {
  try {
    const t = ge({
      baseUrl: $.RESOURCE_LIST,
      kind: G.releaseChannel,
      version: ne.alpha1,
      queryParams: {
        lite: s
      }
    }), { result: n } = await xe(t);
    return lf(n?.data);
  } catch (t) {
    throw U(t), t;
  }
}, rf = (s) => {
  const t = ge({
    baseUrl: $.RESOURCE,
    kind: G.releaseChannel,
    version: ne.alpha1,
    queryParams: {
      identifier: s
    }
  });
  return Ht(t);
}, of = ({
  name: s,
  channelId: t,
  isDefault: n,
  description: a
}) => {
  const l = ge({
    baseUrl: $.RESOURCE,
    kind: G.releaseChannel,
    version: ne.alpha1
  }), o = {
    identifier: t,
    query: [
      {
        op: he.replace,
        path: "name",
        value: s
      },
      {
        op: he.replace,
        path: "description",
        value: a
      },
      {
        op: he.replace,
        path: "isDefault",
        value: n
      }
    ]
  };
  return Ls(l, o);
}, cf = ({
  name: s,
  channelId: t,
  isDefault: n,
  description: a
}) => {
  const l = ge({
    baseUrl: $.RESOURCE,
    kind: G.releaseChannel,
    version: ne.alpha1
  });
  return Ue(l, {
    name: s,
    overview: {
      isDefault: n,
      description: a,
      releaseChannelId: t
    }
  });
};
var Kn = /* @__PURE__ */ ((s) => (s.tenantInstallation = "tenantInstallation", s))(Kn || {});
const df = Array.from(Array(3).keys()).map((s) => ({
  tenantConfig: qt(s),
  lastTriggeredRelease: {
    version: `${s}.${s}.${s}`,
    name: `release-${s}`,
    deployStatus: A.PROGRESSING,
    triggerTime: ""
  },
  apps: Array.from(Array(5).keys()).map((t) => ({
    appId: t,
    envId: t,
    appName: `app-${t}`,
    envName: `env-${t}`,
    lastTriggeredRelease: {
      version: `${s}.${s}.${s}`,
      name: `release-${s}`,
      deployStatus: A.PROGRESSING,
      triggerTime: ""
    },
    pipelineId: t,
    cdWorkflowRunnerId: t
  }))
}));
var Ze = /* @__PURE__ */ ((s) => (s.application = "application", s.lastTriggeredRelease = "lastTriggeredRelease", s.deploymentStatus = "deploymentStatus", s.triggerTime = "triggerTime", s))(Ze || {});
const Qo = ({
  appliedReleaseChannelIds: s,
  handleApplyFilter: t,
  releaseChannelList: n,
  isReleaseChannelLoading: a
}) => {
  const l = [
    { ...at },
    ...(n ?? []).map(({ name: r, channelId: i }) => ({
      label: r,
      value: i
    }))
  ], o = l.filter(
    (r) => s.includes(r.value)
  );
  return /* @__PURE__ */ e.jsx(
    sl,
    {
      inputId: "release-channel-filter",
      placeholder: "Release Channel",
      appliedFilterOptions: o,
      handleApplyFilter: t,
      isDisabled: a,
      isLoading: a,
      options: l
    }
  );
}, Xo = (s) => du[s] ?? null, pf = ({
  isLoading: s,
  handleSearchEnter: t,
  searchKey: n,
  versionOptions: a,
  appliedVersions: l,
  appliedReleaseChannelIds: o,
  filterConfig: { clearFilters: r, updateSearchParams: i },
  refetchTrackSummaryAndChannelList: c,
  releaseChannelList: d,
  isReleaseChannelLoading: m,
  getFormattedFilterValue: p
}) => {
  const u = (f) => {
    i({
      version: f.map((g) => g.value)
    });
  }, _ = (f) => {
    i({
      releaseChannelId: f.map((g) => g.value)
    });
  }, h = (f) => {
    i(f);
  };
  return /* @__PURE__ */ e.jsxs("div", { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space dc__gap-8 px-16 pt-16 pb-6", children: [
      /* @__PURE__ */ e.jsx(
        qs,
        {
          inputProps: {
            placeholder: "Search tenant",
            disabled: s
          },
          handleEnter: t,
          initialSearchText: n,
          containerClassName: "w-250"
        }
      ),
      /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-8", children: [
        /* @__PURE__ */ e.jsx(re, { className: "default-tt", arrow: !1, placement: "top", content: "Refresh active releases", children: /* @__PURE__ */ e.jsx(
          "button",
          {
            className: `dc__transparent br-4 flex ${s ? "dc__disabled" : "dc__hover-n50 dc__tab-focus"}`,
            type: "button",
            "aria-label": "Refresh active releases & release channels",
            onClick: c,
            disabled: s,
            children: s ? /* @__PURE__ */ e.jsx(vs, { size: 16 }) : /* @__PURE__ */ e.jsx(md, { className: "dc__no-shrink scn-6 icon-dim-16" })
          }
        ) }),
        /* @__PURE__ */ e.jsx(
          Qo,
          {
            appliedReleaseChannelIds: o,
            handleApplyFilter: _,
            releaseChannelList: d,
            isReleaseChannelLoading: m
          }
        ),
        /* @__PURE__ */ e.jsx(
          sl,
          {
            inputId: "release-version-filter",
            placeholder: "Release version",
            appliedFilterOptions: l.map((f) => ({
              label: f,
              value: f
            })),
            handleApplyFilter: u,
            isDisabled: s,
            isLoading: s,
            options: a,
            shouldMenuAlignRight: !0
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(
      sa,
      {
        clearFilters: r,
        filterConfig: {
          version: l,
          releaseChannelId: o
        },
        onRemoveFilter: h,
        getFormattedLabel: Xo,
        getFormattedValue: p,
        className: "px-16"
      }
    )
  ] });
}, Zo = ({ version: s, className: t }) => {
  const { name: n } = it(), a = W(D.RELEASE_DETAIL_OVERVIEW, {
    releaseTrack: n,
    releaseVersion: s
  });
  return s ? /* @__PURE__ */ e.jsxs(
    ke,
    {
      to: a,
      target: "_blank",
      className: `flex dc__gap-6 dc__transparent px-6 br-4 ${t} dc__no-decor cursor dc__w-fit-content`,
      children: [
        /* @__PURE__ */ e.jsx(zs, { className: "icon-dim-14 dc__no-shrink" }),
        /* @__PURE__ */ e.jsx("span", { className: "dc__truncate cn-7 fs-14 fw-4 lh-20 mono", children: s })
      ]
    }
  ) : /* @__PURE__ */ e.jsx("span", { children: "-" });
}, mf = ({
  appName: s,
  appId: t,
  envId: n,
  envName: a,
  pipelineId: l,
  cdWorkflowRunnerId: o,
  lastTriggeredRelease: r
}) => {
  const { name: i } = it(), c = Go(r.deployStatus, {
    appId: t,
    envId: n,
    pipelineId: l,
    releaseTrack: i,
    releaseVersion: r.version,
    triggerId: o
  }), d = (p) => /* @__PURE__ */ e.jsx(ke, { to: c, target: "_blank", className: "anchor dc__w-fit-content dc__truncate", children: p }), m = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__align-items-center p-6", children: [
      /* @__PURE__ */ e.jsx("div", { className: "w-8 h-8 dc__border-radius-50-per bw-1 en-0" }),
      /* @__PURE__ */ e.jsx("div", { className: "dc__divider bcn-6" }),
      /* @__PURE__ */ e.jsx("div", { className: "w-8 h-8 dc__border-radius-50-per bg__primary" })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
      /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-0 fs-12 fw-6 lh-20 dc__truncate", children: s }),
      /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-0 fs-12 fw-6 lh-20 dc__truncate", children: a })
    ] })
  ] });
  return /* @__PURE__ */ e.jsxs("div", { className: "display-grid dc__align-items-center dc__column-gap-16 releases__active-releases-apps-table fs-12 lh-20 cn-7 dc__border-bottom-n1 last-child__no-border px-16", children: [
    /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx($e, { condition: !!c, wrap: d, children: /* @__PURE__ */ e.jsx(re, { content: m(), arrow: !1, className: "default-tt", children: /* @__PURE__ */ e.jsx("div", { className: "dc__w-fit-content dc__truncate", children: s }) }) }) }),
    r.version ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(Zo, { version: r.version, className: "bg__primary" }) }),
      /* @__PURE__ */ e.jsx("div", { className: "dc__truncate", children: /* @__PURE__ */ e.jsx(Wo, { status: r.deployStatus }) }),
      /* @__PURE__ */ e.jsx(
        re,
        {
          content: r.triggerTime,
          arrow: !1,
          className: "default-tt",
          placement: "top",
          children: /* @__PURE__ */ e.jsx("div", { className: "dc__truncate", children: Qa(r.triggerTime, !0) })
        }
      )
    ] }) : /* @__PURE__ */ e.jsx("div", { children: "No release triggered" })
  ] });
}, uf = ({ apps: s }) => {
  const { sortBy: t, sortOrder: n, handleSorting: a } = ds({
    initialSortKey: Ze.triggerTime
  }), l = q(() => {
    if (s?.length)
      switch (t) {
        case Ze.application:
          return s.sort((d, m) => te(d.appName, m.appName, n));
        case Ze.lastTriggeredRelease:
          return s.sort(
            (d, m) => te(
              d.lastTriggeredRelease.version,
              m.lastTriggeredRelease.version,
              n
            )
          );
        case Ze.deploymentStatus:
          return s.sort(
            (d, m) => te(
              d.lastTriggeredRelease.deployStatus,
              m.lastTriggeredRelease.deployStatus,
              n
            )
          );
        case Ze.triggerTime:
        default:
          return s.sort(
            (d, m) => Ka(
              d.lastTriggeredRelease.triggerTime,
              m.lastTriggeredRelease.triggerTime,
              n
            )
          );
      }
    return [];
  }, [s, t, n]), o = () => {
    a(Ze.application);
  }, r = () => {
    a(Ze.lastTriggeredRelease);
  }, i = () => {
    a(Ze.deploymentStatus);
  }, c = () => {
    a(Ze.triggerTime);
  };
  return /* @__PURE__ */ e.jsxs("div", { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "releases__active-releases-apps-table dc__column-gap-16 display-grid dc__align-items-center fs-12 lh-20 fw-6 cn-7 dc__uppercase dc__border-bottom-n1 px-16", children: [
      /* @__PURE__ */ e.jsx(
        Z,
        {
          isSorted: t === Ze.application,
          disabled: !1,
          sortOrder: n,
          title: "Application",
          triggerSorting: o
        }
      ),
      /* @__PURE__ */ e.jsx(
        Z,
        {
          isSorted: t === Ze.lastTriggeredRelease,
          disabled: !1,
          sortOrder: n,
          title: "Last triggered Release",
          triggerSorting: r
        }
      ),
      /* @__PURE__ */ e.jsx(
        Z,
        {
          isSorted: t === Ze.deploymentStatus,
          disabled: !1,
          sortOrder: n,
          title: "Deployment Status",
          triggerSorting: i
        }
      ),
      /* @__PURE__ */ e.jsx(
        Z,
        {
          isSorted: t === Ze.triggerTime,
          disabled: !1,
          sortOrder: n,
          title: "Trigger Time",
          triggerSorting: c
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "bg__secondary", children: l.map((d) => /* @__PURE__ */ fs(mf, { ...d, key: `${d.appId}-${d.envId}` })) })
  ] });
}, _f = (s) => /* @__PURE__ */ e.jsx(re, { className: "default-tt", arrow: !1, content: "No applications available", children: s }), hf = ({
  lastTriggeredRelease: s,
  apps: t
}) => {
  const [n, a] = T(!1), { name: l } = it(), o = t.length === 0, r = () => {
    a((i) => !i);
  };
  return /* @__PURE__ */ e.jsxs("div", { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "px-12 py-10 flexbox dc__align-items-center dc__gap-20 fs-12 fw-4 lh-20 cn-7", children: [
      /* @__PURE__ */ e.jsx("div", { className: "flex dc__gap-8 dc__content-space", children: t.length === 0 || !s.version ? /* @__PURE__ */ e.jsxs("span", { children: [
        "No release triggered from ‘",
        l,
        "’"
      ] }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(Zo, { version: s.version, className: "bcn-1" }),
        /* @__PURE__ */ e.jsx(Wo, { status: s.deployStatus, showTippy: !0 })
      ] }) }),
      /* @__PURE__ */ e.jsx($e, { condition: o, wrap: _f, children: /* @__PURE__ */ e.jsxs(
        "button",
        {
          type: "button",
          className: `flex dc__content-end flex-grow-1 dc__transparent p-0 dc__gap-4 dc__hover-n50 br-4 cursor dc__no-shrink ${o ? "dc__disabled" : ""}`,
          onClick: r,
          disabled: o,
          children: [
            !o && /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-12 lh-20 fw-4 dc__truncate", children: n ? "Hide apps" : "View apps" }),
            /* @__PURE__ */ e.jsx(
              Gr,
              {
                className: `icon-dim-16 icon-color-n6 dc__no-shrink dc__transition--transform ${n ? "dc__flip-180" : ""}`
              }
            )
          ]
        }
      ) })
    ] }),
    !o && n && /* @__PURE__ */ e.jsx(uf, { apps: t })
  ] });
}, ff = ({
  isSummaryLoading: s,
  filterConfig: { sortBy: t, sortOrder: n, handleSorting: a, clearFilters: l },
  filteredTrackSummaryList: o
}) => {
  const r = () => {
    a(Kn.tenantInstallation);
  };
  return !s && !o.length ? /* @__PURE__ */ e.jsx(yt, { handleClearFilters: l, classname: "mh-440 flex-grow-1" }) : /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "display-grid releases__active-releases-table releases__active-releases-table--header dc__align-items-center fs-12 lh-20 fw-6 cn-7 dc__uppercase dc__border-bottom-n1 bg__primary", children: [
      /* @__PURE__ */ e.jsx("div", { className: "px-16 py-8", children: /* @__PURE__ */ e.jsx(
        Z,
        {
          isSorted: t === Kn.tenantInstallation,
          disabled: s,
          sortOrder: n,
          title: "Tenant (Installation)",
          triggerSorting: r
        }
      ) }),
      /* @__PURE__ */ e.jsx("div", { className: "px-12 py-8", children: "Last Triggered Release" })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: s ? df.map((i) => /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: "display-grid releases__active-releases-table fs-13 lh-20 cn-9 dc__border-bottom-n1 show-shimmer-loading",
        children: [
          /* @__PURE__ */ e.jsx("div", { className: "px-16 py-10 dc__border-right--n1", children: /* @__PURE__ */ e.jsx("div", { className: "child-shimmer-loading h-16 w-100" }) }),
          /* @__PURE__ */ e.jsx("div", { className: "px-12 py-10", children: /* @__PURE__ */ e.jsx("div", { className: "child-shimmer-loading h-16 w-100" }) })
        ]
      },
      i.tenantConfig.identifier
    )) : o.map(({ tenantConfig: i, lastTriggeredRelease: c, apps: d }) => /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: "display-grid releases__active-releases-table fs-13 lh-20 cn-9 dc__border-bottom-n1",
        children: [
          /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center px-16 py-10 dc__border-right--n1", children: /* @__PURE__ */ e.jsx(ga, { tenantConfig: i, children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8 dc__w-fit-content dc__align-self-start", children: [
            /* @__PURE__ */ e.jsx(
              is,
              {
                imageProps: {
                  src: i.image,
                  height: 20,
                  width: 20
                }
              }
            ),
            /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: i.displayText })
          ] }) }) }),
          /* @__PURE__ */ e.jsx(hf, { lastTriggeredRelease: c, apps: d })
        ]
      },
      i.identifier
    )) })
  ] });
}, gf = (s) => ({
  version: s.getAll("version").map((t) => t.trim()).filter((t) => !!t),
  releaseChannelId: s.getAll(Jt.releaseChannelId).map((t) => t.trim()).filter((t) => !!t)
}), xf = (s, {
  searchKey: t,
  version: n,
  sortOrder: a,
  releaseChannelId: l
}) => {
  if (s?.length) {
    const o = t.trim().toLowerCase();
    let r = structuredClone(s);
    if (o && (r = r.filter(
      (i) => i.tenantConfig.displayText.toLowerCase().includes(o)
    )), n.length) {
      const i = n.reduce((c, d) => (c[d] = !0, c), {});
      r = r.map(({ apps: c, ...d }) => ({
        ...d,
        apps: c.filter((m) => i[m.lastTriggeredRelease.version])
      })).filter((c) => c.apps.length);
    }
    if (l.length) {
      const i = l.reduce(
        (c, d) => (c[d] = !0, c),
        {}
      );
      r = r.filter((c) => {
        const { releaseChannelId: d } = c.tenantConfig.installationConfig;
        return d ? i[d] : i[at.value];
      });
    }
    return {
      filteredTrackSummaryList: r.sort(
        (i, c) => te(i.tenantConfig.displayText, c.tenantConfig.displayText, a)
      ),
      versionOptions: [
        ...new Set(
          s.flatMap((i) => i.apps).map(({ lastTriggeredRelease: i }) => i.version).filter((i) => !!i)
        )
      ].map((i) => ({
        label: i,
        value: i
      }))
    };
  }
  return { filteredTrackSummaryList: [], versionOptions: [] };
}, bf = () => {
  const { name: s } = it(), {
    searchKey: t,
    handleSearch: n,
    sortBy: a,
    sortOrder: l,
    handleSorting: o,
    clearFilters: r,
    version: i,
    releaseChannelId: c,
    updateSearchParams: d
  } = Xn({
    initialSortKey: Kn.tenantInstallation,
    parseSearchParams: gf
  }), [m, p, u, _] = K(
    () => _m(s)
  ), [h, f, , g] = K(
    () => Ea(),
    []
  ), b = m && (!p || u), j = !b && u, { filteredTrackSummaryList: E, versionOptions: v } = q(
    () => xf(p, {
      searchKey: t,
      sortOrder: l,
      version: i,
      releaseChannelId: c
    }),
    [p, t, l, i.toString(), c.toString()]
  ), x = q(
    () => Tl(f),
    [f]
  ), N = (S) => {
    n(S);
  }, y = () => {
    _(), g();
  }, C = (S, I) => S === Jt.releaseChannelId ? x[I] : null;
  return /* @__PURE__ */ e.jsx(
    "div",
    {
      className: `flexbox-col dc__overflow-auto bg__primary br-4 dc__info-card dc__info-card--no-hover dc__info-card--no-box-shadow ${j ? "p-16" : ""}`,
      children: /* @__PURE__ */ e.jsx(
        Ee,
        {
          isLoading: !1,
          error: j,
          errorScreenManagerProps: {
            code: u?.code,
            reload: _
          },
          children: b || p?.length ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx(
              pf,
              {
                isLoading: m,
                handleSearchEnter: N,
                searchKey: t,
                appliedVersions: i,
                versionOptions: v,
                filterConfig: {
                  clearFilters: r,
                  updateSearchParams: d
                },
                refetchTrackSummaryAndChannelList: y,
                appliedReleaseChannelIds: c,
                getFormattedFilterValue: C,
                releaseChannelList: f,
                isReleaseChannelLoading: h
              }
            ),
            /* @__PURE__ */ e.jsx(
              ff,
              {
                isSummaryLoading: b,
                filterConfig: {
                  sortBy: a,
                  sortOrder: l,
                  handleSorting: o,
                  clearFilters: r
                },
                filteredTrackSummaryList: E
              }
            )
          ] }) : /* @__PURE__ */ e.jsx(
            J,
            {
              title: `No releases are active in ‘${s}’`,
              subTitle: "Release version deployed and active on tenants will be available here",
              image: dn,
              classname: "flex-grow-1 mh-500"
            }
          )
        }
      )
    }
  );
}, Ef = () => {
  const { name: s } = it(), { breadcrumbs: t } = ta({
    alias: {
      ..._a(),
      releases: {
        component: /* @__PURE__ */ e.jsx(Et, { heading: "Release Hub" }),
        linked: !0
      },
      track: {
        component: null
      },
      detail: {
        component: null
      },
      ":trackName": {
        component: /* @__PURE__ */ e.jsx(Et, { heading: s, isActive: !0 })
      }
    }
  }), n = () => /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center", children: /* @__PURE__ */ e.jsx(Xa, { breadcrumbs: t }) });
  return /* @__PURE__ */ e.jsx(na, { isBreadcrumbs: !0, breadCrumbs: n, docPath: aa.SOFTWARE_DISTRIBUTION_HUB });
}, Nf = () => {
  const { id: s, name: t, description: n, createdBy: a, createdOn: l, refetchTrackDetail: o } = it(), r = async (i) => {
    const c = {
      id: s,
      description: i
    };
    try {
      await mm(c), ae.showToast({
        variant: le.success,
        description: "Successfully saved"
      }), await o();
    } catch (d) {
      throw U(d), d;
    }
  };
  return /* @__PURE__ */ e.jsxs("aside", { className: "flexbox-col dc__gap-16", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
      /* @__PURE__ */ e.jsx(Mr, { className: "icon-dim-48 br-4 p-4" }),
      /* @__PURE__ */ e.jsx("h3", { className: "fs-16 fw-7 lh-24 cn-9 dc__word-break font-merriweather m-0", children: t }),
      /* @__PURE__ */ e.jsx(
        el,
        {
          emptyState: "Write a short description for this release track",
          placeholder: "Write a short description for this release track",
          initialText: n,
          updateContent: r,
          validations: {
            maxLength: {
              value: qn,
              message: `Max ${qn} characters allowed`
            }
          }
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "dc__border-top-n1" }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
      /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-4 lh-20 cn-7 mb-4", children: "Added on" }),
        /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-6 lh-20 cn-9 dc__truncate", children: l })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-4 lh-20 cn-7 mb-4", children: "Added by" }),
        /* @__PURE__ */ e.jsxs("div", { className: "fs-13 fw-6 lh-20 cn-9 dc__word-break flexbox flex-align-center dc__gap-8", children: [
          /* @__PURE__ */ e.jsx(
            "div",
            {
              className: "icon-dim-20 mw-20 flexbox flex-justify-center flex-align-center dc__border-radius-50-per dc__uppercase cn-0 fw-4",
              style: { backgroundColor: la(a) },
              children: a[0]
            }
          ),
          a
        ] })
      ] })
    ] })
  ] });
}, jf = () => {
  const { replace: s } = fe(), t = Te(), { trackName: n } = t, { queryParams: a } = jr(), l = a.get(zn), o = l === et.manageApplication, [r, i, c, d] = K(
    () => dm(n),
    [n],
    !0,
    {
      resetOnChange: !1
    }
  ), m = q(
    () => ({
      ...i,
      refetchTrackDetail: d
    }),
    [i]
  ), p = (_) => {
    const h = new URLSearchParams(a);
    h.set(zn, _), s({ search: h.toString() });
  };
  ee(() => {
    (!l || !Object.values(et).some((_) => _ === l)) && p(et.activeReleases);
  }, [a]);
  const u = (_) => {
    const h = _.value;
    p(h);
  };
  return /* @__PURE__ */ e.jsx(
    Ee,
    {
      isLoading: r && !i,
      customLoader: (
        // We don't want to show loading in case of atomic update. Example: description change
        /* @__PURE__ */ e.jsx("div", { className: "flex h-100 w-100", children: /* @__PURE__ */ e.jsx(ra, {}) })
      ),
      errorScreenManagerProps: {
        code: c?.code,
        redirectURL: D.RELEASES,
        reload: d
      },
      error: c,
      children: /* @__PURE__ */ e.jsx(Np, { value: m, children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col h-100 dc__overflow-hidden", children: [
        /* @__PURE__ */ e.jsx(Ef, {}),
        /* @__PURE__ */ e.jsxs("div", { className: "pl-20 pr-20 pt-20 pb-20 software-hub__overview display-grid dc__gap-32 dc__content-center flex-grow-1 dc__overflow-auto", children: [
          /* @__PURE__ */ e.jsx(Nf, {}),
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 flex-grow-1 dc__overflow-auto", children: [
            /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
              ea,
              {
                segments: [
                  {
                    label: "Active Releases",
                    value: et.activeReleases
                  },
                  {
                    label: "Manage Applications",
                    value: et.manageApplication
                  }
                ],
                value: l,
                onChange: u,
                name: "track-detail-tabs"
              }
            ) }),
            o ? /* @__PURE__ */ e.jsx(fm, {}) : /* @__PURE__ */ e.jsx(bf, {})
          ] })
        ] })
      ] }) })
    }
  );
}, vf = () => /* @__PURE__ */ e.jsxs("div", { className: "fs-13 fw-4 lh-20 cn-9", children: [
  /* @__PURE__ */ e.jsx("div", { children: "The Software Release Management provides a unified platform to efficiently package, version, and deliver software products to customers’ environments." }),
  /* @__PURE__ */ e.jsxs("div", { className: "mt-20", children: [
    /* @__PURE__ */ e.jsxs("div", { children: [
      /* @__PURE__ */ e.jsx("span", { className: "fw-6", children: "1. Release Hub: " }),
      /* @__PURE__ */ e.jsx("span", { children: "Create, collaborate and deploy your software's versions across multiple tenant installations." })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { children: [
      /* @__PURE__ */ e.jsx("span", { className: "fw-6", children: "2. Tenants: " }),
      /* @__PURE__ */ e.jsx("span", { children: "Tenants represent the organizations you deliver software to." })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { children: [
      /* @__PURE__ */ e.jsx("span", { className: "fw-6", children: "3. Tenant Installations: " }),
      /* @__PURE__ */ e.jsx("span", { children: "Each tenant can have multiple installations. An installation represents deployment of your software across the tenant's environments." })
    ] })
  ] })
] }), ei = () => {
  const { breadcrumbs: s } = ta({
    alias: {
      ..._a(),
      releases: {
        component: /* @__PURE__ */ e.jsx(Et, { heading: "Release Hub", isActive: !0 }),
        linked: !1
      },
      tenants: {
        component: /* @__PURE__ */ e.jsx(Et, { heading: "Tenants", isActive: !0 }),
        linked: !1
      }
    }
  }), t = () => /* @__PURE__ */ e.jsx(
    cc,
    {
      breadCrumbs: s,
      SVGImage: qc,
      docLink: "SOFTWARE_DISTRIBUTION_HUB",
      title: "Software Release Management",
      renderDescriptionContent: vf
    }
  );
  return /* @__PURE__ */ e.jsx(
    na,
    {
      additionalHeaderInfo: t,
      docPath: aa.SOFTWARE_DISTRIBUTION_HUB
    }
  );
}, dr = 2, Jn = {
  TRACK_NAME_STATE_KEY: "track",
  INITIAL_CLONE_SOURCE_STATE_KEY: "selectedReleaseSource"
}, Cf = Array.from(
  Array(dr).keys()
).map((s) => ({
  id: s,
  name: "",
  description: "",
  createdBy: "",
  createdOn: "",
  releases: Array.from(Array(dr - s).keys()).map((t) => ({
    id: t,
    name: "",
    status: H.DRAFT,
    isLocked: !1,
    description: "",
    note: Fp,
    track: "",
    trackId: s,
    version: "",
    createdBy: "",
    createdOn: "",
    tags: [],
    firstReleasedOn: "",
    areAllImagesSelected: !1,
    areDepPresent: !1,
    installationsMappedToRelease: {
      areAllInstallationsTargeted: !0
    }
  }))
}));
var Ll = /* @__PURE__ */ ((s) => (s.track = "track", s))(Ll || {});
const yf = ({
  handleClose: s,
  handleSuccess: t
}) => {
  const { id: n } = Te(), a = n !== gl, [l, o, r, i] = K(() => Vm(n), [n], a), [c, d] = T(wt), [m, p] = T(wt), [u, _] = T(!1);
  ee(() => {
    o && (d({ value: o.name, error: "" }), p({ value: o.description, error: "" }));
  }, [o]);
  const h = (v) => {
    const { isValid: x, message: N } = mn(v);
    return x || d((y) => ({ ...y, error: N })), x;
  }, f = (v) => {
    const { isValid: x, message: N } = oa(v);
    return x || p((y) => ({ ...y, error: N })), x;
  }, g = (v) => {
    const { value: x } = v.target;
    d({ value: x, error: "" }), h(x);
  }, b = (v) => {
    const { value: x } = v.target;
    p({ value: x, error: "" }), f(x);
  }, j = async (v) => {
    if (v.preventDefault(), !h(c.value) || !f(m.value)) {
      ae.showToast({
        variant: le.error,
        description: ot
      });
      return;
    }
    _(!0);
    const { value: x } = c, N = {
      id: a ? +n : 0,
      name: x,
      description: m.value
    };
    try {
      await qm(N, a), ae.showToast({
        variant: le.success,
        description: `Release track ${a ? "updated" : "created"} successfully`
      }), _(!1), t && t(), s(x);
    } catch (y) {
      U(y), _(!1);
    }
  }, E = () => {
    s();
  };
  return /* @__PURE__ */ e.jsx(Nn, { className: "visible-modal__body", children: /* @__PURE__ */ e.jsx("div", { className: "flexbox bg__primary w-800 h-500 dc__m-auto mt-40 dc__border-radius-8-imp dc__overflow-hidden", children: /* @__PURE__ */ e.jsxs(
    Ee,
    {
      isLoading: l,
      progressingProps: {
        size: 36
      },
      error: a && r,
      errorScreenManagerProps: {
        code: r?.code,
        reload: i,
        redirectURL: D.RELEASES
      },
      children: [
        /* @__PURE__ */ e.jsxs(
          vn,
          {
            rootClassName: "p-24",
            heading: "Release Track",
            icon: /* @__PURE__ */ e.jsx(Kd, {}),
            documentationLink: "RELEASE_TRACKS",
            children: [
              /* @__PURE__ */ e.jsx("p", { className: "m-0", children: 'A "Release Track" in Devtron is where you organise software releases, like a project or application.' }),
              /* @__PURE__ */ e.jsx("p", { children: "Each release within a Release Track is a unique version of your software." }),
              /* @__PURE__ */ e.jsx("p", { className: "m-0", children: 'Eg. You can think of Kubernetes as a release track, with "v1.28.8" as one of its releases.' })
            ]
          }
        ),
        /* @__PURE__ */ e.jsxs("form", { className: "flexbox-col flex-grow-1 h-100", onSubmit: j, noValidate: !0, children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 pt-24 pb-24 p-lr-20 dc__gap-16", children: [
            /* @__PURE__ */ e.jsx(
              Fe,
              {
                name: "release-track-name",
                value: c.value,
                label: "Release track name",
                placeholder: "Enter a name for this release track",
                onChange: g,
                required: !0,
                error: c.error,
                disabled: a || l
              }
            ),
            /* @__PURE__ */ e.jsx(
              jn,
              {
                label: "Description",
                name: "release-track-description",
                value: m.value,
                placeholder: "Write a description for this release track",
                onChange: b,
                error: m.error
              }
            )
          ] }),
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox flex-justify-end dc__gap-12 p-lr-20 pt-20 pb-20", children: [
            /* @__PURE__ */ e.jsx(
              "button",
              {
                type: "button",
                className: "flex cta secondary h-36",
                disabled: u,
                onClick: E,
                children: /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-20", children: "Cancel" })
              }
            ),
            /* @__PURE__ */ e.jsx("button", { type: "submit", className: "flex cta h-36", disabled: u || l, children: u ? /* @__PURE__ */ e.jsx(vs, {}) : /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-20", children: a ? "Save changes" : "Create release track" }) })
          ] })
        ] })
      ]
    }
  ) }) });
}, si = ({ handleClose: s, handleSuccess: t, path: n }) => /* @__PURE__ */ e.jsx(Bs, { children: /* @__PURE__ */ e.jsx(Re, { path: n, exact: !0, children: /* @__PURE__ */ e.jsx(yf, { handleClose: s, handleSuccess: t }) }) });
var Es = /* @__PURE__ */ ((s) => (s.FROM_SCRATCH = "FROM_SCRATCH", s.CLONE = "CLONE", s))(Es || {});
const Tf = (s) => s ? /^.{0,50}$/.test(s) ? {
  isValid: !0
} : {
  isValid: !1,
  message: dc.getMaxCharMessage(50)
} : {
  isValid: !0
}, Sf = (s) => ({
  track: s.getAll(Ll.track).map((t) => t.trim()).filter((t) => !!t)
}), wf = ({
  releaseTracks: s,
  searchKey: t,
  filterConfig: { track: n }
}) => {
  if (s?.length) {
    const a = t.trim().toLowerCase(), l = s.map(({ name: i }) => ({
      label: i,
      value: i
    })), o = n.reduce(
      (i, c) => (i[c] = !0, i),
      {}
    );
    let r = a ? s.map(({ releases: i, ...c }) => ({
      ...c,
      releases: i.filter(
        (d) => d.name.toLowerCase().includes(a) || d.version.toLowerCase().includes(a)
      )
    })).filter((i) => i.releases.length > 0) : structuredClone(s);
    return n.length > 0 && (r = r.filter(({ name: i }) => o[i])), {
      filteredReleaseTracks: r,
      releaseTrackOptions: l,
      selectedFilterTrackMap: o
    };
  }
  return {
    filteredReleaseTracks: [],
    releaseTrackOptions: [],
    selectedFilterTrackMap: {}
  };
}, pr = "select-release-clone-source", Xs = {
  NO_CLONE_OPTIONS: "No releases available in this release track",
  SOURCE_RELEASE_TRACK_TOOLTIP: "Releases can only be cloned from the same release track.",
  SOURCE_RELEASE_TRACK_TITLE: "Release track",
  NO_RELEASE_TRACK_FOR_SOURCE_INFO_BAR: "Select a release track first. You'll be able to clone a release from the selected track.",
  SELECT_SOURCE_CLONE_SELECT_LABEL: "Select a release to clone",
  SELECT_SOURCE_CLONE_SELECT_PLACEHOLDER: "Select release",
  CREATE_RELEASE_FROM_SCRATCH: "Create from scratch",
  CLONE_EXISTING_RELEASE: "Clone existing release"
}, Rf = (s) => {
  const {
    label: t,
    data: { status: n }
  } = s;
  return /* @__PURE__ */ e.jsx(Vr.Option, { ...s, children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__gap-8", children: [
    /* @__PURE__ */ e.jsx("h4", { className: "m-0 cn-9 fs-13 fw-4 lh-20 dc__truncate", children: t }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-4 dc__no-shrink", children: [
      /* @__PURE__ */ e.jsx(
        "span",
        {
          className: `icon-dim-14 flex dc__no-shrink dc__fill-available-space ${X_(n)}`,
          children: fa[n]
        }
      ),
      /* @__PURE__ */ e.jsx(
        "p",
        {
          className: `m-0 cn-7 fs-12 fw-4 lh-20 dc__truncate ${Z_(n)}`,
          children: Ae[n].label
        }
      )
    ] })
  ] }) });
}, kl = ({
  version: s,
  id: t,
  status: n
}) => t ? {
  label: s,
  value: String(t),
  status: n
} : null, If = ({
  releaseCreationType: s,
  selectedReleaseTrack: t,
  trackError: n,
  reloadReleaseList: a,
  releaseListError: l,
  releaseList: o,
  selectedReleaseSource: r,
  isLoading: i,
  handleChange: c,
  handleBlur: d,
  errorMessage: m
}) => {
  if (s !== Es.CLONE)
    return null;
  if (n || !t)
    return /* @__PURE__ */ e.jsx(cs, { description: Xs.NO_RELEASE_TRACK_FOR_SOURCE_INFO_BAR });
  const p = o?.map(
    (_) => kl({
      id: _.id,
      version: _.version,
      status: _.status
    })
  ) || [], u = () => l ? /* @__PURE__ */ e.jsx(As, { withBorder: !0, reload: a }) : /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-7 fs-13 fw-4 lh-20 py-6 px-8", children: Xs.NO_CLONE_OPTIONS });
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__align-start w-100", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6", children: [
      /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-13 fw-4 lh-20", children: Xs.SOURCE_RELEASE_TRACK_TITLE }),
      /* @__PURE__ */ e.jsx(
        re,
        {
          className: "default-tt w-200",
          content: Xs.SOURCE_RELEASE_TRACK_TOOLTIP,
          arrow: !1,
          children: /* @__PURE__ */ e.jsx("span", { className: "p-8 br-4 dc__border bcn-1 cn-6 fs-13 fw-4 lh-20 dc__ellipsis-right w-200 h-36 cursor-not-allowed dc__word-break-all", children: t })
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("span", { className: "flexbox-col fs-20 fw-4 lh-36 pt-24", children: "/" }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6 w-100", children: [
      /* @__PURE__ */ e.jsx(
        "label",
        {
          className: "m-0 cn-7 fs-13 fw-4 lh-20 dc__required-field",
          htmlFor: pr,
          children: Xs.SELECT_SOURCE_CLONE_SELECT_LABEL
        }
      ),
      /* @__PURE__ */ e.jsx(
        Wr,
        {
          value: r ?? null,
          options: p,
          placeholder: Xs.SELECT_SOURCE_CLONE_SELECT_PLACEHOLDER,
          onChange: c,
          onBlur: d,
          isLoading: i,
          isDisabled: i,
          styles: Up,
          components: {
            IndicatorSeparator: null,
            LoadingIndicator: Sr,
            NoOptionsMessage: u,
            Option: Rf
          },
          maxMenuHeight: 200,
          inputId: pr
        }
      ),
      m && /* @__PURE__ */ e.jsxs("span", { className: "form__error", children: [
        /* @__PURE__ */ e.jsx(da, { className: "form__icon form__icon--error dc__no-shrink" }),
        m
      ] })
    ] })
  ] });
}, Af = ({
  releaseCreationType: s,
  handleReleaseCreationTypeChange: t
}) => /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__gap-16 dc__align-items-center", children: /* @__PURE__ */ e.jsxs(
  En,
  {
    className: "radio-group-no-border releases__create-release-modal-radio-group",
    value: s,
    name: "release-creation-type",
    onChange: t,
    children: [
      /* @__PURE__ */ e.jsx(
        $s,
        {
          dataTestId: `${Es.FROM_SCRATCH}-radio-item`,
          value: Es.FROM_SCRATCH,
          children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: Xs.CREATE_RELEASE_FROM_SCRATCH })
        }
      ),
      /* @__PURE__ */ e.jsx($s, { dataTestId: `${Es.CLONE}-radio-item`, value: Es.CLONE, children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: Xs.CLONE_EXISTING_RELEASE }) })
    ]
  }
) }), mr = ({ handleClose: s, handleSuccess: t }) => {
  const n = fe(), { url: a } = gs(), l = Te(), o = fn(), r = Ye(new AbortController()), { releaseId: i } = Te(), c = !!i, d = c ? D.RELEASE_RELEASE_EDIT_TRACK_ADD_EDIT : D.RELEASE_RELEASE_CREATE_TRACK_ADD_EDIT, { TRACK_NAME_STATE_KEY: m, INITIAL_CLONE_SOURCE_STATE_KEY: p } = Jn, u = o.state?.[m], _ = o.state?.[p], [h, f] = T(wt), [g, b] = T(wt), [j, E] = T(wt), [v, x] = T(wt), [N, y] = T(
    Es.FROM_SCRATCH
  ), [C, S] = T(null), [I, w] = T(!1), [k, R, B, P] = K(
    Wm,
    [],
    !_ && !c
  ), [L, F, M, Y] = K(
    () => Vs(
      () => vo({ trackName: h.value, signal: r.current.signal }),
      r
    ),
    [h.value],
    !h.error && !!h.value && !c
  ), [O, Q, je, ps] = K(
    () => No({
      id: +i
    }),
    [i],
    c
  ), ts = (R ?? []).map((V) => ({ label: V, value: V })), X = q(() => c ? {
    label: Q?.track,
    value: Q?.track
  } : _ && u ? {
    label: u,
    value: u
  } : ts.find((V) => V.value === h.value) ?? null, [JSON.stringify(ts), h.value, Q?.track]);
  ee(() => {
    u && f({
      ...h,
      value: u,
      error: ""
    }), _ && (y(Es.CLONE), S({
      value: _,
      error: ""
    }));
  }, [o]), ee(() => {
    if (_ && h.value === u) {
      S({
        value: _,
        error: ""
      });
      return;
    }
    if (L || M) {
      S(null);
      return;
    }
    if (F?.length > 0) {
      const { id: Se, version: ms, status: Os } = F[0];
      S({
        value: kl({
          id: Se,
          version: ms,
          status: Os
        }),
        error: ""
      });
    }
  }, [L, M, JSON.stringify(F)]), ee(() => {
    !O && Q && (f({ value: Q.track, error: "" }), b({ value: Q.version, error: "" }), E({ value: Q.name, error: "" }), x({ value: Q.description, error: "" }));
  }, [O, je, Q]);
  const ce = (V) => V ? X ? !0 : (f({ ...h, error: Bp }), !1) : (f({ ...h, error: $p }), !1), we = (V) => {
    const { isValid: Se, message: ms } = mc(V);
    return Se || b((Os) => ({ ...Os, error: ms })), Se;
  }, Ge = (V) => {
    const { isValid: Se, message: ms } = Tf(V);
    return Se || E((Os) => ({ ...Os, error: ms })), Se;
  }, ye = (V) => {
    const { isValid: Se, message: ms } = oa(V);
    return Se || x((Os) => ({ ...Os, error: ms })), Se;
  }, Ds = (V) => N !== Es.CLONE || V?.value ? !0 : (S({ value: null, error: "A release source is required to clone." }), !1), Tt = (V) => {
    ae.showToast({
      variant: le.success,
      description: V
    }), V === Jl ? n.push(
      W(D.RELEASE_DETAIL, { releaseTrack: h.value, releaseVersion: g.value })
    ) : s(), t();
  }, Zt = async () => {
    try {
      const V = {
        id: 0,
        name: j.value,
        description: v.value,
        track: h.value,
        version: g.value,
        tags: [],
        cloneSourceId: N === Es.CLONE ? C?.value?.value : null
      };
      await Im(V), Tt(Jl);
    } catch (V) {
      U(V), w(!1);
    }
  }, en = async () => {
    try {
      const V = {
        id: +i,
        name: j.value,
        description: v.value
      };
      await km(V), Tt(Hp);
    } catch (V) {
      U(V), w(!1);
    }
  }, ct = async (V) => {
    if (V.preventDefault(), ![
      ce(h.value),
      we(g.value),
      ye(v.value),
      Ge(j.value),
      Ds(C?.value)
    ].every((ms) => ms)) {
      ae.showToast({
        variant: le.error,
        description: ot
      });
      return;
    }
    if (w(!0), c) {
      await en();
      return;
    }
    await Zt();
  }, dt = (V) => {
    n.replace({
      pathname: a,
      ...V ? {
        state: {
          [m]: V
        }
      } : {}
    });
  }, Ks = () => {
    P(), t();
  }, sn = (V) => {
    f({ value: V.value, error: "" });
  }, tn = (V) => {
    const { value: Se } = V.target;
    b({ value: Se, error: "" }), we(Se);
  }, nn = (V) => {
    const { value: Se } = V.target;
    E({ value: Se, error: "" }), Ge(Se);
  }, an = (V) => {
    const { value: Se } = V.target;
    x({ value: Se, error: "" }), ye(Se);
  }, se = () => {
    ce(h.value);
  }, Xe = (V) => {
    S({ value: V, error: "" });
  }, Ie = (V) => {
    y(V.target.value);
  }, Ss = () => {
    Ds(C?.value);
  }, xs = (V) => {
    V.key === "Enter" && V.preventDefault();
  }, ws = () => {
    const V = W(d, {
      ...l,
      id: gl
    });
    n.push(V);
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(rt, { position: "right", width: "1024px", onEscape: s, children: /* @__PURE__ */ e.jsxs(
      "form",
      {
        className: "flexbox-col flex-grow-1 bg__primary h-100",
        onSubmit: ct,
        onKeyDown: xs,
        noValidate: !0,
        children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__align-items-center pt-12 pb-11 pl-20 pr-20 dc__border-bottom", children: [
            /* @__PURE__ */ e.jsx("h2", { className: "fs-16 fw-6 lh-24 cn-9 m-0-imp dc__truncate", children: c ? `Edit release ${Q?.version ? `'${Q.version}'` : ""}` : "Create a new release" }),
            /* @__PURE__ */ e.jsx(
              "button",
              {
                type: "button",
                className: "dc__transparent dc__no-shrink flexbox",
                "aria-label": "close-modal",
                onClick: s,
                disabled: I,
                children: /* @__PURE__ */ e.jsx(Ts, { className: "icon-dim-20 fcn-6" })
              }
            )
          ] }),
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox flex-grow-1 dc__overflow-auto w-100", children: [
            /* @__PURE__ */ e.jsxs(
              vn,
              {
                rootClassName: "pl-24 pr-24 pt-24 pb-16 dc__no-shrink",
                heading: "Release",
                icon: /* @__PURE__ */ e.jsx(zs, {}),
                documentationLink: "RELEASES",
                children: [
                  /* @__PURE__ */ e.jsx("p", { className: "m-0", children: "Each release within a Release Track is a unique version of your software." }),
                  /* @__PURE__ */ e.jsx("p", { children: 'Eg. You can think of Android as a release track, with "v15.0" as one of its releases.' }),
                  /* @__PURE__ */ e.jsx("p", { className: "m-0", children: "Tip: You can also name a release for easier identification like “Marshmallow” or “Nougat”." })
                ]
              }
            ),
            /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__gap-16 pt-20 pb-20 pl-20 pr-20 dc__overflow-auto", children: /* @__PURE__ */ e.jsxs(
              Ee,
              {
                isLoading: O,
                progressingProps: {
                  pageLoader: !0
                },
                error: je,
                errorScreenManagerProps: {
                  code: je?.code,
                  reload: ps,
                  redirectURL: D.RELEASES
                },
                children: [
                  /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8", children: [
                    /* @__PURE__ */ e.jsx("div", { className: "w-200", children: /* @__PURE__ */ e.jsx(
                      st,
                      {
                        inputId: "release-track-select",
                        label: "Release Track",
                        options: ts,
                        isLoading: k,
                        isDisabled: k || !!_ || c,
                        onChange: sn,
                        onBlur: se,
                        menuListFooterConfig: {
                          type: "button",
                          buttonProps: {
                            variant: _e.borderLess,
                            text: "Create release track",
                            startIcon: /* @__PURE__ */ e.jsx(Me, { name: "ic-add", color: null }),
                            onClick: ws,
                            dataTestId: "create-release-track"
                          }
                        },
                        value: X,
                        size: oe.large,
                        optionListError: B,
                        reloadOptionList: P,
                        error: h.error,
                        required: !0
                      }
                    ) }),
                    /* @__PURE__ */ e.jsx("span", { className: "flexbox-col fs-20 fw-4 lh-36 pt-24", children: "/" }),
                    /* @__PURE__ */ e.jsx(
                      Fe,
                      {
                        name: "release-version",
                        label: "Release Version",
                        value: g.value,
                        placeholder: "e.g. 1.1.0",
                        onChange: tn,
                        required: !0,
                        error: g.error,
                        autoFocus: !c,
                        disabled: c,
                        helperText: /* @__PURE__ */ e.jsxs("span", { children: [
                          "Version cannot be changed later. Using",
                          /* @__PURE__ */ e.jsx(
                            "a",
                            {
                              href: pc,
                              target: "_blank",
                              rel: "noreferrer",
                              className: "cb-5 dc__no-decor cursor",
                              children: " semantic versioning "
                            }
                          ),
                          "is recommended for best practices."
                        ] })
                      }
                    )
                  ] }),
                  /* @__PURE__ */ e.jsx(
                    Fe,
                    {
                      name: "release-name",
                      label: "Release Name",
                      value: j.value,
                      placeholder: "Enter a Release Name",
                      onChange: nn,
                      error: j.error,
                      autoFocus: !!c
                    }
                  ),
                  /* @__PURE__ */ e.jsx(
                    jn,
                    {
                      label: "Description",
                      name: "release-description",
                      value: v.value,
                      placeholder: "Write a description for this release",
                      onChange: an,
                      error: v.error
                    }
                  ),
                  !c && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                    /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom" }),
                    /* @__PURE__ */ e.jsx(
                      Af,
                      {
                        releaseCreationType: N,
                        handleReleaseCreationTypeChange: Ie
                      }
                    ),
                    /* @__PURE__ */ e.jsx(
                      If,
                      {
                        releaseCreationType: N,
                        selectedReleaseTrack: X?.label,
                        trackError: h.error,
                        reloadReleaseList: Y,
                        releaseList: F,
                        releaseListError: M,
                        selectedReleaseSource: C?.value,
                        errorMessage: C?.error,
                        isLoading: L || k,
                        handleChange: Xe,
                        handleBlur: Ss
                      }
                    )
                  ] })
                ]
              }
            ) })
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "flexbox flex-justify-end pl-20 pr-20 pt-15 pb-16 dc__border-top", children: /* @__PURE__ */ e.jsx(
            "button",
            {
              type: "submit",
              className: "flex cta h-36",
              disabled: I || k || O || je || N === Es.CLONE && L && !C,
              children: I ? /* @__PURE__ */ e.jsx(vs, {}) : /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-20", children: c ? "Save changes" : "Create release" })
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      si,
      {
        path: d,
        handleClose: dt,
        handleSuccess: Ks
      }
    )
  ] });
}, Lf = ({
  deleteTrackModalConfig: s,
  setDeleteTrackModalConfig: t,
  handleSuccess: n
}) => {
  const a = s.name, l = () => {
    t(null);
  }, o = (i) => {
    i?.code === Bt.BAD_REQUEST ? ae.showToast({
      variant: le.warn,
      title: "Cannot delete release track",
      description: "Please delete releases in this track first and try again."
    }) : U(i);
  }, r = async () => {
    await Ym(s.id), n(), t(null);
  };
  return /* @__PURE__ */ e.jsx(
    Gt,
    {
      title: a,
      component: "Release Track",
      onDelete: r,
      subtitle: "Deleting a release track will delete all its release and any requirements added against them.",
      closeConfirmationModal: l,
      confirmationConfig: {
        identifier: "delete-release-track-confirmation",
        confirmationKeyword: a
      },
      successToastMessage: "Release track deleted successfully",
      onError: o
    }
  );
}, kf = ({
  id: s,
  name: t,
  track: n,
  status: a,
  version: l,
  refetchReleaseTracks: o
}) => {
  const r = fe(), [i, c] = T(!1), d = () => {
    c(!0);
  }, m = () => {
    c(!1);
  }, p = () => {
    const { TRACK_NAME_STATE_KEY: _, INITIAL_CLONE_SOURCE_STATE_KEY: h } = Jn, f = kl({
      id: s,
      version: l,
      status: a
    });
    r.push({
      pathname: D.RELEASE_CREATE,
      state: {
        [_]: n,
        [h]: f
      }
    });
  }, u = () => {
    const _ = W(D.RELEASE_EDIT, {
      releaseId: s
    });
    r.push(_);
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs(It, { autoPosition: !0, autoClose: !0, children: [
      /* @__PURE__ */ e.jsx(
        It.Button,
        {
          isKebab: !0,
          rootClassName: "icon-dim-20 dc__no-shrink p-0 dc__no-background dc__no-border dc__outline-none-imp flex dc__tab-focus dc__hover-n50",
          dataTestId: `edit-${t}-options-button`,
          children: /* @__PURE__ */ e.jsx(ol, { className: "flex icon-dim-16 dc__no-shrink icon-color-n6" })
        }
      ),
      /* @__PURE__ */ e.jsxs(It.Body, { rootClassName: "br-4 py-4 dc__overflow-hidden dc__border dc__box-shadow--menu", children: [
        /* @__PURE__ */ e.jsxs(
          "button",
          {
            type: "button",
            "aria-label": `edit ${t} name`,
            "data-testid": `edit-${t}-name`,
            className: "flexbox dc__transparent dc__hover-n50 dc__align-items-center py-6 px-8 w-100 dc__gap-8",
            onClick: u,
            children: [
              /* @__PURE__ */ e.jsx(Ys, { className: "icon-dim-16 dc__no-shrink scn-6" }),
              /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "Edit release" })
            ]
          }
        ),
        /* @__PURE__ */ e.jsxs(
          "button",
          {
            type: "button",
            "aria-label": `clone ${t}`,
            "data-testid": `clone-${t}`,
            className: "flexbox dc__transparent dc__hover-n50 dc__align-items-center py-6 px-8 w-100 dc__gap-8",
            onClick: p,
            children: [
              /* @__PURE__ */ e.jsx(Jd, { className: "icon-dim-16 dc__no-shrink" }),
              /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "Clone release" })
            ]
          }
        ),
        /* @__PURE__ */ e.jsxs(
          "button",
          {
            type: "button",
            "aria-label": `delete ${t}`,
            "data-testid": `delete-${t}`,
            className: "flexbox dc__transparent dc__hover-n50 dc__align-items-center py-6 px-8 w-100 dc__gap-8",
            onClick: d,
            children: [
              /* @__PURE__ */ e.jsx(Wt, { className: "icon-dim-16 scr-5 dc__no-shrink" }),
              /* @__PURE__ */ e.jsx("span", { className: "cr-5 fs-13 fw-4 lh-20", children: "Delete release" })
            ]
          }
        )
      ] })
    ] }),
    i && /* @__PURE__ */ e.jsx(
      Jo,
      {
        handleClose: m,
        handleSuccess: o,
        id: s,
        name: t
      }
    )
  ] });
}, Df = ({
  name: s,
  description: t,
  createdBy: n,
  firstReleasedOn: a,
  status: l,
  version: o,
  track: r,
  id: i,
  refetchReleaseTracks: c,
  searchKey: d
}) => {
  const { push: m } = fe(), p = () => {
    const u = W(D.RELEASE_DETAIL, {
      releaseTrack: r,
      releaseVersion: o
    });
    m(u);
  };
  return /* @__PURE__ */ e.jsxs(
    "button",
    {
      type: "button",
      className: "dc__transparent p-0 bg__primary br-8 dc__info-card dc__info-card w-100",
      onClick: p,
      children: [
        /* @__PURE__ */ e.jsx("div", { className: "p-16 flexbox-col dc__gap-12", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space", children: [
            /* @__PURE__ */ e.jsx(zs, { className: "icon-dim-32 dc__no-shrink" }),
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4 dc__align-items-center", children: [
              /* @__PURE__ */ e.jsx(
                Vo,
                {
                  id: i,
                  currentStatus: l,
                  handleStatusChangeSuccess: c
                },
                l
              ),
              /* @__PURE__ */ e.jsx(
                kf,
                {
                  id: i,
                  name: s,
                  track: r,
                  status: l,
                  version: o,
                  refetchReleaseTracks: c
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
            /* @__PURE__ */ e.jsx(re, { content: s, arrow: !1, className: "default-tt dc__word-break", placement: "top", children: /* @__PURE__ */ e.jsx(
              "h3",
              {
                className: "fs-13 lh-20 fw-6 dc__truncate m-0 dc__w-fit-content",
                dangerouslySetInnerHTML: {
                  __html: us.sanitize(
                    _s({
                      searchText: d,
                      text: s,
                      highlightClasses: "bcy-2"
                    })
                  )
                }
              }
            ) }),
            /* @__PURE__ */ e.jsx(re, { content: o, arrow: !1, className: "default-tt dc__word-break", placement: "top", children: /* @__PURE__ */ e.jsx(
              "span",
              {
                className: "mono fs-14 lh-20 cn-9 dc__truncate dc__w-fit-content",
                dangerouslySetInnerHTML: {
                  __html: us.sanitize(
                    _s({
                      searchText: d,
                      text: o,
                      highlightClasses: "bcy-2"
                    })
                  )
                }
              }
            ) }),
            t && /* @__PURE__ */ e.jsx(
              re,
              {
                content: t,
                arrow: !1,
                className: "default-tt dc__word-break",
                placement: "top",
                children: /* @__PURE__ */ e.jsx("p", { className: "fs-12 lh-18 cn-7 dc__ellipsis-right__2nd-line dc__w-fit-content m-0 dc__align-left", children: t })
              }
            )
          ] })
        ] }) }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space dc__gap-16 dc__border-top-n1 pt-12 pb-12 pl-16 pr-16 fs-12 lh-18 cn-7", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "fs-12 lh-18 cn-7 dc__word-break flexbox flex-align-center dc__gap-6", children: [
            /* @__PURE__ */ e.jsx(
              "div",
              {
                className: "icon-dim-20 dc__no-shrink flexbox flex-justify-center flex-align-center dc__border-radius-50-per dc__uppercase cn-0 fw-4",
                style: {
                  backgroundColor: la(n)
                },
                children: n[0]
              }
            ),
            /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: n })
          ] }),
          /* @__PURE__ */ e.jsx("span", { className: "dc__truncate dc__no-shrink", children: a ? /* @__PURE__ */ e.jsx(re, { content: "First release date", arrow: !1, className: "default-tt", placement: "top", children: /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: a }) }) : "Not released" })
        ] })
      ]
    }
  );
}, Of = ({
  id: s,
  name: t,
  description: n,
  releases: a,
  openDeleteReleaseTrackModal: l,
  refetchReleaseTracks: o,
  searchKey: r
}) => {
  const i = fe(), c = W(D.RELEASE_TRACK_DETAIL, {
    trackName: t
  }), d = () => {
    const h = W(D.RELEASE_TRACK_ADD_EDIT, {
      id: s
    });
    i.push(h);
  }, m = () => {
    i.push({
      pathname: D.RELEASE_CREATE,
      state: {
        [Jn.TRACK_NAME_STATE_KEY]: t
      }
    });
  }, p = () => {
    l({ id: s, name: t });
  }, u = (h) => /* @__PURE__ */ e.jsx(re, { content: n, arrow: !1, className: "default-tt dc__word-break", placement: "top", children: h }), _ = (h) => {
    switch (h.id) {
      case "edit":
        d();
        break;
      case "delete":
        p();
        break;
    }
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "bg__secondary mw-400 dc__mxw-500 w-100 dc__top-radius-8 flexbox-col flex-grow-1", children: [
    /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__content-space dc__align-start dc__gap-16 pt-12 pb-12 pr-16 pl-16 dc__border-bottom-n1 dc__no-shrink", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4 dc__content-space flex-grow-1", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
        /* @__PURE__ */ e.jsx(re, { content: t, arrow: !1, className: "default-tt dc__word-break", placement: "top", children: /* @__PURE__ */ e.jsxs(
          ke,
          {
            to: c,
            className: "flexbox dc__align-items-center dc__no-decor fs-14 fw-6 cn-9 m-0 lh-20 dc__w-fit-content",
            children: [
              /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: t }),
              /* @__PURE__ */ e.jsx(Gr, { className: "icon-dim-24 p-4 dc__no-shrink icon-color-n6 dc__flip-270" })
            ]
          }
        ) }),
        /* @__PURE__ */ e.jsx($e, { condition: !!n, wrap: u, children: /* @__PURE__ */ e.jsx("p", { className: "cn-7 fs-12 lh-18 m-0 dc__truncate dc__w-fit-content", children: n || "No description" }) })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "flex top left dc__no-shrink", children: [
        /* @__PURE__ */ e.jsxs(
          ke,
          {
            to: {
              pathname: D.RELEASE_CREATE,
              state: {
                [Jn.TRACK_NAME_STATE_KEY]: t
              }
            },
            className: "anchor dc__no-shrink flex py-2 px-4 dc__gap-4 fs-13 lh-20 fw-6",
            onClick: m,
            children: [
              /* @__PURE__ */ e.jsx(Je, { className: "icon-dim-16 fcb-5" }),
              /* @__PURE__ */ e.jsx("span", { children: "New Release" })
            ]
          }
        ),
        /* @__PURE__ */ e.jsx(
          Lr,
          {
            id: "release-track-card-action-menu",
            onClick: _,
            options: [
              {
                items: [
                  {
                    id: "edit",
                    label: "Edit",
                    startIcon: { name: "ic-pencil" }
                  },
                  {
                    id: "delete",
                    label: "Delete",
                    startIcon: { name: "ic-delete" },
                    type: "negative"
                  }
                ]
              }
            ],
            buttonProps: {
              dataTestId: "release-track-card-action-menu-button",
              icon: /* @__PURE__ */ e.jsx(Me, { name: "ic-more-vertical", color: null }),
              variant: _e.borderLess,
              ariaLabel: "Open action menu",
              style: qe.neutral,
              size: oe.xs
            }
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-12 p-12 dc__overflow-auto flex-grow-1", children: a.length ? a.map((h) => /* @__PURE__ */ e.jsx(
      Df,
      {
        ...h,
        refetchReleaseTracks: o,
        searchKey: r
      },
      `release-${s}-${h.id}`
    )) : /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col p-16 br-4 dc__border-dashed--n3 dc__gap-8", children: [
      /* @__PURE__ */ e.jsx("div", { className: "flex", children: /* @__PURE__ */ e.jsx(zs, { className: "icon-dim-32 dc__blend-luminosity" }) }),
      /* @__PURE__ */ e.jsxs("div", { className: "flex column dc__gap-4", children: [
        /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-20 cn-9", children: "No releases" }),
        /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-20 cn-7", children: "No releases are created in this release track" })
      ] })
    ] }) })
  ] });
}, Mf = () => /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__gap-16 pl-20 pr-20 flex-grow-1", children: Cf.map((s) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col bg__secondary dc__top-radius-8 flex-grow-1 dc__mxw-500", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col pl-16 pr-16 pt-12 pb-12 dc__gap-6 show-shimmer-loading dc__border-bottom-n1", children: [
    /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading w-200 h-20" }),
    /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading w-100 h-20" })
  ] }),
  /* @__PURE__ */ e.jsx("div", { className: "flexbox-col p-12 dc__gap-12", children: s.releases.map((t) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col br-8 bg__primary dc__info-card", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8 p-16 dc__border-bottom-n1", children: [
      /* @__PURE__ */ e.jsx(zs, { className: "icon-dim-32 dc__opacity-0_5 dc__blend-luminosity" }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6 show-shimmer-loading", children: [
        /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading w-200 h-16" }),
        /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading w-120 h-16" })
      ] })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox pr-16 pl-16 pt-12 pb-12 dc__content-space dc__align-items-center", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox show-shimmer-loading dc__gap-6 dc__align-items-center", children: [
        /* @__PURE__ */ e.jsx("span", { className: "w-20 h-20 child child-shimmer-loading dc__border-radius-50-per-imp" }),
        /* @__PURE__ */ e.jsx("span", { className: "w-100px h-16 child child-shimmer-loading" })
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "flex show-shimmer-loading", children: /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading h-16 w-60" }) })
    ] })
  ] }, `${s.id}-${t.id}`)) })
] }, s.id)) }), Pf = () => {
  const { url: s } = gs(), t = fe(), [n, a] = T(null), {
    searchKey: l = "",
    handleSearch: o,
    clearFilters: r,
    track: i,
    updateSearchParams: c
  } = Xn({
    parseSearchParams: Sf
  }), [d, m, p, u] = K(
    () => jo({ lite: !1, fetchChild: !0 })
  ), { filterConfig: _, filteredReleaseTracks: h, releaseTrackOptions: f, selectedFilterTrackMap: g } = q(() => {
    const y = {
      track: i
    };
    return {
      ...wf({
        releaseTracks: m,
        searchKey: l,
        filterConfig: y
      }),
      filterConfig: y
    };
  }, [l, m, `${i}`]), b = f.filter((y) => g[y.value]), j = (y) => (C) => {
    c({
      [y]: C.map(({ value: S }) => S)
    });
  }, E = () => {
    t.push(s);
  }, v = (y) => {
    o(y?.trim());
  }, x = () => /* @__PURE__ */ e.jsx(
    ie,
    {
      component: Rt.link,
      linkProps: {
        to: D.RELEASE_CREATE
      },
      dataTestId: "create-release",
      text: "Create release",
      startIcon: /* @__PURE__ */ e.jsx(Je, {})
    }
  ), N = () => m?.length ? h.length ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__gap-16 fw-4 pt-8 pl-20 pr-20 dc__w-fit-content mw-100p h-100", children: h.map((y) => /* @__PURE__ */ e.jsx(
      Of,
      {
        ...y,
        openDeleteReleaseTrackModal: a,
        refetchReleaseTracks: u,
        searchKey: l
      },
      `release-track-${y.id}`
    )) }) }),
    !!n && /* @__PURE__ */ e.jsx(
      Lf,
      {
        deleteTrackModalConfig: n,
        setDeleteTrackModalConfig: a,
        handleSuccess: u
      }
    )
  ] }) : /* @__PURE__ */ e.jsx(yt, { handleClearFilters: r }) : /* @__PURE__ */ e.jsx(
    J,
    {
      title: "Create your first release",
      subTitle: "Release is a snapshot of your software at a specific time, including all components needed for deployment. It adds value by ensuring stability, consistency, traceability, and facilitating collaboration among team members.",
      renderButton: x,
      isButtonAvailable: !0,
      image: zd
    }
  );
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-hidden", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-8 dc__content-space py-12 px-20 dc__no-shrink", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-8", children: [
        /* @__PURE__ */ e.jsx(
          qs,
          {
            inputProps: {
              placeholder: "Search by release name or version",
              disabled: d
            },
            handleEnter: v,
            initialSearchText: l,
            containerClassName: "w-250",
            keyboardShortcut: "/"
          }
        ),
        /* @__PURE__ */ e.jsx(
          sl,
          {
            placeholder: "Release Track",
            options: f,
            isDisabled: d,
            isLoading: d,
            inputId: "release-track-filter",
            appliedFilterOptions: b,
            handleApplyFilter: j(Ll.track),
            menuPosition: "absolute"
          }
        )
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "flex right dc__gap-8", children: [
        /* @__PURE__ */ e.jsx(
          ie,
          {
            component: Rt.link,
            linkProps: {
              to: W(D.RELEASE_TRACK_ADD_EDIT, {
                id: gl
              })
            },
            variant: _e.secondary,
            size: oe.medium,
            dataTestId: "create-release-track",
            startIcon: /* @__PURE__ */ e.jsx(Je, {}),
            text: "Release Track"
          }
        ),
        /* @__PURE__ */ e.jsx(
          ie,
          {
            component: Rt.link,
            linkProps: {
              to: W(D.RELEASE_CREATE)
            },
            size: oe.medium,
            dataTestId: "create-release",
            startIcon: /* @__PURE__ */ e.jsx(Je, {}),
            text: "Create release"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(
      sa,
      {
        filterConfig: _,
        onRemoveFilter: c,
        clearFilters: r,
        className: "px-20"
      }
    ),
    /* @__PURE__ */ e.jsx(
      Ee,
      {
        isLoading: d,
        customLoader: /* @__PURE__ */ e.jsx(Mf, {}),
        error: p,
        errorScreenManagerProps: {
          code: p?.code,
          reload: u
        },
        children: N()
      }
    ),
    /* @__PURE__ */ e.jsxs(Bs, { children: [
      /* @__PURE__ */ e.jsx(Re, { path: D.RELEASE_CREATE, children: /* @__PURE__ */ e.jsx(mr, { handleClose: E, handleSuccess: We }) }),
      /* @__PURE__ */ e.jsx(Re, { path: D.RELEASE_EDIT, children: /* @__PURE__ */ e.jsx(mr, { handleClose: E, handleSuccess: u }) }),
      /* @__PURE__ */ e.jsx(
        si,
        {
          path: D.RELEASE_TRACK_ADD_EDIT,
          handleClose: E,
          handleSuccess: u
        }
      )
    ] })
  ] });
}, Ff = () => /* @__PURE__ */ e.jsx("div", { className: "flexbox-col bg__primary h-100 dc__overflow-hidden", children: /* @__PURE__ */ e.jsx(Pf, {}) }), Uf = () => /* @__PURE__ */ e.jsxs(Bs, { children: [
  /* @__PURE__ */ e.jsx(
    Re,
    {
      path: D.RELEASE_DETAIL,
      render: ({ match: s }) => /* @__PURE__ */ e.jsx(af, {}, `release-detail-${s.params.releaseTrack}-${s.params.releaseVersion}`)
    }
  ),
  /* @__PURE__ */ e.jsx(
    Re,
    {
      path: D.RELEASE_TRACK_DETAIL,
      render: ({ match: s }) => /* @__PURE__ */ e.jsx(jf, {}, `release-track-detail-${s.params.trackName}}`)
    }
  ),
  /* @__PURE__ */ e.jsxs(Re, { path: D.RELEASES, children: [
    /* @__PURE__ */ e.jsx(ei, {}),
    /* @__PURE__ */ e.jsx(Ff, {})
  ] }),
  /* @__PURE__ */ e.jsx(gn, { to: D.RELEASES })
] }), $f = (s) => ({
  partOfReleaseTracks: (s?.releaseTrackDownstreams ?? []).filter((t) => t.resourceKind === G.releaseTrack).map(({ id: t, identifier: n }) => ({
    id: t,
    name: n,
    redirectUrl: W(D.RELEASE_TRACK_DETAIL, {
      trackName: n
    })
  }))
}), Bf = async (s) => {
  const t = ge({
    kind: G.devtronApplication,
    baseUrl: $.RESOURCE,
    version: ne.v1,
    queryParams: {
      id: s
    }
  }), { result: n } = await xe(t);
  return $f(n);
}, TE = ({ appId: s }) => {
  const [, t, n] = K(() => Bf(s), [s]);
  if (n)
    return null;
  const a = t?.partOfReleaseTracks ?? [];
  return a.length ? /* @__PURE__ */ e.jsxs("div", { children: [
    /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-4 lh-20 cn-7 mb-4", children: "Part of release track" }),
    /* @__PURE__ */ e.jsx("div", { className: "flex column left top dc__gap-4", children: a.map(
      (l) => l.name && /* @__PURE__ */ e.jsxs("div", { className: "flex left flex-grow-1 dc__gap-8", children: [
        /* @__PURE__ */ e.jsx(Mr, { className: "icon-dim-20 dc__no-shrink" }),
        /* @__PURE__ */ e.jsx(
          ke,
          {
            to: l.redirectUrl,
            target: "_blank",
            className: "anchor fs-13 fw-6 lh-20 cn-9 dc__truncate",
            children: l.name
          }
        )
      ] }, l.id)
    ) })
  ] }) : null;
}, Hf = async (s, t) => {
  try {
    const n = ge({
      baseUrl: $.RESOURCE_LIST,
      kind: G.tenant,
      version: ne.alpha1,
      queryParams: {
        fetchChild: !0,
        filterCriteria: Cp(s)
      }
    }), {
      result: { data: a }
    } = await xe(n, { signal: t });
    return a?.map(ml) ?? [];
  } catch (n) {
    throw hs(n) || U(n), n;
  }
}, Gf = async () => {
  const s = ge({
    baseUrl: $.RESOURCE_LIST,
    kind: G.tenant,
    version: ne.alpha1
  }), {
    result: { data: t }
  } = await xe(s);
  return [
    {
      label: "All Tenants",
      options: (t ?? []).map(ml).map(({ name: n, tenantId: a }) => ({
        label: n,
        value: a,
        description: a
      }))
    }
  ];
}, ti = async (s) => {
  try {
    const t = ge({
      baseUrl: $.RESOURCE,
      kind: G.tenant,
      version: ne.alpha1,
      queryParams: {
        identifier: s
      }
    }), { result: n } = await xe(t);
    return ml(n);
  } catch (t) {
    throw U(t), t;
  }
}, Dl = (s) => {
  const t = ge({
    baseUrl: $.RESOURCE,
    kind: G.tenant,
    version: ne.alpha1
  });
  return Ls(t, s);
}, Wf = (s) => {
  const { name: t, description: n, image: a, tenantId: l } = s, o = {
    identifier: l,
    query: [
      {
        op: he.replace,
        path: "name",
        value: t
      },
      {
        op: he.replace,
        path: "description",
        value: n
      },
      {
        op: he.replace,
        path: "icon",
        value: a
      }
    ]
  };
  return Dl(o);
}, Vf = (s) => {
  const { tenantId: t, name: n, description: a, image: l } = s, o = ge({
    baseUrl: $.RESOURCE,
    kind: G.tenant,
    version: ne.alpha1
  });
  return Ue(o, {
    name: n,
    overview: {
      icon: l,
      description: a,
      tenantId: t
    }
  });
}, qf = async (s) => Ht(
  ge({
    baseUrl: $.RESOURCE,
    kind: G.tenant,
    version: ne.alpha1,
    queryParams: {
      identifier: s
    }
  })
), Yf = async ({ tenantId: s, description: t }) => {
  const n = {
    identifier: s,
    query: [
      {
        op: he.replace,
        path: "description",
        value: t
      }
    ]
  };
  return Dl(n);
}, zf = async ({ tenantId: s, note: t }) => {
  const n = {
    identifier: s,
    query: [
      {
        op: he.replace,
        path: "readme",
        value: t
      }
    ]
  };
  return Dl(n);
}, Kf = async (s) => {
  try {
    const t = ge({
      baseUrl: $.RESOURCE_LIST,
      kind: G.installation,
      version: ne.alpha1,
      queryParams: {
        filterCriteria: `${G.tenant}|identifier|${s}`
      }
    }), {
      result: { data: n }
    } = await xe(t);
    return n?.map(Zr) ?? [];
  } catch (t) {
    throw U(t), t;
  }
}, Jf = async (s) => {
  const t = {
    identifier: Yt(s)
  };
  try {
    const [n, a] = await Promise.all([
      xe(
        ge({
          baseUrl: $.RESOURCE_DEPENDENCIES,
          kind: G.installation,
          version: ne.alpha1,
          queryParams: t
        })
      ),
      xe(
        ge({
          baseUrl: $.RESOURCE,
          kind: G.installation,
          version: ne.alpha1,
          queryParams: t
        })
      )
    ]);
    return vp(
      n?.result,
      a?.result
    );
  } catch (n) {
    throw n?.code !== Er.NOT_FOUND && U(n), n;
  }
}, Qf = async (s) => {
  const t = ge({
    baseUrl: $.RESOURCE,
    kind: G.installation,
    version: ne.alpha1,
    queryParams: {
      identifier: Yt(s)
    }
  });
  return Ht(t);
}, Xf = async ({
  name: s,
  installationId: t,
  tenantId: n,
  releaseChannelId: a
}) => {
  const l = ge({
    baseUrl: $.RESOURCE,
    kind: G.installation,
    version: ne.alpha1
  }), o = {
    identifier: Yt({
      tenantId: n,
      installationId: t
    }),
    query: [
      {
        op: he.replace,
        path: "name",
        value: s
      },
      a ? {
        op: he.replace,
        path: "releaseChannel",
        value: a
      } : {
        op: he.remove,
        path: "releaseChannel"
      }
    ]
  };
  return Ls(l, o);
}, Zf = async ({
  tenantId: s,
  installationId: t,
  pushToRemote: n,
  repository: a,
  dockerRegistryId: l
}) => {
  const o = ge({
    baseUrl: $.RESOURCE,
    kind: G.installation,
    version: ne.alpha1
  }), r = {
    identifier: Yt({
      tenantId: s,
      installationId: t
    }),
    query: [
      {
        op: he.replace,
        path: "deploymentConfiguration",
        value: n ? {
          pushToRemote: n,
          repository: a,
          dockerRegistryId: l
        } : {
          pushToRemote: n,
          repository: null,
          dockerRegistryId: null
        }
      }
    ]
  };
  return Ls(o, r);
}, eg = async ({
  name: s,
  installationId: t,
  tenantId: n,
  releaseChannelId: a
}) => {
  const l = ge({
    baseUrl: $.RESOURCE,
    kind: G.installation,
    version: ne.alpha1
  }), o = {
    name: s,
    overview: {
      installationId: t
    },
    parentConfig: {
      identifier: n,
      resourceKind: G.tenant,
      resourceVersion: ne.alpha1
    },
    subscriptionConfig: a ? {
      resourceKind: G.releaseChannel,
      resourceVersion: ne.alpha1,
      identifier: a
    } : null
  };
  return Ue(l, o);
}, sg = async (s) => {
  try {
    const t = ge({
      baseUrl: $.RESOURCE_DEPENDENCIES_OPTIONS,
      kind: G.installation,
      version: ne.alpha1,
      queryParams: {
        filterCriteria: `${G.cluster}|identifier|${s}`
      }
    }), { result: n } = await xe(t);
    return n?.map(Sp) ?? [];
  } catch (t) {
    throw U(t), t;
  }
}, tg = async () => {
  try {
    const s = ge({
      baseUrl: $.RESOURCE_DEPENDENCIES_OPTIONS,
      kind: G.installation,
      version: ne.alpha1
    }), { result: t } = await xe(s);
    return t ? t.map(({ identifier: n, id: a, data: l }) => ({
      id: a,
      name: n,
      isVirtual: l?.isVirtualCluster ?? !1,
      isProd: l?.isProd ?? !1
    })).sort((n, a) => te(n.name, a.name)) : [];
  } catch (s) {
    throw U(s), s;
  }
}, ng = async ({
  tenantId: s,
  installationId: t,
  selectedEnvironmentMap: n
}) => {
  const a = ge({
    baseUrl: $.RESOURCE_DEPENDENCIES,
    kind: G.installation,
    version: ne.alpha1
  }), l = {
    identifier: Yt({
      tenantId: s,
      installationId: t
    }),
    dependencies: wp(n)
  };
  return $t(a, l);
}, He = {
  ADD_TENANT: "Add tenant",
  EDIT_TENANT: "Edit tenant",
  CTA: "Save",
  CANCEL: "Cancel",
  EDIT_IMAGE_CTA: "Preview",
  EDIT_IMAGE_LABEL: "Image URL",
  EDIT_IMAGE_PLACEHOLDER: "Enter image url",
  TENANT_NAME_LABEL: "Tenant display name",
  TENANT_NAME_PLACEHOLDER: "Eg. Acme Inc.",
  TENANT_ID_LABEL: "Tenant ID",
  TENANT_ID_PLACEHOLDER: "Eg. acme-inc",
  TENANT_ID_FIELD_SUBTITLE: "Tenant ID is a unique identifier for a tenant. This cannot be changed once set.",
  DESCRIPTION_LABEL: "Description",
  DESCRIPTION_PLACEHOLDER: "Write a description for this tenant",
  CREATE_SUCCESS: "Tenant created successfully",
  UPDATE_SUCCESS: "Tenant updated successfully"
}, ag = {
  tenantId: null,
  tenantName: null,
  installationId: null,
  installationName: null,
  description: null,
  image: null
}, lg = {
  tenantId: "",
  tenantName: "",
  installationId: null,
  installationName: null,
  description: null,
  image: null
}, rg = {
  name: "",
  tenantId: "",
  description: "",
  image: "",
  installations: []
}, og = {
  isLoading: !1,
  isEditing: !1,
  src: ""
}, ur = 2 * 1024 * 1024;
var De = /* @__PURE__ */ ((s) => (s.UPDATE_DESCRIPTION = "updateDescription", s.UPDATE_INSTALLATION_ID = "updateInstallationId", s.UPDATE_INSTALLATION_NAME = "updateInstallationName", s.UPDATE_TENANT_ID = "updateTenantId", s.UPDATE_TENANT_NAME = "updateTenantName", s.UPDATE_IMAGE = "updateImage", s.ENABLE_IMAGE_EDIT = "enableImageEdit", s.CANCEL_IMAGE_CHANGES = "cancelImageChanges", s.PREVIEW_IMAGE = "previewImage", s.ADD_INSTALLATION = "addInstallation", s.REMOVE_INSTALLATION = "removeInstallation", s))(De || {});
const ig = ({
  value: s,
  error: t,
  handleTenantInputChange: n
}) => {
  const a = (l) => {
    n({ action: De.UPDATE_DESCRIPTION, value: l.currentTarget.value });
  };
  return /* @__PURE__ */ e.jsx(
    jn,
    {
      name: "tenant-description",
      placeholder: He.DESCRIPTION_PLACEHOLDER,
      value: s,
      onChange: a,
      label: He.DESCRIPTION_LABEL,
      error: t
    }
  );
}, cg = ({
  value: s,
  error: t,
  handleTenantInputChange: n
}) => {
  const a = (l) => {
    n({ action: De.UPDATE_TENANT_NAME, value: l.currentTarget.value });
  };
  return /* @__PURE__ */ e.jsx(
    Fe,
    {
      name: "tenant-display-name",
      label: He.TENANT_NAME_LABEL,
      placeholder: He.TENANT_NAME_PLACEHOLDER,
      value: s,
      onChange: a,
      error: t,
      required: !0,
      fullWidth: !0
    }
  );
}, dg = ({ value: s, error: t, handleTenantInputChange: n, isEditMode: a }) => {
  const l = (o) => {
    n({ action: De.UPDATE_TENANT_ID, value: o.currentTarget.value });
  };
  return /* @__PURE__ */ e.jsx(
    Fe,
    {
      name: "tenant-id-field",
      label: He.TENANT_ID_LABEL,
      placeholder: He.TENANT_ID_PLACEHOLDER,
      value: s,
      onChange: l,
      error: t,
      required: !0,
      disabled: a,
      helperText: He.TENANT_ID_FIELD_SUBTITLE,
      fullWidth: !0
    }
  );
}, pg = () => /* @__PURE__ */ e.jsx("div", { className: "flex p-4 br-4 dc__border edit-image-icon dc__zi-1 bg__primary dc__hover-n50 icon-dim-24", children: /* @__PURE__ */ e.jsx(Ys, { className: "dc__no-shrink icon-dim-16" }) }), mg = ({
  value: s,
  error: t,
  isEditing: n,
  isLoading: a,
  src: l,
  handleTenantInputChange: o
}) => {
  const r = a || !!t, i = () => {
    o({ action: De.ENABLE_IMAGE_EDIT });
  }, c = (u) => {
    o({ action: De.UPDATE_IMAGE, value: u.currentTarget.value });
  }, d = () => {
    o({ action: De.PREVIEW_IMAGE, value: s });
  }, m = () => {
    o({ action: De.CANCEL_IMAGE_CHANGES });
  }, p = (u) => {
    !r && u.key === "Enter" && (u.preventDefault(), d());
  };
  return n ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-20", children: [
    /* @__PURE__ */ e.jsx(
      is,
      {
        imageProps: {
          src: l,
          height: 72,
          width: 72
        }
      }
    ),
    n && /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16 flex-grow-1", children: [
      /* @__PURE__ */ e.jsx(
        Fe,
        {
          name: "tenant-image-url",
          label: He.EDIT_IMAGE_LABEL,
          placeholder: He.EDIT_IMAGE_PLACEHOLDER,
          value: s,
          onChange: c,
          error: t,
          required: !0,
          onKeyDown: p,
          fullWidth: !0
        }
      ),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8", children: [
        /* @__PURE__ */ e.jsx(
          Ws,
          {
            isLoading: a,
            rootClassName: "cta h-28 flex",
            type: "button",
            disabled: r,
            "data-testid": "preview-tenant-image-update",
            onClick: d,
            children: He.EDIT_IMAGE_CTA
          }
        ),
        /* @__PURE__ */ e.jsx(
          "button",
          {
            className: "cta secondary h-28 flex",
            "data-testid": "cancel-image-url-edit",
            type: "button",
            disabled: a,
            onClick: m,
            children: He.CANCEL
          }
        )
      ] })
    ] })
  ] }) : /* @__PURE__ */ e.jsxs(
    "button",
    {
      className: "dc__no-background dc__no-border dc__outline-none-imp tenants__tenant-figure-container p-0 icon-dim-72 dc__no-shrink",
      type: "button",
      "data-testid": "edit-tenant-image",
      "aria-label": "edit tenant image",
      onClick: i,
      children: [
        /* @__PURE__ */ e.jsx(
          is,
          {
            imageProps: {
              src: l,
              height: 72,
              width: 72
            },
            fallbackImageProps: {
              showEditIcon: !0
            }
          }
        ),
        /* @__PURE__ */ e.jsx(pg, {})
      ]
    }
  );
}, ug = ({
  handleTenantInputChange: s,
  tenantInput: t,
  tenantInputErrors: n,
  imageFieldInfo: a,
  isEditMode: l
}) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col py-24 px-20 dc__gap-16 w-100 dc__overflow-auto", children: [
  /* @__PURE__ */ e.jsx(
    mg,
    {
      value: t.image,
      error: n.image,
      isEditing: a.isEditing,
      isLoading: a.isLoading,
      src: a.src,
      handleTenantInputChange: s
    }
  ),
  /* @__PURE__ */ e.jsx(
    cg,
    {
      value: t.name,
      error: n.tenantName,
      handleTenantInputChange: s
    }
  ),
  /* @__PURE__ */ e.jsx(
    dg,
    {
      value: t.tenantId,
      error: n.tenantId,
      handleTenantInputChange: s,
      isEditMode: l
    }
  ),
  /* @__PURE__ */ e.jsx(
    ig,
    {
      value: t.description,
      error: n.description,
      handleTenantInputChange: s
    }
  )
] }), Ya = ({ handleClose: s, handleSuccess: t, tenantId: n }) => {
  const a = !!n, [l, o] = T(!1), [r, i] = T(
    structuredClone(rg)
  ), [c, d] = T(
    a ? {
      ...ag
    } : { ...lg }
  ), [m, p] = T(
    structuredClone(og)
  ), [u, _, h, f] = K(
    () => ti(n),
    [n, a],
    a
  ), g = q(
    () => Object.values(c).filter((x) => x != null).length > 0,
    [c]
  );
  ee(() => {
    a && _ && (i({
      tenantId: _.tenantId,
      name: _.name,
      description: _.description,
      image: _.image,
      installations: []
    }), p({
      ...m,
      src: _.image
    }));
  }, [_]);
  const b = async (x) => {
    try {
      p({ ...m, isLoading: !0 });
      const N = await fetch(x, { mode: "cors" });
      if (!N.ok)
        throw new Error("Invalid network response");
      const y = await N.blob();
      if (y.size > ur)
        throw new Error(`Add an image smaller than ${ur}`);
      const C = URL.createObjectURL(y), S = await uc(C);
      if (URL.revokeObjectURL(C), S.isValid)
        p({ isEditing: !1, isLoading: !1, src: x });
      else
        throw new Error(S.message);
    } catch (N) {
      d({ ...c, image: N.message || "Failed to load image" }), p({ ...m, isLoading: !1 });
    }
  }, j = (x) => mn(x).message, E = async ({
    action: x,
    value: N
  }) => {
    const y = structuredClone(r), C = { ...c }, S = { ...m };
    switch (x) {
      case De.UPDATE_DESCRIPTION:
        y.description = N, C.description = oa(N).message;
        break;
      case De.UPDATE_IMAGE:
        y.image = N, C.image = Hl(N, !1).message;
        break;
      case De.ENABLE_IMAGE_EDIT:
        S.isEditing = !0, C.image = m.src ? Hl(m.src, !1).message : "";
        break;
      case De.CANCEL_IMAGE_CHANGES:
        S.isEditing = !1, y.image = S.src, C.image = null;
        break;
      case De.PREVIEW_IMAGE:
        b(N);
        return;
      case De.UPDATE_INSTALLATION_ID: {
        const I = y.installations?.[0] ?? { name: "", installationId: "" };
        I.installationId = N, y.installations = [{ ...I }], C.installationId = j(N), I.name || (C.installationName = cn(I.name).message);
        break;
      }
      case De.UPDATE_INSTALLATION_NAME: {
        const I = y.installations?.[0] ?? { name: "", installationId: "" };
        I.name = N, y.installations = [I], C.installationName = cn(N).message, I.installationId || (C.installationId = j(I.installationId));
        break;
      }
      case De.ADD_INSTALLATION:
        C.installationId = "", C.installationName = "";
        break;
      case De.REMOVE_INSTALLATION:
        y.installations = [{ name: "", installationId: "" }], C.installationId = null, C.installationName = null;
        break;
      case De.UPDATE_TENANT_ID:
        y.tenantId = N, C.tenantId = mn(N).message;
        break;
      case De.UPDATE_TENANT_NAME:
        y.name = N, C.tenantName = cn(N).message;
        break;
      default:
        throw new Error("Invalid action type");
    }
    i(y), p(S), d(C);
  }, v = async () => {
    if (g) {
      ae.showToast({
        variant: le.error,
        description: ot
      });
      return;
    }
    o(!0);
    try {
      const x = {
        // Need to add only if installation section was expanded
        installations: a || !(r.installations?.[0]?.installationId && r.installations?.[0]?.name) ? null : r.installations,
        tenantId: r.tenantId,
        name: r.name,
        description: r.description,
        image: r.image
      };
      await (a ? Wf(x) : Vf(x)), ae.showToast({
        variant: le.success,
        description: a ? He.UPDATE_SUCCESS : He.CREATE_SUCCESS
      }), t(), s();
    } catch (x) {
      U(x), o(!1);
    }
  };
  return /* @__PURE__ */ e.jsx(Ut, { className: "", onEscape: s, close: s, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "bg__primary dc__position-fixed dc__right-0 dc__top-0 h-100 flexbox-col dc__content-space w-1024",
      onClick: lt,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col h-100 dc__content-space bg__primary dc__overflow-auto", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__align-items-center dc__border-bottom-n1 pb-12 pt-12 pl-20 pr-20", children: [
            /* @__PURE__ */ e.jsx("h2", { className: "m-0 cn-9 fs-16 fw-6 lh-24 dc__ellipsis-right", children: a ? He.EDIT_TENANT : He.ADD_TENANT }),
            /* @__PURE__ */ e.jsx(
              "button",
              {
                className: "flex dc__transparent dc__outline-none-imp dc__no-border p-0 dc__tab-focus",
                type: "button",
                onClick: s,
                "aria-label": "close upsert tenant modal",
                children: /* @__PURE__ */ e.jsx(Ts, { className: "icon-dim-24 dc__no-shrink fcn-6" })
              }
            )
          ] }),
          /* @__PURE__ */ e.jsx(
            Ee,
            {
              isLoading: u,
              progressingProps: {
                pageLoader: !0
              },
              error: h,
              errorScreenManagerProps: {
                code: h?.code,
                reload: f
              },
              children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox w-100 h-100 dc__overflow-auto", children: [
                /* @__PURE__ */ e.jsx(
                  vn,
                  {
                    rootClassName: "pl-24 pr-24 pt-24 pb-24 dc__no-shrink",
                    heading: "Tenant",
                    icon: /* @__PURE__ */ e.jsx(ad, { className: "dc__no-shrink icon-dim-40" }),
                    documentationLink: "TENANTS",
                    children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-24", children: [
                      /* @__PURE__ */ e.jsx("p", { className: "m-0", children: "A tenant represents an organization or team you deliver software to using Devtron." }),
                      /* @__PURE__ */ e.jsx("p", { className: "m-0", children: "A tenant can have multiple installations of your software. Relevant environments can be mapped to each tenant installation." })
                    ] })
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  ug,
                  {
                    tenantInput: r,
                    tenantInputErrors: c,
                    handleTenantInputChange: E,
                    imageFieldInfo: m,
                    isEditMode: a
                  }
                )
              ] })
            }
          )
        ] }),
        !u && !h && /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-end dc__no-shrink px-20 py-16 dc__gap-12 dc__border-top", children: [
          /* @__PURE__ */ e.jsx(
            "button",
            {
              className: "cta secondary flex h-36",
              type: "button",
              onClick: s,
              "data-testid": "cancel-upsert-tenant",
              disabled: l,
              children: He.CANCEL
            }
          ),
          /* @__PURE__ */ e.jsx($e, { condition: g, wrap: tl, children: /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center", children: /* @__PURE__ */ e.jsx(
            Ws,
            {
              rootClassName: "cta flex h-36",
              type: "button",
              onClick: v,
              "data-testid": "save-upsert-tenant-changes",
              disabled: g || l,
              isLoading: l,
              children: He.CTA
            }
          ) }) })
        ] })
      ]
    }
  ) });
}, _g = ({ handleClose: s, handleSuccess: t, tenantId: n, name: a }) => {
  const l = async () => {
    await qf(n), t();
  };
  return /* @__PURE__ */ e.jsx(
    Gt,
    {
      title: a,
      onDelete: l,
      subtitle: "Deleting a tenant will delete all the information added to it.",
      closeConfirmationModal: s,
      confirmationConfig: {
        identifier: "delete-tenant-confirmation",
        confirmationKeyword: a
      },
      successToastMessage: "Tenant deleted successfully"
    }
  );
}, ni = ({
  tenantId: s,
  name: t,
  handleSuccess: n,
  openTenantEditModal: a
}) => {
  const [l, o] = T(!1), r = () => {
    o(!0);
  }, i = () => {
    o(!1);
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs(It, { autoPosition: !0, autoClose: !0, children: [
      /* @__PURE__ */ e.jsx(
        It.Button,
        {
          isKebab: !0,
          rootClassName: "icon-dim-20 dc__no-shrink p-0 dc__no-background dc__no-border dc__outline-none-imp flex dc__tab-focus dc__hover-n50",
          dataTestId: `edit-${t}-options-button`,
          children: /* @__PURE__ */ e.jsx(ol, { className: "flex icon-dim-16 dc__no-shrink icon-color-n6" })
        }
      ),
      /* @__PURE__ */ e.jsxs(It.Body, { rootClassName: "br-4 py-4 dc__overflow-hidden dc__border dc__box-shadow--menu", children: [
        /* @__PURE__ */ e.jsxs(
          "button",
          {
            type: "button",
            "aria-label": `edit ${t}`,
            "data-testid": `edit-${t}-name`,
            className: "flexbox dc__transparent dc__hover-n50 dc__align-items-center py-6 px-8 w-100 dc__gap-8",
            onClick: a,
            children: [
              /* @__PURE__ */ e.jsx(Ys, { className: "icon-dim-16 dc__no-shrink scn-6" }),
              /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "Edit tenant" })
            ]
          }
        ),
        /* @__PURE__ */ e.jsxs(
          "button",
          {
            type: "button",
            "aria-label": `delete ${t}`,
            "data-testid": `delete-${t}`,
            className: "flexbox dc__transparent dc__hover-n50 dc__align-items-center py-6 px-8 w-100 dc__gap-8",
            onClick: r,
            children: [
              /* @__PURE__ */ e.jsx(Wt, { className: "icon-dim-16 scr-5 dc__no-shrink" }),
              /* @__PURE__ */ e.jsx("span", { className: "cr-5 fs-13 fw-4 lh-20", children: "Delete tenant" })
            ]
          }
        )
      ] })
    ] }),
    l && /* @__PURE__ */ e.jsx(
      _g,
      {
        tenantId: s,
        name: t,
        handleClose: i,
        handleSuccess: n
      }
    )
  ] });
}, ai = vt(null), hg = ({ value: s, children: t }) => /* @__PURE__ */ e.jsx(ai.Provider, { value: s, children: t }), ss = () => {
  const s = Ct(ai);
  if (!s)
    throw new Error("Wrap with TenantDetailProvider");
  return s;
}, fg = () => {
  const s = fe(), { params: t, url: n } = gs(), { tenantId: a, name: l } = ss(), o = { label: l, value: a }, r = (p) => {
    if (p.value === a) return;
    const u = s.location.pathname.replace(n, "").split("/")[1], _ = W(D.TENANT_DETAIL, {
      ...t,
      tenantId: p.value
    });
    Rr({
      category: "Tenant Selector",
      action: oo.SDH_SWITCH_TENANTS_ITEM_CLICKED
    }), s.push(`${_}/${u}`);
  }, [i, c, d, m] = K(() => Gf(), [a]);
  return /* @__PURE__ */ e.jsx(
    wr,
    {
      options: c ?? [],
      onChange: r,
      value: o,
      inputId: `tenant-switcher-${a}`,
      isLoading: i,
      optionListError: d,
      reloadOptionList: m,
      resource: "Tenant"
    }
  );
}, gg = ({ openTenantEditModal: s }) => {
  const t = Te(), { push: n } = fe(), { tenantId: a, name: l } = ss(), { breadcrumbs: o } = ta({
    alias: {
      ..._a(),
      tenants: {
        component: /* @__PURE__ */ e.jsx(Et, { heading: "Tenants" }),
        linked: !0
      },
      detail: {
        component: null
      },
      ":tenantId": {
        component: /* @__PURE__ */ e.jsx(fg, {})
      }
    }
  }), r = () => {
    n(D.TENANTS);
  }, i = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12 dc__align-items-center", children: [
    /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center", children: /* @__PURE__ */ e.jsx(Xa, { breadcrumbs: o }) }),
    /* @__PURE__ */ e.jsx(
      ni,
      {
        tenantId: a,
        name: l,
        handleSuccess: r,
        openTenantEditModal: s
      }
    )
  ] }), c = (p) => W(p, {
    ...t
  }), d = [
    {
      id: "tenants-overview-tab",
      tabType: "navLink",
      label: "Overview",
      props: {
        to: c(D.TENANT_DETAIL_OVERVIEW),
        "data-testid": "Tenant-Overview-click",
        "data-action": "Tenant Overview Clicked"
      }
    },
    {
      id: "tenants-installations-tab",
      tabType: "navLink",
      label: "Installations",
      props: {
        to: c(D.TENANT_DETAIL_INSTALLATIONS),
        "data-testid": "Installations-click",
        "data-action": "Installations Clicked"
      }
    }
  ], m = () => /* @__PURE__ */ e.jsx(Ir, { tabs: d, hideTopPadding: !0 });
  return /* @__PURE__ */ e.jsx(
    na,
    {
      showTabs: !0,
      renderHeaderTabs: m,
      isBreadcrumbs: !0,
      breadCrumbs: i,
      docPath: aa.SOFTWARE_DISTRIBUTION_HUB
    }
  );
};
var mt = /* @__PURE__ */ ((s) => (s.name = "name", s.subscribedInstallationCount = "subscribedInstallationCount", s))(mt || {});
const xg = Array.from(Array(3).keys()).map((s) => ({
  channelId: `channel-${s}`,
  description: "Description",
  name: `channel name ${s}`,
  subscribedInstallations: [],
  subscribedInstallationsCount: 0,
  isDefault: s === 1
})), Ol = {
  channelId: "",
  name: "",
  description: "",
  isDefault: !1
};
var Ps = /* @__PURE__ */ ((s) => (s.updateName = "updateName", s.updateChannelId = "updateChannelId", s.updateDescription = "updateDescription", s.toggleIsDefault = "toggleIsDefault", s))(Ps || {});
const li = ({
  handleClose: s,
  handleSuccess: t,
  releaseChannelConfig: n
}) => {
  const { name: a, description: l, channelId: o, isDefault: r } = n, i = !!n?.channelId, [c, d] = T(
    structuredClone(Ol)
  ), [m, p] = T({
    description: null,
    ...i ? {
      name: null,
      channelId: null
    } : {
      name: "",
      channelId: ""
    }
  }), [u, _] = T(!1), h = q(
    () => Object.values(m).filter((E) => !$n(E)).length > 0,
    [m]
  );
  ee(() => {
    n && d({
      name: a,
      channelId: o,
      isDefault: r,
      description: l
    });
  }, [n]);
  const f = async (E) => {
    if (E.preventDefault(), h) {
      ae.showToast({
        variant: le.error,
        description: ot
      });
      return;
    }
    _(!0);
    const v = {
      name: c.name,
      channelId: c.channelId,
      isDefault: c.isDefault,
      description: c.description.trim()
    };
    try {
      await (i ? of(v) : cf(v)), ae.showToast({
        variant: le.success,
        description: `Release channel ${i ? "updated" : "created"} successfully`
      }), _(!1), t(), s();
    } catch (x) {
      U(x), _(!1);
    }
  }, g = ({ action: E, value: v }) => {
    const x = structuredClone(c), N = structuredClone(m);
    switch (E) {
      case Ps.updateName:
        x.name = v, N.name = cn(v).message;
        break;
      case Ps.updateChannelId:
        x.channelId = v, N.channelId = mn(v).message;
        break;
      case Ps.toggleIsDefault: {
        x.isDefault = !x.isDefault;
        break;
      }
      case Ps.updateDescription:
        x.description = v, N.description = oa(v.trim()).message;
        break;
      default:
        throw new Error(`Action ${E} is not supported`);
    }
    d(x), p(N);
  }, b = (E) => (v) => {
    g({ action: E, value: v.target.value });
  }, j = () => {
    g({ action: Ps.toggleIsDefault });
  };
  return /* @__PURE__ */ e.jsx(Nn, { className: "visible-modal__body", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox bg__primary w-800 h-500 dc__m-auto mt-40 dc__border-radius-8-imp dc__overflow-hidden", children: [
    /* @__PURE__ */ e.jsx(
      vn,
      {
        rootClassName: "pl-24 pr-24 pt-24 pb-24 dc__no-shrink",
        heading: "Release Channel",
        icon: /* @__PURE__ */ e.jsx(td, { className: "dc__no-shrink icon-dim-40" }),
        documentationLink: "DOC_HOME_PAGE",
        children: /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-24", children: /* @__PURE__ */ e.jsx("p", { className: "m-0", children: "Release channel is way to be subscribed by one or group of tenant (installation) for easy management (such as bulk deployments, user access management etc)." }) })
      }
    ),
    /* @__PURE__ */ e.jsxs("form", { className: "flexbox-col flex-grow-1 h-100", onSubmit: f, noValidate: !0, children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 py-24 px-20 dc__gap-16", children: [
        /* @__PURE__ */ e.jsx(
          Fe,
          {
            name: "release-channel-name",
            value: c.name,
            label: "Release channel display name",
            placeholder: "Eg. Acme Inc.",
            onChange: b(Ps.updateName),
            required: !0,
            fullWidth: !0,
            error: m.name,
            autoFocus: !0
          }
        ),
        /* @__PURE__ */ e.jsx(
          Fe,
          {
            name: "release-channel-id",
            value: c.channelId,
            label: "Release channel ID",
            placeholder: "Eg. acme-inc",
            onChange: b(
              Ps.updateChannelId
            ),
            required: !0,
            error: m.channelId,
            disabled: i,
            helperText: "This is a unique identifier for a release channel. It cannot be changed once set."
          }
        ),
        /* @__PURE__ */ e.jsx(
          jn,
          {
            label: "Description",
            name: "release-channel-description",
            placeholder: "Write a description for this release channel",
            value: c.description,
            onChange: b(
              Ps.updateDescription
            ),
            error: m.description
          }
        ),
        /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom-n1" }),
        /* @__PURE__ */ e.jsx("div", { className: "flex left", children: /* @__PURE__ */ e.jsx(
          js,
          {
            isChecked: c.isDefault,
            onChange: j,
            value: Oe.CHECKED,
            rootClassName: "mb-0 dc__align-self-start dc__no-shrink",
            children: /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-20 cn-9", children: "Set as default release channel" })
          }
        ) })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox flex-justify-end dc__gap-12 p-lr-20 pt-20 pb-20", children: [
        /* @__PURE__ */ e.jsx(
          "button",
          {
            type: "button",
            className: "flex cta secondary h-36 fs-13 fw-6 lh-20-imp",
            disabled: u,
            onClick: s,
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ e.jsx($e, { condition: h, wrap: tl, children: /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center", children: /* @__PURE__ */ e.jsx(
          Ws,
          {
            isLoading: u,
            type: "submit",
            rootClassName: "flex cta h-36 fs-13 fw-6 lh-20-imp",
            disabled: u || h,
            children: "Save"
          }
        ) }) })
      ] })
    ] })
  ] }) });
};
var Fs = /* @__PURE__ */ ((s) => (s.updateName = "updateName", s.updateInstallationId = "updateInstallationId", s.toggleShouldSubscribeToReleaseChannel = "toggleShouldSubscribeToReleaseChannel", s.updateReleaseChannel = "updateReleaseChannel", s))(Fs || {});
const bg = {
  installationId: "",
  name: "",
  releaseChannelId: null
}, Eg = {
  name: null,
  installationId: null,
  releaseChannelId: null
}, Ng = {
  name: "",
  installationId: "",
  releaseChannelId: null
}, jg = ({
  handleClose: s,
  handleSuccess: t,
  installationConfig: n
}) => {
  const [a, l] = T(!1), o = Ye(), { image: r, name: i, tenantId: c } = ss(), [d, m, , p] = K(
    () => Ea()
  ), { installationId: u, name: _, releaseChannelId: h } = n, f = !!u, [g, b] = T(
    structuredClone(bg)
  ), [j, E] = T(
    structuredClone(
      f ? Eg : Ng
    )
  ), [v, x] = T(!1), N = q(
    () => Object.values(j).filter((L) => !$n(L)).length > 0 || d,
    [j, d]
  ), y = (m ?? []).map(({ name: L, channelId: F }) => ({
    label: L,
    value: F,
    startIcon: /* @__PURE__ */ e.jsx(Pa, {})
  })), C = !$n(g.releaseChannelId);
  ee(() => {
    n && b({
      name: _,
      installationId: u,
      releaseChannelId: h
    });
  }, [n]);
  const S = async (L) => {
    if (L.preventDefault(), N) {
      ae.showToast({
        variant: le.error,
        description: ot
      });
      return;
    }
    x(!0);
    const F = {
      name: g.name,
      installationId: g.installationId,
      tenantId: c,
      releaseChannelId: g.releaseChannelId
    };
    try {
      await (f ? Xf(F) : eg(F)), ae.showToast({
        variant: le.success,
        description: `Installation ${f ? "updated" : "created"} successfully`
      }), x(!1), t(), s();
    } catch (M) {
      U(M), x(!1);
    }
  }, I = (L, F) => {
    const M = structuredClone(g), Y = structuredClone(j);
    switch (L) {
      case Fs.updateName:
        M.name = F, Y.name = cn(F).message;
        break;
      case Fs.updateInstallationId:
        M.installationId = F, Y.installationId = mn(F).message;
        break;
      case Fs.toggleShouldSubscribeToReleaseChannel: {
        const O = C ? null : "";
        M.releaseChannelId = O, Y.releaseChannelId = O;
        break;
      }
      case Fs.updateReleaseChannel:
        M.releaseChannelId = F, Y.releaseChannelId = null;
        break;
      default:
        throw new Error(`Action ${L} is not supported`);
    }
    b(M), E(Y);
  }, w = (L) => {
    I(Fs.updateName, L.target.value);
  }, k = (L) => {
    I(Fs.updateInstallationId, L.target.value);
  }, R = () => {
    I(Fs.toggleShouldSubscribeToReleaseChannel, null);
  }, B = (L) => {
    I(Fs.updateReleaseChannel, L.value);
  }, P = () => {
    l((L) => (L || o.current.blur(), !L));
  };
  return /* @__PURE__ */ e.jsx(Ut, { className: "visible-modal__body", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox bg__primary w-800 h-500 dc__m-auto mt-40 dc__border-radius-8-imp dc__overflow-hidden", children: [
    /* @__PURE__ */ e.jsx(
      vn,
      {
        rootClassName: "pl-24 pr-24 pt-24 pb-24 dc__no-shrink",
        heading: "Installation",
        icon: /* @__PURE__ */ e.jsx(nd, { className: "dc__no-shrink icon-dim-40" }),
        documentationLink: "TENANTS_INSTALLATION",
        children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-24", children: [
          /* @__PURE__ */ e.jsx("p", { className: "m-0", children: "A tenant can have multiple installations of your software." }),
          /* @__PURE__ */ e.jsx("p", { className: "m-0", children: "An installation represents a deployment of your software across one or more environments of a tenant." })
        ] })
      }
    ),
    /* @__PURE__ */ e.jsxs("form", { className: "flexbox-col flex-grow-1 h-100", onSubmit: S, children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 py-24 px-20 dc__gap-16", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
            /* @__PURE__ */ e.jsx("span", { className: "form__label dc__required-field", children: "Tenant" }),
            /* @__PURE__ */ e.jsxs("div", { className: "dc__border br-4 bg__primary h-36 w-150 p-8 flex dc__content-start dc__gap-8 cursor-not-allowed", children: [
              /* @__PURE__ */ e.jsx(
                is,
                {
                  imageProps: {
                    src: r,
                    alt: `Logo for tenant: ${i}`,
                    height: 20,
                    width: 20,
                    loading: "lazy"
                  }
                }
              ),
              /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-20 cn-9 dc__truncate", children: i })
            ] })
          ] }),
          /* @__PURE__ */ e.jsx("span", { className: "flexbox-col fs-20 fw-4 lh-36 pt-24", children: "/" }),
          /* @__PURE__ */ e.jsx(
            Fe,
            {
              fullWidth: !0,
              name: "installation-name",
              value: g.name,
              label: "Installation display name",
              placeholder: "Eg. Production",
              onChange: w,
              required: !0,
              error: j.name,
              autoFocus: !0
            }
          )
        ] }),
        /* @__PURE__ */ e.jsx(
          Fe,
          {
            name: "installation-id",
            value: g.installationId,
            label: "Installation ID",
            placeholder: "Eg. acme-prod",
            onChange: k,
            required: !0,
            error: j.installationId,
            disabled: f,
            helperText: "This cannot be changed later."
          }
        ),
        /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom-n1 w-100" }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-8", children: [
          /* @__PURE__ */ e.jsx(
            js,
            {
              isChecked: C,
              onChange: R,
              value: Oe.CHECKED,
              rootClassName: "mb-0 w-20 p-2 dc__align-self-start dc__no-shrink",
              id: "subscribe-to-release-channel"
            }
          ),
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
            /* @__PURE__ */ e.jsxs("label", { htmlFor: "subscribe-to-release-channel", className: "m-0 fw-4 flexbox-col cursor", children: [
              /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-20 cn-9", children: "Subscribe to a release channel" }),
              /* @__PURE__ */ e.jsx("span", { className: "fs-12 fw-4 lh-18 cn-7", children: "For easy management (such as bulk deployments, user access management etc), subscribe to a release channel." })
            ] }),
            C && /* @__PURE__ */ e.jsx(
              st,
              {
                inputId: "subscribe-release-channel",
                options: y,
                value: y.find(
                  (L) => L.value === g.releaseChannelId
                ) ?? null,
                required: !0,
                placeholder: "Select a release channel to subscribe",
                onChange: B,
                isDisabled: d,
                isLoading: d,
                icon: /* @__PURE__ */ e.jsx(Pa, {}),
                showSelectedOptionIcon: !1,
                menuListFooterConfig: {
                  type: "button",
                  buttonProps: {
                    variant: _e.borderLess,
                    text: "Create Release Channel",
                    startIcon: /* @__PURE__ */ e.jsx(Me, { name: "ic-add", color: null }),
                    onClick: P,
                    dataTestId: "create-release-channel"
                  }
                },
                selectRef: o
              }
            )
          ] })
        ] })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox flex-justify-end dc__gap-12 p-lr-20 pt-20 pb-20", children: [
        /* @__PURE__ */ e.jsx(
          "button",
          {
            type: "button",
            className: "flex cta secondary h-36 fs-13 fw-6 lh-20-imp",
            disabled: v,
            onClick: s,
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ e.jsx($e, { condition: N, wrap: tl, children: /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center", children: /* @__PURE__ */ e.jsx(
          Ws,
          {
            isLoading: v,
            type: "submit",
            rootClassName: "flex cta h-36 fs-13 fw-6 lh-20-imp",
            disabled: v || N,
            children: "Save"
          }
        ) }) })
      ] })
    ] }),
    a && /* @__PURE__ */ e.jsx(
      li,
      {
        handleClose: P,
        handleSuccess: p,
        releaseChannelConfig: structuredClone(Ol)
      }
    )
  ] }) });
};
var ns = /* @__PURE__ */ ((s) => (s.environment = "environment", s.namespace = "namespace", s.environmentType = "environmentType", s.cluster = "cluster", s))(ns || {});
const vg = Array.from(
  Array(3).keys()
).map((s) => ({
  id: s,
  name: `env-${s}`,
  namespace: "",
  environmentType: Ot.nonProduction,
  cluster: "",
  isVirtual: !1
})), Cg = ({
  isInstallationLoading: s,
  environments: t = [],
  renderMapEnvButton: n
}) => {
  const { sortBy: a, sortOrder: l, searchKey: o, handleSearch: r, clearFilters: i, handleSorting: c } = ds({
    initialSortKey: ns.environment
  }), d = q(() => t ? (o.toLowerCase() ? t.filter(
    (j) => j.name.toLowerCase().includes(o) || j.namespace.toLowerCase().includes(o) || j.cluster.toLowerCase().includes(o)
  ) : structuredClone(t)).sort((j, E) => {
    switch (a) {
      case ns.namespace:
        return te(j.namespace, E.namespace, l);
      case ns.environmentType:
        return te(j.environmentType, E.environmentType, l);
      case ns.cluster:
        return te(j.cluster, E.cluster, l);
      default:
        return te(j.name, E.name, l);
    }
  }) : [], [t, o, a, l]), m = (g) => {
    r(g);
  }, p = () => {
    c(ns.environment);
  }, u = () => {
    c(ns.namespace);
  }, _ = () => {
    c(ns.environmentType);
  }, h = () => {
    c(ns.cluster);
  }, f = () => s ? vg.map((g) => /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "display-grid dc__column-gap-16 tenants__installation-env-row fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-20 show-shimmer-loading",
      children: [
        /* @__PURE__ */ e.jsx("span", { className: "child-shimmer-loading" }),
        /* @__PURE__ */ e.jsx("span", { className: "child-shimmer-loading" }),
        /* @__PURE__ */ e.jsx("span", { className: "child-shimmer-loading" }),
        /* @__PURE__ */ e.jsx("span", { className: "child-shimmer-loading" }),
        /* @__PURE__ */ e.jsx("span", { className: "child-shimmer-loading" })
      ]
    },
    `env-list-loading-${g.name}-${g.cluster}`
  )) : d.length ? d.map(({ name: g, namespace: b, environmentType: j, cluster: E, isVirtual: v }) => /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "display-grid dc__column-gap-16 tenants__installation-env-row fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-20",
      children: [
        /* @__PURE__ */ e.jsx(il, { className: "icon-dim-24 dc__no-shrink" }),
        /* @__PURE__ */ e.jsx(
          "span",
          {
            className: "dc__truncate",
            dangerouslySetInnerHTML: {
              __html: us.sanitize(
                _s({
                  searchText: o,
                  text: g,
                  highlightClasses: "bcy-2"
                })
              )
            }
          }
        ),
        /* @__PURE__ */ e.jsx(
          "span",
          {
            className: "dc__truncate",
            dangerouslySetInnerHTML: {
              __html: us.sanitize(
                _s({
                  searchText: o,
                  text: b,
                  highlightClasses: "bcy-2"
                })
              )
            }
          }
        ),
        /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: v ? "-" : j }),
        /* @__PURE__ */ e.jsx(
          "span",
          {
            className: "dc__truncate",
            dangerouslySetInnerHTML: {
              __html: us.sanitize(
                _s({
                  searchText: o,
                  text: E,
                  highlightClasses: "bcy-2"
                })
              )
            }
          }
        )
      ]
    },
    g
  )) : /* @__PURE__ */ e.jsx(yt, { classname: "flex-grow-1", handleClearFilters: i });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space dc__gap-16 px-20 py-16", children: [
      /* @__PURE__ */ e.jsx(
        qs,
        {
          inputProps: {
            placeholder: "Search",
            disabled: s
          },
          handleEnter: m,
          initialSearchText: o,
          containerClassName: "w-250"
        }
      ),
      n()
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "display-grid dc__column-gap-16 tenants__installation-env-row tenants__installation-env-row--header dc__border-bottom-n1 fs-12 fw-6 lh-20 cn-7 dc__align-items-center px-20 dc__uppercase", children: [
        /* @__PURE__ */ e.jsx("span", {}),
        /* @__PURE__ */ e.jsx(
          Z,
          {
            disabled: s,
            isSorted: a === ns.environment,
            sortOrder: l,
            title: "Environment",
            triggerSorting: p
          }
        ),
        /* @__PURE__ */ e.jsx(
          Z,
          {
            disabled: s,
            isSorted: a === ns.namespace,
            sortOrder: l,
            title: "Namespace",
            triggerSorting: u
          }
        ),
        /* @__PURE__ */ e.jsx(
          Z,
          {
            disabled: s,
            isSorted: a === ns.environmentType,
            sortOrder: l,
            title: "Environment Type",
            triggerSorting: _
          }
        ),
        /* @__PURE__ */ e.jsx(
          Z,
          {
            disabled: s,
            isSorted: a === ns.cluster,
            sortOrder: l,
            title: "Cluster",
            triggerSorting: h
          }
        )
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1 dc__overflow-auto", children: f() })
    ] })
  ] });
};
var St = /* @__PURE__ */ ((s) => (s.uploadManifestToOCI = "uploadManifestToOCI", s.downloadManifestToLocal = "downloadManifestToLocal", s))(St || {});
const yg = {
  pushToRemote: !1,
  dockerRegistryId: null,
  repository: ""
}, Tg = {
  pushToRemote: null,
  dockerRegistryId: null,
  repository: null
}, Sg = async () => {
  const { result: s } = await xe("docker/registry");
  return s ? s.filter(
    ({ active: t, isOCICompliantRegistry: n, ociRegistryConfig: a }) => t && n && ["PUSH", "PULL/PUSH"].includes(a?.CHART)
  ).map(({ id: t, registryType: n }) => ({
    label: t,
    value: t,
    startIcon: /* @__PURE__ */ e.jsx(Mt, { registryType: n })
  })) : [];
}, wg = async ({
  tenantId: s,
  installationId: t,
  shouldAddTimeStamp: n
}) => {
  const a = window.location.origin, l = Yt({
    tenantId: s,
    installationId: t
  }), o = (/* @__PURE__ */ new Date()).getTime(), { result: r } = await Ue("api-token", {
    name: `${l}${n ? `-${o}` : ""}`,
    description: `API Token for isolated installation with identifier: ${l}`,
    expireAtInMs: 0
  });
  await Ue($.USER, {
    id: r.userId,
    email_id: r.userIdentifier,
    userRoleGroups: [],
    superAdmin: !1,
    roleFilters: [],
    userStatus: _c.active,
    userGroups: []
  });
  const i = ge({
    baseUrl: $.RESOURCE,
    kind: G.installation,
    version: ne.alpha1
  }), c = {
    identifier: l,
    query: [
      {
        op: he.replace,
        path: "tokenId",
        value: r.id
      },
      {
        op: he.replace,
        path: "hostName",
        value: a
      }
    ]
  };
  return Ls(i, c);
};
var ut = /* @__PURE__ */ ((s) => (s.updatePushToRemote = "updatePushToRemote", s.updateRegistry = "updateRegistry", s.updateRepository = "updateRepository", s))(ut || {});
const Rg = ({
  handleClose: s,
  handleSuccess: t,
  installationId: n,
  deploymentConfig: a
}) => {
  const { tenantId: l } = ss(), [o, r] = K(() => Sg()), [i, c] = T(
    structuredClone(yg)
  ), [d, m] = T(
    structuredClone(Tg)
  ), [p, u] = T(!1), _ = q(
    () => o || Object.values(d).filter((N) => !$n(N)).length > 0,
    [d, o]
  ), { dockerRegistryId: h, pushToRemote: f, repository: g } = a ?? {};
  ee(() => {
    a && c({
      dockerRegistryId: h,
      pushToRemote: f,
      repository: g
    });
  }, [a]);
  const b = async (N) => {
    if (N.preventDefault(), _) {
      ae.showToast({
        variant: le.error,
        description: ot
      });
      return;
    }
    u(!0);
    const y = {
      installationId: n,
      tenantId: l,
      repository: i.repository,
      dockerRegistryId: i.dockerRegistryId,
      pushToRemote: i.pushToRemote
    };
    try {
      await Zf(y), ae.showToast({
        variant: le.success,
        description: "Isolated deployment settings updated successfully"
      }), u(!1), t(), s();
    } catch (C) {
      U(C), u(!1);
    }
  }, j = ({ action: N, value: y }) => {
    const C = structuredClone(i), S = structuredClone(d);
    switch (N) {
      case ut.updatePushToRemote:
        C.pushToRemote = y, y ? (S.dockerRegistryId = C.dockerRegistryId ? null : "", S.repository = Gl(C.repository).isValid ? null : "") : (S.dockerRegistryId = null, S.repository = null);
        break;
      case ut.updateRegistry:
        C.dockerRegistryId = y, S.dockerRegistryId = y ? null : "This field is required";
        break;
      case ut.updateRepository: {
        C.repository = y, S.repository = Gl(y).message;
        break;
      }
      default:
        throw new Error(`Action ${N} is not supported`);
    }
    c(C), m(S);
  }, E = (N) => {
    j({
      action: ut.updatePushToRemote,
      value: N.target.value === St.uploadManifestToOCI
    });
  }, v = (N) => {
    j({
      action: ut.updateRegistry,
      value: N.value
    });
  }, x = (N) => {
    j({
      action: ut.updateRepository,
      value: N.target.value
    });
  };
  return /* @__PURE__ */ e.jsx(Nn, { className: "visible-modal__body", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col bg__primary w-600 dc__m-auto mt-40 dc__border-radius-8-imp", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-8 dc__content-space dc__border-bottom py-12 px-16", children: [
      /* @__PURE__ */ e.jsx("h2", { className: "fs-16 fw-6 lh-24 cn-9 m-0", children: "Release orchestration manifest delivery" }),
      /* @__PURE__ */ e.jsx(
        "button",
        {
          type: "button",
          "aria-label": "close modal",
          onClick: s,
          className: "dc__transparent p-4 flex dc__no-shrink",
          children: /* @__PURE__ */ e.jsx(ys, { className: "fcn-6 icon-dim-16" })
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx(
      cs,
      {
        description: "A release orchestration manifest is generated when a release is triggered for an isolated tenant installation.",
        borderConfig: { top: !1, left: !1, right: !1 },
        borderRadiusConfig: { top: !1, left: !1, right: !1, bottom: !1 }
      }
    ),
    /* @__PURE__ */ e.jsxs("form", { className: "flexbox-col flex-grow-1", onSubmit: b, children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 p-20 dc__gap-12", children: [
        /* @__PURE__ */ e.jsx("h3", { className: "fs-13 fw-6 lh-20 cn-9 m-0", children: "How do you want to deliver the manifest?" }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
          /* @__PURE__ */ e.jsx(
            En,
            {
              name: "push-to-remote",
              value: i.pushToRemote ? St.uploadManifestToOCI : St.downloadManifestToLocal,
              disabled: !1,
              onChange: E,
              className: "radio-group-no-border w-100",
              children: /* @__PURE__ */ e.jsxs("div", { className: "flex column dc__gap-8 left", children: [
                /* @__PURE__ */ e.jsx($s, { value: St.downloadManifestToLocal, children: "Download manifest to local machine" }),
                /* @__PURE__ */ e.jsx($s, { value: St.uploadManifestToOCI, children: "Upload manifest to OCI registry" })
              ] })
            }
          ),
          i.pushToRemote && /* @__PURE__ */ e.jsxs("div", { className: "pl-28 flex left top dc__gap-12", children: [
            /* @__PURE__ */ e.jsx("div", { className: "w-200", children: /* @__PURE__ */ e.jsx(
              st,
              {
                inputId: "docker-registry",
                options: r,
                value: r?.find(
                  (N) => N.value === i.dockerRegistryId
                ) ?? null,
                error: d.dockerRegistryId,
                placeholder: "Select registry",
                label: "Registry",
                required: !0,
                menuPosition: "absolute",
                isLoading: o,
                isDisabled: o || p,
                onChange: v,
                size: oe.large
              }
            ) }),
            /* @__PURE__ */ e.jsx(
              Fe,
              {
                name: "repository",
                value: i.repository,
                onChange: x,
                label: "Repository (desired format: username/repo-name)",
                required: !0,
                placeholder: "Enter repository name",
                error: d.repository
              }
            )
          ] })
        ] })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox flex-justify-end dc__gap-12 p-16 dc__border-top", children: [
        /* @__PURE__ */ e.jsx(
          ie,
          {
            text: "Cancel",
            variant: _e.secondary,
            style: qe.neutral,
            disabled: p,
            onClick: s,
            dataTestId: "close-manifest-modal"
          }
        ),
        /* @__PURE__ */ e.jsx(
          ie,
          {
            text: "Save",
            disabled: p || _,
            isLoading: p,
            onClick: b,
            dataTestId: "save-manifest",
            showTooltip: _,
            tooltipProps: {
              content: "Valid input is required for all mandatory fields."
            }
          }
        )
      ] })
    ] })
  ] }) });
}, Ig = () => /* @__PURE__ */ e.jsxs("div", { className: "fs-13 fw-4 lh-20 cn-9", children: [
  /* @__PURE__ */ e.jsx("div", { children: "Devtron enables you to distribute software to your customers even when their Kubernetes clusters are not directly connected to Devtron." }),
  /* @__PURE__ */ e.jsxs("div", { className: "mt-20", children: [
    "For such software distribution, Devtron at your infrastructure pushes the following artifacts to OCI registry:",
    /* @__PURE__ */ e.jsxs("ul", { children: [
      /* @__PURE__ */ e.jsxs("li", { children: [
        /* @__PURE__ */ e.jsx("span", { className: "fw-6", children: "Helm packages" }),
        " for each deployment stage"
      ] }),
      /* @__PURE__ */ e.jsxs("li", { children: [
        /* @__PURE__ */ e.jsx("span", { className: "fw-6", children: "A release orchestration manifest" }),
        " (containing instructions & references to respective Helm charts for each deployment stage)"
      ] })
    ] })
  ] }),
  /* @__PURE__ */ e.jsx("div", { className: "mt-20", children: "A deployment agent, installed in the customer's infrastructure, pulls artifacts & executes the installation by applying the manifest." })
] }), Ag = ({
  installationDetail: s,
  refetchInstallationDetail: t,
  toggleIsolatedDeploymentConfigModal: n
}) => {
  const [a, l] = T(!1), [o, r] = T(!1), [i, c] = T(!1), { tenantId: d, name: m } = ss();
  if (!s || !ul(s.environments))
    return null;
  const { deploymentConfig: p, name: u, installationId: _ } = s, h = () => {
    r((b) => !b);
  }, f = () => {
    l((b) => !b);
  }, g = (b = !1) => async () => {
    try {
      c(!0), await wg({
        tenantId: d,
        installationId: _,
        shouldAddTimeStamp: !b
      }), t(), ae.showToast({
        variant: le.success,
        description: "Authentication token generated"
      }), c(!1);
    } catch (j) {
      b ? await g(!1)() : (U(j), c(!1));
    }
  };
  return /* @__PURE__ */ e.jsxs("aside", { className: "w-320 dc__border-left-n1 flexbox-col dc__gap-16 flex-grow-1 bg__primary p-20 dc__no-shrink", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-6", children: [
      /* @__PURE__ */ e.jsx("h3", { className: "fs-16 fw-6 lh-24 cn-9 m-0", children: "Isolated delivery configurations" }),
      /* @__PURE__ */ e.jsx(
        Cn,
        {
          className: "icon-dim-20 fcn-6 dc__no-shrink cursor",
          onClick: h
        }
      )
    ] }),
    p ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space dc__gap-4", children: [
          /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-20 cn-9", children: "Release manifest delivery" }),
          /* @__PURE__ */ e.jsx(
            ie,
            {
              text: "Change",
              size: oe.medium,
              variant: _e.text,
              dataTestId: "change-deployment-config",
              onClick: n
            }
          )
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 dc__border-left-n1 pl-12", children: [
          p.pushToRemote ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 w-100", children: [
            /* @__PURE__ */ e.jsx("div", { children: "Release orchestration manifest will be pushed to the below OCI repository." }),
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
              /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4 fs-13 fw-4 lh-20 cn-9", children: [
                /* @__PURE__ */ e.jsx("span", { className: "cn-7", children: "Registry" }),
                /* @__PURE__ */ e.jsxs("span", { className: "flex left dc__gap-6", children: [
                  /* @__PURE__ */ e.jsx(Mt, { registryType: p.dockerRegistryType }),
                  /* @__PURE__ */ e.jsx(
                    xt,
                    {
                      content: p.dockerRegistryId,
                      showOnTruncate: !!p.dockerRegistryId,
                      className: "mxh-250 dc__overflow-auto",
                      interactive: !0,
                      children: /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: p.dockerRegistryId || "-" })
                    }
                  )
                ] })
              ] }),
              /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4 fs-13 fw-4 lh-20 cn-9", children: [
                /* @__PURE__ */ e.jsx("span", { className: "cn-7", children: "Repository" }),
                /* @__PURE__ */ e.jsxs("span", { className: "flex left dc__gap-6", children: [
                  /* @__PURE__ */ e.jsx(Xc, { className: "icon-dim-20 dc__no-shrink" }),
                  /* @__PURE__ */ e.jsx(
                    xt,
                    {
                      content: p.repository,
                      showOnTruncate: !!p.repository,
                      className: "mxh-250 dc__overflow-auto",
                      interactive: !0,
                      children: /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: p.repository || "-" })
                    }
                  )
                ] })
              ] })
            ] })
          ] }) : /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-4 lh-20 cn-9", children: "Release orchestration manifest can be downloaded on every release trigger." }),
          /* @__PURE__ */ e.jsxs("div", { className: "flex column left dc__gap-4 fs-12 fw-4 lh-18 cn-7", children: [
            /* @__PURE__ */ e.jsx(
              ie,
              {
                text: "How to deliver manifest to tenant",
                variant: _e.text,
                size: oe.small,
                dataTestId: "manifest-delivery-description",
                endIcon: /* @__PURE__ */ e.jsx(
                  tt,
                  {
                    className: `dc__transition--transform ${a ? "dc__flip-180" : ""}`
                  }
                ),
                onClick: f
              }
            ),
            a && /* @__PURE__ */ e.jsxs("div", { children: [
              /* @__PURE__ */ e.jsx("span", { children: p.pushToRemote ? "Add this OCI registry & repository to your deployment agent to pull and apply release orchestration manifest for new release versions." : "Release orchestration manifest can be shared offline or by any medium of your choice." }),
              " ",
              /* @__PURE__ */ e.jsx(
                "a",
                {
                  className: "anchor",
                  target: "_blank",
                  href: hc,
                  rel: "noreferrer",
                  children: "Learn more"
                }
              )
            ] })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "w-100 h-1 dc__border-bottom-n1" }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "fw-6", children: [
          "Receive application and deployment status from ‘",
          m,
          " (",
          u,
          ")’"
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-12 dc__border-left-n1 pl-12", children: p.tokenId ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4 fs-13 fw-4 lh-20 cn-9", children: [
            /* @__PURE__ */ e.jsx("span", { className: "cn-7", children: "Host name" }),
            /* @__PURE__ */ e.jsxs("span", { className: "flex left dc__content-space dc__gap-4", children: [
              /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: p.hostName ?? "-" }),
              p.hostName && /* @__PURE__ */ e.jsx(Un, { content: p.hostName })
            ] })
          ] }),
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4 fs-13 fw-4 lh-20 cn-9", children: [
            /* @__PURE__ */ e.jsx("span", { className: "cn-7", children: /* @__PURE__ */ e.jsxs("span", { children: [
              "Auth token: ",
              /* @__PURE__ */ e.jsx(
                ke,
                {
                  to: W(Nt.AUTH_API_TOKEN_EDIT, {
                    apiTokenId: p.tokenId
                  }),
                  className: "anchor cb-5 dc__word-break",
                  target: "_blank",
                  children: p.tokenName
                }
              )
            ] }) }),
            /* @__PURE__ */ e.jsxs("span", { className: "flex left dc__content-space dc__gap-4", children: [
              /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: p.token ?? "-" }),
              p.token && /* @__PURE__ */ e.jsx(Un, { content: p.token })
            ] })
          ] })
        ] }) : /* @__PURE__ */ e.jsx(
          ie,
          {
            variant: _e.text,
            size: oe.medium,
            text: i ? "Generating token ..." : "Get hostname & Auth token",
            dataTestId: "get-hostname-and-api-token",
            onClick: g(!0),
            disabled: i
          }
        ) })
      ] })
    ] }) : /* @__PURE__ */ e.jsx(
      cs,
      {
        description: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4 fs-13 fw-4 lh-20 cn-9", children: [
          /* @__PURE__ */ e.jsxs("div", { children: [
            /* @__PURE__ */ e.jsx("h4", { className: "m-0 fw-6 lh-20", children: "Action required" }),
            /* @__PURE__ */ e.jsx("span", { children: "Configure how to deliver release orchestration manifest to this tenant." })
          ] }),
          /* @__PURE__ */ e.jsx(
            ie,
            {
              text: "Configure",
              dataTestId: "configure-manifest-delivery",
              onClick: n,
              variant: _e.text,
              size: oe.medium
            }
          )
        ] }),
        variant: "warning"
      }
    ),
    o && /* @__PURE__ */ e.jsx(
      fc,
      {
        SVGImage: Zc,
        docLink: "DOC_HOME_PAGE",
        title: "Isolated delivery configurations",
        renderDescriptionContent: Ig,
        closeModal: h
      }
    )
  ] });
}, Lg = ({
  name: s,
  namespace: t,
  environmentType: n,
  tenantConfig: a,
  isChecked: l,
  isVirtual: o,
  toggleEnvironmentSelection: r,
  isEnvListLoading: i,
  installationName: c,
  searchKey: d
}) => {
  const { name: m } = ss(), p = i || !eo(
    { tenantConfig: a },
    {
      tenantName: m,
      installationName: c
    }
  ), u = () => {
    r({
      name: s,
      isVirtual: o
    });
  }, _ = (h) => /* @__PURE__ */ e.jsx(
    re,
    {
      content: `The environment is currently mapped to the '${a.displayText}'. Each environment can only be mapped to one tenant installation at a time.`,
      placement: "top",
      className: "default-tt w-200 dc__word-break",
      arrow: !1,
      children: h
    }
  );
  return /* @__PURE__ */ e.jsxs("div", { className: "display-grid dc__column-gap-16 tenants__installation-env-row fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-20", children: [
    /* @__PURE__ */ e.jsx($e, { condition: p, wrap: _, children: /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
      js,
      {
        isChecked: l ?? !1,
        onChange: u,
        rootClassName: "mb-0",
        value: Oe.CHECKED,
        disabled: p
      }
    ) }) }),
    /* @__PURE__ */ e.jsx(
      "span",
      {
        className: "dc__truncate",
        dangerouslySetInnerHTML: {
          __html: us.sanitize(
            _s({
              searchText: d,
              text: s,
              highlightClasses: "bcy-2"
            })
          )
        }
      }
    ),
    /* @__PURE__ */ e.jsx(
      "span",
      {
        className: "dc__truncate",
        dangerouslySetInnerHTML: {
          __html: us.sanitize(
            _s({
              searchText: d,
              text: t,
              highlightClasses: "bcy-2"
            })
          )
        }
      }
    ),
    /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: o ? "-" : n }),
    /* @__PURE__ */ e.jsx(
      "span",
      {
        className: "dc__truncate",
        dangerouslySetInnerHTML: {
          __html: us.sanitize(
            _s({
              searchText: d,
              text: a.displayText,
              highlightClasses: "bcy-2"
            })
          )
        }
      }
    )
  ] });
}, kg = ({
  isEnvListLoading: s,
  envListResponse: t,
  updateEnvMapForSelectedCluster: n,
  selectedEnvMapForCluster: a,
  toggleEnvironmentSelection: l,
  installationName: o,
  filterConfig: { sortBy: r, sortOrder: i, handleSorting: c, searchKey: d, clearFilters: m }
}) => {
  const { name: p } = ss(), u = q(() => t ? (d.toLowerCase() ? t.filter(
    (C) => C.name.toLowerCase().includes(d) || C.namespace.toLowerCase().includes(d) || C.tenantConfig.name.toLowerCase().includes(d) || C.tenantConfig.installationConfig.name.toLowerCase().includes(d)
  ) : structuredClone(t)).sort((C, S) => {
    switch (r) {
      case as.namespace:
        return te(C.namespace, S.namespace, i);
      case as.environmentType:
        return te(C.environmentType, S.environmentType, i);
      case as.tenantInstallation:
        return te(
          C.tenantConfig.displayText,
          S.tenantConfig.displayText,
          i
        );
      default:
        return te(C.name, S.name, i);
    }
  }) : [], [t, r, i, d]), _ = u.length, h = q(() => {
    const N = so(a);
    return _ > 0 && u.map((C) => C.name).every((C) => a[C]) ? Oe.CHECKED : N > 0 ? Oe.INTERMEDIATE : null;
  }, [u, a]), f = h === Oe.CHECKED || h === Oe.INTERMEDIATE, g = () => {
    const N = u.filter(
      ({ tenantConfig: C }) => eo(
        { tenantConfig: C },
        {
          tenantName: p,
          installationName: o
        }
      )
    ).map(({ name: C, isVirtual: S }) => ({
      name: C,
      isVirtual: S
    }));
    if (f) {
      n({});
      return;
    }
    const y = N.reduce(
      (C, { name: S, isVirtual: I }) => (C[S] = {
        isVirtual: I
      }, C),
      {}
    );
    n(y);
  }, b = () => {
    c(as.environment);
  }, j = () => {
    c(as.namespace);
  }, E = () => {
    c(as.environmentType);
  }, v = () => {
    c(as.tenantInstallation);
  }, x = () => s ? Rp.map((N) => /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "display-grid dc__column-gap-16 tenants__installation-env-row fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-20 show-shimmer-loading",
      children: [
        /* @__PURE__ */ e.jsx("span", { className: "child-shimmer-loading" }),
        /* @__PURE__ */ e.jsx("span", { className: "child-shimmer-loading" }),
        /* @__PURE__ */ e.jsx("span", { className: "child-shimmer-loading" }),
        /* @__PURE__ */ e.jsx("span", { className: "child-shimmer-loading" }),
        /* @__PURE__ */ e.jsx("span", { className: "child-shimmer-loading" })
      ]
    },
    `env-list-loading-${N.name}`
  )) : u.map((N) => /* @__PURE__ */ fs(
    Lg,
    {
      ...N,
      isEnvListLoading: s,
      isChecked: !!a[N.name],
      toggleEnvironmentSelection: l,
      installationName: o,
      key: N.name,
      searchKey: d
    }
  ));
  return /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: s || _ ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "display-grid dc__column-gap-16 tenants__installation-env-row tenants__installation-env-row--header dc__border-bottom-n1 fs-12 fw-6 lh-20 cn-7 dc__align-items-center px-20 dc__uppercase show-shimmer-loading", children: [
      s ? /* @__PURE__ */ e.jsx("span", { className: "child-shimmer-loading" }) : /* @__PURE__ */ e.jsx(
        js,
        {
          isChecked: h === Oe.CHECKED || h === Oe.INTERMEDIATE,
          onChange: g,
          rootClassName: "mb-0",
          value: h ?? void 0,
          disabled: _ === 0
        }
      ),
      /* @__PURE__ */ e.jsx(
        Z,
        {
          disabled: s,
          isSorted: r === as.environment,
          sortOrder: i,
          title: "Environment",
          triggerSorting: b
        }
      ),
      /* @__PURE__ */ e.jsx(
        Z,
        {
          disabled: s,
          isSorted: r === as.namespace,
          sortOrder: i,
          title: "Namespace",
          triggerSorting: j
        }
      ),
      /* @__PURE__ */ e.jsx(
        Z,
        {
          disabled: s,
          isSorted: r === as.environmentType,
          sortOrder: i,
          title: "Environment Type",
          triggerSorting: E
        }
      ),
      /* @__PURE__ */ e.jsx(
        Z,
        {
          disabled: s,
          isSorted: r === as.tenantInstallation,
          sortOrder: i,
          title: "Tenant (Installation)",
          triggerSorting: v
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1 dc__overflow-auto", children: x() })
  ] }) : /* @__PURE__ */ e.jsx(yt, { handleClearFilters: m, classname: "flex-grow-1" }) });
}, Dg = (s) => /* @__PURE__ */ e.jsxs(
  ke,
  {
    to: `${Nt.GLOBAL_CONFIG_CLUSTER}/${s}${Nt.CREATE_ENV}`,
    target: "_blank",
    className: "flex dc__content-start dc__gap-4 anchor cta h-32 pr-8-imp pl-8-imp dc__no-shrink",
    children: [
      /* @__PURE__ */ e.jsx(Je, { className: "icon-dim-16 dc__no-shrink" }),
      /* @__PURE__ */ e.jsx("span", { className: "fw-6 lh-18 cn-0 fs-12", children: "Add Environment" })
    ]
  }
), Og = ({
  selectedCluster: s,
  toggleEnvironmentSelection: t,
  selectedEnvMapForCluster: n,
  updateEnvMapForSelectedCluster: a,
  installationName: l
}) => {
  const [o, r, i, c] = K(
    () => sg(s),
    [s],
    !!s
  ), { sortBy: d, sortOrder: m, handleSorting: p, searchKey: u, handleSearch: _, clearFilters: h } = ds({
    initialSortKey: as.environment
  });
  if (!s)
    return /* @__PURE__ */ e.jsx(
      J,
      {
        image: Ma,
        title: "Please select an cluster",
        subTitle: "Select a cluster to map environments",
        classname: "flex-grow-1"
      }
    );
  const f = (b) => {
    _(b);
  }, g = () => Dg(s);
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto dc__gap-12", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space py-10 px-20 dc__gap-6", children: [
      /* @__PURE__ */ e.jsxs("h3", { className: "dc__truncate cn-9 fs-16 lh-28 fw-6 cn-9 m-0", children: [
        "Cluster / ",
        s
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8 dc__no-shrink", children: [
        /* @__PURE__ */ e.jsx(qs, { handleEnter: f, initialSearchText: u }),
        g()
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(
      Ee,
      {
        isLoading: !1,
        error: i,
        errorScreenManagerProps: {
          code: i?.code,
          reload: c
        },
        children: /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: o || r?.length ? /* @__PURE__ */ e.jsx(
          kg,
          {
            envListResponse: r,
            isEnvListLoading: o,
            selectedEnvMapForCluster: n,
            toggleEnvironmentSelection: t,
            updateEnvMapForSelectedCluster: a,
            installationName: l,
            filterConfig: {
              sortBy: d,
              sortOrder: m,
              handleSorting: p,
              searchKey: u,
              clearFilters: h
            }
          }
        ) : /* @__PURE__ */ e.jsx(
          J,
          {
            image: Ma,
            title: "No environments added",
            subTitle: "This cluster doesn't have any environments yet.",
            classname: "flex-grow-1",
            isButtonAvailable: !0,
            renderButton: g
          }
        ) })
      }
    )
  ] });
}, Mg = ({ name: s, isSelected: t, handleClick: n, selectedEnvCount: a, isVirtual: l }) => {
  const o = () => {
    n(s);
  };
  return /* @__PURE__ */ e.jsxs(
    "button",
    {
      type: "button",
      className: `dc__transparent px-8 py-6 flexbox dc__content-start br-4 dc__gap-8 ${l ? "" : "dc__align-items-center"} ${t ? "bcb-1" : "dc__hover-n50"}`,
      onClick: o,
      children: [
        /* @__PURE__ */ e.jsx(
          sd,
          {
            className: `icon-dim-16 dc__no-shrink ${l ? "mt-2" : ""} ${t ? "" : "scn-6"}`
          }
        ),
        /* @__PURE__ */ e.jsxs("span", { className: "flex column left flex-grow-1", children: [
          /* @__PURE__ */ e.jsx("span", { className: `fs-13 lh-20 dc__truncate flex-grow-1 ${t ? "cb-5 fw-6" : "cn-9 fw-4"}`, children: s }),
          l && /* @__PURE__ */ e.jsx("span", { className: "fs-12 lh-18 dc__truncate flex-grow-1 fw-4 cn-7", children: "Isolated cluster" })
        ] }),
        a > 0 && /* @__PURE__ */ e.jsx(
          "span",
          {
            className: `px-6 br-12 ${t ? "bcb-5 cn-0" : "bcn-1 cn-7"} dc__align-center fs-12 fw-6 lh-20 dc__truncate dc__no-shrink`,
            children: a
          }
        )
      ]
    }
  );
}, Pg = ({
  clusterList: s,
  handleClusterSelection: t,
  selectedCluster: n,
  selectedEnvMapByCluster: a
}) => /* @__PURE__ */ e.jsxs("div", { className: "w-220 flexbox-col dc__no-shrink dc__overflow-auto dc__border-right--n1", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space dc__no-shrink py-12 pr-12 pl-20 dc__gap-6", children: [
    /* @__PURE__ */ e.jsx("span", { className: "cn-9 fw-6 lh-20 fs-13", children: "Clusters" }),
    /* @__PURE__ */ e.jsxs(
      ke,
      {
        to: `${Nt.GLOBAL_CONFIG_CLUSTER}${Nt.CONNECT_CLUSTER}`,
        target: "blank",
        className: "px-4 py-2 flex dc__content-start dc__gap-6 anchor fw-6 lh-20 fs-13 cb-5 h-24",
        children: [
          /* @__PURE__ */ e.jsx(Je, { className: "icon-dim-16 dc__no-shrink fcb-5" }),
          "Add"
        ]
      }
    )
  ] }),
  /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto p-12", children: s.map(({ name: l, isVirtual: o }) => /* @__PURE__ */ e.jsx(
    Mg,
    {
      name: l,
      isSelected: l === n,
      handleClick: t,
      selectedEnvCount: so(a[l]),
      isVirtual: o
    },
    l
  )) })
] }), Fg = () => /* @__PURE__ */ e.jsxs(
  ke,
  {
    to: Nt.GLOBAL_CONFIG_CLUSTER,
    target: "blank",
    className: "flex dc__content-start dc__gap-6 anchor cta fw-6 lh-20-imp fs-13 cb-5 h-24",
    children: [
      /* @__PURE__ */ e.jsx(Je, { className: "icon-dim-16 dc__no-shrink fcb-5 h-36" }),
      "Add Cluster"
    ]
  }
), Ug = ({
  installationName: s,
  handleSuccess: t,
  getInitialEnvSelectionMap: n,
  deploymentConfig: a,
  openIsolatedDeploymentConfigModal: l,
  updateInstallationMappingRef: o
}) => {
  const { push: r } = fe(), i = Te(), { name: c } = ss(), [d, m] = T(!1), [p, u] = T(null), [_, h] = T(n()), [f, g] = T(null), [b, j, E, v] = K(tg);
  ee(() => {
    j && !p && u(j?.[0]?.name);
  }, [j, p]);
  const x = (R) => {
    u(R);
  }, N = (R) => {
    if (Ip(
      _,
      R
    )) {
      g({
        updatedEnvMapForSelectedCluster: R
      });
      return;
    }
    h({
      ..._,
      [p]: {
        ...R
      }
    });
  }, y = () => {
    g(null);
  }, C = () => {
    h({
      [p]: f.updatedEnvMapForSelectedCluster
    }), y();
  }, S = ({
    name: R,
    isVirtual: B
  }) => {
    const P = structuredClone(_[p] ?? {});
    P[R] ? delete P[R] : P[R] = {
      isVirtual: B
    }, N(P);
  }, I = () => {
    r(
      W(D.TENANT_DETAIL_INSTALLATIONS, {
        ...i
      })
    );
  }, w = async () => {
    m(!0);
    try {
      await ng({
        installationId: i.installationId,
        tenantId: i.tenantId,
        selectedEnvironmentMap: _
      }), m(!1), ae.showToast({
        variant: le.success,
        description: "Environments mapped successfully"
      }), I(), t();
    } catch (R) {
      U(R), m(!1);
    }
  };
  ee(() => (o.current = w, () => {
    o.current = null;
  }), [_]);
  const k = async () => {
    if (to(_) === Is.isolated && !a) {
      l();
      return;
    }
    await w();
  };
  return /* @__PURE__ */ e.jsx(Ut, { className: "", onEscape: I, close: I, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "bg__primary dc__position-fixed dc__right-0 dc__top-0 h-100 flexbox-col dc__content-space w-1024",
      onClick: lt,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col h-100 dc__content-space bg__primary dc__overflow-auto", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__align-items-center dc__border-bottom py-12 px-20 dc__gap-8", children: [
            /* @__PURE__ */ e.jsxs("h2", { className: "m-0 cn-9 fs-16 fw-6 lh-24 dc__ellipsis-right", children: [
              "Map Environment to ",
              c,
              " (",
              s,
              ")"
            ] }),
            /* @__PURE__ */ e.jsx(
              "button",
              {
                className: "flex dc__transparent dc__outline-none-imp dc__no-border p-0 dc__tab-focus",
                type: "button",
                onClick: I,
                "aria-label": "close-deployment-source-modal",
                children: /* @__PURE__ */ e.jsx(Ts, { className: "icon-dim-24 dc__no-shrink fcn-6" })
              }
            )
          ] }),
          /* @__PURE__ */ e.jsx(
            Ee,
            {
              isLoading: b,
              progressingProps: {
                pageLoader: !0
              },
              error: E,
              errorScreenManagerProps: {
                code: E?.code,
                reload: v
              },
              children: /* @__PURE__ */ e.jsx("div", { className: "flexbox flex-grow-1 dc__overflow-auto", children: j?.length ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                /* @__PURE__ */ e.jsx(
                  Pg,
                  {
                    selectedCluster: p,
                    clusterList: j,
                    handleClusterSelection: x,
                    selectedEnvMapByCluster: _
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  Og,
                  {
                    selectedCluster: p,
                    selectedEnvMapForCluster: _[p] ?? {},
                    toggleEnvironmentSelection: S,
                    updateEnvMapForSelectedCluster: N,
                    installationName: s
                  },
                  p
                )
              ] }) : /* @__PURE__ */ e.jsx(
                J,
                {
                  image: Ma,
                  title: "No clusters",
                  subTitle: "No clusters have been connected to Devtron",
                  classname: "flex-grow-1",
                  isButtonAvailable: !0,
                  renderButton: Fg
                }
              ) })
            }
          )
        ] }),
        !b && !E && /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__content-end dc__gap-12 pt-12 pb-12 pl-16 pr-16 bg__primary dc__border-top dc__no-shrink", children: [
          /* @__PURE__ */ e.jsx(
            "button",
            {
              type: "button",
              className: "cta cancel lh-20-imp h-32",
              onClick: I,
              disabled: d,
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ e.jsx(
            ie,
            {
              dataTestId: "map-environments-save",
              text: "save",
              size: oe.medium,
              isLoading: d,
              onClick: k
            }
          )
        ] }),
        !!f && /* @__PURE__ */ e.jsx(
          Hs,
          {
            variant: Gs.custom,
            Icon: /* @__PURE__ */ e.jsx(ed, {}),
            title: "Previous selections will be cleared",
            subtitle: "An installation can either have connected environments or isolated environments",
            buttonConfig: {
              secondaryButtonConfig: {
                text: "Cancel",
                onClick: y
              },
              primaryButtonConfig: {
                text: "Clear & continue",
                onClick: C
              }
            },
            handleClose: y
          }
        )
      ]
    }
  ) });
}, $g = ({ openEditInstallationModal: s, refetchInstallationList: t }) => {
  const [n, a] = T(!1), l = Ye(null), { push: o } = fe(), r = Te(), { installationId: i } = r, { image: c, name: d, tenantId: m } = ss(), [p, u, _, h] = K(
    () => Jf({ tenantId: m, installationId: i }),
    [i],
    !!i
  ), f = () => u?.environments?.reduce((C, S) => (C[S.cluster] || (C[S.cluster] = {}), C[S.cluster][S.name] = {
    isVirtual: S.isVirtual
  }, C), {});
  if (!i)
    return /* @__PURE__ */ e.jsx(
      J,
      {
        image: Hn,
        title: "Please select an installation",
        subTitle: "Select an installation to map environments",
        classname: "flex-grow-1"
      }
    );
  const g = () => {
    s({
      installationId: u.installationId,
      name: u.name,
      releaseChannelId: u.releaseChannelId
    });
  }, b = () => /* @__PURE__ */ e.jsxs("div", { className: "p-20 flexbox dc__align-items-center dc__gap-16", children: [
    /* @__PURE__ */ e.jsx(
      is,
      {
        imageProps: {
          src: c,
          alt: `Logo for tenant: ${d}`
        }
      }
    ),
    /* @__PURE__ */ e.jsx("div", { children: p ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx("div", { className: "child-shimmer-loading w-120 h-22 mt-0" }),
      /* @__PURE__ */ e.jsx("div", { className: "child-shimmer-loading w-150 h-18" })
    ] }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-start dc__gap-6", children: [
        /* @__PURE__ */ e.jsx("h3", { className: "cn-9 fs-16 lh-24 fw-6 dc__truncate m-0", children: u.name }),
        /* @__PURE__ */ e.jsx(
          "button",
          {
            type: "button",
            "aria-label": `edit ${u.name}`,
            "data-testid": `edit-${u.name}`,
            className: "flex dc__transparent p-0",
            onClick: g,
            children: /* @__PURE__ */ e.jsx(Ys, { className: "icon-dim-16 dc__no-shrink scn-6" })
          }
        )
      ] }),
      /* @__PURE__ */ e.jsxs("p", { className: "cn-9 fs-13 fw-4 lh-20 m-0 dc__truncate", children: [
        "Installation ID: ",
        u.installationId,
        " • ",
        u.releaseChannelId ? `Release Channel: ${u.releaseChannelName}` : "No release channel subscribed"
      ] })
    ] }) })
  ] }), j = () => {
    o(
      W(D.TENANT_DETAIL_INSTALLATION_MAP_ENVIRONMENT, {
        ...r,
        installationId: i
      })
    );
  }, E = () => {
    t();
  }, v = () => {
    if (l.current) {
      l.current();
      return;
    }
    t();
  }, x = () => /* @__PURE__ */ e.jsx(
    ie,
    {
      size: oe.medium,
      variant: _e.secondary,
      startIcon: /* @__PURE__ */ e.jsx(Qc, {}),
      disabled: p,
      onClick: j,
      dataTestId: "map-env-button",
      text: "Map Environment"
    }
  ), N = () => !p && !u.environments?.length ? /* @__PURE__ */ e.jsx(
    J,
    {
      image: Hn,
      title: `Map environments to '${u.name}'`,
      subTitle: "When deploying a release, you can target this installation. Mapped environments will be automatically selected for the deployment.",
      isButtonAvailable: !0,
      renderButton: x
    }
  ) : /* @__PURE__ */ e.jsx(
    Cg,
    {
      isInstallationLoading: p,
      environments: u?.environments,
      renderMapEnvButton: x
    }
  ), y = () => {
    a((C) => !C);
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsx(
      Ee,
      {
        isLoading: !1,
        error: _,
        errorScreenManagerProps: {
          code: _?.code,
          reload: h,
          redirectURL: W(D.TENANT_DETAIL_INSTALLATIONS, {
            ...r,
            installationId: void 0
          })
        },
        children: (p || !!u) && /* @__PURE__ */ e.jsxs("div", { className: "flexbox flex-grow-1", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 show-shimmer-loading dc__overflow-auto w-100", children: [
            b(),
            /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: N() })
          ] }),
          /* @__PURE__ */ e.jsx(
            Ag,
            {
              installationDetail: u,
              refetchInstallationDetail: h,
              toggleIsolatedDeploymentConfigModal: y
            }
          ),
          !p && !_ && /* @__PURE__ */ e.jsx(Bs, { children: /* @__PURE__ */ e.jsx(Re, { path: D.TENANT_DETAIL_INSTALLATION_MAP_ENVIRONMENT, children: /* @__PURE__ */ e.jsx(
            Ug,
            {
              installationName: u.name,
              deploymentConfig: u.deploymentConfig,
              handleSuccess: E,
              getInitialEnvSelectionMap: f,
              openIsolatedDeploymentConfigModal: y,
              updateInstallationMappingRef: l
            }
          ) }) })
        ] })
      }
    ),
    n && /* @__PURE__ */ e.jsx(
      Rg,
      {
        installationId: u?.installationId,
        handleClose: y,
        handleSuccess: v,
        deploymentConfig: u?.deploymentConfig
      }
    )
  ] });
}, Bg = ({
  handleClose: s,
  handleSuccess: t,
  installationId: n,
  name: a
}) => {
  const { tenantId: l } = ss(), o = async () => {
    await Qf({ tenantId: l, installationId: n }), t();
  };
  return /* @__PURE__ */ e.jsx(
    Gt,
    {
      title: a,
      onDelete: o,
      subtitle: "Deleting a installation will delete all the mapping added to it.",
      closeConfirmationModal: s,
      confirmationConfig: {
        identifier: "delete-installation-confirmation",
        confirmationKeyword: a
      },
      successToastMessage: "Installation deleted successfully"
    }
  );
}, Hg = ({
  installationId: s,
  name: t,
  handleDeleteSuccess: n,
  handleEditInstallation: a
}) => {
  const [l, o] = T(!1), r = () => {
    o(!0);
  }, i = () => {
    o(!1);
  }, c = (d, m) => {
    switch (lt(m), d.id) {
      case "edit":
        a();
        break;
      case "delete":
        r();
        break;
    }
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      Lr,
      {
        id: "installation-list-options-menu",
        onClick: c,
        options: [
          {
            items: [
              {
                id: "edit",
                label: `Edit ${t}`,
                startIcon: { name: "ic-pencil" }
              },
              {
                id: "delete",
                label: `Delete ${t}`,
                startIcon: { name: "ic-delete" },
                type: "negative"
              }
            ]
          }
        ],
        buttonProps: {
          dataTestId: "installation-list-options-menu-button",
          icon: /* @__PURE__ */ e.jsx(Me, { name: "ic-more-vertical", color: null }),
          variant: _e.borderLess,
          ariaLabel: "Open action menu",
          style: qe.neutral,
          size: oe.xs
        }
      }
    ),
    l && /* @__PURE__ */ e.jsx(
      Bg,
      {
        installationId: s,
        name: t,
        handleClose: i,
        handleSuccess: n
      }
    )
  ] });
}, Gg = ({
  name: s,
  installationId: t,
  releaseChannelId: n,
  environmentCount: a,
  refetchInstallationList: l,
  openEditInstallationModal: o
}) => {
  const r = Te(), { push: i } = fe(), { refetchTenantDetail: c } = ss(), d = () => {
    o({
      installationId: t,
      name: s,
      releaseChannelId: n
    });
  }, m = async () => {
    await l(), await c(), i(W(D.TENANT_DETAIL_INSTALLATIONS, { ...r, installationId: void 0 }));
  };
  return /* @__PURE__ */ e.jsxs(
    ke,
    {
      to: W(D.TENANT_DETAIL_INSTALLATIONS, {
        ...r,
        installationId: t
      }),
      className: `anchor flexbox dc__content-space dc__gap-8 px-8 py-6 br-4 cursor dc__transparent w-100 ${r.installationId === t ? "bcb-1" : "dc__hover-n50"}`,
      children: [
        /* @__PURE__ */ e.jsxs("div", { children: [
          /* @__PURE__ */ e.jsx("h4", { className: "cb-5 fs-12 fw-6 lh-20 m-0", children: s }),
          /* @__PURE__ */ e.jsxs("p", { className: "cn-7 fs-12 fw-4 lh-18 m-0", children: [
            a,
            " ",
            a === 1 ? "Environment" : "Environments"
          ] })
        ] }),
        /* @__PURE__ */ e.jsx(
          Hg,
          {
            installationId: t,
            name: s,
            handleDeleteSuccess: m,
            handleEditInstallation: d
          }
        )
      ]
    }
  );
}, Wg = ({
  openAddInstallationModal: s,
  installationList: t,
  refetchInstallationList: n,
  openEditInstallationModal: a
}) => /* @__PURE__ */ e.jsxs("div", { className: "w-250 dc__no-shrink flexbox-col dc__border-right", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space dc__gap-8 py-12 pr-12 pl-20", children: [
    /* @__PURE__ */ e.jsx("div", { className: "cn-9 fs-13 fw-6 lh-20 dc__truncate", children: pa(t.length) }),
    /* @__PURE__ */ e.jsxs(
      "button",
      {
        type: "button",
        className: "cta text flex h-24 dc__gap-6 anchor lh-20-imp dc__no-border-imp px-4 py-2",
        onClick: s,
        children: [
          /* @__PURE__ */ e.jsx(Je, { className: "icon-dim-14 dc__no-shrink fcb-5" }),
          /* @__PURE__ */ e.jsx("span", { children: "Add" })
        ]
      }
    )
  ] }),
  /* @__PURE__ */ e.jsx("div", { className: "flexbox-col p-12 flex-grow-1 dc__overflow-auto", children: t.map((l) => /* @__PURE__ */ fs(
    Gg,
    {
      ...l,
      key: l.installationId,
      refetchInstallationList: n,
      openEditInstallationModal: a
    }
  )) })
] }), Vg = () => {
  const [s, t] = T(), { installationId: n, ...a } = Te(), { replace: l } = fe(), { tenantId: o, name: r, refetchTenantDetail: i } = ss(), [c, d, m, p] = K(
    () => Kf(o)
  );
  ee(() => {
    d && !n && l(
      W(D.TENANT_DETAIL_INSTALLATIONS, {
        ...a,
        installationId: d[0]?.installationId
      })
    );
  }, [d, n]);
  const u = () => {
    t({
      installationId: "",
      name: "",
      releaseChannelId: null
    });
  }, _ = (j) => {
    t(j);
  }, h = () => {
    t(null);
  }, f = async () => {
    p(), await i(), h();
  }, g = () => /* @__PURE__ */ e.jsxs("button", { type: "button", className: "flex cta h-36 dc__gap-8", onClick: u, children: [
    /* @__PURE__ */ e.jsx(Je, { className: "icon-dim-16" }),
    /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-20", children: "Add Installation" })
  ] }), b = () => d?.length ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox h-100 bg__primary dc__overflow-hidden", children: [
    /* @__PURE__ */ e.jsx(
      Wg,
      {
        installationList: d,
        openAddInstallationModal: u,
        openEditInstallationModal: _,
        refetchInstallationList: p
      }
    ),
    /* @__PURE__ */ e.jsx(
      $g,
      {
        openEditInstallationModal: _,
        refetchInstallationList: p
      },
      n
    )
  ] }) : /* @__PURE__ */ e.jsx(
    J,
    {
      image: Hn,
      title: `Add an installation for '${r}'`,
      subTitle: "A tenant can have multiple installations of your software. An installation represents a deployment of your software across one or more environments of a tenant.",
      isButtonAvailable: !0,
      renderButton: g,
      classname: "flex-grow-1"
    }
  );
  return /* @__PURE__ */ e.jsxs(
    Ee,
    {
      isLoading: c,
      progressingProps: {
        pageLoader: !0
      },
      error: m,
      errorScreenManagerProps: {
        code: m?.code,
        reload: p
      },
      children: [
        b(),
        s && /* @__PURE__ */ e.jsx(
          jg,
          {
            handleClose: h,
            handleSuccess: f,
            installationConfig: s
          }
        )
      ]
    }
  );
}, qg = `## Describe this tenant

Describe this tenant in a few words. The description could include the purpose, features, benefits, and target audience of your tenant. A well-written description will help users know about this tenant and how it works. Keep it concise and informative!`, Yg = () => {
  const { tenantId: s, name: t, description: n, image: a, installationsCount: l, createdOn: o, createdBy: r, refetchTenantDetail: i } = ss(), c = async (d) => {
    const m = {
      tenantId: s,
      description: d
    };
    try {
      await Yf(m), ae.showToast({
        variant: le.success,
        description: "Successfully saved"
      }), await i();
    } catch (p) {
      throw U(p), p;
    }
  };
  return /* @__PURE__ */ e.jsxs("aside", { className: "flexbox-col dc__gap-16", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
      /* @__PURE__ */ e.jsx(
        is,
        {
          imageProps: {
            src: a,
            alt: `Logo for tenant: ${t}`,
            loading: "lazy"
          }
        }
      ),
      /* @__PURE__ */ e.jsx("h3", { className: "fs-16 fw-7 lh-24 cn-9 dc__word-break font-merriweather m-0", children: t }),
      /* @__PURE__ */ e.jsx(
        el,
        {
          emptyState: "Write a short description for this tenant",
          placeholder: "Write a short description for this tenant",
          initialText: n,
          updateContent: c,
          validations: {
            maxLength: {
              value: 350,
              message: "Max 350 characters allowed"
            }
          }
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "dc__border-top-n1" }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
      /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-4 lh-20 cn-7 mb-4", children: "Tenant ID" }),
        /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-6 lh-20 cn-9 dc__truncate", children: s })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-4 lh-20 cn-7 mb-4", children: "Added on" }),
        /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-6 lh-20 cn-9 dc__truncate", children: o })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-4 lh-20 cn-7 mb-4", children: "Added by" }),
        /* @__PURE__ */ e.jsxs("div", { className: "fs-13 fw-6 lh-20 cn-9 dc__word-break flexbox flex-align-center dc__gap-8", children: [
          /* @__PURE__ */ e.jsx(
            "div",
            {
              className: "icon-dim-20 mw-20 flexbox flex-justify-center flex-align-center dc__border-radius-50-per dc__uppercase cn-0 fw-4",
              style: { backgroundColor: la(r) },
              children: r[0]
            }
          ),
          r
        ] })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-4 lh-20 cn-7 mb-4", children: "Installations" }),
        /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-6 lh-20 cn-9 dc__truncate", children: pa(l) })
      ] })
    ] })
  ] });
}, zg = () => {
  const { tenantId: s, note: t, refetchTenantDetail: n } = ss(), a = async (l) => {
    try {
      await zf({
        tenantId: s,
        note: l
      }), ae.showToast({
        variant: le.success,
        description: xl
      }), await n();
    } catch (o) {
      U(o);
    }
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "pl-20 pr-20 pt-20 pb-20 software-hub__overview display-grid dc__gap-32 dc__content-center flex-grow-1 dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsx(Yg, {}),
    /* @__PURE__ */ e.jsxs("div", { children: [
      /* @__PURE__ */ e.jsx(
        qo,
        {
          resourceType: G.tenant,
          resourceIdentifier: s,
          version: ne.alpha1
        }
      ),
      /* @__PURE__ */ e.jsx(
        Za,
        {
          text: t || qg,
          title: "Readme",
          updateDescription: a
        }
      )
    ] })
  ] });
}, Kg = () => {
  const { tenantId: s } = Te(), [t, n] = T(!1), [a, l, o, r] = K(
    () => ti(s),
    [s],
    !0,
    {
      resetOnChange: !1
    }
  ), i = q(
    () => ({
      ...l,
      refetchTenantDetail: r
    }),
    [l]
  ), c = () => {
    n(!1);
  }, d = () => {
    n(!0);
  };
  return /* @__PURE__ */ e.jsx(
    Ee,
    {
      isLoading: a && !l,
      customLoader: (
        // We don't want to show loading in case of atomic update. Example: description change
        /* @__PURE__ */ e.jsx("div", { className: "flex h-100 w-100", children: /* @__PURE__ */ e.jsx(ra, {}) })
      ),
      errorScreenManagerProps: {
        code: o?.code,
        redirectURL: D.TENANTS,
        reload: r
      },
      error: o,
      children: /* @__PURE__ */ e.jsx(hg, { value: i, children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col h-100 dc__overflow-hidden", children: [
        /* @__PURE__ */ e.jsx(gg, { openTenantEditModal: d }),
        /* @__PURE__ */ e.jsxs(Bs, { children: [
          /* @__PURE__ */ e.jsx(Re, { path: D.TENANT_DETAIL_OVERVIEW, component: zg }),
          /* @__PURE__ */ e.jsx(Re, { path: D.TENANT_DETAIL_INSTALLATIONS, component: Vg }),
          /* @__PURE__ */ e.jsx(gn, { to: D.TENANT_DETAIL_INSTALLATIONS })
        ] }),
        t && /* @__PURE__ */ e.jsx(
          Ya,
          {
            tenantId: l.tenantId,
            handleClose: c,
            handleSuccess: r
          }
        )
      ] }) })
    }
  );
}, Jg = ({
  handleClose: s,
  handleSuccess: t,
  releaseChannelId: n,
  releaseChannelName: a
}) => {
  const l = async () => {
    await rf(n), t();
  };
  return /* @__PURE__ */ e.jsx(
    Gt,
    {
      title: a,
      component: "release channel",
      onDelete: l,
      subtitle: "Deleting this release channel will unsubscribe any installations subscribed to it.",
      closeConfirmationModal: s,
      confirmationConfig: {
        identifier: "delete-release-channel-confirmation",
        confirmationKeyword: a
      },
      successToastMessage: "Release channel deleted successfully"
    }
  );
}, Qg = () => /* @__PURE__ */ e.jsx(e.Fragment, { children: xg.map(({ channelId: s }) => /* @__PURE__ */ e.jsxs(
  "div",
  {
    className: "display-grid dc__align-items-center dc__column-gap-16 release-channel__table-row fs-13 fw-4 lh-24 cn-9 px-20 show-shimmer-loading",
    children: [
      /* @__PURE__ */ e.jsx("span", { className: "child-shimmer-loading" }),
      /* @__PURE__ */ e.jsx("span", { className: "child-shimmer-loading" }),
      /* @__PURE__ */ e.jsx("span", { className: "child-shimmer-loading" }),
      /* @__PURE__ */ e.jsx("span", { className: "child-shimmer-loading" })
    ]
  },
  s
)) }), Xg = ({
  name: s,
  channelId: t,
  subscribedInstallations: n,
  subscribedInstallationsCount: a,
  description: l,
  isDefault: o,
  searchKey: r,
  openDeleteReleaseChannelModal: i,
  openEditReleaseChannelModal: c
}) => /* @__PURE__ */ e.jsxs("div", { className: "display-grid dc__align-items-center dc__column-gap-16 release-channel__table-row fs-13 fw-4 lh-20 cn-9 px-20 dc__hover-n50 dc__visible-hover dc__visible-hover--parent", children: [
  /* @__PURE__ */ e.jsx(Pa, { className: "icon-dim-24" }),
  /* @__PURE__ */ e.jsxs("span", { className: "flexbox-col", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-8", children: [
      /* @__PURE__ */ e.jsx(
        "span",
        {
          className: "dc__truncate",
          dangerouslySetInnerHTML: {
            __html: us.sanitize(
              _s({
                searchText: r,
                text: s,
                highlightClasses: "bcy-2"
              })
            )
          }
        }
      ),
      o && /* @__PURE__ */ e.jsx("span", { className: "dc__uppercase px-6 fs-12 fw-6 lh-20 cb-5 dc__no-shrink br-4 dc__border eb-2 bcb-1", children: "Default" })
    ] }),
    /* @__PURE__ */ e.jsx(
      "span",
      {
        className: "cn-7 dc__truncate",
        dangerouslySetInnerHTML: {
          __html: us.sanitize(
            _s({
              searchText: r,
              text: t,
              highlightClasses: "bcy-2"
            })
          )
        }
      }
    )
  ] }),
  /* @__PURE__ */ e.jsx(
    vr,
    {
      theme: Cr.white,
      className: "w-400 dc__align-left mxh-250 dc__overflow-auto",
      placement: "bottom-start",
      Icon: $r,
      iconClass: "fcv-5",
      infoText: a ? /* @__PURE__ */ e.jsx("ul", { className: "fs-14 fw-4 lh-20 cn-9 m-0 pl-24", children: n.map(({ displayText: d, identifier: m }) => /* @__PURE__ */ e.jsx("li", { children: d }, m)) }) : /* @__PURE__ */ e.jsx(
        As,
        {
          title: "No installations subscribed",
          subTitle: `No installations are subscribed to '${s}'`,
          description: "",
          useInfoIcon: !0,
          rootClassName: "mh-150"
        }
      ),
      heading: `Installations subscribed to ${s}`,
      showCloseButton: !0,
      trigger: "click",
      interactive: !0,
      children: /* @__PURE__ */ e.jsx("span", { className: "cb-5 dc__truncate cursor dc__w-fit-content dc__lowercase", children: pa(a) })
    }
  ),
  /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: l || "-" }),
  /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-4", children: [
    /* @__PURE__ */ e.jsx(
      "button",
      {
        type: "button",
        className: "dc__visible-hover--child dc__transparent p-4 flex",
        "data-testid": `release-channel__edit-button-${t}`,
        "aria-label": "Edit release channel",
        onClick: c({
          name: s,
          description: l,
          isDefault: o,
          channelId: t
        }),
        children: /* @__PURE__ */ e.jsx(Ys, { className: "scn-6 icon-dim-16 dc__no-shrink" })
      }
    ),
    /* @__PURE__ */ e.jsx(
      "button",
      {
        type: "button",
        className: "dc__visible-hover--child dc__transparent icon-delete p-4 flex",
        "data-testid": `release-channel__delete-button-${t}`,
        onClick: i({
          releaseChannelId: t,
          releaseChannelName: s
        }),
        "aria-label": "Delete release channel",
        children: /* @__PURE__ */ e.jsx(Wt, { className: "icon-delete__hover icon-dim-16 dc__no-shrink" })
      }
    )
  ] })
] }), Zg = ({ handleClose: s }) => {
  const [t, n, a, l] = K(
    () => Ea({
      lite: !1
    })
  ), [o, r] = T(null), [i, c] = T(null), d = !!o, m = !!i, { searchKey: p, handleSearch: u, clearFilters: _, sortBy: h, sortOrder: f, handleSorting: g } = ds({
    initialSortKey: mt.name
  }), b = q(() => {
    if (n?.length) {
      const k = p.toLowerCase().trim() ? n.filter(
        (R) => R.name.toLowerCase().includes(p) || R.channelId.toLowerCase().includes(p)
      ) : structuredClone(n);
      return h === mt.subscribedInstallationCount ? k.sort(
        (R, B) => Us(
          R.subscribedInstallationsCount,
          B.subscribedInstallationsCount,
          f
        )
      ) : k.sort((R, B) => te(R.name, B.name, f));
    }
    return [];
  }, [n, p, h, f]), j = !t && !b?.length, E = ({ releaseChannelId: w, releaseChannelName: k }) => () => {
    c({ releaseChannelId: w, releaseChannelName: k });
  }, v = () => {
    c(null);
  }, x = () => {
    r(structuredClone(Ol));
  }, N = (w) => () => {
    r(structuredClone(w));
  }, y = () => {
    r(null);
  }, C = () => /* @__PURE__ */ e.jsxs("button", { type: "button", className: "cta flex dc__gap-4 lh-20-imp h-32", onClick: x, children: [
    /* @__PURE__ */ e.jsx(Je, { className: "icon-dim-16 dc__no-shrink fcn-0" }),
    /* @__PURE__ */ e.jsx("span", { children: "Add Release Channel" })
  ] }), S = (w) => () => {
    g(w);
  }, I = () => j && !p ? /* @__PURE__ */ e.jsx(
    J,
    {
      title: "No Release Channel is added",
      subTitle: "Release channel is way to subscribe one or group of tenant (installation) for easy management (such as bulk deployments, user access management etc).",
      classname: "flex flex-grow-1",
      image: rd,
      isButtonAvailable: !0,
      renderButton: C
    }
  ) : /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space dc__gap-12 px-20 py-12", children: [
      /* @__PURE__ */ e.jsx(
        qs,
        {
          inputProps: {
            placeholder: "Search release channel"
          },
          initialSearchText: p,
          handleEnter: u,
          containerClassName: "w-250"
        }
      ),
      C()
    ] }),
    j && p ? /* @__PURE__ */ e.jsx(yt, { classname: "flex flex-grow-1", handleClearFilters: _ }) : /* @__PURE__ */ e.jsxs("div", { children: [
      /* @__PURE__ */ e.jsxs("div", { className: "display-grid dc__column-gap-16 release-channel__table-row release-channel__table-row--header dc__border-bottom-n1 fs-12 fw-6 lh-20 cn-7 dc__align-items-center dc__uppercase bg__primary px-20 dc__top-49 dc__position-sticky dc__zi-4", children: [
        /* @__PURE__ */ e.jsx("span", {}),
        /* @__PURE__ */ e.jsx(
          Z,
          {
            isSorted: h === mt.name,
            sortOrder: f,
            title: "Channel Name",
            triggerSorting: S(mt.name),
            disabled: !1
          }
        ),
        /* @__PURE__ */ e.jsx(
          Z,
          {
            isSorted: h === mt.subscribedInstallationCount,
            sortOrder: f,
            title: "Subscribed installation",
            triggerSorting: S(
              mt.subscribedInstallationCount
            ),
            disabled: t
          }
        ),
        /* @__PURE__ */ e.jsx(Z, { title: "Description", isSortable: !1 }),
        /* @__PURE__ */ e.jsx("span", {})
      ] }),
      /* @__PURE__ */ e.jsx("div", { children: t ? /* @__PURE__ */ e.jsx(Qg, {}) : b.map((w) => /* @__PURE__ */ e.jsx(
        Xg,
        {
          ...w,
          searchKey: p,
          openDeleteReleaseChannelModal: E,
          openEditReleaseChannelModal: N
        }
      )) })
    ] })
  ] });
  return /* @__PURE__ */ e.jsxs(rt, { position: "right", width: "1024px", onEscape: s, children: [
    /* @__PURE__ */ e.jsx("div", { className: "bg__primary h-100 flexbox-col show-shimmer-loading", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
      /* @__PURE__ */ e.jsx("div", { className: "dc__position-sticky dc__top-0 bg__primary dc__zi-20", children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-justify dc__border-bottom pt-10 pr-20 pb-10 pl-20", children: [
        /* @__PURE__ */ e.jsx("h2", { className: "fs-16 fw-6 lh-24 m-0 dc__ellipsis-right", children: "Release Channels" }),
        /* @__PURE__ */ e.jsx(
          "button",
          {
            type: "button",
            className: "dc__transparent dc__no-shrink flexbox",
            "aria-label": "close-modal",
            onClick: s,
            children: /* @__PURE__ */ e.jsx(Ts, { className: "icon-dim-24 icon-use-fill-n6" })
          }
        )
      ] }) }),
      /* @__PURE__ */ e.jsx(
        Ee,
        {
          isLoading: !1,
          error: a,
          errorScreenManagerProps: {
            code: a?.code,
            reload: l
          },
          children: I()
        }
      )
    ] }) }),
    m && /* @__PURE__ */ e.jsx(
      Jg,
      {
        ...i,
        handleClose: v,
        handleSuccess: l
      }
    ),
    d && /* @__PURE__ */ e.jsx(
      li,
      {
        handleClose: y,
        handleSuccess: l,
        releaseChannelConfig: o
      }
    )
  ] });
}, ex = ({
  tenantId: s,
  image: t,
  name: n,
  description: a,
  installations: l,
  searchText: o,
  refetchTenantsList: r
}) => {
  const i = Te(), { push: c } = fe(), d = () => {
    const u = W(D.TENANT_DETAIL, {
      tenantId: s
    });
    c(u);
  }, m = () => {
    c(
      W(D.TENANT_EDIT, {
        ...i,
        tenantId: s
      })
    );
  }, p = (u) => /* @__PURE__ */ e.jsx(re, { content: a, arrow: !1, className: "default-tt dc__word-break", placement: "top", children: u });
  return /* @__PURE__ */ e.jsx(
    "button",
    {
      type: "button",
      className: "dc__transparent p-0 bg__primary br-8 dc__info-card w-100",
      onClick: d,
      children: /* @__PURE__ */ e.jsxs("div", { className: "p-16 flexbox-col dc__gap-12", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__gap-4", children: [
          /* @__PURE__ */ e.jsx(
            is,
            {
              imageProps: {
                src: t,
                alt: `Logo for tenant: ${n}`,
                loading: "lazy"
              }
            }
          ),
          /* @__PURE__ */ e.jsx(
            ni,
            {
              tenantId: s,
              name: n,
              handleSuccess: r,
              openTenantEditModal: m
            }
          )
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex column left dc__content-space dc__gap-12 flex-grow-1", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
            /* @__PURE__ */ e.jsxs("div", { children: [
              /* @__PURE__ */ e.jsx(re, { content: n, arrow: !1, className: "default-tt dc__word-break", placement: "top", children: /* @__PURE__ */ e.jsx(
                "h3",
                {
                  className: "cn-9 fs-16 fw-6 lh-24 dc__truncate m-0 dc__w-fit-content",
                  dangerouslySetInnerHTML: {
                    __html: us.sanitize(
                      _s({
                        searchText: o,
                        text: n,
                        highlightClasses: "bcy-2"
                      })
                    )
                  }
                }
              ) }),
              /* @__PURE__ */ e.jsx(
                re,
                {
                  content: s,
                  arrow: !1,
                  className: "default-tt dc__word-break",
                  placement: "top",
                  children: /* @__PURE__ */ e.jsx(
                    "p",
                    {
                      className: "cn-9 fs-13 fw-4 lh-20 dc__truncate m-0 mono dc__w-fit-content",
                      dangerouslySetInnerHTML: {
                        __html: us.sanitize(
                          _s({
                            searchText: o,
                            text: s,
                            highlightClasses: "bcy-2"
                          })
                        )
                      }
                    }
                  )
                }
              )
            ] }),
            /* @__PURE__ */ e.jsx($e, { condition: !!a, wrap: p, children: /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-7 fw-4 lh-18 fs-12 dc__ellipsis-right__2nd-line dc__w-fit-content dc__align-left", children: a || "No description" }) })
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "dc__truncate fs-13 fw-6 lh-20 cn-9", children: pa(l.length) })
        ] })
      ] })
    }
  );
}, sx = Array.from(Array(3).keys()).map((s) => ({
  id: s,
  tenantId: `${s}`,
  name: "",
  description: "",
  image: "",
  installations: [],
  createdBy: "",
  createdOn: "",
  note: "",
  catalogSchemaResourceId: 0
})), tx = () => /* @__PURE__ */ e.jsx(e.Fragment, { children: sx.map(({ tenantId: s }) => /* @__PURE__ */ e.jsxs(
  "div",
  {
    className: "dc__transparent br-4 p-16 flexbox-col dc__gap-12 bg__primary dc__info-card dc__info-card--no-hover show-shimmer-loading",
    children: [
      /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__content-space dc__gap-4", children: /* @__PURE__ */ e.jsx("div", { className: "icon-dim-48 dc__chart-grid-item__icon br-4 child-shimmer-loading h-48" }) }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__content-space dc__gap-12 flex-grow-1", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4 h-100", children: [
          /* @__PURE__ */ e.jsx("div", { className: "child-shimmer-loading h-24" }),
          /* @__PURE__ */ e.jsx("p", { className: "m-0 child-shimmer-loading h-20" }),
          /* @__PURE__ */ e.jsx("p", { className: "m-0 child-shimmer-loading h-36" })
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "child-shimmer-loading h-20" })
      ] })
    ]
  },
  s
)) }), nx = (s) => ({
  releaseChannelId: s.getAll(Jt.releaseChannelId).map((t) => t.trim()).filter((t) => !!t)
}), ax = () => {
  const [s, t] = T(!1), { url: n } = gs(), a = fe(), l = Ye(new AbortController()), { searchKey: o, handleSearch: r, clearFilters: i, releaseChannelId: c, updateSearchParams: d } = Xn({
    parseSearchParams: nx
  }), m = c.length > 0 || !!o, [p, u, _, h] = K(
    () => Vs(
      () => Hf({ releaseChannelId: c }, l.current.signal),
      l
    ),
    [c.toString()]
  ), [f, g, , b] = K(
    () => Ea()
  ), j = q(
    () => Tl(g),
    [g]
  ), E = p || hs(_), v = !E && !u?.length && !m, x = q(() => {
    if (u) {
      const P = o.trim().toLowerCase();
      return P ? u.filter(
        (L) => L.name.toLowerCase().includes(P) || L.tenantId.toLowerCase().includes(P)
      ) : u;
    }
    return [];
  }, [o, u]), N = () => {
    t((P) => !P);
  }, y = () => {
    N(), b(), h();
  }, C = () => {
    a.push(D.TENANT_CREATE);
  }, S = () => {
    a.push(n);
  }, I = (P) => {
    r(P?.trim());
  }, w = () => /* @__PURE__ */ e.jsxs(
    "button",
    {
      className: "cta flex h-32 lh-20-imp dc__gap-6",
      type: "button",
      "data-testid": "add-tenant-button",
      onClick: C,
      children: [
        /* @__PURE__ */ e.jsx(Je, { className: "icon-dim-14 dc__no-shrink" }),
        "Add tenant"
      ]
    }
  ), k = () => E || x.length ? /* @__PURE__ */ e.jsx("div", { className: "display-grid tenants__list-container dc__gap-16 flex-grow-1", children: E ? /* @__PURE__ */ e.jsx(tx, {}) : x.map((P) => /* @__PURE__ */ fs(
    ex,
    {
      ...P,
      key: P.tenantId,
      searchText: o,
      refetchTenantsList: h
    }
  )) }) : /* @__PURE__ */ e.jsx(yt, { classname: "flex-grow-1", handleClearFilters: i }), R = (P) => {
    d({
      releaseChannelId: P.map(({ value: L }) => L.toString())
    });
  }, B = (P, L) => P === Jt.releaseChannelId ? j[L] : null;
  return /* @__PURE__ */ e.jsxs(
    Ee,
    {
      isLoading: !1,
      error: _,
      errorScreenManagerProps: {
        code: _?.code,
        reload: h
      },
      children: [
        /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__overflow-auto px-20 pb-12 bg__primary flex-grow-1", children: v ? /* @__PURE__ */ e.jsx(
          J,
          {
            title: "Add your first tenant",
            subTitle: "Tenants represent the organizations or teams you deliver software to. Create tenants to deploy and manage releases across multiple environments using Devtron's multi-tenant capabilities.",
            isButtonAvailable: !0,
            renderButton: w,
            image: ld,
            classname: "flex-grow-1"
          }
        ) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsxs("div", { children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__content-space py-12", children: [
              /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-8", children: [
                /* @__PURE__ */ e.jsx(
                  qs,
                  {
                    inputProps: {
                      placeholder: "Search by tenant name or id",
                      disabled: E
                    },
                    handleEnter: I,
                    initialSearchText: o,
                    containerClassName: "w-250",
                    keyboardShortcut: "/"
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  Qo,
                  {
                    appliedReleaseChannelIds: c,
                    handleApplyFilter: R,
                    releaseChannelList: g,
                    isReleaseChannelLoading: f
                  }
                )
              ] }),
              /* @__PURE__ */ e.jsxs("div", { className: "flex right dc__gap-12", children: [
                /* @__PURE__ */ e.jsx(
                  "button",
                  {
                    className: "cta secondary flex h-32 lh-20-imp",
                    type: "button",
                    "data-testid": "view-release-channel",
                    onClick: N,
                    children: /* @__PURE__ */ e.jsx("span", { className: "cn-7", children: "View Release Channels" })
                  }
                ),
                w()
              ] })
            ] }),
            !f && /* @__PURE__ */ e.jsx(
              sa,
              {
                filterConfig: { releaseChannelId: c },
                clearFilters: i,
                onRemoveFilter: d,
                className: "pt-0-imp pb-12",
                getFormattedLabel: Xo,
                getFormattedValue: B
              }
            )
          ] }),
          k()
        ] }) }),
        s && /* @__PURE__ */ e.jsx(Zg, { handleClose: y }),
        /* @__PURE__ */ e.jsxs(Bs, { children: [
          /* @__PURE__ */ e.jsx(Re, { path: D.TENANT_CREATE, children: /* @__PURE__ */ e.jsx(Ya, { handleClose: S, handleSuccess: h }) }),
          /* @__PURE__ */ e.jsx(
            Re,
            {
              path: D.TENANT_EDIT,
              render: ({ match: P }) => /* @__PURE__ */ e.jsx(
                Ya,
                {
                  tenantId: P.params.tenantId,
                  handleClose: S,
                  handleSuccess: h
                }
              )
            }
          )
        ] })
      ]
    }
  );
}, lx = () => /* @__PURE__ */ e.jsxs(Bs, { children: [
  /* @__PURE__ */ e.jsx(
    Re,
    {
      path: D.TENANT_DETAIL,
      render: ({ match: s }) => /* @__PURE__ */ e.jsx(Kg, {}, `tenant-detail-${s.params.tenantId}`)
    }
  ),
  /* @__PURE__ */ e.jsxs(Re, { path: D.TENANTS, children: [
    /* @__PURE__ */ e.jsx(ei, {}),
    /* @__PURE__ */ e.jsx(ax, {})
  ] }),
  /* @__PURE__ */ e.jsx(gn, { to: D.TENANTS })
] }), SE = () => /* @__PURE__ */ e.jsx("div", { className: "flexbox-col h-100 dc__overflow-hidden", children: /* @__PURE__ */ e.jsxs(Bs, { children: [
  /* @__PURE__ */ e.jsx(Re, { path: D.RELEASES, children: /* @__PURE__ */ e.jsx(Uf, {}) }),
  /* @__PURE__ */ e.jsx(Re, { path: D.TENANTS, children: /* @__PURE__ */ e.jsx(lx, {}) }),
  /* @__PURE__ */ e.jsx(gn, { to: D.RELEASES })
] }) });
function ri({
  userApprovalMetadata: s,
  showApprovalCounts: t,
  triggeredBy: n,
  neverShowConfiguredFilters: a = !1,
  appliedFilters: l,
  appliedFiltersTimestamp: o,
  promotionApprovalMetadata: r,
  selectedEnvironmentName: i,
  isDeploymentWithoutApproval: c
}) {
  const [d, m] = T(!1), p = () => {
    m(!1);
  }, u = () => {
    m(!0);
  }, _ = r?.approvedUsersData?.map((h) => h.userEmail);
  return !c && !ja(s?.approvalConfigData) && l.length === 0 && !r?.promotedFromType ? null : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "w-100 bg__primary flex left dc__gap-8 px-12 pt-8 pb-7 border__primary dc__top-radius-4", children: [
      !!r?.promotedFromType && /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-8", children: [
        /* @__PURE__ */ e.jsx(
          Dc,
          {
            promotedTo: i,
            promotedFrom: r.promotedFrom,
            promotedFromType: r.promotedFromType,
            promotedBy: r.requestedUserData?.userEmail,
            approvedBy: _,
            promotionPolicyName: r.policy?.name,
            showBackgroundColor: !1
          }
        ),
        (l.length > 0 || !!s) && /* @__PURE__ */ e.jsx("div", { className: "dc__bullet" })
      ] }),
      c ? /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-6", children: [
        /* @__PURE__ */ e.jsx(Me, { name: "ic-lightning-fill", color: "Y500" }),
        /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-13 lh-20 cn-9", children: "Deployed by an exception user" })
      ] }) : !!ja(s?.approvalConfigData) && /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-8", children: [
        /* @__PURE__ */ e.jsx(
          Oc,
          {
            userApprovalMetadata: s,
            showCount: t,
            triggeredBy: n
          }
        ),
        l.length > 0 && /* @__PURE__ */ e.jsx("div", { className: "dc__bullet" })
      ] }),
      l.length > 0 && /* @__PURE__ */ e.jsx(
        re,
        {
          className: "default-tt",
          placement: "top",
          content: "Image filters configured at the time of deployment.",
          arrow: !1,
          children: /* @__PURE__ */ e.jsxs(
            "button",
            {
              className: "flexbox dc__align-items-center dc__gap-4 fs-13 fw-4 lh-20 dc__hover-color-b500 cursor cn-9 dc__no-border dc__content-space dc__outline-none-imp p-0 bg__primary",
              onClick: u,
              type: "button",
              children: [
                !ja(s?.approvalConfigData) && /* @__PURE__ */ e.jsx(qr, { className: "icon-dim-16" }),
                "Passing Filters"
              ]
            }
          )
        }
      )
    ] }),
    d && !a && /* @__PURE__ */ e.jsx(Ut, { className: "", parentClassName: "dc__overflow-hidden", close: p, children: /* @__PURE__ */ e.jsx("div", { className: "modal-body--cd-material h-100", onClick: lt, children: /* @__PURE__ */ e.jsx(
      Mc,
      {
        isFromBulkCD: !1,
        resourceFilters: l,
        handleDisableFiltersView: p,
        closeModal: p,
        deployedTime: Qa(o),
        showDisableFiltersButton: !1
      }
    ) }) })
  ] });
}
const wE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ri
}, Symbol.toStringTag, { value: "Module" }));
export {
  uE as A,
  yE as B,
  wE as C,
  jE as D,
  _E as G,
  hE as H,
  TE as P,
  Bo as R,
  dE as S,
  xE as V,
  qo as a,
  CE as b,
  fE as c,
  bE as d,
  mE as e,
  EE as f,
  NE as g,
  pE as h,
  Su as i,
  wu as j,
  Ru as k,
  Iu as l,
  Au as m,
  vE as n,
  SE as o,
  Ao as p,
  yl as r,
  iu as u,
  gE as v
};
